{
  "testit": {
    "catalog": {
      "title": "TestIt",
      "subtitle": "I tuoi risultati di test riutilizzabili — fai un test una volta e riutilizzalo in qualsiasi CheckUp.",
      "notTaken": "Non ancora svolto",
      "validDays": "Valido · {{days}}g rimasti",
      "expired": "Scaduto",
      "delete": "Elimina",
      "declareHint": "Autodichiara il tuo livello (non verificato). Potrai sostituirlo con un test verificato in seguito.",
      "retake": "Rifai",
      "footnote": "I risultati validi vengono riutilizzati automaticamente nel CheckUp.",
      "kindPitch": "Pitch video",
      "kindCefr": "Test di lingua",
      "kindMotivational": "Questionario",
      "valid": "Valido",
      "takeTest": "Fai il test",
      "viewRetake": "Vedi e ripeti",
      "lastTaken": "Ultima volta il {{date}}",
      "recordedOn": "Registrato il {{date}}",
      "emptyPrompt": "Fallo una volta — riusa il risultato in qualsiasi CheckUp.",
      "heroTitle": "Il tuo archivio di test riutilizzabili",
      "heroSubtitle": "I risultati validi vengono ripresi automaticamente la prossima volta che fai un CheckUp.",
      "statValid": "Validi",
      "statExpired": "Scaduti",
      "statUntaken": "Non fatti",
      "errorTitle": "Non siamo riusciti a caricare i tuoi test",
      "errorBody": "Qualcosa è andato storto nel recuperare il tuo archivio di test. Riprova tra poco."
    },
    "modal": {
      "history": "Cronologia",
      "historyError": "Non siamo riusciti a caricare i tuoi tentativi.",
      "current": "Attuale",
      "superseded": "Sostituito",
      "selfDeclared": "Autodichiarato",
      "verified": "Verificato",
      "recorded": "Registrato",
      "daysLeft": "{{days}} giorni rimasti",
      "takenOn": "Fatto il {{date}}",
      "expiresOn": "scade il {{date}}",
      "reuseNote": "Riutilizzato automaticamente nel tuo prossimo CheckUp",
      "takeNew": "Fai un nuovo test",
      "declareCta": "Dichiara livello"
    },
    "test": {
      "pitch": "Pitch",
      "languageEn": "Inglese",
      "languagePt": "Portoghese",
      "language": "Lingua",
      "motivational": "Motivazionale"
    },
    "invite": {
      "bulkKindNote": "Si applica a tutti i candidati selezionati.",
      "kindFull": "CheckUp completo",
      "kindFullHint": "La valutazione CheckUp completa — un profilo iQulture completo.",
      "kindLabel": "Cosa devono completare?",
      "kindTestit": "Test specifici",
      "kindTestitHint": "Solo i test che scegli qui sotto: più veloce e i risultati sono riutilizzabili.",
      "previewFull": "L'email di invito al CheckUp completo.",
      "previewLabel": "Riceveranno",
      "previewTestit": "Un invito TestIt che indica: {{tests}}.",
      "previewTestitEmpty": "Un invito TestIt: scegli i test qui sopra.",
      "selectAtLeastOne": "Seleziona almeno un test.",
      "selectTestsHint": "Scegline uno o più. Il candidato completa solo questi.",
      "selectTestsLabel": "Quali test devono svolgere?",
      "testNeverExpires": "Nessuna scadenza",
      "wizardBannerCta": "Inizia ora",
      "wizardCompleteBody": "I tuoi risultati sono stati condivisi con l’azienda. Puoi chiudere e passare alla dashboard.",
      "wizardCompleteTitle": "Tutti i test completati!",
      "wizardDoLater": "Fallo più tardi",
      "wizardDone": "Completato",
      "wizardGoToDashboard": "Vai alla dashboard",
      "wizardIntro": "Sei stato invitato a completare questi test. Falli nell’ordine che preferisci: i risultati vengono salvati e sono riutilizzabili.",
      "wizardPending": "Da completare",
      "wizardProgress": "{{done}} di {{total}} completati",
      "wizardRetake": "Ripeti",
      "wizardStart": "Inizia",
      "wizardTitle": "Completa i test a cui sei stato invitato",
      "testValidityDays_one": "Valido {{count}} giorno",
      "testValidityDays_other": "Valido {{count}} giorni",
      "wizardBannerTitle_one": "Sei stato invitato a completare {{count}} test",
      "wizardBannerTitle_other": "Sei stato invitato a completare {{count}} test",
      "completeBannerTitle": "I test che ti sono stati chiesti sono completati",
      "completeBannerBody": "L’azienda che li ha chiesti può vedere i tuoi risultati. Non resta nulla da fare."
    },
    "vetting": {
      "allComplete": "Tutti i test invitati completati",
      "askDescription": "Chiederemo a {{name}} la valutazione selezionata. Se serve più di ciò che condivide ora con te, decide lui se condividerlo: non viene condiviso altro finché non risponde. I risultati che ha già vengono riutilizzati.",
      "askFailed": "Impossibile inviare la richiesta",
      "askForCheckup": "Richiedi CheckUp completo",
      "askSend": "Invia richiesta",
      "askSending": "Invio…",
      "askEmailFailed": "La richiesta a {{name}} è registrata, ma non è stato possibile inviare l’e-mail",
      "askTitle": "Richiedi una valutazione a {{name}}",
      "decline": "Rifiuta",
      "declined": "Rifiutato",
      "durationLabel": "Durata",
      "expired": "Scaduto",
      "invitedProgress": "{{done}} di {{total}} test completati",
      "latestResult": "Ultimo risultato",
      "motivationalComplete": "Questionario completato",
      "noPriorAttempts": "Nessun tentativo precedente",
      "noResults": "Nessun risultato di test",
      "noVerdict": "Nessuna decisione",
      "notTaken": "Non svolto",
      "otherResults": "Altri risultati",
      "overallLevel": "Livello complessivo",
      "overviewTitle": "Valutazione TestIt",
      "pass": "Approva",
      "passed": "Approvato",
      "pending": "In attesa",
      "pitchAria": "Registrazione del pitch del candidato",
      "pitchUnavailable": "Registrazione non disponibile",
      "previousAttempts": "Tentativi precedenti",
      "recorded": "Registrato",
      "remind": "Ricorda",
      "reminderFailed": "Impossibile inviare il promemoria.",
      "reminderSent": "Promemoria inviato",
      "reminderTooSoon": "Hai già inviato un promemoria di recente — riprova più tardi.",
      "selfDeclared": "Autodichiarato",
      "skillListening": "Ascolto",
      "skillReading": "Lettura",
      "skillSpeaking": "Produzione orale",
      "skillWriting": "Produzione scritta",
      "sourceCheckup": "Dal CheckUp",
      "sourceTestit": "TestIt",
      "takenOn": "svolto il {{date}}",
      "valid": "Valido · {{days}}g rimasti",
      "validShort": "Valido",
      "verdictTitle": "Verdetto",
      "failed": "Analisi fallita",
      "failedReason": {
        "languageMismatch": "Il certificato attesta una lingua diversa da quella di questo test.",
        "unsupportedDocument": "Non è stato possibile leggere il file caricato.",
        "archiveTooLarge": "Il documento Word è troppo grande per essere letto in sicurezza.",
        "docxEmpty": "Il documento Word non contiene testo né immagini leggibili.",
        "tooManyPages": "Il certificato ha più di {{max}} pagine; vengono letti solo certificati fino a {{max}} pagine.",
        "noLevelFound": "Nel certificato non è stato trovato alcun livello QCER.",
        "serviceUnavailable": "Il nostro servizio di analisi non è riuscito a elaborare il certificato."
      },
      "withheldBody": "Questo cittadino non ha condiviso i risultati dei test con la tua azienda. I test a cui lo hai invitato restano elencati; se li abbia completati è trattenuto: non è «in attesa».",
      "moreActions": "Altre azioni",
      "motivationalAnswered_one": "{{count}} risposta",
      "motivationalAnswered_other": "{{count}} risposte",
      "repositoryTitle": "Risultati dei test salvati",
      "repositorySubtitle": "Tutti i test e ciò che il candidato ha completato di ciascuno — sola lettura. Questo invito CheckUp non ha richiesto test specifici.",
      "loadFailed": "Non è stato possibile caricare i risultati dei test.",
      "analyserConfidence": "Affidabilità dell'analisi: {{value}}",
      "askRequested": "Richiesta inviata a {{name}}: non viene condiviso altro finché non risponde",
      "askReminded": "Abbiamo ricordato a {{name}} ciò che resta da fare",
      "askAlreadyShared": "{{name}} condivide già questo con te: non c’è nulla da chiedere"
    },
    "doOnWeb": "Fai i miei test sul web",
    "doOnWebDesc": "I test richiesti dalla tua azienda si svolgono sul portale web Citizen: aprilo in un browser desktop per iniziare."
  },
  "introCarousel": {
    "back": "Indietro",
    "business": {
      "cta": "Aggiungi talenti",
      "ctaSecondary": "Forse più tardi",
      "slides": {
        "welcome": {
          "eyebrow": "Benvenuto in Tonnie",
          "title": "Sponsorizza talenti globali, con protezione",
          "body": "Valuta, sponsorizza e supporta assunzioni internazionali in un unico posto: Tonnie protegge ogni sponsorizzazione, con tracciabilità a ogni passo."
        },
        "acquire": {
          "eyebrow": "Talent Pool · Valutazione",
          "title": "Valuta prima di sponsorizzare",
          "body": "Verifica la prontezza alla ricollocazione di ogni candidato nel Talent Pool, per sponsorizzare solo chi arriverà davvero."
        },
        "sponsor": {
          "eyebrow": "Sponsorizzazione · Protetta",
          "title": "Sponsorizza con protezione",
          "body": "Punta su un talento e Tonnie protegge l'investimento dall'inizio alla fine: verifiche di prontezza, tappe ed evidenze tengono ogni sponsorizzazione sulla giusta rotta."
        },
        "mobility": {
          "eyebrow": "Mobilità · Adattamento",
          "title": "Segui il trasferimento e l'inserimento",
          "body": "Segui ogni ricollocazione tra pratiche legali, viaggio e sistemazione, e osserva come ogni assunto sponsorizzato si inserisce nel ruolo e nel Paese."
        },
        "care": {
          "eyebrow": "Care · Conformità",
          "title": "Trattieni i talenti, con prove alla mano",
          "body": "Supporta il benessere senza sorveglianza ed esporta registri verificati appena lo richiedono audit, ufficio legale o direzione."
        },
        "start": {
          "eyebrow": "Iniziamo",
          "title": "Sponsorizza il tuo primo talento",
          "body": "Aggiungi un talento al tuo programma: ogni sponsorizzazione è protetta da Tonnie, fin dal primo giorno."
        }
      }
    },
    "goToSlide": "Vai alla diapositiva {{number}}",
    "next": "Avanti",
    "skip": "Salta",
    "title": "Introduzione a Tonnie"
  },
  "activity": {
    "task": {
      "completed": "Completato: {{label}}",
      "completedForMember": "Completato: {{label}} — {{member}}"
    },
    "housing": {
      "secured": "Alloggio assicurato"
    },
    "checkup": {
      "scored": "Punteggio CheckUp calcolato"
    },
    "checkin": {
      "completed": "Check-in completato"
    },
    "checkpoint": {
      "completed": "Checkpoint: {{label}}"
    },
    "mission": {
      "completed": "Missione completata: {{label}}"
    },
    "world": {
      "completed": "Mondo completato: {{label}}"
    },
    "streak": {
      "milestone_one": "{{count}} giorno di fila!",
      "milestone_other": "{{count}} giorni di fila!"
    },
    "stamp": {
      "earned": "Francobollo guadagnato: {{label}}"
    },
    "badge": {
      "earned": "Badge guadagnato: {{label}}"
    },
    "onboarding": {
      "completed": "Iniziare"
    },
    "journey": {
      "completed": "Viaggio completato!"
    },
    "event": {
      "addedFromPool": "Aggiunto dal pool di talenti",
      "adoptedByInvitation": "Percorso collegato a un invito aziendale",
      "arrived": "Arrivato a destinazione",
      "badgeEarned": "Badge guadagnato",
      "checkpointCompleted": "Checkpoint completato",
      "checkupCompleted": "CheckUp completato",
      "checkupStarted": "CheckUp iniziato",
      "companyTaskCompleted": "Compito aziendale completato",
      "documentUploaded": "Documento caricato",
      "expiryRenewed": "Viaggio esteso",
      "fundingChanged": "Finanziamento cambiato",
      "guideCompleted": "Guida completata",
      "guideDiscarded": "Guida scartata",
      "guideRestarted": "Guida riavviata",
      "guideRetaken": "Guida ripresa",
      "guideStarted": "Guida avviata",
      "interventionLogged": "Intervento Care registrato",
      "interventionResolved": "Intervento Care risolto",
      "interventionScheduled": "Intervento Care programmato",
      "interventionUpdated": "Intervento Care aggiornato",
      "interviewRequested": "Colloquio richiesto",
      "invitationAccepted": "Invito accettato",
      "journeyArchived": "Viaggio archiviato",
      "journeyCreated": "Viaggio creato",
      "journeyLifecycle": "Stato del viaggio cambiato",
      "journeyRestored": "Viaggio ripristinato",
      "missionCompleted": "Missione completata",
      "objectiveFeedbackSubmitted": "Feedback obiettivo inviato",
      "pipelineStageChanged": "Fase del pipeline cambiata",
      "pitchAnalyzed": "Pitch analizzato",
      "protectiveActionLogged": "Azione protettiva registrata",
      "setPrimary": "Imposta come viaggio principale",
      "sponsorshipAccepted": "Sponsorizzazione accettata",
      "sponsorshipCancelled": "Sponsorizzazione annullata",
      "sponsorshipDeclined": "Sponsorizzazione rifiutata",
      "sponsorshipRefunded": "Sponsorizzazione rimborsata",
      "sponsorshipStarted": "Sponsorizzazione avviata",
      "stampEarned": "Francobollo guadagnato",
      "talentArchived": "Talento archiviato",
      "talentSponsored": "Sponsorizzazione attivata",
      "talentUnarchived": "Talento non archiviato",
      "teleportalTaskCompleted": "Compito TelePortal completato",
      "trackCompleted": "Tracciamento completato",
      "vettingInviteEmailFailed": "Impossibile inviare l'e-mail dell'invito alla valutazione",
      "visaApproved": "Visto approvato",
      "worldCompleted": "Mondo completato",
      "copilotInterviewCompleted": "Intervista con CoPilot completata",
      "testResultsRecorded": "Risultati dei test registrati",
      "testitPassed": "Verdetto TestIt: superato",
      "testitDeclined": "Verdetto TestIt: respinto",
      "profileCompleted": "Profilo completato",
      "documentValidated": "Documento convalidato",
      "relocationPlanCreated": "Piano di trasferimento creato",
      "relocationPlanUpdated": "Piano di trasferimento aggiornato",
      "milestoneReached": "Traguardo raggiunto",
      "interventionDue": "Azione di cura programmata in scadenza",
      "taskReopened": "Attività di trasferimento riaperta",
      "relationshipMoved": "Spostato su un percorso dedicato",
      "programmeLeft": "Ha lasciato il programma",
      "shareRequested": "Ha chiesto di vedere di più",
      "shareRequestAccepted": "Ha condiviso quanto richiesto",
      "shareRequestDeclined": "Ha rifiutato la richiesta di vedere di più",
      "vettingReminded": "Promemoria di ciò che resta da fare",
      "testitCompleted": "Ha completato i test richiesti"
    },
    "pipeline": {
      "transition": "Pipeline: {{from}} → {{to}}"
    },
    "business": {
      "intervention": "Intervento: {{label}}",
      "feedbackRoutineCreated": "Routine di feedback \"{{name}}\" creata",
      "feedbackRoutineStarted": "Routine di feedback avviata",
      "feedbackRoutineCompleted": "Routine di feedback completata",
      "feedbackRoutinePaused": "Routine di feedback in pausa",
      "protectiveAction": "Azione protettiva — {{label}}",
      "interventionLogged": "Intervento — {{label}}",
      "documentUploaded": "Documento caricato — {{label}}",
      "taskReminderSent": "Promemoria inviato — {{label}}",
      "interventionScheduled": "{{label}} programmato",
      "messageSent": "Inviato \"{{name}}\" tramite {{channel}}",
      "messageSentNoName": "Messaggio inviato tramite {{channel}}",
      "messageNotDelivered": "\"{{name}}\" tramite {{channel}} non è stato consegnato",
      "messageNotDeliveredNoName": "Il messaggio tramite {{channel}} non è stato consegnato",
      "messageDispatched": "\"{{name}}\" tramite {{channel}} è stato affidato all'invio — esito non registrato",
      "messageDispatchedNoName": "Il messaggio tramite {{channel}} è stato affidato all'invio — esito non registrato",
      "invitationCreated": "Invito creato",
      "invitationSent": "Invito inviato",
      "invitationReminded": "Promemoria dell'invito inviato",
      "invitationAccepted": "Invito accettato",
      "invitationRevoked": "Invito revocato",
      "invitationRevokedAccountDeleted": "Invito revocato — la persona ha eliminato il proprio account",
      "invitationExpired": "Invito scaduto",
      "invitationDeclined": "Invito rifiutato"
    },
    "generic": "{{text}}",
    "objective": {
      "selfEvaluated": "Completata un'autovalutazione degli obiettivi"
    },
    "messageTemplate": {
      "account_email_changed": "Email di accesso modificata",
      "account_invitation_claim_code": "Codice per rivendicare l’invito",
      "adaptation_nudge_missions": "Suggerimento per missione di adattamento",
      "adaptation_streak_broken": "Promemoria per serie di adattamento",
      "care_checkin_request": "Richiesta di check-in Care",
      "care_checkpoint_overdue_reminder": "Promemoria di scadenza checkpoint (talento)",
      "care_feedback_requested": "Richiesta di feedback Care (per talento)",
      "care_intervention_due": "Intervento Care in scadenza (interno)",
      "care_objective_feedback_cycle_open": "Feedback obiettivo — round aperto (talento)",
      "care_objective_feedback_due": "Feedback obiettivo — scadenza (fornitore)",
      "care_objective_feedback_received": "Feedback obiettivo — ricevuto (talento)",
      "coaching_message": "Messaggio di coaching",
      "cohort_welcome": "Benvenuto nel gruppo",
      "company_nudge_digest": "Azione necessaria — riepilogo settimanale dell’azienda",
      "evidence_celebrate_badge": "Celebrazione del badge",
      "evidence_request": "Richiesta di prova / documento",
      "integration_mission_assigned": "Missione QultureUp assegnata",
      "interview_first_requested": "Richiesta Interview-First",
      "mobility_task_assigned": "Compito di mobilità assegnato",
      "mobility_task_pending": "Promemoria compito mobilità",
      "program_enrollment": "Benvenuto nell'iscrizione al programma",
      "services_request_received": "Richiesta di servizi Tonnie ricevuta (interna)",
      "sponsorship_activate": "Attivazione sponsorizzazione — in attesa di accettazione del talento",
      "sponsorship_invite": "Invito alla sponsorizzazione (lancio del viaggio)",
      "sponsorship_offer_reminder": "Promemoria offerta di sponsorizzazione (senza risposta)",
      "sponsorship_talent_accepted": "Sponsorizzazione — talento accettato (notifica admin)",
      "sponsorship_talent_declined": "Sponsorizzazione — talento rifiutato (notifica admin + rimborso)",
      "sponsorship_welcome": "Benvenuto nella sponsorizzazione",
      "talent_invite": "Invito all'onboarding del talento",
      "team_invite": "Invito a membro del team",
      "team_invite_reminder": "Promemoria invito al team",
      "vetting_complete_checkup": "Promemoria progresso CheckUp",
      "vetting_invite": "Invita il candidato a CheckUp",
      "vetting_invite_reminder": "Promemoria invito (senza risposta)",
      "vetting_invite_testit": "Invita il candidato a test specifici (TestIt)",
      "vetting_reminder": "Promemoria CheckUp",
      "talent_checkup_link": "Link del CheckUp per il computer",
      "coaching_encourage": "Coaching — incoraggiamento",
      "coaching_challenge": "Coaching — sfida settimanale",
      "coaching_checkin": "Coaching — aggiornamento",
      "coaching_celebrate": "Coaching — celebrazione",
      "coaching_remind": "Coaching — promemoria",
      "talent_programme_left": "Talento ha lasciato il programma (notifica admin)",
      "vetting_share_request": "Richiesta di vedere il CheckUp (relazione esistente)",
      "vetting_share_request_testit": "Richiesta di vedere i risultati dei test (relazione esistente)",
      "vetting_testit_reminder": "Promemoria TestIt",
      "talent_share_request_declined": "Il talento ha rifiutato una richiesta (notifica all’amministratore)",
      "talent_testit_completed": "Il talento ha completato i test che hai richiesto (notifica all’amministratore)"
    },
    "guide": {
      "started": "Guida {{flow}} avviata",
      "completed": "Guida {{flow}} completata",
      "discarded": "Guida {{flow}} scartata",
      "restarted": "Guida {{flow}} riavviata",
      "retaken": "Guida {{flow}} ripetuta"
    },
    "milestone": {
      "reached": "Traguardo raggiunto: {{label}}"
    }
  },
  "catalog": {
    "stamps": {
      "first_step": {
        "name": "Primo Passo",
        "description": "Completa il tuo onboarding e inizia il tuo viaggio"
      },
      "first_checkup": {
        "name": "Primo CheckUp",
        "description": "Completa la tua prima valutazione CheckUp"
      },
      "iqulture_pro": {
        "name": "iQulture PRO",
        "description": "Ottieni lo stato iQulture PRO (punteggio 70+)"
      },
      "visa_approved": {
        "name": "Visto Approvato",
        "description": "Il tuo visto o permesso di soggiorno è stato approvato"
      },
      "arrived": {
        "name": "Arrivato a Destinazione",
        "description": "Sei arrivato nel tuo paese di destinazione"
      },
      "housing_secured": {
        "name": "Casa Dolce Casa",
        "description": "Hai assicurato un alloggio nella tua destinazione"
      },
      "first_mission": {
        "name": "Prima missione",
        "description": "Completa la tua prima missione di apprendimento QultureUp"
      },
      "world_explorer": {
        "name": "Esploratore del Mondo",
        "description": "Completa il tuo primo mondo QultureUp (tutti i percorsi)"
      },
      "streak_7": {
        "name": "Serie di 7 Giorni",
        "description": "Completa QultureUp attività per 7 giorni di fila"
      },
      "streak_30": {
        "name": "Serie di 30 Giorni",
        "description": "Completa QultureUp attività per 30 giorni di fila"
      },
      "first_checkpoint": {
        "name": "Primo Checkpoint",
        "description": "Completa il tuo primo checkpoint di benessere Care"
      },
      "care_champion": {
        "name": "Campione Care",
        "description": "Completa tutti i 4 checkpoint Care programmati"
      },
      "all_heroes": {
        "name": "Viaggio Completo",
        "description": "Attivati tutti i 5 eroi nel tuo viaggio"
      },
      "adaptation_master": {
        "name": "Maestro dell'Adattamento",
        "description": "Dominato l'adattamento culturale attraverso più mondi"
      },
      "journey_complete": {
        "name": "Viaggio Completato",
        "description": "Hai completato con successo l'intero viaggio di integrazione"
      }
    },
    "badges": {
      "legal_expert": {
        "name": "Esperto Legale",
        "description": "Dominato il percorso legale e i diritti civici"
      },
      "culture_citizen": {
        "name": "Cultura Citizen",
        "description": "Completati tutti i mondi culturali a livello Avanzato"
      },
      "workplace_master": {
        "name": "Maestro del Luogo di Lavoro",
        "description": "Adattamento al luogo di lavoro e padronanza della lingua completati"
      },
      "fully_adapted": {
        "name": "Completamente adattato Citizen",
        "description": "Integrazione completa — tutti i viaggi terminati"
      },
      "cultural_ambassador": {
        "name": "Ambasciatore Culturale",
        "description": "Eccellente adattamento culturale — stato di ambasciatore"
      }
    }
  },
  "about": {
    "aiModel": "Modello AI",
    "appName": "Tonnie Citizen",
    "appVersion": "Versione app",
    "brainService": "Servizio cerebrale",
    "build": "Costruisci",
    "copyright": "© {{year}} Tonnie. Tutti i diritti riservati.",
    "description": "Tonnie è una piattaforma globale di mobilità dei talenti che riduce il fallimento della relocation e accelera l'integrazione stabile. Combiniamo la guida alimentata dall'IA con la cura umana per supportare ogni passo del tuo viaggio.",
    "environment": "Ambiente",
    "expoSdk": "Expo SDK",
    "fetchingVersions": "Recupero informazioni sulla versione...",
    "platform": "Piattaforma",
    "platformApi": "API della piattaforma",
    "systemInfo": "Informazioni di sistema",
    "title": "Informazioni su Tonnie",
    "version": "Versione {{version}}"
  },
  "accessControl": {
    "accessDenied": "Accesso negato",
    "accessFeatureInCitizenApp": "Accedi a {{feature}} tramite l'app mobile Citizen.",
    "buildJourney": "Crea viaggio",
    "enableFamilyProgram": "Abilita il Programma Famiglia nella fatturazione per accedere a questa funzionalità.",
    "familyMasterOnly": "Questa funzione è disponibile solo per i Family Masters.",
    "familyProgramRequired": "Programma familiare richiesto",
    "featureInCitizenApp": "Questa funzionalità è disponibile tramite l'app mobile Citizen.",
    "featureLocked": "Funzionalità bloccata",
    "goToBilling": "Vai a fatturazione",
    "heroNotEnabled": "Eroe non abilitato",
    "heroNotEnabledDescription": "Questo eroe non è abilitato nel tuo piano attuale. Aggiorna o cambia viaggio per sbloccarlo.",
    "journeyRequired": "Viaggio richiesto",
    "locked": "Bloccato",
    "needJourneyToAccess": "Devi costruire un viaggio per accedere a questa funzionalità.",
    "noPermission": "Non hai il permesso di accedere a questa funzione.",
    "openCitizen": "Apri Citizen",
    "switchJourney": "Cambia viaggio",
    "talentOrFamilyMasterOnly": "Questa funzione è disponibile solo per Talenti e Family Masters.",
    "upgrade": "Aggiorna",
    "useCitizenMobileApp": "Usa l'app mobile Citizen"
  },
  "accessScenario": {
    "badges": {
      "companySponsored": "Sponsorizzato dall'azienda",
      "familyMember": "Membro della famiglia",
      "free": "Modalità gratuita",
      "governmentSponsored": "Sponsorizzato dal governo"
    },
    "companySponsored": {
      "description": "Talento con viaggio sponsorizzato dall'azienda. Accesso completo a livello Pro, nessun pagamento richiesto.",
      "label": "Sponsorizzato dall'azienda"
    },
    "familyMember": {
      "description": "Membro della famiglia con lo stesso accesso della Modalità gratuita. Il viaggio è sbloccato tramite il Programma Familiare.",
      "label": "Membro della famiglia"
    },
    "free": {
      "description": "Abbonamento gratuito con accesso limitato. Aggiorna tramite Fatturazione per sbloccare Pro, Famiglia o più Viaggi.",
      "label": "Modalità gratuita"
    },
    "governmentSponsored": {
      "description": "Talento con viaggio sponsorizzato dal governo. Accesso completo a livello Pro, nessun pagamento richiesto.",
      "label": "Sponsorizzato dal governo"
    },
    "info": {
      "description": "Gli scenari di accesso ti aiutano a testare diverse combinazioni di modalità di abbonamento, sponsorizzazione del viaggio e ruoli utente. Lo scenario selezionato determina quali funzionalità puoi accedere nel mockup. In produzione, il tuo accesso è determinato dal tuo abbonamento effettivo e dalle istanze di viaggio.",
      "title": "Informazioni sugli scenari di accesso"
    },
    "loading": "Caricamento...",
    "matrix": {
      "allowed": "Accesso completo",
      "billingDescription": "Gestione del piano e della fatturazione",
      "careDescription": "Checkpoint e supporto post-arrivo",
      "careNotAllowed": "Nessun accesso a Care in modalità gratuita",
      "careerDescription": "Opportunità di lavoro e strumenti per la carriera",
      "checkupDescription": "Valutazione di prontezza pre-immigrazione",
      "citizenMobile": "Citizen mobile",
      "cvBuilder": "Costruttore CV",
      "cvBuilderDescription": "Generatore di CV in stile UE e modelli",
      "description": "Confronta l'accesso alle funzionalità tra tutti gli scenari. Seleziona uno scenario per continuare.",
      "familyProgramDescription": "Gestione del programma familiare e inviti",
      "familyProgramViaBilling": "Disponibile tramite fatturazione. Acquista l'add-on familiare (€4,99/mese) per abilitare.",
      "features": "Funzionalità",
      "homeDescription": "Panoramica del dashboard e del percorso",
      "journeyBuilder": "Costruttore di percorsi",
      "journeyBuilderDescription": "Configura e costruisci il tuo percorso personalizzato",
      "journeyBuilderViaBilling": "Disponibile dopo aver acquistato un viaggio tramite Fatturazione",
      "legend": {
        "allowed": "Accesso completo",
        "citizenMobile": "Disponibile tramite l'app mobile Citizen",
        "limited": "Accesso limitato",
        "notAllowed": "Non disponibile",
        "readOnly": "Sola lettura (membro della famiglia)",
        "viaBilling": "Disponibile tramite fatturazione/Aggiornamento"
      },
      "limited": "Accesso limitato",
      "notAllowed": "Non disponibile",
      "passportDescription": "Cronologia del percorso e traguardi",
      "passportLimited": "Visualizza solo eventi/log, nessuna funzionalità avanzata",
      "profileDescription": "Impostazioni e preferenze del profilo",
      "qultureupDescription": "Integrazione culturale e apprendimento",
      "qultureupLimited": "Solo missioni di base, contenuti limitati",
      "readOnly": "Sola lettura",
      "selected": "Selezionato",
      "teleportalDescription": "Compiti di rilocazione e mobilità",
      "teleportalLimited": "Solo checklist, nessun caricamento di documenti, nessuna revisione AI",
      "title": "Matrice di accesso alle funzionalità",
      "viaBilling": "Via fatturazione"
    },
    "select": "Seleziona scenario",
    "subtitle": "Scegli uno scenario per testare diversi livelli di accesso. Puoi aggiornare a Pro, aggiungere Famiglia o acquistare più Viaggi tramite Fatturazione.",
    "title": "Seleziona scenario di accesso"
  },
  "address": {
    "city": "Città",
    "country": "Paese",
    "detailsError": "Impossibile ottenere i dettagli dell'indirizzo. Riprova.",
    "search": "Cerca indirizzo",
    "searchDescription": "Inizia a digitare per cercare un indirizzo",
    "searchError": "Impossibile cercare indirizzi. Riprova.",
    "searchPlaceholder": "Inizia a digitare un indirizzo...",
    "typeMinChars": "Digita almeno 3 caratteri per cercare",
    "citySearch": {
      "suggestions": "Suggerimenti di città",
      "noResults": "Nessuna città trovata — puoi mantenere ciò che hai scritto.",
      "unavailable": "I suggerimenti non sono disponibili al momento — puoi mantenere ciò che hai scritto."
    }
  },
  "admin": {
    "carePillars": {
      "saveSuccess": "Configurazione dei pilastri salvata!"
    }
  },
  "alt": {
    "care": "Care",
    "career": "Career",
    "checkup": "CheckUp",
    "copilot": "CoPilot",
    "dialogGraphic": "Grafica del dialogo",
    "logo": "Logo",
    "passport": "Passport",
    "profile": "Profilo",
    "qultureup": "QultureUp",
    "teleportal": "TelePortal",
    "tonnieLogo": "Logo di Tonnie"
  },
  "assessment": {
    "analyzing": "Analizzando il tuo livello di conoscenza...",
    "answerPlaceholder": "Scrivi la tua risposta qui...",
    "duration": "Richiede circa 5-10 minuti",
    "evaluating": "Valutando le tue risposte",
    "finish": "Fine",
    "saveFailed": "Non è stato possibile salvare le tue risposte. Riprova.",
    "getRecommendations": "Ottieni il tuo livello e le raccomandazioni",
    "loadingAssessment": "Caricamento valutazione...",
    "next": "Avanti",
    "personalizedResults": "Risultati personalizzati",
    "previous": "Precedente",
    "questionOf": "Domanda {{current}} di {{total}}",
    "quickAssessment": "Valutazione veloce",
    "skipAhead": "Salta avanti",
    "skipKnownContent": "Salta contenuti che già conosci",
    "startAssessment": "Inizia valutazione",
    "startFailed": "Non siamo riusciti a caricare le domande. Controlla la connessione e riprova.",
    "startFromBeginning": "Inizia dall'inizio",
    "subtitle": "Lasciaci valutare il tuo attuale livello di conoscenza culturale",
    "title": "Valutazione della conoscenza",
    "viewRecommendedPath": "Visualizza percorso raccomandato"
  },
  "assessmentChat": {
    "clickToStartRecording": "Clicca per iniziare a registrare",
    "clickToUpload": "Clicca per caricare il CV",
    "fileFormats": "PDF, DOC, DOCX",
    "notAtAll": "Per niente",
    "recordAgain": "Registra di nuovo",
    "recordPitch": "Registra il tuo pitch",
    "recordPitchDesc": "Registra un pitch di 60 secondi su di te e i tuoi obiettivi",
    "recordVideoDesc": "Registra un breve video per presentarti (max 30 secondi)",
    "recording": "Registrazione in corso...",
    "recordingPitch": "Registrazione in corso... (max 60 secondi)",
    "startRecording": "Inizia a registrare",
    "stopRecording": "Ferma la registrazione",
    "typeAnswer": "Scrivi la tua risposta...",
    "typeMessage": "Scrivi il tuo messaggio...",
    "veryMuch": "Molto"
  },
  "auth": {
    "alreadySignedIn": {
      "continueToDashboard": "Continua al dashboard",
      "description": "Sei connesso come {{email}}. Continua il tuo viaggio, o disconnettiti per utilizzare un altro account.",
      "descriptionBusiness": "Sei connesso come {{email}}. Continua al dashboard Business, oppure disconnettiti per utilizzare un altro account.",
      "signingOut": "Disconnessione in corso…",
      "switchAccount": "Disconnettiti e usa un altro account",
      "title": "Sei già connesso"
    },
    "backToLogin": "Torna al login",
    "biometricSignIn": "Accedi con le biometrie",
    "checkEmail": "Controlla la tua email",
    "confirmPassword": "Conferma password",
    "createNewPassword": "Crea nuova password",
    "createStrongPassword": "Crea una password forte per il tuo account",
    "email": "Email",
    "enterEmailToReset": "Inserisci la tua email per reimpostare la tua password",
    "enterNewPassword": "Inserisci la tua nuova password qui sotto",
    "errors": {
      "invalidCredentials": "Email o password non validi. Riprova.",
      "invalidVerificationCode": "Codice di verifica non valido. Riprova.",
      "resetFailed": "Impossibile reimpostare la password. Riprova o richiedi un nuovo link di reset.",
      "twoFactorRequiredOnReset": "L'autenticazione a due fattori è richiesta. Accedi normalmente e reimposta la tua password dalle Impostazioni.",
      "unableToCreate": "Impossibile creare l'account. Riprova.",
      "unableToProcess": "Impossibile elaborare la tua richiesta. Riprova più tardi.",
      "unableToResend": "Impossibile reinviare il codice. Riprova."
    },
    "forgotPassword": "Hai dimenticato la password?",
    "forgotPasswordTitle": "Hai dimenticato la password?",
    "goToLogin": "Vai al login",
    "hidePassword": "Nascondi password",
    "newPassword": "Nuova password",
    "oauthError": "L'autenticazione OAuth non è stata completata. Per favore riprova.",
    "oauthFailed": "Accesso non riuscito",
    "oauthRedirecting": "Reindirizzamento in corso...",
    "oauthSuccess": "Accesso riuscito!",
    "oauthVerifying": "Attendere mentre verifichiamo il tuo account",
    "password": "Password",
    "passwordResetSuccess": "Ripristino password riuscito!",
    "passwordResetSuccessDesc": "La tua password è stata ripristinata con successo",
    "passwordResetSuccessTitle": "Ripristino password riuscito",
    "resendEmail": "Reinvia email",
    "resetCode": "Reimposta codice",
    "resetLinkInstructions": "Clicca sul link nell'email per reimpostare la tua password. Il link scadrà in 1 ora.",
    "resetLinkSent": "Link per la reimpostazione della password inviato alla tua email!",
    "resetLinkSentTo": "Abbiamo inviato un link per la reimpostazione della password a {{email}}",
    "resetPassword": "Reimposta password",
    "returnToLogin": "Torna al login",
    "sendResetCode": "Invia codice di reimpostazione",
    "sendResetLink": "Invia link di reimpostazione",
    "sessionExpiring": "Sessione in scadenza",
    "sessionExpiringDesc": "Sei stato inattivo. Verrai disconnesso tra {{seconds}} secondi.",
    "showPassword": "Mostra password",
    "signIn": "Accedi",
    "signOut": "Disconnetti",
    "staySignedIn": "Rimani connesso",
    "validation": {
      "passwordsMatch": "Le password corrispondono"
    },
    "providerErrors": {
      "emailTaken": "Esiste già un account con questa email. Accedi.",
      "accountNotFound": "Non abbiamo trovato nessun account con questa email.",
      "passwordIncorrect": "La password non è corretta. Riprova o reimpostala.",
      "credentialsIncorrect": "L'email o la password non sono corrette.",
      "passwordBreached": "Questa password è comparsa in una violazione di dati. Scegline un'altra.",
      "passwordTooShort": "La password deve contenere almeno {{passwordMinLength}} caratteri.",
      "passwordTooWeak": "Questa password è troppo debole. Scegline una più sicura.",
      "passwordUnchanged": "La nuova password deve essere diversa da quella attuale.",
      "codeIncorrect": "Il codice non è corretto. Controlla l'email e riprova.",
      "codeExpired": "Il codice è scaduto. Richiedine uno nuovo.",
      "codeAttemptsExhausted": "Troppi codici errati. Richiedine uno nuovo.",
      "emailInvalid": "Inserisci un indirizzo email valido.",
      "emailNotAllowed": "Questo indirizzo email non può essere usato qui.",
      "tooManyAttempts": "Troppi tentativi. Attendi qualche minuto e riprova.",
      "accountLocked": "Il tuo account è bloccato temporaneamente dopo troppi tentativi. Riprova più tardi.",
      "alreadySignedIn": "Hai già effettuato l'accesso.",
      "botCheckFailed": "Non è stato possibile verificare questa richiesta. Aggiorna la pagina e riprova.",
      "passwordNotSet": "Questo account non usa una password. Accedi nel modo in cui l'hai creato.",
      "accountUnavailable": "Questo account non può essere usato. Contatta l'assistenza.",
      "networkUnreachable": "Impossibile raggiungere il server. Controlla la connessione e riprova.",
      "passwordTooLong": "Questa password è troppo lunga. Scegline una più corta.",
      "reverificationRequired": "Per sicurezza, esci e accedi di nuovo, poi riprova.",
      "socialCancelled": "L'accesso è stato annullato. Puoi riprovare o usare la tua email.",
      "socialAccountInUse": "Quell'account è già collegato a un altro account Tonnie. Accedi a quell'account o scegli un'altra opzione."
    },
    "passwordRule": {
      "length": "Almeno {{passwordMinLength}} caratteri",
      "advice": "Qualche parola messa insieme crea una password forte e facile da ricordare.",
      "levels": {
        "weak": "Debole",
        "fair": "Discreta",
        "good": "Buona",
        "strong": "Forte"
      }
    },
    "passwordCard": {
      "signOutOthers": "Esci dagli altri dispositivi",
      "signOutOthersHint": "Chi ha effettuato l'accesso al tuo account altrove avrà bisogno della nuova password."
    },
    "social": {
      "continueWith": "Continua con {{provider}}",
      "failed": "Non siamo riusciti a farti accedere con {{provider}}. Riprova o usa la tua email.",
      "failedGeneric": "Non siamo riusciti a completare l'accesso. Riprova o usa la tua email.",
      "signingIn": "Accesso in corso…",
      "signingInDesc": "Un momento mentre completiamo l'accesso.",
      "returnFailed": "Non siamo riusciti a completare l'accesso",
      "returnFailedDesc": "Il ritorno dalla pagina di accesso ha richiesto troppo tempo. Riprova."
    },
    "signUpContinue": {
      "unsupported": "Non siamo riusciti a completare la creazione del tuo account",
      "unsupportedDesc": "Quell'accesso richiede qualcosa che non chiediamo. Ricomincia o registrati con la tua email.",
      "startAgain": "Ricomincia"
    },
    "connected": {
      "connect": "Collega {{provider}}",
      "disconnect": "Scollega",
      "disconnectTitle": "Scollegare {{provider}}?",
      "disconnectDesc": "Non potrai più accedere con {{provider}}. Potrai comunque accedere con la tua email.",
      "connected": "{{provider}} è collegato. Ora puoi accedere con esso.",
      "disconnected": "{{provider}} è stato scollegato.",
      "failed": "Non siamo riusciti a collegare {{provider}}. Riprova.",
      "disconnectFailed": "Non siamo riusciti a scollegare {{provider}}. Riprova."
    },
    "brand": {
      "name": "Tonnie",
      "copyright": "© {{year}} Tonnie",
      "citizen": {
        "signInHeadline": "Il tuo trasferimento all'estero, guidato passo dopo passo.",
        "signInSubline": "Un unico posto per il tuo percorso di trasferimento — dal primo CheckUp fino a sentirti a casa.",
        "signUpHeadline": "Inizia il tuo trasferimento con un piano.",
        "signUpSubline": "Crea il tuo account e Tonnie ti guida in ogni passo — prima di partire, il giorno stesso e quando arrivi.",
        "checkup": "Scopri a che punto sei prima di trasferirti",
        "teleportal": "Ogni attività del trasferimento, in ordine",
        "qultureup": "Impara la cultura prima di arrivare",
        "care": "Supporto dopo l'arrivo",
        "passport": "Ogni tappa del tuo percorso, timbrata"
      },
      "business": {
        "signInHeadline": "Trasferisci i tuoi talenti con fiducia.",
        "signInSubline": "Invita, sponsorizza e segui il trasferimento di ogni assunzione — in un unico posto.",
        "signUpHeadline": "Riunisci in un unico posto i trasferimenti del tuo team.",
        "signUpSubline": "Crea l'account della tua azienda e invita le persone che stai trasferendo quando vuoi.",
        "vetting": "Scopri chi è pronto a trasferirsi",
        "mobility": "Ogni attività del trasferimento, in ordine",
        "adaptation": "Aiuta chi arriva ad ambientarsi",
        "care": "Supporto dopo l'arrivo"
      }
    },
    "flow": {
      "back": "Indietro",
      "continue": "Continua",
      "orWithEmail": "oppure con la tua email",
      "or": "oppure",
      "emailLabel": "Email",
      "emailPlaceholder": "nome@esempio.com",
      "change": "Cambia",
      "signIn": {
        "title": "Bentornato",
        "descriptionCitizen": "Accedi per continuare il tuo percorso.",
        "descriptionBusiness": "Accedi allo spazio di lavoro della tua azienda.",
        "newHere": "Sei nuovo su Tonnie?",
        "createAccount": "Crea un account",
        "noAccount": "Non esiste alcun account Tonnie con questa email."
      },
      "password": {
        "title": "Inserisci la tua password",
        "label": "Password",
        "forgot": "Password dimenticata?",
        "submit": "Accedi",
        "codeInstead": "Accedi con un codice via email"
      },
      "code": {
        "title": "Controlla la tua email",
        "description": "Abbiamo inviato un codice di 6 cifre a {{email}}.",
        "newDevice": "Questo dispositivo è nuovo per noi. Abbiamo inviato un codice di 6 cifre a {{email}} per confermare che sei tu.",
        "label": "Codice di 6 cifre",
        "submit": "Accedi",
        "resend": "Invia un nuovo codice",
        "resendIn": "Potrai inviare un nuovo codice tra {{seconds}} s."
      },
      "totp": {
        "title": "Inserisci il codice dell'autenticatore",
        "description": "Apri la tua app di autenticazione e inserisci il codice di 6 cifre di Tonnie.",
        "label": "Codice dell'autenticatore"
      },
      "signUp": {
        "title": "Crea il tuo account",
        "description": "Usa un account che hai già, oppure la tua email.",
        "haveAccount": "Hai già un account?",
        "signIn": "Accedi",
        "emailTaken": "Esiste già un account con questa email.",
        "signInInstead": "Accedi",
        "legal": "Continuando, accetti i termini di Tonnie.",
        "terms": "Termini di servizio",
        "privacy": "Informativa sulla privacy",
        "step": "Passaggio {{current}} di {{total}}",
        "detailsTitle": "Parlaci di te",
        "firstName": "Nome",
        "lastName": "Cognome",
        "passwordLabel": "Crea una password",
        "submit": "Crea account",
        "codeNext": "Poi ti invieremo un codice via email per confermare l'indirizzo.",
        "codeTitle": "Conferma la tua email",
        "codeSubmit": "Conferma"
      },
      "invitation": {
        "signIn": "Questo invito è stato inviato a {{email}}. Accedi con quell'indirizzo per accettarlo.",
        "signUp": "Questo invito è stato inviato a {{email}}. Crea il tuo account con quell'indirizzo per accettarlo."
      }
    },
    "security": {
      "methods": {
        "title": "Metodi di accesso",
        "description": "Tutti i modi per entrare nel tuo account Tonnie, in un unico posto."
      },
      "email": {
        "label": "Email",
        "badge": "Accesso e messaggi",
        "change": "Cambia"
      },
      "password": {
        "label": "Password",
        "set": "Impostata — usala con la tua email per accedere.",
        "notSetWith": "Non impostata — accedi con {{providers}} o con un codice inviato alla tua email.",
        "notSet": "Non impostata — accedi con un codice inviato alla tua email.",
        "add": "Aggiungi password",
        "change": "Cambia"
      },
      "connected": {
        "heading": "Account collegati",
        "connected": "Collegato",
        "notConnected": "Non collegato",
        "connect": "Collega"
      },
      "sessions": {
        "title": "Dove hai effettuato l'accesso",
        "description": "Esci da qualsiasi posto che non riconosci.",
        "signOutOthers": "Esci dagli altri dispositivi",
        "thisDevice": "Questo dispositivo",
        "signOut": "Esci",
        "none": "Nessun altro dispositivo ha effettuato l'accesso."
      },
      "passwordDialog": {
        "changeTitle": "Cambia password",
        "addTitle": "Aggiungi una password",
        "description": "La userai la prossima volta che accedi con la tua email.",
        "current": "Password attuale",
        "new": "Nuova password",
        "confirm": "Conferma la nuova password",
        "submitChange": "Aggiorna password",
        "submitAdd": "Aggiungi password"
      },
      "emailDialog": {
        "step": "Passaggio {{current}} di {{total}}",
        "title": "Cambia la tua email",
        "description": "Invieremo un codice al nuovo indirizzo. Non cambia nulla finché non lo inserisci.",
        "current": "Attuale",
        "new": "Nuova email",
        "linkedNote": "{{provider}} continua a farti accedere. Il suo indirizzo resta collegato e non è toccato da questa modifica.",
        "send": "Invia codice",
        "codeTitle": "Inserisci il codice",
        "codeDescription": "L'abbiamo inviato a {{email}}.",
        "codeLabel": "Codice",
        "confirm": "Conferma la nuova email",
        "resend": "Invia un nuovo codice",
        "doneTitle": "La tua email è stata cambiata",
        "close": "Fatto"
      }
    },
    "welcome": {
      "haveAccount": "Ho già un account"
    }
  },
  "billing": {
    "availableBalance": "Saldo disponibile",
    "availableJourneys": "Percorsi disponibili",
    "basicAccess": "Accesso base",
    "cancel": "Annulla",
    "cancelFailed": "Impossibile annullare l'abbonamento. Riprova.",
    "cancelFamilyAddon": "Annulla componente aggiuntivo famiglia",
    "cancelFamilyAddonError": "Impossibile annullare l'addon familiare",
    "cancelFamilyDesc": "I tuoi familiari perderanno l’accesso alla fine del periodo di fatturazione corrente.",
    "cancelMessage": "Sei sicuro di voler annullare il tuo abbonamento Pro? Avrai accesso fino alla fine del tuo periodo di fatturazione.",
    "cancelSubscriptionError": "Impossibile annullare l'abbonamento",
    "cancelSuccess": "Abbonamento annullato. L'accesso continua fino alla fine del periodo.",
    "cancelTitle": "Annulla abbonamento",
    "checkoutError": "Impossibile avviare il checkout. Riprova.",
    "checkoutFailed": "Impossibile avviare il checkout. Riprova.",
    "comingSoon": "In arrivo",
    "commitmentNote": "Nessun vincolo — puoi annullare quando vuoi.",
    "confirmCancellation": "Conferma annullamento",
    "contactSupport": "Contatta l’assistenza",
    "createFirstJourney": "Crea il tuo primo percorso",
    "currentPlan": "Piano corrente",
    "downgradeToFree": "Passa al piano gratuito",
    "email": "Email",
    "emailPlaceholder": "member@example.com",
    "expired": "Scaduto",
    "expires": "Scade",
    "expiringSoon": "In scadenza presto",
    "familyAddonError": "Impossibile acquistare l'add-on familiare. Riprova.",
    "familyCancelFailed": "Impossibile annullare l'add-on familiare. Riprova.",
    "familyCancelSuccess": "Il tuo componente aggiuntivo famiglia è stato annullato.",
    "familyDesc": "Porta con te la tua famiglia — accesso condiviso al tuo percorso di trasferimento.",
    "familyMembersWithAccess": "Membri della famiglia con accesso",
    "familyProgram": "Programma familiare",
    "familyProgramAccess": "Accesso al programma familiare",
    "familyPurchaseFailed": "Impossibile acquistare l'add-on familiare. Riprova.",
    "freeDescription": "Accesso limitato alle funzionalità Tonnie",
    "freePlan": "Piano gratuito",
    "fullAccess": "Accesso completo",
    "invalidEmail": "Inserisci un indirizzo email valido",
    "inviteDesc": "Invia un invito per farli partecipare al tuo percorso.",
    "inviteFailed": "Impossibile inviare l'invito. Riprova.",
    "inviteFamilyMember": "Invita un membro della famiglia",
    "inviteMember": "Invita un membro",
    "inviteSent": "Invito inviato a {{email}}",
    "journeyInstances": "I tuoi percorsi",
    "journeyUnlockedPro": "Questo percorso è sbloccato con Pro.",
    "keepAddon": "Mantieni componente aggiuntivo",
    "keepPro": "Mantieni Pro",
    "locked": "Bloccato",
    "manageHousehold": "Gestisci il nucleo familiare",
    "members": "Membri",
    "monthly": "Mensile",
    "monthlyPrice": "Prezzo mensile",
    "needHelp": "Ti serve aiuto?",
    "nextRenewal": "Prossima scadenza",
    "noFamilyMembers": "Nessun membro della famiglia",
    "noJourneyInstances": "Nessuna istanza di viaggio",
    "paymentAlreadyProcessed": "Pagamento già elaborato. Il tuo viaggio è attivo!",
    "paymentCompleted": "Pagamento completato! Il tuo viaggio è stato sbloccato.",
    "paymentStillProcessing": "Il pagamento è ancora in fase di elaborazione. Attendere un momento e aggiornare.",
    "paymentSuccessUnlocked": "Pagamento riuscito! Il tuo viaggio è stato sbloccato.",
    "paymentVerificationIssue": "Problema di verifica del pagamento. Contatta il supporto se il tuo viaggio non è sbloccato.",
    "pending": "In Attesa",
    "perMonth": "/mese",
    "perYear": "/anno",
    "pro": "Pro",
    "proDescription": "Viaggi illimitati, tutte le funzionalità, supporto prioritario",
    "proFullAccessDesc": "Accesso completo a tutti gli eroi, gli strumenti e i documenti del tuo percorso.",
    "proPlan": "Piano Pro",
    "proUnlockDesc": "Sblocca il percorso completo con Pro.",
    "proceedToPayment": "Procedi al pagamento",
    "processing": "Elaborazione",
    "purchaseFamilyAddon": "Acquista add-on familiare",
    "purchased": "Acquistato",
    "recentInvoices": "Fatture recenti",
    "recommended": "Consigliato",
    "renewFailed": "Impossibile rinnovare il viaggio. Riprova.",
    "renewJourney": "Rinnova viaggio",
    "renewStripeDesc": "Verrai reindirizzato a Stripe per rinnovare l’abbonamento in sicurezza.",
    "revokeAccess": "Revoca accesso",
    "revokeConfirm": "Sei sicuro di voler revocare l'accesso a questo membro?",
    "revokeFailed": "Impossibile revocare l'accesso. Riprova.",
    "revokeSuccess": "Accesso revocato con successo",
    "sendInvite": "Invia invito",
    "sending": "Invio in corso",
    "statusActive": "Stato attivo",
    "stripeRedirectDesc": "Verrai reindirizzato a Stripe per completare il pagamento in sicurezza.",
    "title": "Fatturazione",
    "tonnieWallet": "Portafoglio Tonnie",
    "topUpWallet": "Ricarica portafoglio",
    "unlockFailed": "Impossibile sbloccare il viaggio. Riprova.",
    "unlockJourney": "Sblocca viaggio",
    "unlockNow": "Sblocca ora",
    "unlocked": "Sbloccato",
    "unlockedJourneys": "Percorsi sbloccati",
    "upgradeToPro": "Aggiorna a Pro",
    "verificationFailed": "Impossibile verificare la sessione di checkout.",
    "verificationIssue": "Pagamento completato ma la verifica ha avuto un problema. Il tuo accesso dovrebbe essere aggiornato a breve.",
    "verifyPaymentError": "Impossibile verificare il pagamento. Ricarica la pagina o contatta il supporto.",
    "yearly": "Annuale",
    "yearlyDiscount": "Risparmia con la fatturazione annuale",
    "planChangesUnavailable": "Le modifiche al piano non sono disponibili in questa app.",
    "invoiceKind": {
      "journey_unlock": "Sblocco del viaggio",
      "journey_renewal": "Rinnovo del viaggio",
      "talent_sponsorship": "Sponsorizzazione del talento",
      "pro_subscription": "Abbonamento Pro",
      "enterprise_subscription": "Abbonamento Enterprise",
      "family_addon": "Aggiunta famiglia",
      "subscription": "Abbonamento"
    },
    "invoiceStatus": {
      "draft": "Bozza",
      "open": "In attesa di pagamento",
      "paid": "Pagata",
      "void": "Annullata",
      "uncollectible": "Pagamento non riuscito"
    },
    "planFeature": {
      "checkup_basic": "Accesso base a CheckUp",
      "career_basic": "Strumenti di carriera di base",
      "teleportal_limited": "Accesso limitato a TelePortal",
      "qultureup_limited": "Accesso limitato a QultureUp",
      "copilot_limited": "Uso limitato di CoPilot",
      "passport_basic": "Accesso base a Passport",
      "journeys_unlimited": "Viaggi illimitati",
      "checkup_full": "Accesso completo a CheckUp",
      "teleportal_full": "Accesso completo a TelePortal",
      "qultureup_full": "Accesso completo a QultureUp",
      "copilot_unlimited": "Uso illimitato di CoPilot",
      "care_advanced": "Funzionalità avanzate di Care",
      "passport_full": "Accesso completo a Passport",
      "career_tools": "Strumenti di Career",
      "journey_access_shared": "Accesso condiviso al viaggio",
      "family_dashboard": "Pannello della famiglia",
      "seats_unlimited": "Postazioni illimitate",
      "candidates_unlimited": "Candidati illimitati",
      "programs_unlimited": "Programmi illimitati",
      "cohorts_unlimited": "Coorti illimitate",
      "copilot_queries_unlimited": "Domande a CoPilot illimitate",
      "analytics_basic": "Analisi di base",
      "analytics_advanced_api": "Analisi avanzate e API",
      "mobility_adaptation_full": "Percorsi completi di Mobilità e Adattamento",
      "yearly_two_months_free": "2 mesi gratis rispetto al mensile",
      "sponsorship_full_access": "Accesso completo al viaggio e all'area cittadino per il talento",
      "sponsorship_heroes": "CheckUp, TelePortal, QultureUp e Care",
      "sponsorship_passport": "Passport e traguardi",
      "family_access_optional": "Aggiunta facoltativa di accesso per la famiglia",
      "discount_vs_free": "{{count}}% di sconto rispetto al piano Gratuito",
      "support_email": "Assistenza via email",
      "support_priority": "Assistenza prioritaria",
      "family_members_up_to_one": "Fino a {{count}} familiare",
      "family_members_up_to_other": "Fino a {{count}} familiari",
      "seats_one": "{{count}} postazione (un utente)",
      "seats_other": "{{count}} postazioni",
      "candidates_up_to_one": "Fino a {{count}} candidato",
      "candidates_up_to_other": "Fino a {{count}} candidati",
      "programs_one": "{{count}} programma",
      "programs_other": "{{count}} programmi",
      "cohorts_one": "{{count}} coorte",
      "cohorts_other": "{{count}} coorti",
      "copilot_queries_monthly_one": "{{count}} domanda a CoPilot al mese",
      "copilot_queries_monthly_other": "{{count}} domande a CoPilot al mese",
      "access_window_months_one": "Accesso per {{count}} mese",
      "access_window_months_other": "Accesso per {{count}} mesi"
    },
    "seeAllInvoices": "Vedi tutte"
  },
  "biometric": {
    "authenticating": "Autenticazione in corso...",
    "benefits": {
      "dataOnDevice": "I tuoi dati rimangono sul dispositivo",
      "fastLogin": "Accesso rapido con un tocco",
      "secure": "Sicuro e crittografato"
    },
    "enable": "Abilita {{name}}",
    "maybeLater": "Forse più tardi",
    "settingUp": "Configurazione in corso...",
    "touchSensorOrLook": "Tocca il sensore o guarda il tuo dispositivo per autenticarti",
    "tryAgain": "Riprova",
    "use": "Usa {{name}}",
    "usePasswordInstead": "Usa invece la password",
    "type": {
      "iris": "Scansione dell'iride",
      "generic": "Biometrico"
    },
    "usePasscode": "Usa il codice di accesso",
    "authenticatePrompt": "Autenticati per continuare",
    "verifyToEnablePrompt": "Verifica per abilitare il login biometrico",
    "error": {
      "initFailed": "Inizializzazione dell'autenticazione biometrica non riuscita",
      "notSupported": "Autenticazione biometrica non supportata",
      "lockout": "Troppi tentativi non riusciti. Riprova più tardi.",
      "authFailed": "Autenticazione fallita",
      "enableFailed": "Attivazione dell'autenticazione biometrica non riuscita",
      "disableFailed": "Disattivazione dell'autenticazione biometrica non riuscita"
    }
  },
  "sponsorships": {
    "offer": {
      "fallbackCompany": "Il tuo sponsor",
      "headline": "{{company}} vorrebbe sponsorizzare il tuo viaggio",
      "subheadline": "Accetta per sbloccare l'intera esperienza Pro — senza alcun costo per te.",
      "loading": "Caricamento dettagli dell'offerta…",
      "unlocks": {
        "title": "Cosa include la sponsorizzazione",
        "checkup": "Valutazione CheckUp completa",
        "teleportal": "Playbook di relocation TelePortal",
        "qultureup": "Integrazione culturale QultureUp",
        "care": "Care per il viaggio di immigrazione",
        "passport": "Passport — il tuo record portatile"
      },
      "route": "Percorso: {{from}} → {{to}}",
      "declineNote": "Se rifiuti, l'azienda verrà automaticamente rimborsata. In ogni caso, manterrai il tuo accesso di base.",
      "declineCta": "Rifiuta",
      "acceptCta": "Accetta sponsorizzazione",
      "decline": {
        "title": "Rifiutare questa sponsorizzazione?",
        "body": "{{company}} sarà rimborsato per intero. Puoi comunque completare il tuo CheckUp sul livello base.",
        "reasonLabel": "Dì a {{company}} perché (opzionale)",
        "cancel": "Annulla",
        "confirmCta": "Rifiuta comunque",
        "bodyKeepsAccess": "{{company}} sarà rimborsata per intero. Il tuo percorso resta esattamente com'è."
      },
      "accepted": {
        "toast": "Benvenuto a bordo! Il tuo viaggio è ora completamente sponsorizzato."
      },
      "declined": {
        "toast": "Sponsorizzazione rifiutata. {{company}} è stata rimborsata."
      },
      "errors": {
        "load": "Non siamo riusciti a caricare questa offerta di sponsorizzazione.",
        "accept": "Impossibile accettare la sponsorizzazione in questo momento.",
        "decline": "Impossibile rifiutare la sponsorizzazione in questo momento.",
        "notOpen": "Questa offerta non è più disponibile: ha già ricevuto una risposta o è stata ritirata."
      },
      "dedicatedNote": "{{company}} sponsorizzerà un nuovo percorso tutto tuo su questa rotta. Il tuo percorso attuale resta com'è, con le aziende che già lo seguono.",
      "takeover": {
        "subheadline": "{{company}} coprirà questo percorso da ora in poi, senza costi per te.",
        "pro": {
          "title": "Hai già l'accesso completo con Pro",
          "body": "{{company}} prende in carico questo percorso. Il tuo Pro continua a coprire gli altri percorsi, e questo torna al tuo Pro se la sponsorizzazione viene annullata."
        },
        "paid": {
          "title": "Hai già pagato questo percorso",
          "refund": "{{company}} lo prende in carico e ti rimborsiamo {{amount}}, la parte non usata dello sblocco del percorso, sul tuo metodo di pagamento originale. I rimborsi arrivano di solito entro 5–10 giorni lavorativi.",
          "noRefund": "{{company}} lo prende in carico. Non resta nulla da rimborsare dello sblocco del percorso."
        },
        "declineNote": "Se rifiuti, l'azienda viene rimborsata automaticamente e il tuo percorso resta esattamente com'è."
      },
      "card": {
        "eyebrow": "Offerta di sponsorizzazione",
        "detail": "Il tuo percorso verso {{country}}",
        "detailDedicated": "Un nuovo percorso tutto tuo verso {{country}}",
        "review": "Vedi offerta",
        "actionFailed": "Operazione non riuscita. Controlla la connessione e riprova."
      },
      "notNow": "Non ora",
      "deferredUntil": "Hai rimandato questa offerta per ora. Ti aspetta qui finché non decidi e torna nella Home il {{date}}.",
      "list": {
        "title": "{{company}} vuole sponsorizzarti",
        "kind": "Sponsorizzazione",
        "sent": "Inviata il {{date}}"
      }
    }
  },
  "business": {
    "activity": {
      "title": "Attività",
      "subtitle": "Tutto ciò che accade tra i tuoi talenti",
      "empty": "Nessuna attività ancora",
      "untitled": "Attività"
    },
    "pipeline": {
      "stages": {
        "acquisition": "Acquisizione",
        "vetting": "Verifica",
        "mobility": "Mobilità",
        "integration": "Integrazione",
        "adaptation": "Adattamento",
        "care": "Care",
        "evidence": "Prove",
        "sponsored": "Sponsorizzato",
        "pending_invite": "Invito in sospeso",
        "archived": "Archiviato",
        "cohort_assigned": "Coorte assegnata",
        "unknown": "Sconosciuto"
      },
      "talentActions": "Azioni sui talenti"
    },
    "about": {
      "aboutUs": "Chi siamo",
      "backToDashboard": "Torna alla dashboard",
      "heroCare": "Gestione checkpoint Care e monitoraggio del benessere",
      "heroCheckup": "Risultati CheckUp, punteggi MESH e approfondimenti iQulture per la verifica",
      "heroEvidence": "Evidenze Passport/IRR e risultati del programma",
      "heroPrograms": "Gestione del programma e del gruppo",
      "heroQultureup": "Progresso di adattamento QultureUp tramite Mondi, Percorsi e Missioni",
      "heroSponsored": "Allocazioni e fatturazione del viaggio sponsorizzato",
      "heroTeleportal": "Progresso TelePortal attraverso i percorsi Legale, Viaggio e Setup",
      "heroes": "Eroi",
      "heroesDesc": "Incontra gli eroi dietro Tonnie — il team dedicato a trasformare la mobilità globale dei talenti.",
      "learnMore": "Scopri di più su Tonnie Business",
      "platformOverview": "Panoramica della piattaforma",
      "platformOverviewDesc": "La nostra piattaforma aiuta le aziende a gestire l'intero ciclo di vita della mobilità dei talenti — dalla ricerca e selezione al trasferimento e assistenza continua.",
      "termsAndPrivacy": "Termini e privacy",
      "title": "Informazioni",
      "tonnieBusiness": "Tonnie Business",
      "tonnieBusinessDesc": "Tonnie Business è una piattaforma completa per gestire la mobilità internazionale dei talenti, le assunzioni e i programmi di integrazione.",
      "version": "Versione {{version}}"
    },
    "adaptationPage": {
      "active": "Attivo",
      "activeFilter": "Attivo",
      "activeTab": "Attivo",
      "archivedTab": "Archiviato",
      "activelyLearning": "Apprendimento attivo",
      "attentionReason": {
        "inactive": "Nessuna attività da oltre 2 settimane",
        "declining": "Attività in calo",
        "not_begun": "Valutazione completata — nessuna missione ancora",
        "streak_at_risk": "Serie in procinto di interrompersi"
      },
      "levels": {
        "beginner": "Principiante",
        "intermediate": "Intermedio",
        "advanced": "Avanzato"
      },
      "clearFilters": "Cancella filtri",
      "coach": "Coaching",
      "errors": {
        "messageTooShort": "Il messaggio deve contenere almeno 5 caratteri",
        "messageTooLong": "Il messaggio deve contenere 500 caratteri o meno"
      },
      "nudge": "Promemoria",
      "nudgeAria": "Invia un rapido nudge a {{name}}",
      "sendCoachAria": "Invia messaggio di coaching a {{name}}",
      "sendMessage": "Invia messaggio",
      "streakAtRisk": "Serie a rischio",
      "talentRowActionsAria": "Azioni per {{name}}",
      "tryAdjustFilters": "Prova a modificare la tua ricerca o i filtri",
      "view": "Visualizza",
      "viewTalentAria": "Visualizza i dettagli per {{name}}",
      "aiCoachDesc": "Coaching suggerito per ogni talento, in base ai progressi in QultureUp",
      "aiCoachRecommendations": "Raccomandazioni AI coach",
      "alertDescription": "{{inactive}} talenti inattivi, {{atRisk}} a rischio e {{streaks}} serie a rischio",
      "allCohorts": "Tutte le coorti",
      "allEngagement": "Tutti gli engagement",
      "allTalents": "Tutti i talenti",
      "atRiskExcl": "A rischio!",
      "atRiskFilter": "A rischio",
      "avgMiles": "Miles medie",
      "avgQultureUpCompletion": "Media QultureUp completamento",
      "boostMotivation": "Aumenta la motivazione",
      "celebrateTopPerformers": "Celebra i migliori performer",
      "coachAlert": "Avviso coach",
      "coachTip1": "I messaggi personalizzati hanno un coinvolgimento 3 volte superiore rispetto a quelli generici",
      "coachTip2": "I talenti che ricevono controlli settimanali hanno il 40% di probabilità in più di completare il loro viaggio",
      "coachTip3": "Celebrare piccoli successi aumenta la motivazione e la retention delle serie",
      "coachingCenter": "Centro di coaching",
      "coachingToolkit": "Toolkit di coaching",
      "coachingToolkitDesc": "Strumenti di coaching personalizzati e modelli di messaggio",
      "description": "Monitora e gestisci il progresso di adattamento dei talenti, le metriche di coinvolgimento e le intuizioni di coaching",
      "engagement": "Coinvolgimento",
      "engagementDistDesc": "Visualizza il coinvolgimento dei talenti a diversi livelli",
      "engagementDistribution": "Distribuzione del coinvolgimento",
      "engagementLegendAria": "Come vengono calcolati i gruppi di coinvolgimento",
      "engagementLegendTitle": "Come vengono calcolati i gruppi",
      "engagementLegendDesc": "Ogni talento è classificato in base a quanto recentemente è stato attivo, alla sua continuità giornaliera e a quante missioni ha completato questa settimana.",
      "quickActionsAllClear": "Tutto chiaro",
      "quickActionsAllClearDesc": "Non sono necessarie azioni di coaching al momento.",
      "coachingQueueTitle": "Coda di coaching",
      "coachingQueueDesc": "Ogni talento raggruppato per coinvolgimento — i più urgenti per primi.",
      "coachAllCount": "Coacha tutti i {{count}}",
      "noCoachingTalents": "Nessun talento in Adattamento ancora",
      "noCoachingTalentsDesc": "I talenti appariranno qui una volta che iniziano il loro viaggio QultureUp.",
      "engagementTrends": "Apprendimento in sintesi",
      "engagementTrendsDesc": "A che punto sono i tuoi talenti questa settimana",
      "filterByCohort": "Filtra per coorte",
      "gentleNudge": "Gentile promemoria",
      "healthDashboard": "Dashboard della salute",
      "healthScore": "Punteggio di salute",
      "inactiveFilter": "Inattivo",
      "insights": "Approfondimenti",
      "messageFailed": "Invio del messaggio fallito",
      "messageSent": "{{type}} messaggio inviato a {{name}}",
      "miles": "Miles",
      "missions": "Missioni",
      "missionsThisWeek": "Missioni questa settimana",
      "motivateActiveLearners": "Motiva gli studenti attivi con nuove sfide",
      "needAttention": "Necessita attenzione",
      "needsEncouragement": "Necessita incoraggiamento",
      "noTalentsFound": "Nessun talento trovato",
      "notificationInApp": "Il talento riceverà una notifica nell'app",
      "overallProgress": "Progresso complessivo",
      "quickCoachActions": "Azioni di coaching veloci",
      "quickCoachActionsDesc": "Azioni con un clic per supportare i tuoi talenti",
      "quickNudgeSent": "Promemoria veloce inviato a {{name}}",
      "reachInactiveTalents": "Raggiungi talenti inattivi",
      "recognizeAchievements": "Riconosci i risultati",
      "saveStreaks": "Salva continuità",
      "score": "Punteggio",
      "searchTalents": "Cerca talenti...",
      "sendPersonalizedMessage": "Scegli un'azione, poi aggiungi una nota personale o invia il messaggio della tua azienda.",
      "sendWeeklyChallenge": "Invia sfida settimanale",
      "setGoals": "Imposta obiettivi",
      "showYouCare": "Mostra che ti interessa",
      "slowing": "Rallentando",
      "slowingDownFilter": "Rallentando",
      "streak": "Serie",
      "thriving": "Fiorente",
      "thrivingFilter": "Fiorente",
      "title": "Adattamento",
      "topPerformers": "Top performer",
      "topPerformersDesc": "Talenti con il massimo coinvolgimento e progresso",
      "worlds": "Mondi",
      "writeYourMessage": "Scrivi il tuo messaggio",
      "engagementDescriptions": {
        "thriving": "Altamente coinvolto, progresso costante",
        "active": "Attività regolare, progresso costante",
        "slowing": "Attività in diminuzione, potrebbe aver bisogno di incoraggiamento",
        "at_risk": "Coinvolgimento in calo, necessita di attenzione",
        "inactive": "Nessuna attività recente, attenzione urgente necessaria"
      },
      "engagementCriteria": {
        "thriving": "Una serie di giorni di {{thrivingStreak}}+ con forte slancio questa settimana",
        "active": "Attivo di recente con slancio settimanale costante",
        "slowing": "Inattivo da più di {{slowingDays}} giorni, o recente ma in calo di slancio",
        "at_risk": "Inattivo da più di {{atRiskDays}} giorni, o bloccato senza progressi questa settimana",
        "inactive": "Nessuna attività da {{inactiveDays}}+ giorni"
      },
      "coachingBandMessage": {
        "thriving": "Celebra il loro progresso per rafforzare l'abitudine.",
        "active": "Mantieni il slancio con una nuova sfida.",
        "slowing": "Un incoraggiamento tempestivo ora li tiene da scivolare ulteriormente.",
        "at_risk": "Contatta per rimuovere ostacoli e ricostruire il slancio.",
        "inactive": "Ri-engaggia con un check-in personale prima che si disimpegnino."
      },
      "coachingBandLabel": {
        "thriving": "Celebra i talenti fiorenti",
        "active": "Sfida i talenti attivi",
        "slowing": "Allena i talenti in rallentamento",
        "at_risk": "Allena i talenti a rischio",
        "inactive": "Allena i talenti inattivi"
      },
      "coachTipsTitle": "Suggerimenti per il coaching",
      "coachActions": {
        "encourage": "Incoraggia",
        "challenge": "Sfida",
        "checkin": "Registrati",
        "celebrate": "Celebra",
        "remind": "Ricorda"
      },
      "insightsRecommendations": {
        "topWorldRecommend": "Il Mondo di Esplorazione Culturale ha il massimo coinvolgimento — raccomandalo ai talenti in difficoltà",
        "sendReminders": "Invia promemoria",
        "celebrate": "Celebra",
        "recommend": "Raccomanda",
        "checkIn": "Registrati",
        "streaksAtRisk_one": "{{count}} talento sta per perdere la sua serie — invia un promemoria ora",
        "streaksAtRisk_other": "{{count}} talenti stanno per perdere le loro serie — invia promemoria ora",
        "thrivingCelebrate_one": "{{count}} talento sta fiorendo — considera di celebrare i suoi successi",
        "thrivingCelebrate_other": "{{count}} talenti stanno fiorendo — considera di celebrare i loro successi",
        "inactiveCheckIn_one": "{{count}} talento non effettua il login da oltre 2 settimane — potrebbe aver bisogno di un check-in",
        "inactiveCheckIn_other": "{{count}} talenti non hanno effettuato il login da oltre 2 settimane — potrebbero aver bisogno di un check-in"
      },
      "trendMetrics": {
        "activeLearners": "Apprendisti attivi",
        "weeklyMissions": "Missioni settimanali",
        "avgMiles": "Miles medie"
      },
      "noOneNeedsAttention": "Nessuno ha bisogno di attenzione immediata",
      "confirmBulkSend": "Invia {{count}}",
      "personalNote": "Nota personale (facoltativa)",
      "personalNoteHint": "Lascialo vuoto per inviare il messaggio di {{action}} della tua azienda, definito in Messaggi.",
      "ofTotal": "{{value}} di {{total}}",
      "viewAllInBand": "Vedi tutti ({{count}})",
      "dayStreak_one": "{{count}} giorno di fila",
      "dayStreak_other": "{{count}} giorni di fila",
      "engagementBandAria_one": "Mostra {{count}} talento {{band}}",
      "engagementBandAria_other": "Mostra {{count}} talenti {{band}}",
      "needsAttentionCount_one": "{{count}} necessita attenzione",
      "needsAttentionCount_other": "{{count}} necessitano attenzione",
      "milesCount_one": "{{count}} Mile",
      "milesCount_other": "{{count}} Miles",
      "talentCount_one": "{{count}} talento",
      "talentCount_other": "{{count}} talenti",
      "viewAllNeedingAttention_one": "Visualizza il {{count}} che necessita attenzione",
      "viewAllNeedingAttention_other": "Visualizza tutti i {{count}} che necessitano attenzione",
      "confirmBulkTitle_one": "Inviare {{count}} messaggio di coaching?",
      "confirmBulkTitle_other": "Inviare {{count}} messaggi di coaching?",
      "confirmBulkDescription_one": "Stai per inviare \"{{action}}\" a {{count}} talento. Riceverà una notifica nella propria app mobile.",
      "confirmBulkDescription_other": "Stai per inviare \"{{action}}\" a {{count}} talenti. Ognuno riceverà una notifica nella propria app mobile.",
      "searchTalentsLabel": "Cerca talenti"
    },
    "addTalentsWizard": {
      "addCohortToOrganize": "Aggiungi un nuovo gruppo per organizzare i talenti",
      "atsIntegration": "Integrazione ATS",
      "atsMethodDesc": "Collega il tuo sistema ATS e importa i candidati direttamente nel tuo pipeline. Sincronizza in tempo reale con i tuoi strumenti di reclutamento esistenti.",
      "biWeekly": "Ogni due settimane (prime 8 settimane)",
      "cancel": "Annulla",
      "chooseCohortForCandidates": "Scegli a quale gruppo aggiungere questi candidati",
      "chooseCohortForTalents": "Scegli a quale gruppo aggiungere questi talenti",
      "clear": "Cancella",
      "close": "Chiudi",
      "cohortCreated": "Gruppo \"{{name}}\" creato con successo",
      "cohortNamePlaceholder": "es. Q2 2024 — Ingegneri Backend",
      "cohortNameRequired": "Nome gruppo *",
      "cohortsCanExistWithoutProgram": "I gruppi possono esistere senza un programma. I percorsi sono definiti per talento quando si sponsorizza.",
      "connectAdditionalATS": "Puoi connettere sistemi ATS aggiuntivi dalle impostazioni delle tue integrazioni.",
      "createCohortButton": "Crea cohorte",
      "createCohortDesc": "Crea un nuovo gruppo. Puoi assegnarlo a un programma in seguito, o lasciarlo non assegnato.",
      "createNewCohort": "Crea nuovo gruppo",
      "createNewProgram": "Crea nuovo programma",
      "createProgramButton": "Crea programma",
      "createProgramDesc": "Crea un nuovo programma per organizzare le tue iniziative di assunzione internazionali.",
      "defaultFeedbackCadence": "Cadenza di feedback predefinita",
      "describeProgramPlaceholder": "Descrivi gli obiettivi e l'ambito del programma...",
      "descriptionOptional": "Descrizione (opzionale)",
      "deselectAll": "Deseleziona tutto",
      "downloadTemplateCsv": "Scarica modello CSV",
      "dropFileHere": "Trascina il tuo file qui o clicca per sfogliare",
      "email": "Email",
      "enterProgramName": "Inserisci un nome per il programma",
      "errorReason": "Motivo",
      "errorReason_duplicate": "Duplica",
      "errorReason_invalid": "Non valido",
      "errorReason_system": "Errore di sistema",
      "errors": {
        "cohortNameRequired": "Il nome della coorte è obbligatorio",
        "createCohortFailed": "Impossibile creare il gruppo. Riprova.",
        "createProgramFailed": "Impossibile creare il programma. Riprova.",
        "emptyFile": "Il file è vuoto o non contiene righe di dati",
        "endDateInvalid": "Inserisci una data di fine valida",
        "malformedFile": "Non siamo riusciti a leggere questo file. Prova a salvarlo come .csv e ricaricalo.",
        "mustMapEmail": "Mappa almeno una colonna a Email prima di continuare",
        "mustMapName": "Mappa almeno una colonna a Nome (o Nome completo) prima di continuare",
        "noValidRows": "Nessuna riga ha superato la validazione. Risolvi gli errori sopra e riprova.",
        "programNameRequired": "Il nome del programma è obbligatorio",
        "selectCohort": "Seleziona un gruppo prima di continuare",
        "startDateInvalid": "Inserisci una data di inizio valida",
        "startDateRequired": "La data di inizio è obbligatoria",
        "systemFailure": "Qualcosa è andato storto. Riprova.",
        "tooManyRows": "I file sono limitati a {{max}} righe. Dividi il tuo file e riprova.",
        "unsupportedFile": "Carica un file .csv, .xlsx o .xls",
        "planLimit": "Il piano gratuito consente fino a 100 candidati. Passa a Enterprise per aggiungerne di più.",
        "fileTooLarge": "Il file è più grande di 10 MB. Riduci il file e riprova.",
        "cohortAtCapacity": "Questa coorte è al completo ({{max}} talenti). Scegli un'altra coorte o aumentane il limite.",
        "programAtCapacity": "Questo programma è al completo ({{max}} talenti). Scegli un altro programma o aumentane il limite."
      },
      "excelColumn": "Colonna Excel",
      "excelCsvUpload": "Caricamento Excel/CSV",
      "excelMethodDesc": "Importa talenti da file di fogli di calcolo. Supporta i formati Excel e CSV con mappatura automatica delle colonne.",
      "expectedTalentCount": "Conteggio talenti previsto (opzionale)",
      "fieldLabels": {
        "email": "Email",
        "firstName": "Nome",
        "ignore": "Ignora",
        "lastName": "Cognome",
        "location": "Posizione",
        "name": "Nome completo (verrà diviso)",
        "role": "Ruolo",
        "skills": "Competenze"
      },
      "fileReady": "File pronto!",
      "fillRequiredFields": "Compila tutti i campi obbligatori",
      "firstName": "Nome",
      "fixValidationErrors": "Si prega di correggere gli errori di validazione prima di continuare",
      "importCandidatesFrom": "Importa candidati direttamente da {{name}}",
      "importMethodLabel": "Metodo di importazione",
      "importSummary": "Riepilogo importazione",
      "invalidEmail": "Email non valida",
      "invalidFileType": "Si prega di caricare un file Excel o CSV valido",
      "inviteToVetting": "Invita alla selezione",
      "inviteToVettingFailed": "Impossibile invitare i talenti",
      "lastName": "Cognome",
      "location": "Posizione",
      "mapColumnsInstruction": "Mappa le colonne di Excel ai campi Tonnie. Prime 5 righe mostrate:",
      "mapTo": "Mappa A",
      "match": "corrispondere",
      "missingName": "Nome mancante",
      "monthly": "Mensile (mesi 3-6)",
      "name": "Nome",
      "needDifferentATS": "Hai bisogno di connettere un ATS diverso?",
      "noDataYet": "Nessun dato ancora — i talenti in questa fase popoleranno questa vista",
      "noProgramUnassigned": "Nessun programma (non assegnato)",
      "plusMore": "+ Altro",
      "poolMethodDesc": "Sfoglia e aggiungi talenti dal tuo Tonnie Talent Pool direttamente nella tua pipeline.",
      "programCreated": "Programma \"{{name}}\" creato con successo",
      "programNamePlaceholder": "es. Iniziativa Talenti Tecnologici",
      "programNameRequired": "Nome del programma *",
      "programOptional": "Programma (opzionale)",
      "quarterly": "Trimestrale (mesi 6-12)",
      "readyToImport": "Pronto per importare talenti",
      "readyToMapColumns": "Pronto per mappare le colonne",
      "requiredFields": "Nome ed Email sono campi obbligatori",
      "resultDuplicates": "Duplicati",
      "resultFailed": "Fallito",
      "resultImported": "Importato",
      "resultPartial": "Alcuni talenti non sono stati importati",
      "role": "Ruolo",
      "samplePreview": "Valore di esempio",
      "searchPlaceholder": "Cerca per nome, ruolo o posizione...",
      "select": "Seleziona",
      "selectATSError": "Seleziona un sistema ATS",
      "selectAllCount": "Seleziona tutti ({{count}})",
      "selectCandidateError": "Seleziona almeno un candidato",
      "selectCohortError": "Si prega di selezionare una coorte",
      "selectFile": "Seleziona file",
      "selectProgramOptional": "Seleziona programma (opzionale)",
      "selectedLabel": "Selezionato",
      "startDateRequired": "Data di inizio *",
      "status": "Stato",
      "stepATS": "ATS",
      "stepCohort": "Coorte",
      "stepConfirm": "Conferma",
      "stepMap": "Mappa",
      "stepMethod": "Metodo",
      "stepReview": "Revisione",
      "stepSelect": "Seleziona",
      "stepUpload": "Carica",
      "supportsFileTypes": "Supporta file Excel (.xlsx, .xls) e CSV fino a 10MB",
      "targetArrivalDate": "Data di arrivo target",
      "toastImportedHint": "Apri il Pipeline > colonna Acquisizione e clicca su Invia invito per la selezione quando sei pronto per inviare un'email a ciascun candidato.",
      "toastNothingImported": "Nessun talento importato",
      "totalCandidates": "Candidati totali",
      "totalTalents": "Talenti totali",
      "unassigned": "Non assegnato",
      "uploadDifferentFile": "Carica un file diverso",
      "vettingNotStarted": "La selezione non è ancora iniziata per questo talento",
      "whatHappensNext": "Cosa succede dopo?",
      "whatHappensNextDesc": "Dopo l'importazione, i talenti appariranno nella fase di Acquisizione. Puoi quindi invitarli a CheckUp e sponsorizzare quelli pronti.",
      "addingToPill": "Aggiungendo a: {{name}}",
      "guard": {
        "archivedTitle": "Questo gruppo è archiviato",
        "pausedTitle": "Questo gruppo è in pausa",
        "programPausedTitle": "Il programma principale è in pausa",
        "archivedBody": "I gruppi archiviati non possono accettare nuovi talenti. Ripristina prima il gruppo per invitare persone.",
        "pausedBody": "I gruppi in pausa non possono accettare nuovi talenti. Riprendi prima il gruppo per invitare persone.",
        "programPausedBody": "Il programma principale è in pausa. Riprendi il programma per iniziare ad accettare nuovi talenti in questo gruppo.",
        "cohortPill": "Gruppo: {{name}}"
      },
      "issues": {
        "emailInvalid": "Email non valida o mancante",
        "emailDuplicate": "Duplicato della riga {{row}}",
        "nameMissing": "Nome mancante",
        "textTooLong": "{{field}} supera i {{max}} caratteri",
        "skillsTooMany": "Più di {{max}} competenze",
        "skillTooLong": "Una competenza supera i {{max}} caratteri"
      },
      "candidatesAttached_one": "{{count}} candidato associato al gruppo",
      "candidatesAttached_other": "{{count}} candidati associati al gruppo",
      "candidatesSelected_one": "{{count}} candidato selezionato",
      "candidatesSelected_other": "{{count}} candidati selezionati",
      "candidatesWillBeAdded_one": "{{count}} candidato sarà aggiunto a {{cohort}}",
      "candidatesWillBeAdded_other": "{{count}} candidati saranno aggiunti a {{cohort}}",
      "candidatesWillBeAddedVetting_one": "{{count}} candidato sarà aggiunto al gruppo selezionato e potrà essere invitato ad avviare la selezione.",
      "candidatesWillBeAddedVetting_other": "{{count}} candidati saranno aggiunti al gruppo selezionato e potranno essere invitati ad avviare la selezione.",
      "errorsCount_one": "{{count}} errore",
      "errorsCount_other": "{{count}} errori",
      "errorsTitle_one": "{{count}} riga necessita di attenzione",
      "errorsTitle_other": "{{count}} righe necessitano di attenzione",
      "inviteToVettingSent_one": "{{count}} talento invitato alla selezione",
      "inviteToVettingSent_other": "{{count}} talenti invitati alla selezione",
      "ofShown_one": "(di {{count}} mostrato)",
      "ofShown_other": "(di {{count}} mostrati)",
      "readyToAddCandidates_one": "Pronto per aggiungere {{count}} candidato dal tuo ATS",
      "readyToAddCandidates_other": "Pronto per aggiungere {{count}} candidati dal tuo ATS",
      "readyToImportTalents_one": "Pronto per importare {{count}} talento dal tuo foglio di calcolo",
      "readyToImportTalents_other": "Pronto per importare {{count}} talenti dal tuo foglio di calcolo",
      "resultAllImported_one": "{{count}} talento importato",
      "resultAllImported_other": "Importati {{count}} talenti",
      "reviewImportedData_one": "Rivedi i dati importati ({{count}} riga)",
      "reviewImportedData_other": "Rivedi i dati importati ({{count}} righe)",
      "rowsDetected_one": "{{count}} riga rilevata",
      "rowsDetected_other": "{{count}} righe rilevate",
      "talentsCount_one": "{{count}} talento",
      "talentsCount_other": "{{count}} talenti",
      "talentsImported_one": "{{count}} talento importato",
      "talentsImported_other": "{{count}} talenti importati",
      "talentsWillBeImported_one": "{{count}} talento sarà importato in {{cohort}}",
      "talentsWillBeImported_other": "{{count}} talenti saranno importati in {{cohort}}",
      "talentsWillBeImportedAcquisition_one": "{{count}} talento sarà importato nel gruppo selezionato e apparirà nella fase di Acquisizione.",
      "talentsWillBeImportedAcquisition_other": "{{count}} talenti saranno importati nel gruppo selezionato e appariranno nella fase di Acquisizione.",
      "toastDuplicates_one": "{{count}} già nella tua azienda",
      "toastDuplicates_other": "{{count}} già nella tua azienda",
      "toastFailed_one": "{{count}} fallito",
      "toastFailed_other": "{{count}} falliti",
      "toastImported_one": "{{count}} aggiunto all'acquisizione",
      "toastImported_other": "{{count}} aggiunti all'acquisizione",
      "validCount_one": "{{count}} valido",
      "validCount_other": "{{count}} validi",
      "mapColumnTo": "Mappa la colonna {{column}} su"
    },
    "sponsor": {
      "modal": {
        "title": "Sponsorizza il viaggio di {{firstName}}",
        "subtitle": "Attiva l'esperienza completa di Tonnie per questo talento.",
        "steps": {
          "recap": "Riepilogo",
          "pricing": "Prezzi",
          "message": "Messaggio",
          "review": "Revisione"
        },
        "step1": {
          "noCheckup": "CheckUp in attesa — il punteggio apparirà una volta che {{firstName}} completa la valutazione.",
          "craHeading": "Profilo di rischio",
          "verdictHeading": "Perché sponsorizzare ora",
          "verdict": {
            "pro": "Candidato PRO forte. La sponsorizzazione sblocca l'intero viaggio per un'assunzione ad alta fiducia.",
            "potential": "Alto potenziale — la sponsorizzazione accelera il percorso dalla valutazione all'evidenza.",
            "emerging": "Segnale emergente — la sponsorizzazione consente una valutazione completa attraverso tutti e cinque gli eroi."
          },
          "unlocksHeading": "Cosa sblocca la sponsorizzazione",
          "unlocksFootnote": "Una volta che {{firstName}} accetta, tutti e cinque gli eroi si attivano.",
          "continueCta": "Continua ai prezzi"
        },
        "step2": {
          "heading": "Prezzi",
          "planNameFree": "Pagamento a consumo",
          "planNameEnterprise": "Tariffa Enterprise",
          "subtitle": "Addebito una tantum — rimborso proporzionale se cancelli in seguito.",
          "monthlyRate": "Tariffa mensile",
          "duration": "Durata",
          "total": "Impegno totale",
          "billedOnce": "Addebitato una volta tramite Stripe",
          "heroes": {
            "checkup": "CheckUp",
            "teleportal": "TelePortal",
            "qultureup": "QultureUp",
            "care": "Care",
            "passport": "Passport"
          },
          "familyAccess": "Accesso familiare",
          "familyAccessHint": "Includi i membri della famiglia nel percorso",
          "refundHeading": "Rimborsabile su base proporzionale",
          "refundScenarios": {
            "decline": {
              "label": "Se rifiutano",
              "body": "rimborso automatico completo, nessuna azione necessaria."
            },
            "cancel": {
              "label": "Se annulli a metà",
              "body": "il rimborso è pari ai mesi rimanenti × tariffa mensile."
            },
            "lock": {
              "label": "Gli eroi si bloccano fino all'accettazione",
              "body": "nessun rischio prima che il talento accetti."
            }
          },
          "refundFootnote": "I rimborsi vengono elaborati automaticamente tramite Stripe.",
          "continueCta": "Continua a messaggiare",
          "durationMonths_one": "{{count}} mese",
          "durationMonths_other": "{{count}} mesi"
        },
        "step3": {
          "subtitle": "Tonnie invia un'email di attivazione curata con il link per accettare/rifiutare. Aggiungi una nota personale opzionale che apparirà nell'email sopra la call-to-action.",
          "customMessageLabel": "La tua nota (facoltativa)",
          "customMessagePlaceholder": "Benvenuto a bordo — ci piacerebbe averti con noi a {{destination}}.",
          "charsCounter": "{{count}} / {{max}}",
          "previewHeading": "Anteprima email",
          "previewSubheading": "Cosa riceverà realmente {{firstName}}",
          "previewAriaLabel": "Anteprima dell'email di attivazione che {{firstName}} riceverà",
          "previewDisclaimer": "Inviato automaticamente al successo del pagamento. {{firstName}} ha tempo illimitato per accettare.",
          "toneHint": {
            "concise": "Conciso",
            "warm": "Caloroso",
            "professional": "Dettagliato"
          },
          "chips": {
            "label": "Inserimenti rapidi",
            "destination": "Aggiungi destinazione",
            "destinationSnippet": "Non vediamo l'ora di averti con noi a {{destination}}.",
            "destinationAria": "Inserisci una frase sulla destinazione",
            "teamWelcome": "Aggiungi benvenuto dal team",
            "teamWelcomeSnippet": "L'intero team di {{company}} è con te.",
            "teamWelcomeAria": "Inserisci una frase di benvenuto dal team",
            "signoff": "Aggiungi firma",
            "signoffSnippet": "Non vediamo l'ora di costruire insieme questo percorso.",
            "signoffAria": "Inserisci una frase di firma personale"
          },
          "continueCta": "Rivedi e paga"
        },
        "step4": {
          "talentLabel": "Talento",
          "routeLabel": "Percorso",
          "pricingLabel": "Prezzi",
          "rateTimesMonths": "{{rate}}/mese × {{count}}",
          "messageLabel": "Nota di attivazione",
          "messageEmptyPlaceholder": "Il messaggio di attivazione predefinito di Tonnie sarà inviato.",
          "routeEmpty": "Impostato nel profilo del talento.",
          "routeUnknown": "Non impostato",
          "vatNote": "Le tasse (se presenti) sono calcolate in Stripe Checkout.",
          "previewToggle": "Anteprima dell'email di attivazione",
          "previewToggleOpen": "Nascondi anteprima email",
          "commitmentTitle": "Stai per impegnarti",
          "commitmentBody": "{{total}} oggi. Rimborso proporzionale disponibile durante il periodo di {{durationMonths}} mesi. {{firstName}} ha tempo illimitato per accettare.",
          "trustAriaLabel": "Segnali di fiducia nel pagamento",
          "trust": {
            "stripe": "Sicuro con Stripe",
            "refundable": "Rimborso proporzionale",
            "noExpiry": "Nessuna scadenza per il talento",
            "autoSent": "Email inviata automaticamente"
          },
          "nextTitle": "Cosa succede dopo",
          "next": {
            "s1": "Apriamo Stripe Checkout in questa scheda.",
            "s2": "Al successo del pagamento, {{firstName}} riceve automaticamente la tua email di attivazione.",
            "s3": "La carta passa a Sponsorizzato — In attesa di accettazione."
          },
          "payCta": "Sponsorizza e paga {{total}}"
        },
        "preview": {
          "fromLabel": "Da",
          "subject": "{{company}} vorrebbe sponsorizzare il tuo viaggio Tonnie",
          "greeting": "Ciao {{firstName}},",
          "introTail": "ha appena pagato per sponsorizzare il tuo intero viaggio Tonnie — in attesa della tua accettazione.",
          "unlocksHeading": "Cosa sblocchi se accetti",
          "heroes": {
            "checkup": "valutazione completa iQulture",
            "teleportal": "guida per visto, trasferimento e alloggio",
            "qultureup": "missioni di integrazione culturale",
            "care": "supporto al benessere durante il trasferimento",
            "passport": "il tuo registro portatile dei progressi"
          },
          "noCost": "Non ti costa nulla. Se rifiuti, {{company}} verrà automaticamente rimborsata e tu manterrai l'accesso di base.",
          "yourNoteHeading": "Una nota dal team",
          "ctaLabel": "Esamina e rispondi all'offerta di sponsorizzazione",
          "noExpiry": "Questa offerta ti aspetta — non ha scadenza. Prenditi il tempo necessario.",
          "signOff": "Benvenuto a bordo,",
          "signature": "Il team di Tonnie",
          "fallbackCompany": "La tua azienda"
        },
        "footer": {
          "back": "Indietro",
          "cancel": "Annulla",
          "peekPreview": "Dai un'occhiata all'email"
        },
        "errors": {
          "checkoutFailed": "Impossibile aprire Stripe Checkout. Riprova o contatta il supporto.",
          "customMessageTooLong": "La tua nota deve contenere 2000 caratteri o meno.",
          "planNotFound": "Impossibile trovare il piano di sponsorizzazione. Contatta l'assistenza.",
          "planMisconfigured": "Il piano di sponsorizzazione non è configurato correttamente. Contatta l'assistenza.",
          "discountUnavailable": "Questo sconto non è più disponibile. Controlla il prezzo e riprova.",
          "planLimitExceeded": "Hai raggiunto il limite del tuo piano. Passa a un piano superiore per sponsorizzare altri talenti.",
          "needsInvitation": "La tua azienda non ha ancora una relazione con questa persona, quindi non può essere sponsorizzata direttamente. Invitala prima dal Pool.",
          "inviteFromPool": "Invita dal Pool",
          "alreadySponsored": "Questo viaggio ha già una sponsorizzazione in corso, quindi non può essere sponsorizzato di nuovo finché non termina.",
          "sharedWithAnotherCompany": "Un'altra azienda segue questa persona su questo percorso, e un percorso sponsorizzato appartiene a una sola azienda. Puoi sponsorizzarla su un percorso tutto tuo sulla stessa rotta: lo accetta con la tua offerta.",
          "sponsoredByAnotherCompany": "Un'altra azienda sponsorizza già questo percorso.",
          "routeFull": "Questa persona ha già il massimo di percorsi per una rotta, quindi non è possibile crearne uno nuovo per te. Può prima archiviarne uno.",
          "sponsorDedicated": "Sponsorizza su un percorso dedicato",
          "notSponsorable": "Questo percorso è già finanziato in un modo che una sponsorizzazione aziendale non può rilevare, quindi non è stato addebitato nulla."
        }
      },
      "return": {
        "verifyingPayment": "Conferma il tuo pagamento…",
        "paymentFailed": "Il pagamento non è stato confermato",
        "paymentFailedDescription": "Tonnie non ha ricevuto una sessione di pagamento Stripe Checkout. Se hai completato il pagamento, aggiorna tra un momento — i webhook possono impiegare alcuni secondi per arrivare. In caso contrario, riprova dal cassetto di Vetting.",
        "backToVetting": "Torna alla verifica",
        "stepConfirm": {
          "title": "Sponsorizzazione pagata — in attesa di accettazione",
          "subtitleHint": "Il talento resta in Verifica, segnato come “Sponsorizzazione offerta”, finché non accetta.",
          "headline": "Sponsorizzazione pagata — email di attivazione inviata",
          "awaitingTitle": "In attesa dell'accettazione del talento",
          "body": "Il talento riceverà un'email e potrà accettare o rifiutare. Passa a Sponsorizzato quando accetta; se rifiuta, vieni rimborsato automaticamente. Fino ad allora lo trovi in Verifica, dove puoi reinviare l'offerta o abbandonarla.",
          "backToVetting": "Torna alla verifica",
          "viewTalent": "Visualizza talento",
          "resendCta": "Reinvia email di attivazione",
          "resendSuccess": "Email di attivazione reinviata.",
          "resendAlready": "Email di attivazione è già stata inviata — nessun duplicato inviato."
        },
        "errors": {
          "missingSponsorship": "Tonnie sta ancora confermando il pagamento. Aggiorna tra pochi secondi e riprova.",
          "resendFailed": "Impossibile reinviare l'email di attivazione."
        }
      }
    },
    "talentDetail": {
      "loading": "Caricamento…",
      "viewFullVettingReport": "Visualizza rapporto di verifica completo",
      "header": {
        "couple": "Coppia",
        "familyWithKids": "Famiglia +{{count}}",
        "singleParent": "Famiglia monogenitoriale +{{count}}",
        "openLinkedIn": "Apri profilo LinkedIn",
        "solo": "Solo",
        "sponsorCta": "Sponsorizza questo talento"
      },
      "iqultureBlock": {
        "ariaLabel": "Punteggio iQulture {{score}} su 100, livello {{tier}}",
        "label": "iQulture"
      },
      "kebab": {
        "label": "Altre azioni"
      },
      "insights": {
        "vettingInsights": "Il verdetto di Tonnie a colpo d'occhio — punteggio, fondamenti di MESH, rischi culturali e prove fondamentali in un dashboard decisionale.",
        "vettingMesh": "Motivazione, inglese, competenze trasversali, competenze tecniche — i quattro segnali su cui si basa ogni decisione di sponsorizzazione sicura.",
        "vettingArchetypes": "Gli archetipi culturali rivelano come {{name}} si adatta. Gli archetipi a basso rischio sono le tue scommesse più sicure per la sponsorizzazione.",
        "vettingPillars": "Ogni pilastro è valutato indipendentemente con bandiere verdi, bandiere rosse e prove — la traccia di audit dietro il punteggio iQulture.",
        "vettingSkills": "Cosa porta {{name}} sul tavolo: competenze trasversali, competenze tecniche e l'adattamento culturale.",
        "vettingPitch": "{{name}}'s 60-second pitch — vedi loro con le proprie parole prima di sponsorizzare.",
        "vettingProfile": "Identità, background, contesto familiare — il profilo completo che {{name}} ha costruito su Tonnie.",
        "vettingActivity": "Ogni segnale catturato da Tonnie: messaggi inviati, transizioni di fase, traguardi degli eroi.",
        "sponsoredOverview": "Dove si trova {{name}} ora nel loro viaggio di trasferimento.",
        "sponsoredVetting": "Perché hai sponsorizzato {{name}}: il loro punteggio iQulture e le prove MESH.",
        "sponsoredMobility": "Legale e documenti, sistemazione locale, viaggio e logistica — tre percorsi di mobilità. Un blocco qui ritarda tutto il resto.",
        "sponsoredAdaptation": "QultureUp trasforma lo shock culturale in adattamento misurabile. La coerenza batte le corse.",
        "sponsoredCare": "La stabilità è il successo sponsorizzato. Il check-in economico di oggi previene il recupero costoso di domani.",
        "sponsoredEvidence": "Prova tangibile del viaggio di {{name}}: badge, miglia, traguardi.",
        "sponsoredActivity": "Segnale dal vivo da ogni eroe — la risposta a 'cosa è successo?' di cui gli amministratori hanno sempre bisogno."
      },
      "toneRibbon": {
        "label": "Tonnie raccomanda",
        "phase": {
          "invited": "Invitato",
          "started": "CheckUp in corso",
          "submitted": "CheckUp inviato",
          "scored": "Punteggiato",
          "verdict": "Pronto per il verdetto"
        },
        "tone": {
          "green": "Adatto — procedere con fiducia",
          "amber": "Alcuni caveat — rivedere le intuizioni prima di sponsorizzare",
          "red": "Preoccupazioni significative — leggere attentamente i segnali",
          "neutralAwaiting": "In attesa del segnale CheckUp",
          "neutralScored": "Punteggio disponibile — segnale qualitativo in attesa"
        }
      },
      "recommendation": {
        "green": {
          "title": "Tonnie raccomanda di sponsorizzare"
        },
        "amber": {
          "title": "Sponsorizza con occhi aperti"
        },
        "red": {
          "title": "Preoccupazioni significative"
        },
        "neutral": {
          "title": "Raccomandazione in attesa"
        }
      },
      "radar": {
        "tooltip": {
          "pillar": {
            "scoreAt": "A {{min}}–{{max}}",
            "evaluationQuestion": "Richieste cerebrali",
            "band": {
              "excellent": "Eccellente",
              "solid": "Solido",
              "mixed": "Misto",
              "weak": "Debole",
              "tier": "Livello {{tier}}"
            }
          },
          "archetype": {
            "persona": "Persona {{persona}}",
            "bucketLow": "Basso rischio ({{score}})",
            "bucketModerate": "Rischio moderato ({{score}})",
            "bucketHigh": "Alto rischio ({{score}})"
          }
        },
        "axis": {
          "ariaLabel": "Maggiore informazioni su {{label}}"
        }
      },
      "insightsTab": {
        "label": "Approfondimenti",
        "emptyTitle": "Le intuizioni si sbloccano una volta che CheckUp è valutato",
        "verdict": {
          "scoreSuffix": "/ 100",
          "badgeLabel": "badge iQulture",
          "scoreLabel": "punteggio iQulture",
          "confidenceBand": {
            "high": "Alta fiducia",
            "moderate": "Fiducia moderata",
            "low": "Bassa fiducia"
          },
          "confidenceTooltip": "La fiducia di Tonnie in questa valutazione: {{percent}}% (media sui 7 pilastri di valutazione).",
          "scoredToday": "Punteggiato oggi",
          "scoredAgo_one": "Punteggiato {{count}} giorni fa",
          "scoredAgo_other": "Punteggiato {{count}} giorni fa",
          "fallbackRationale": "Tonnie ha valutato questo profilo su MESH fondamenti e 10 archetipi culturali — le schede di supporto qui sotto contengono il dettaglio completo.",
          "rationaleStrong": "Forte {{strongest}} ({{strongestScore}}%) sostiene questo profilo.",
          "rationaleWeak": "Debolezza in {{weakest}} ({{weakestScore}}%) è la preoccupazione principale.",
          "rationaleAlert": "Avviso principale: {{alert}}",
          "eyebrow": "Raccomandazione di Tonnie"
        },
        "deepLink": {
          "openActivity": "Apri attività",
          "openArchetypes": "Apri archetipi",
          "openMesh": "Apri MESH",
          "openPillars": "Apri pilastri",
          "openPitch": "Apri pitch",
          "openSkills": "Apri competenze"
        },
        "deepDive": {
          "activity": "Cronologia di coinvolgimento e attività di questo profilo",
          "pillars": "Per la tracciabilità e le prove pilastro per pilastro",
          "pitch": "Per vedere questo candidato con le proprie parole",
          "skills": "Per l'inventario completo delle capacità",
          "title": "Dove guardare dopo"
        },
        "badgeAndScore": {
          "title": "punteggio iQulture & badge",
          "scoreLabel": "Punteggio",
          "badgeLabel": "Badge"
        },
        "mesh": {
          "title": "Fondamenti MESH",
          "subtitle": "I quattro segnali su cui si basa ogni sponsorizzazione sicura."
        },
        "conclusion": {
          "title": "Conclusione di Tonnie"
        },
        "snapshot": {
          "title": "A colpo d'occhio"
        },
        "cra": {
          "title": "Archetipi di rischio culturale",
          "severityChip": "{{low}} basso · {{moderate}} moderato · {{high}} alto",
          "severityTier": {
            "low": "basso",
            "moderate": "moderato",
            "high": "alto"
          },
          "radarSeries": "Punteggio di rischio",
          "radarA11yLabel": "Radar degli Archetipi di Rischio Culturale — {{summary}}",
          "empty": "Nessun dato sugli archetipi disponibile ancora.",
          "description_one": "Dove si colloca {{name}} sul {{count}} archetipo — più vicino al centro = minore rischio culturale.",
          "description_other": "Dove si colloca {{name}} tra i {{count}} archetipi — più vicino al centro = minore rischio culturale."
        },
        "pillars": {
          "title": "Valutazione dei pilastri",
          "description": "Tutti e sette i pilastri di valutazione su un radar — più vicino al bordo esterno significa un punteggio di pilastro più forte.",
          "confidenceChip": "{{band}} · fiducia media",
          "radarSeries": "Punteggio del pilastro",
          "radarA11yLabel": "Radar di valutazione del pilastro — {{summary}}",
          "legendUnknownCodes": "Le etichette degli assi sono codici dei pilastri. Apri la scheda Pilastri per il dettaglio completo."
        }
      },
      "tabs": {
        "testit": "TestIt",
        "activity": "Attività",
        "adaptation": "Adattamento",
        "archetypes": "Archetipi",
        "care": "Care",
        "checkup": "CheckUp",
        "evidence": "Prove",
        "insights": "Approfondimenti",
        "mesh": "MESH",
        "mobility": "Mobilità",
        "overview": "Panoramica",
        "pillars": "Piloni",
        "pitch": "Pitch",
        "profile": "Profilo",
        "skills": "Competenze",
        "vetting": "Verifica",
        "decisionRecords": "Registri delle decisioni",
        "stripLabel": "Sezioni del talento",
        "scrollPrevious": "Mostra sezioni precedenti",
        "scrollNext": "Mostra altre sezioni"
      },
      "communications": {
        "privacyNote": "Vedi cosa è stato inviato e cosa gli è successo, mai il contenuto, l'indirizzo a cui è andato né perché un messaggio non è stato consegnato.",
        "empty": "A questo talento non è stato ancora inviato nulla.",
        "loadError": "Impossibile caricare le comunicazioni. Riprova tra un momento.",
        "loadMore": "Carica messaggi precedenti",
        "channelEmail": "Email",
        "channelInApp": "Nell'app",
        "channelPush": "Push",
        "kindSystem": "Messaggio automatico",
        "kindAdmin": "Messaggio del tuo team",
        "kindInApp": "Notifica nell'app",
        "statusQueued": "In coda",
        "statusDispatched": "Inviato · esito non registrato",
        "statusSent": "Inviato",
        "statusDelivered": "Consegnato",
        "statusOpened": "Aperto",
        "statusFailed": "Non riuscito",
        "statusBounced": "Respinto",
        "statusNotDelivered": "Non consegnato",
        "deliveredAt": "Consegnato il {{date}}",
        "openedAt": "Aperto il {{date}}",
        "readInAppAt": "Letto su Tonnie il {{date}}"
      },
      "activity": {
        "empty": "Nessuna attività ancora — gli eventi appariranno qui quando il talento si muove attraverso il pipeline, completa un passo CheckUp, o riceve un messaggio.",
        "error": "Impossibile caricare l'attività. Riprova tra un momento.",
        "eventCount_one": "{{count}} evento",
        "eventCount_other": "{{count}} eventi",
        "loadMore": "Carica attività precedenti",
        "loadingMore": "Caricamento delle attività precedenti…",
        "live": "Dal vivo",
        "polling": "Aggiornamento periodico",
        "withheldBody": "Questo cittadino non ha condiviso la propria attività con la tua azienda. Gli eventi mostrati sono della tua azienda: passaggi nel pipeline e messaggi che hai inviato.",
        "eventCountPartial_one": "{{count}} evento solo della tua azienda",
        "eventCountPartial_other": "{{count}} eventi solo della tua azienda",
        "viewLabel": "Mostra",
        "view": {
          "all": "Tutto",
          "progress": "Progressi del talento",
          "pipeline": "Pipeline",
          "messages": "Messaggi"
        },
        "viewEmpty": "Ancora niente in questa vista.",
        "hero": {
          "checkup": "CheckUp",
          "mobility": "Mobilità",
          "adaptation": "Adattamento",
          "care": "Care",
          "evidence": "Prove",
          "pipeline": "Pipeline",
          "system": "Tonnie"
        },
        "actorNotRecorded": "Autore non registrato"
      },
      "sponsored": {
        "ribbon": {
          "status": {
            "awaitingAcceptance": "In attesa dell'accettazione del talento",
            "active": "Sponsorizzazione attiva",
            "cancelling": "Elaborazione del rimborso",
            "talentDeclined": "Il talento ha rifiutato",
            "refunded": "Rimborsato",
            "cancelled": "Annullato",
            "pastDue": "Pagamento scaduto",
            "failed": "Pagamento non riuscito",
            "unknown": "Nessuna sponsorizzazione attiva",
            "completed": "Completata"
          },
          "monthsRemaining_one": "{{count}} mo rimanenti",
          "monthsRemaining_other": "{{count}} mo rimanenti",
          "refundAtRisk": "{{amount}} rimborso a rischio",
          "acceptedOn": "Accettato {{date}}",
          "awaitingTalent": "In attesa dell'accettazione del talento"
        },
        "health": {
          "totalMonths_one": "{{count}} mo",
          "totalMonths_other": "{{count}} mo",
          "elapsed": "{{elapsed}} di {{total}} mesi trascorsi",
          "awaitingActivationSent": "Attivazione inviata {{ago}}",
          "awaitingBody": "Il talento ha ricevuto un'email con un link di attivazione. La sponsorizzazione si attiva nel momento in cui accettano.",
          "cancellingBody": "Il rimborso è in elaborazione. Stripe ci notificherà quando i fondi si sistemano; la sponsorizzazione passerà automaticamente a rimborsata.",
          "declinedBody": "Il talento ha rifiutato l'offerta di sponsorizzazione. È stato emesso un rimborso completo.",
          "closedBody": "La sponsorizzazione è chiusa e l'azienda non finanzia più questo percorso. Il talento mantiene il proprio accesso e può ancora completare il suo CheckUp.",
          "closedOn": "Chiuso {{date}}",
          "paymentFailedBody": "L'ultimo pagamento della sponsorizzazione non è riuscito. Aggiorna il metodo di pagamento per mantenere attivo il talento.",
          "refundAmount": "Importo del rimborso: {{amount}}",
          "completedBody": "La sponsorizzazione di 12 mesi è giunta al termine. Non viene rimborsato nulla; il talento prosegue con il proprio piano.",
          "completedOn": "Terminata il {{date}}"
        },
        "heroes": {
          "mobility": "Mobilità",
          "adaptation": "Adattamento",
          "care": "Care",
          "evidence": "Prove",
          "notStarted": "Non iniziato ancora"
        },
        "heroesGrid": {
          "mobilitySubtitle": "Visto, documenti, prontezza al viaggio",
          "adaptationSubtitle": "Preparazione culturale, missioni, streak",
          "careSubtitle": "Benessere, stabilità, interventi",
          "evidenceSubtitle": "Badge, timbri e miglia guadagnate",
          "blockers_one": "{{count}} blocco",
          "blockers_other": "{{count}} blocchi",
          "worldsLabel": "Mondi",
          "missionsLabel": "Missioni",
          "tracksLabel": "Tracce",
          "streakDays_one": "streak di {{count}} giorni",
          "streakDays_other": "streak di {{count}} giorni",
          "wellbeingLabel": "Punteggio di benessere",
          "lastCheckin": "Ultimo {{ago}}",
          "openInterventions_one": "{{count}} aperti",
          "openInterventions_other": "{{count}} aperti",
          "moodLabel": "Umore",
          "settlementLabel": "Liquidazione",
          "checkpointsValue": "{{done}}/{{total}} checkpoint",
          "docsReady": "Documenti pronti",
          "assessmentDone": "Valutazione completata",
          "awaitingData": "In attesa del primo check-in per vedere il punteggio di benessere.",
          "miles": "Miles",
          "badges": "Badge",
          "stamps": "Timbrature",
          "openTabHint": "Apri la scheda per sollecitare"
        },
        "activity": {
          "preview": {
            "title": "Attività recente",
            "viewAll": "Visualizza attività completa",
            "empty": "Nessun evento di sponsorizzazione ancora"
          }
        },
        "meta": {
          "familyAccess": "Accesso familiare",
          "familyAccessOn": "Abilitato",
          "familyAccessOff": "Disabilitato",
          "familyAccessOnToast": "Accesso familiare abilitato",
          "familyAccessOffToast": "Accesso familiare disabilitato",
          "familyAccessFailed": "Impossibile aggiornare l'accesso familiare",
          "startedAt": "Iniziato",
          "endsAt": "Termina",
          "amountPaid": "Importo pagato",
          "refundIfCancelledToday": "Rimborso se annullato oggi",
          "monthsLeft_one": "Manca {{count}} mese",
          "monthsLeft_other": "Mancano {{count}} mesi"
        },
        "banner": {
          "headline": "Il viaggio di {{name}}",
          "miles": "Miles di viaggio",
          "monthsLeft": "Mesi rimasti",
          "ctaViewVetting": "Visualizza valutazione",
          "ctaOpenMobility": "Apri mobilità",
          "ctaOpenAdaptation": "Apri adattamento",
          "ctaOpenCare": "Apri Care",
          "statusNotStarted": "Non iniziato",
          "statusLocked": "Bloccato",
          "statusDone": "Fatto",
          "day": "Giorno {{day}}",
          "dayLabel": "del percorso",
          "nextEyebrow": "Dove guardare ora"
        },
        "footer": {
          "action": {
            "resendActivation": "Reinvia email di attivazione",
            "abandon": "Abbandona sponsorizzazione",
            "cancel": "Annulla sponsorizzazione",
            "close": "Chiudi",
            "reoffer": "Riproponi sponsorizzazione",
            "updatePayment": "Aggiorna pagamento"
          },
          "refundProcessing": "Rimborso in elaborazione — nessuna azione mentre Stripe finalizza"
        },
        "smartNudge": {
          "sending": "Invio…",
          "cta": {
            "mobility": "Invia compito di mobilità",
            "adaptation": "Invia promemoria di adattamento",
            "care": "Invia check-in Care"
          },
          "sent": {
            "mobility": "Promemoria compito di mobilità inviato a {{name}}",
            "adaptation": "Promemoria di adattamento inviato a {{name}}",
            "care": "Richiesta di check-in Care inviata a {{name}}"
          },
          "errorMissingEmail": "Impossibile inviare — il talento non ha email registrata.",
          "templateMissing": "Il modello \"{{code}}\" non è configurato per questo inquilino. Aggiungilo o ripristinalo in Messaggi → Modelli.",
          "sendFailed": "Impossibile inviare il sollecito",
          "fallback": {
            "mobilityTask": "il tuo prossimo passo di mobilità",
            "adaptationMission": "la tua prossima missione QultureUp"
          }
        },
        "abandon": {
          "confirmTitle": "Abbandonare questa sponsorizzazione?",
          "confirmDescription": "{{name}} riceverà un rimborso completo e il viaggio tornerà ad accesso solo su invito. Questa azione non può essere annullata.",
          "confirmCancel": "Mantieni la sponsorizzazione",
          "confirmAction": "Abbandona e rimborsa",
          "successToast": "Sponsorizzazione abbandonata · rimborso emesso",
          "failedToast": "Impossibile abbandonare la sponsorizzazione"
        },
        "resendActivation": {
          "successToast": "Email di attivazione reinviata",
          "failedToast": "Impossibile reinviare l'email di attivazione"
        },
        "noSponsorshipTitle": "Nessuna sponsorizzazione attiva per questo viaggio",
        "noSponsorshipBody": "Il talento non ha alcuna riga di sponsorizzazione attiva per questo viaggio. Controlla la scheda Sponsorizzato nel pipeline se un viaggio diverso è sponsorizzato, o avvia un nuovo viaggio dal cassetto di Verifica.",
        "relative": {
          "justNow": "proprio adesso",
          "minAgo_one": "{{count}}m fa",
          "minAgo_other": "{{count}}m fa",
          "hourAgo_one": "{{count}}h fa",
          "hourAgo_other": "{{count}}h fa",
          "dayAgo_one": "{{count}}d fa",
          "dayAgo_other": "{{count}}d fa"
        },
        "alreadyAnswered": "Il talento ha già risposto a questa offerta di sponsorizzazione."
      },
      "nudge": {
        "cta": "Invia sollecito",
        "description": "Scegli un messaggio predefinito per svegliarli. Puoi sovrascrivere il corpo prima di inviare.",
        "failed": "Impossibile inviare il sollecito",
        "noTemplates": "Nessun modello configurato per questa fase. Aggiungine uno in Messaggi → Modelli.",
        "overrideHint": "Lascia vuoto per inviare il modello così com'è. Qualsiasi cosa tu scriva qui sostituisce il corpo del modello.",
        "overrideLabel": "Messaggio personalizzato (opzionale)",
        "overridePlaceholder": "Aggiungi una nota personale prima di inviare…",
        "recommended": "Consigliato",
        "send": "Invia sollecito",
        "sending": "Invio…",
        "sent": "“{{name}}” inviato",
        "templateLabel": "Modello",
        "title": "Invia un promemoria"
      },
      "mobility": {
        "blocked": "Bloccato",
        "blockers": {
          "onTrack": "In carreggiata — nessun blocco o attività scaduta.",
          "blockedTracks_one": "{{count}} carreggiata bloccata",
          "blockedTracks_other": "{{count}} carreggiate bloccate",
          "overdueTasks_one": "{{count}} attività scaduta",
          "overdueTasks_other": "{{count}} attività scadute"
        },
        "docStatus": {
          "pending": "In Attesa",
          "uploaded": "Caricato",
          "validated": "Convalidato",
          "rejected": "Rifiutato",
          "missing": "Mancante"
        },
        "documents": {
          "title": "Documenti",
          "otherTrack": "Altro",
          "certified": "Certificato",
          "expiringSoon": "In scadenza presto",
          "downloadAll": "Scarica tutto",
          "downloadSelected": "Scarica {{count}}",
          "downloadError": "Impossibile scaricare i documenti.",
          "select": "Seleziona documento",
          "withheldBody": "Questo cittadino non ha condiviso i propri documenti con la tua azienda. L'elenco qui sotto è ancora corretto: ciò che non può più essere scaricato sono i file stessi."
        },
        "error": "Impossibile caricare i dati di mobilità.",
        "header": {
          "title": "Viaggio di rilocazione",
          "subtitle": "Attività, documenti e traguardi in ogni carreggiata"
        },
        "noTracks": "Nessuna carreggiata di mobilità è ancora iniziata.",
        "nudge": "Invia promemoria di mobilità",
        "progress": "{{percent}}% completato",
        "taskStatus": {
          "pending": "Da fare",
          "in_progress": "In corso",
          "completed": "Completato",
          "blocked": "Bloccato",
          "skipped": "Saltato",
          "archived": "Archiviato"
        },
        "tasks": {
          "title": "Attività talento",
          "talent": "Talento",
          "otherTrack": "Altro",
          "blocking": "Bloccante",
          "blockedBy": "Bloccato da {{count}}",
          "overdue": "Scaduto",
          "certified": "Certificato",
          "docCount_one": "{{count}} documento",
          "docCount_other": "{{count}} documenti",
          "location": {
            "home_country": "Paese d'origine",
            "target_country": "Destinazione",
            "online": "Online",
            "either": "Qualsiasi"
          },
          "ownership": {
            "company": "Azienda",
            "government": "Governo",
            "dual": "Condiviso"
          }
        },
        "timeline": {
          "title": "Traguardi",
          "summary": "{{reached}} su {{total}} raggiunti",
          "reached": "Raggiunto"
        }
      },
      "adaptation": {
        "error": "Impossibile caricare i dati di adattamento.",
        "header": {
          "assessedOn": "Valutato il {{date}}",
          "miles": "Miles",
          "missions": "Missioni",
          "notAssessed": "Non valutato",
          "streak": "Serie",
          "streakDays": "{{count}}d",
          "timeLearning": "Tempo di apprendimento",
          "title": "Adattamento"
        },
        "overviewTab": "Panoramica",
        "tracksTab": "Mondi e carreggiate",
        "thisWeek": "Questa settimana",
        "ariaWeekly": "Grafico di coinvolgimento settimanale",
        "missionsProgress": "{{completed}} di {{total}} missioni",
        "tracksProgress": "{{completed}}/{{total}} carreggiate",
        "noWorlds": "Nessun mondo QultureUp avviato ancora.",
        "tracksTitle": "Mondi e carreggiate",
        "levelAll": "Tutti",
        "noTracksForLevel": "Nessuna carreggiata a questo livello.",
        "noMissions": "Nessuna missione in questa carreggiata ancora.",
        "recommendedNext": "Consigliato prossimo",
        "status": {
          "completed": "Completato",
          "in_progress": "In corso",
          "locked": "Bloccato",
          "not_started": "Non iniziato"
        },
        "suggest": "Suggerisci",
        "suggestionSent": "Suggerito “{{mission}}” — inviato via email",
        "worldsTitle": "Mondi",
        "missionsCount_one": "missione",
        "missionsCount_other": "missioni"
      },
      "evidence": {
        "error": "Impossibile caricare i dati delle prove.",
        "export": {
          "title": "Registro del viaggio",
          "description": "Esporta il registro completo del viaggio del talento come report PDF o file CSV.",
          "pdf": "Esporta PDF",
          "csv": "Esporta CSV"
        },
        "header": {
          "title": "Viaggio Passport",
          "subtitle": "Francobolli, badge e miglia guadagnate durante il viaggio",
          "miles": "Miles totali",
          "level": "Livello Citizen",
          "stamps": "Timbrature",
          "badges": "Badge",
          "thisWeek": "Questa settimana"
        }
      },
      "care": {
        "checkins": {
          "empty": "Nessun check-in finora.",
          "last30Days": "Ultimi 30 giorni",
          "lastCheckin": "Ultimo check-in {{date}}",
          "moodTrend": "Tendenza dell'umore",
          "privacyNote": "Le voci individuali sull'umore rimangono private per il talento — vengono mostrati solo frequenza e tendenza.",
          "streak": "Serie di giorni",
          "title": "Attività di check-in",
          "trend": {
            "down": "In calo",
            "stable": "Stabile",
            "up": "In aumento"
          }
        },
        "commitment": {
          "component": {
            "careResponsiveness": "rispondenza Care",
            "checkinConsistency": "Coerenza dei check-in",
            "engagementLevel": "Coinvolgimento",
            "integrationProgress": "Progresso dell'integrazione",
            "pillarStability": "Stabilità del pilastro",
            "tenureStability": "Stabilità della durata"
          },
          "empty": "L'Indice di Impegno apparirà una volta che il talento avrà check-in o checkpoint.",
          "history": {
            "empty": "Non abbastanza storico finora — la linea di tendenza appare dopo un secondo calcolo.",
            "range": "{{min}}–{{max}}",
            "title": "Storico dell'indice",
            "ariaLabel_one": "Storico dell'Indice di Impegno, {{count}} punto dati da {{min}} a {{max}}",
            "ariaLabel_other": "Storico dell'Indice di Impegno, {{count}} punti dati da {{min}} a {{max}}"
          },
          "level": {
            "at_risk": "A rischio",
            "champion": "Campione",
            "committed": "Impegnato",
            "engaged": "Coinvolto",
            "flight_risk": "Rischio di abbandono"
          },
          "noRisks": "Nessun segnale di rischio attivo.",
          "risks": "Segnali di rischio",
          "risksRestricted": "I segnali di rischio sono riservati in questa azienda. Rivolgiti a un amministratore se ti servono.",
          "title": "Indice di impegno",
          "trend": {
            "declining": "In declino",
            "improving": "Miglioramento",
            "stable": "Stabile"
          }
        },
        "checkpoints": {
          "empty": "Nessun checkpoint pianificato finora.",
          "status": {
            "cancelled": "Annullato",
            "completed": "Completato",
            "due": "Scadenza",
            "in_progress": "In corso",
            "overdue": "Scaduto",
            "scheduled": "Programmato",
            "skipped": "Saltato"
          },
          "title": "Checkpoint"
        },
        "error": "Impossibile caricare i dati di cura.",
        "header": {
          "title": "Care",
          "stage": "Fase: {{stage}}"
        },
        "pillars": {
          "concerns": "Preoccupazioni:",
          "empty": "Nessun pilastro di benessere finora.",
          "title": "Pilastri di benessere"
        },
        "interventions": {
          "empty": "Nessun intervento pianificato finora.",
          "loadError": "Impossibile caricare le interventi.",
          "past": "Passato",
          "retry": "Riprova",
          "subtitle": "Pianifica follow-up di cura ricorrenti o una tantum per questo talento.",
          "title": "interventi Care",
          "upcoming": "In Arrivo"
        },
        "withheldBody": "Questo cittadino non ha condiviso il proprio percorso Care con la tua azienda. Il punteggio di benessere, i pilastri e i checkpoint sono trattenuti. Gli interventi mostrati qui sotto sono il registro della tua azienda su ciò che ha inviato."
      },
      "consent": {
        "withheld": {
          "srLabel": "Non condiviso — trattenuto da questo cittadino",
          "tooltip": "Questo cittadino non ha condiviso questa informazione con la tua azienda. È trattenuta, non è zero.",
          "title": "Trattenuto dal cittadino",
          "body": "Questa informazione non è stata condivisa dal cittadino con la tua azienda. È trattenuta: non è zero e non manca.",
          "householdGroup": "Membro del nucleo familiare — nome trattenuto"
        }
      },
      "checkup": {
        "withheldBody": "Questo cittadino non ha condiviso il proprio CheckUp con la tua azienda. I punteggi, l'analisi MESH e l'analisi del pitch sono trattenuti: non mancano e non sono zero.",
        "completedOn": "CheckUp completato il {{date}}",
        "awaitingConsentBody": "{{name}} ha completato il CheckUp e non ha condiviso il risultato con la tua azienda. La decisione di condividerlo spetta al talento. Fino ad allora i punteggi, l'analisi MESH e l'analisi del pitch sono trattenuti: non mancano e non sono zero.",
        "withdrawnBody": "{{name}} ha smesso di condividere il risultato del CheckUp con la tua azienda. I punteggi, l'analisi MESH e l'analisi del pitch sono trattenuti: non mancano e non sono zero."
      }
    },
    "askTonnieServices": {
      "budgetLabel": "Fascia di budget (opzionale)",
      "budgetPlaceholder": "Se hai in mente una fascia di budget, ti preghiamo di condividerla...",
      "description": "Richiedi a Tonnie di gestire l'intero processo chiavi in mano (Pacchetto Tonnie). I Servizi Tonnie redigeranno una proposta per la tua approvazione.",
      "descriptionLabel": "Descrizione delle esigenze",
      "descriptionPlaceholder": "Descrivi le tue esigenze e requisiti specifici...",
      "scopes": {
        "adaptationDesc": "QultureUp e adattamento culturale",
        "adaptationLabel": "Adattamento",
        "careDesc": "Supporto post-arrivo e Care",
        "careLabel": "Care & stabilità",
        "hireDesc": "Acquisizione e sourcing di talenti",
        "hireLabel": "Assumi",
        "mobilityDesc": "Visto, viaggio e trasferimento",
        "mobilityLabel": "Mobilità",
        "sponsorDesc": "Decisioni di verifica e sponsorizzazione",
        "sponsorLabel": "Sponsor"
      },
      "serviceScopeHint": "Seleziona quali parti del processo desideri che Tonnie gestisca:",
      "serviceScopeLabel": "Ambito del servizio",
      "submitFailed": "Impossibile inviare la richiesta",
      "submitRequest": "Invia richiesta",
      "submitSuccess": "Richiesta inviata — i Servizi Tonnie ti contatteranno a breve",
      "submitting": "Invio in corso…",
      "timelineLabel": "Aspettative temporali",
      "timelinePlaceholder": "Quando hai bisogno che questo sia completato? Ci sono scadenze specifiche?",
      "title": "Chiedi i servizi di Tonnie",
      "whatHappensNextBody": "Tonnie I servizi esamineranno la tua richiesta e redigeranno una proposta (tariffa giornaliera / costo / pacchetto) per la tua approvazione. Una volta approvata, la modalità Pack di Tonnie sarà attivata e i progressi saranno riflessi nel tuo pipeline.",
      "whatHappensNextTitle": "Cosa succede dopo?"
    },
    "auth": {
      "backToSignIn": "Torna al login",
      "inviteRoleAdmin": "Admin",
      "inviteRoleMember": "Membro del team",
      "joinCompanySubtitle": "Crea il tuo account per unirti come {{role}}",
      "joinCompanyTitle": "Unisciti a {{company}}",
      "noAccess": {
        "acceptInvitation": "Accetta un invito",
        "contactAdmin": "Contatta il tuo admin",
        "description": "Sei connesso come {{email}}, ma questo account non ha ancora accesso a Tonnie Business.",
        "hint": "Chiedi a un compagno di squadra di invitarti, accetta un invito in sospeso o disconnettiti per utilizzare un altro account.",
        "signingOut": "Disconnessione in corso…",
        "switchAccount": "Disconnettiti e usa un altro account",
        "title": "Nessun accesso aziendale"
      },
      "signUp": "Registrati"
    },
    "billing": {
      "statusLabel": {
        "active": "Attivo",
        "pending": "In Attesa",
        "paid": "Pagato",
        "cancelling": "Cancellazione",
        "cancelled": "Annullato",
        "past_due": "Scaduto",
        "overdue": "Scaduto",
        "failed": "Fallito",
        "completed": "Completato"
      },
      "active": "Attivo",
      "activeSponsorships": "Sponsorizzazioni attive",
      "checkoutCancelled": "Checkout annullato",
      "checkoutSuccessPending": "Pagamento ricevuto — il tuo account verrà aggiornato a breve.",
      "checkoutSuccessVerified": "Pagamento confermato — il tuo account è stato aggiornato.",
      "checkoutVerifyError": "Abbiamo ricevuto il tuo pagamento ma non siamo riusciti a confermarlo in tempo reale. Ricarica tra un momento.",
      "coPilot": "CoPilot",
      "cohorts": "Cohorti",
      "description": "Il tuo piano, le sponsorizzazioni, le fatture e il metodo di pagamento",
      "downgradeDialog": {
        "confirmDowngrade": "Conferma il downgrade",
        "description": "Verifica cosa cambia prima di passare a un piano inferiore",
        "discountedRate": "Tariffa scontata",
        "keepEnterprise": "Mantieni Enterprise",
        "loseAccess": "Perderai l'accesso a:",
        "sponsorshipNote": "Nota: Le sponsorizzazioni attive continueranno al loro attuale tasso fino alla scadenza. Le nuove sponsorizzazioni saranno addebitate al tasso del piano gratuito.",
        "title": "Dialogo di downgrade",
        "unlimitedProgramsCohorts": "Cohorts di programmi illimitati",
        "unlimitedTeam": "Team illimitato"
      },
      "downgradeFailed": "Impossibile annullare l'abbonamento.",
      "downgradeSuccess": "Downgradato al piano gratuito. Alcune funzionalità sono ora limitate.",
      "enterprisePlanMissing": "Piano Enterprise non configurato. Contatta il supporto.",
      "familyAccessDesc": "L'accesso familiare include i membri della famiglia nello stesso percorso.",
      "familyAddonToggled": "Componente aggiuntivo familiare {{action}} per {{name}}",
      "familyToggleFailed": "Impossibile attivare/disattivare l'accesso familiare.",
      "invoices": {
        "description": "Tutte le fatture della tua azienda, pronte da scaricare",
        "empty": "Nessuna fattura ancora",
        "emptyHint": "Le fatture appariranno dopo il tuo primo pagamento.",
        "title": "Fatture",
        "view": "Visualizza",
        "viewAllInStripe": "Visualizza tutto in Stripe",
        "paymentReference": "Rif. pagamento {{reference}}",
        "refunded": "Rimborsato {{amount}}",
        "viewReceipt": "Vedi ricevuta",
        "documentUnavailable": "Non è stato possibile aprire questo documento ora. Riprova."
      },
      "limitedFeaturesDesc": "Cosa non include il tuo piano attuale",
      "managePlan": "Gestisci piano",
      "monthlySpend": "Spesa mensile",
      "nextInvoice": "Prossima fattura",
      "payment": {
        "addressLabel": "Indirizzo di fatturazione",
        "billingEmail": "Email di fatturazione",
        "billingInfoSubtitle": "Le tue informazioni di fatturazione",
        "billingInformation": "Informazioni di fatturazione",
        "billingSummary": "Riepilogo fatturazione",
        "companyName": "Nome dell'azienda",
        "currency": "Valuta",
        "dueOn": "Scadenza {{date}}",
        "editInStripe": "Modifica in Stripe",
        "enterpriseSubscription": "Abbonamento Enterprise",
        "nextInvoiceEstimate": "Stima della prossima fattura",
        "noAddress": "Nessun indirizzo registrato",
        "openStripePortal": "Apri il portale Stripe",
        "paymentsSecuredBy": "Pagamenti sicuri da",
        "portalSummary": "Apri il portale di fatturazione per gestire il tuo abbonamento, i metodi di pagamento e le fatture.",
        "securePaymentVia": "Pagamento sicuro tramite",
        "vatLabel": "Numero di partita IVA"
      },
      "planLabel": "Piano {{plan}}",
      "planUpdated": "Il tuo piano è stato aggiornato. Nessun nuovo pagamento richiesto.",
      "plans": {
        "anonymizedReporting": "Reporting anonimizzato",
        "breakEvenPoint": "Punto di pareggio",
        "checkupTeleportalQultureupCare": "CheckUp, TelePortal, QultureUp e Care",
        "complianceAuditTools": "Strumenti di audit di conformità",
        "contactSales": "Contatta vendite",
        "currentPlan": "Piano corrente",
        "custom": "Personalizzato",
        "customIntegrations": "Integrazioni personalizzate",
        "customJourneyTemplates": "Modelli di viaggio personalizzati",
        "dedicatedSupport": "Supporto dedicato",
        "downgradeToFree": "Passa a gratuito",
        "eachSponsorshipIncludes": "Ogni sponsorizzazione include",
        "enterprise": "Enterprise",
        "enterpriseRate": "Tariffa Enterprise",
        "familyAccessOptional": "Accesso familiare opzionale",
        "free": "Gratuito",
        "freePlanRate": "Tariffa piano gratuito",
        "fullJourneyCitizenAccess": "Accesso completo al viaggio Citizen",
        "fullMobilityAdaptation": "Adattamento completo della mobilità",
        "fullMobilityAdaptationTitle": "Mobilità completa & adattamento",
        "getStarted": "Inizia",
        "government": "Governo",
        "governmentContactDesc": "Contatta il nostro team vendite per impostare un contratto personalizzato per programmi pubblici.",
        "intelligenceDesc": "Sblocca il supporto completo per Mobilità e Adattamento con analisi avanzate e accesso API.",
        "inviteWholeTeamDesc": "Invita tutto il tuo team con posti, programmi e coorti illimitati.",
        "mobilityAdaptationLocked": "Adattamento della mobilità bloccato",
        "multiYearContracts": "Contratti pluriennali",
        "off67": "67% di sconto",
        "passportAchievements": "Passport risultati",
        "perTalentJourney": "Per percorso di talento",
        "perTalentPerMonth": "Per talento al mese",
        "publicPrograms": "Programmi pubblici",
        "quickRoi": "Roi veloce",
        "recommended": "Consigliato",
        "save67": "Risparmia il 67%",
        "savePerYear": "Risparmia sulle sponsorizzazioni",
        "scaleYourMobility": "Scala la tua mobilità",
        "sponsorship": "Sponsorizzazione",
        "sponsorshipRate": "Tariffa di sponsorizzazione",
        "sponsorshipsDropDesc": "Le tariffe di sponsorizzazione scendono al livello Enterprise, quindi ogni percorso di talento costa meno.",
        "tailoredToYourNeeds": "Su misura per le tue esigenze",
        "unlimitedTeamScale": "Scala illimitata del team",
        "whyUpgrade": "Perché aggiornare",
        "totalSuffix": "totale",
        "sponsorshipMonthlyCaption": "{{rate}}/mese · accesso di 12 mesi",
        "sponsorshipRateError": "Impossibile caricare la tariffa di sponsorizzazione. Si prega di aggiornare."
      },
      "portalUnavailable": "Il Portale Clienti Stripe non è ancora disponibile. Completa prima un checkout.",
      "programs": "Programmi",
      "redirectingToStripe": "Reindirizzamento al checkout Stripe...",
      "renewsOn": "Si rinnova il {{date}}",
      "sponsorships": {
        "access": "Accesso",
        "activeSponsorships": "Sponsorizzazioni attive",
        "addFamilyAccess": "Aggiungi accesso familiare",
        "description": "I percorsi sponsorizzati dalla tua azienda, con date e costi",
        "empty": "Nessuna sponsorizzazione ancora",
        "enterpriseDiscount": "Sconto aziendale",
        "family": "Famiglia",
        "removeFamilyAccess": "Rimuovi accesso familiare",
        "title": "Sponsorizzazioni",
        "totalSponsored": "Totale sponsorizzato",
        "rowActionsAria": "Azioni per {{name}}",
        "viewDetails": "Visualizza dettagli",
        "yourRate": "La tua tariffa",
        "accessMonths_one": "{{count}} mese",
        "accessMonths_other": "{{count}} mesi",
        "monthsLeft_one": "{{count}} mese rimasto",
        "monthsLeft_other": "{{count}} mesi rimasti",
        "journeyProgress": "Avanzamento del percorso"
      },
      "subscriptionError": "Impossibile caricare l'abbonamento. Si prega di aggiornare.",
      "tabs": {
        "invoices": "Fatture",
        "payment": "Pagamento",
        "plans": "Piani",
        "sponsorships": "Sponsorizzazioni"
      },
      "title": "Fatturazione",
      "totalSponsored": "Totale sponsorizzato",
      "unlimitedAccessDesc": "Tutto ciò che include il tuo piano, senza limiti",
      "upgradeDialog": {
        "continueToPayment": "Continua al pagamento",
        "description": "Sblocca posti illimitati, candidati, programmi e supporto alla mobilità completo.",
        "monthlyLabel": "Mensile",
        "save2Months": "Risparmia 2 mesi",
        "whatYouGet": "Cosa ottieni",
        "yearlyLabel": "Annuale"
      },
      "upgradeFailed": "Impossibile avviare il checkout. Si prega di riprovare.",
      "upgradeToEnterprise": "Aggiorna a Enterprise",
      "vetting": "Verifica",
      "stage": {
        "preMobility": "Pre-Mobilità",
        "mobility": "Mobilità",
        "adaptation": "Adattamento",
        "care": "Care",
        "stable": "Stabile"
      },
      "planUnavailable": "Al momento questo piano non può essere acquistato. Contatta l'assistenza."
    },
    "businessMessages": {
      "analytics": {
        "attemptedCount_one": "{{count}} tentativo",
        "attemptedCount_other": "{{count}} tentativi",
        "byEngagement": "Per coinvolgimento",
        "channelPerformance": "Prestazioni del canale",
        "channelPerformanceDesc": "Come ogni canale consegna e viene aperto",
        "deliveryRate": "Tasso di consegna",
        "messagesByCategory": "Messaggi per categoria",
        "messagesByCategoryDesc": "Messaggi inviati in ogni categoria",
        "noChannelDataYet": "Non è ancora stato inviato alcun messaggio: i tassi compaiono qui appena parte il primo.",
        "noTemplatesYet": "Crea il tuo primo modello per vedere il coinvolgimento qui.",
        "openRate": "Tasso di apertura",
        "templatesCount_one": "{{count}} modello",
        "templatesCount_other": "{{count}} modelli",
        "topTemplates": "Modelli principali"
      },
      "cohortAllSuppressed": "Nessuno ha ricevuto questo messaggio: tutti in questa coorte hanno disattivato queste email.",
      "cohortSentWithSuppressed": "Inviato a {{queued}}. {{suppressed}} non lo hanno ricevuto: hanno disattivato queste email.",
      "suppressedByPreferenceGeneric": "Il destinatario ha disattivato queste e-mail — non è stato inviato nulla",
      "suppressedByPreference": "{{name}} ha disattivato queste e-mail — non è stato inviato nulla",
      "channels": {
        "channelIntegrations": "Integrazioni canale",
        "channelIntegrationsDesc": "I canali su cui possono uscire i tuoi messaggi",
        "comingSoon": "In arrivo",
        "configure": "Configura",
        "connected": "Collegato",
        "delivered": "Consegnati",
        "email": "Email",
        "getHelp": "Ottieni aiuto",
        "openRate": "Tasso di apertura",
        "opened": "Aperto",
        "push": "Push",
        "setupRequired": "Configurazione richiesta",
        "sms": "SMS",
        "test": "Test",
        "viewDocumentation": "Visualizza documentazione",
        "whatsapp": "WhatsApp",
        "names": {
          "email": "Email",
          "whatsapp": "WhatsApp",
          "sms": "SMS",
          "push": "Citizen push"
        },
        "descriptions": {
          "email": "Invia email HTML ricche con allegati e tracciamento",
          "whatsapp": "Invia messaggi WhatsApp tramite Business API",
          "sms": "Invia messaggi SMS per notifiche urgenti",
          "push": "Notifiche push all'app mobile Citizen"
        },
        "attempts": "Tentativi"
      },
      "composer": {
        "bold": "Grassetto (**testo**)",
        "boldHtml": "Grassetto (<strong>testo</strong>)",
        "boldShort": "Grassetto",
        "channelsLabel": "Canali di consegna",
        "formattingToolbar": "Formattazione del testo",
        "italic": "Corsivo (*testo*)",
        "italicHtml": "Corsivo (<em>testo</em>)",
        "italicShort": "Corsivo",
        "link": "Collegamento ([testo](url))",
        "linkHtml": "Collegamento (<a href=\"…\">testo</a>)",
        "linkShort": "Collega",
        "message": "Messaggio",
        "messageBodyHtml": "Corpo del messaggio (HTML)",
        "messagePlaceholder": "Scrivi il tuo messaggio qui…",
        "noSubject": "(nessun oggetto)",
        "noTemplate": "Messaggio vuoto — scrivi il tuo",
        "previewDesktop": "Desktop",
        "previewEmpty": "Inizia a scrivere per vedere l'anteprima.",
        "previewLabel": "Anteprima dal vivo",
        "previewMobile": "Mobile",
        "previewPlain": "Testo semplice",
        "recipientsCount_one": "{{count}} destinatario",
        "recipientsCount_other": "{{count}} destinatari",
        "rendering": "Rendering…",
        "startFromTemplate": "Inizia da un modello (opzionale)",
        "subject": "Oggetto",
        "subjectPlaceholder": "Un promemoria amichevole — il tuo CheckUp ti aspetta",
        "tagsLabel": "Inserisci un tag",
        "tagsUsed": "Utilizzato in questo messaggio",
        "templatePlaceholder": "Scegli un modello o lascia vuoto",
        "viaEmail": "Email"
      },
      "description": "Modelli, invii e consegne di ogni messaggio della tua azienda",
      "editor": {
        "bodyRequired": "Il corpo è richiesto",
        "bodyTooLong": "Il corpo è troppo lungo",
        "cancel": "Annulla",
        "category": "Categoria",
        "channelRequired": "Seleziona almeno un canale",
        "createNewTemplate": "Crea nuovo modello",
        "editTemplate": "Modifica modello",
        "editorDescription": "Configura il tuo modello di messaggio con canali, contenuti e tag di personalizzazione.",
        "hintPlain": "Usa la barra degli strumenti (o **grassetto**, *corsivo*, [link](url)) per la formattazione. Usa i segnaposto {{variable}} per inserire valori dinamici.",
        "nameRequired": "Il nome è obbligatorio",
        "nameTooLong": "Il nome è troppo lungo",
        "saveChanges": "Salva modifiche",
        "saving": "Salvataggio…",
        "sendTest": "Invia test",
        "templateName": "Nome del modello",
        "templateNamePlaceholder": "Inserisci nome del modello...",
        "testSendSaveFirst": "Salva le tue modifiche prima di inviare un test",
        "testSending": "Invio test…",
        "unsaved": "Modifiche non salvate",
        "unsavedConfirm": "Hai modifiche non salvate. Scartarle e continuare?"
      },
      "newTemplate": "Nuovo modello",
      "stats": {
        "activeTemplates": "Modelli attivi",
        "avgOpenRate": "Tasso di apertura medio",
        "delivered": "Consegnati",
        "sendAttempts": "Tentativi di invio"
      },
      "tabs": {
        "analytics": "Analisi",
        "channels": "Canali",
        "messageTemplates": "Modelli di messaggio"
      },
      "templates": {
        "activated": "Modello attivato",
        "allCategories": "Tutte le categorie",
        "allChannels": "Tutti i canali",
        "createFailed": "Impossibile creare il modello",
        "createFirstTemplate": "Crea primo modello",
        "createTemplate": "Crea modello",
        "created": "Modello creato",
        "deactivated": "Modello disattivato",
        "delete": "Elimina",
        "deleteFailed": "Impossibile eliminare il modello",
        "deleteTitle": "Eliminare il modello?",
        "deleteWarning": "Questo rimuove permanentemente \"{{name}}\". Questa azione non può essere annullata.",
        "deleted": "Modello eliminato",
        "deleting": "Eliminazione…",
        "duplicate": "Duplica",
        "duplicateFailed": "Impossibile duplicare il modello",
        "duplicated": "Modello duplicato",
        "edit": "Modifica",
        "filterCategory": "Categoria",
        "filterChannel": "Canale",
        "inactive": "Inattivo",
        "loadError": "Impossibile caricare i modelli.",
        "noTemplatesFound": "Nessun modello trovato",
        "restoreDefault": "Ripristina predefinito",
        "restoreFailed": "Impossibile ripristinare il modello predefinito",
        "restored": "Modello predefinito ripristinato",
        "saveFailed": "Impossibile salvare il modello",
        "saved": "Modello salvato",
        "searchPlaceholder": "Inserisci ricerca...",
        "sendTest": "Invia test",
        "testSendFailed": "Impossibile inviare il messaggio di prova",
        "testSent": "Messaggio di prova inviato",
        "toggleFailed": "Impossibile aggiornare lo stato del modello",
        "tryAdjustingSearch": "Prova a regolare la ricerca",
        "talentTagWithoutSubject": "Questo messaggio va al tuo team senza riferirsi a nessun talento, quindi {{tags}} non ha nessuno da nominare. Usa {{readerTag}} per rivolgerti al lettore.",
        "activeToggle": "Attivo: {{name}}",
        "moreActions": "Altre azioni per {{name}}",
        "alwaysOn": "Sempre attivo: la piattaforma invia direttamente le email di account e sicurezza.",
        "sourceDuplicate": "Duplicato",
        "sourceCustom": "Personalizzato",
        "sourceCustomized": "Modificato",
        "sourceSystem": "Predefinito",
        "deliveredCount_one": "{{count}} consegnato",
        "deliveredCount_other": "{{count}} consegnati",
        "opened_one": "{{count}} aperto",
        "opened_other": "{{count}} aperti",
        "sent_one": "{{count}} inviato",
        "sent_other": "{{count}} inviati",
        "searchLabel": "Cerca modelli"
      },
      "title": "Messaggi",
      "categories": {
        "names": {
          "vetting": "Verifica",
          "sponsorship": "Sponsorizzazione",
          "mobility": "Mobilità",
          "adaptation": "Adattamento",
          "care": "Care",
          "evidence": "Prove",
          "general": "Generale",
          "account": "Account e sicurezza"
        },
        "descriptions": {
          "vetting": "CheckUp inviti, risultati e follow-up",
          "sponsorship": "Inviti al percorso e comunicazioni di sponsorizzazione",
          "mobility": "TelePortal attività, documenti e aggiornamenti sullo stato",
          "adaptation": "QultureUp missioni e raccomandazioni di apprendimento",
          "care": "Check-in, interventi e supporto al benessere",
          "evidence": "Passport aggiornamenti, badge e traguardi",
          "general": "Annunci generali e messaggi personalizzati",
          "account": "Codici e avvisi di sicurezza che la piattaforma invia da sé. Arrivano alle persone qualunque siano le loro impostazioni di notifica."
        }
      },
      "variables": {
        "talentFirstName": "Nome di battesimo del talento",
        "talentLastName": "Cognome del talento",
        "talentFullName": "Nome completo del talento",
        "talentEmail": "Indirizzo email del talento",
        "recipientFirstName": "Nome del destinatario",
        "recipientLastName": "Cognome del destinatario",
        "recipientFullName": "Nome completo del destinatario",
        "recipientEmail": "Indirizzo email del destinatario",
        "talentRole": "Ruolo lavorativo del talento",
        "companyName": "Nome dell'azienda sponsor",
        "companyContact": "Persona di contatto dell'azienda",
        "programName": "Nome del programma",
        "cohortName": "Nome del gruppo",
        "journeyStage": "Fase attuale del percorso",
        "checkupBadge": "iQulture livello badge",
        "mobilityArrivalDate": "Data di arrivo stimata",
        "mobilityNextTask": "Prossima attività di mobilità",
        "missionName": "QultureUp nome della missione",
        "actionUrl": "URL/link dell'azione",
        "actionDeadline": "Scadenza dell'azione"
      },
      "cohortRecipientCount_one": "{{count}} membro",
      "cohortRecipientCount_other": "{{count}} membri",
      "cohortSent_one": "Messaggio inviato a {{count}} persona.",
      "cohortSent_other": "Messaggio inviato a {{count}} persone."
    },
    "businessNotifications": {
      "allCaughtUp": "Tutto aggiornato",
      "allNotifications": "Tutte le notifiche",
      "allTab": "Tutti ({{count}})",
      "delete": "Elimina",
      "deleteCount": "Elimina ({{count}})",
      "filter": "Filtra",
      "markAllRead": "Segna tutto come letto",
      "markAsRead": "Segna come letto",
      "new": "Nuovo",
      "noNotifications": "Nessuna notifica",
      "noNotificationsDesc": "Le nuove attività dei tuoi talenti appariranno qui",
      "noUnreadNotifications": "Nessuna notifica non letta",
      "selectAll": "Seleziona tutto",
      "settings": "Impostazioni",
      "summary": {
        "completed": "Completato",
        "unread": "Non lette",
        "urgent": "Urgente",
        "warnings": "Avvisi"
      },
      "title": "Notifiche",
      "unreadTab": "Non letto ({{count}})",
      "unreadUrgent": "{{unread}} non letti, {{urgent}} urgenti",
      "urgentBadge": "Badge urgente",
      "viewDetails": "Visualizza dettagli",
      "viewDetailsButton": "Pulsante visualizza dettagli",
      "categories": {
        "all": "Tutti",
        "mobility": "Mobilità",
        "care": "Care",
        "vetting": "Verifica",
        "evidence": "Prove",
        "cohorts": "Cohorti"
      },
      "unreadCount_one": "{{count}} notifica non letta",
      "unreadCount_other": "{{count}} notifiche non lette",
      "actionsFor": "Azioni per «{{title}}»",
      "selectNotification": "Seleziona «{{title}}»"
    },
    "businessOnboarding": {
      "addTalents": {
        "addFromATSOrExcel": "Aggiungi candidati dal tuo ATS o carica un file Excel/CSV",
        "addTalentsButton": "Aggiungi talenti",
        "added": "Aggiunto",
        "afterOnboarding": "Dopo aver completato l'onboarding, invita questi talenti a CheckUp dal menu Acquisizione",
        "emptyStateDescription": "Importa candidati dal tuo ATS o carica un file Excel/CSV. Un coorte predefinito sarà creato automaticamente.",
        "importDescription": "Importa i tuoi candidati per iniziare. I talenti importati appariranno nel menu Acquisizione, dove potrai invitarli per CheckUp (vetting). Una coorte predefinita sarà creata automaticamente quando aggiungi i tuoi primi talenti.",
        "importTalents": "Importa talenti",
        "startImport": "Inizia importazione",
        "step1": "Seleziona un gruppo di talenti da invitare per CheckUp (vetting e valutazione)",
        "step2": "Dopo il completamento di CheckUp, puoi sponsorizzare talenti verificati e definire il loro percorso di migrazione",
        "step3": "I talenti sponsorizzati inizieranno il percorso attraverso: Mobilità -> Adattamento -> Care -> Evidenza",
        "step4": "Organizza le tue iniziative di assunzione creando programmi e coorti in qualsiasi momento",
        "step5": "Usa CoPilot per operazioni guidate e supporto durante tutto il processo",
        "title": "Aggiungi talenti",
        "whatsNext": "Cosa c'è dopo?",
        "whatsNextDescription": "Dopo aver importato i talenti, appariranno nel menu Acquisizione. Da lì:",
        "readyForCheckUp_one": "{{count}} talento pronto per il CheckUp",
        "readyForCheckUp_other": "{{count}} talenti pronti per il CheckUp",
        "talentsAdded_one": "{{count}} talento aggiunto",
        "talentsAdded_other": "{{count}} talenti aggiunti"
      },
      "additionalDetails": {
        "billing": {
          "billingAddressHint": "Utilizzato per fatture e notifiche di fatturazione",
          "billingAddressLabel": "Indirizzo di fatturazione",
          "billingAddressPlaceholder": "Indirizzo stradale",
          "businessTypeLabel": "Tipo di attività",
          "city": "Città",
          "complement": "Appartamento, suite, ecc. (opzionale)",
          "complementPlaceholder": "es. Suite 200",
          "country": "Paese",
          "description": "Richiesto prima di poter passare a un piano a pagamento.",
          "legalNameLabel": "Nome dell'entità legale",
          "postalCodeLabel": "Codice postale",
          "state": "Stato / Regione",
          "street": "Via",
          "taxIdLabel": "ID fiscale / IVA",
          "title": "Fatturazione e legale"
        },
        "contact": {
          "description": "Telefono diretto e anno di fondazione dell'azienda.",
          "foundedLabel": "Anno di fondazione",
          "phoneLabel": "Telefono di contatto",
          "title": "Informazioni di contatto e aziendali"
        },
        "description": "Ogni campo è facoltativo. Espandi le sezioni che desideri compilare — il resto rimarrà come promemoria sul tuo cruscotto.",
        "geographic": {
          "branchesLabel": "Uffici secondari",
          "cityPlaceholder": "Città",
          "countryPlaceholder": "Paese",
          "description": "Filiali, requisiti linguistici e modalità di lavoro.",
          "languagesLabel": "Requisiti linguistici",
          "title": "Dettagli geografici",
          "workArrangement": "Modalità di lavoro",
          "minimumLevel": "Livello minimo",
          "languageLabel": "Lingua"
        },
        "hiring": {
          "challengesLabel": "Principali sfide (max 3)",
          "description": "Obiettivi, tempistiche, maturità, ruoli target e sfide.",
          "goalsLabel": "Obiettivi principali di assunzione",
          "maturityLabel": "Maturità del programma di mobilità",
          "rolesLabel": "Tipi di ruoli target",
          "timeframeLabel": "Tempistica di assunzione",
          "title": "Dettagli sull'assunzione"
        },
        "title": "Compila i dettagli rimanenti"
      },
      "companyProfile": {
        "businessDetails": {
          "description": "Aiutaci a capire il tuo modello di business e la tua presenza online",
          "title": "Dettagli aziendali"
        },
        "businessType": "Tipo di attività",
        "businessTypes": {
          "agency": "Agenzia",
          "enterprise": "Enterprise",
          "scaleup": "Scale-up",
          "startup": "Startup",
          "startupDesc": "Fase iniziale, alta crescita",
          "scaleupDesc": "Modello provato, in rapida espansione",
          "enterpriseDesc": "Grande azienda consolidata",
          "agencyDesc": "Fornitore di servizi"
        },
        "companyInfo": {
          "description": "Dettagli di base sulla tua organizzazione",
          "title": "Informazioni sull'azienda"
        },
        "companyName": "Nome dell'azienda",
        "companySize": "Dimensione dell'azienda",
        "description": "Raccontaci della tua organizzazione. Queste informazioni ci aiutano a personalizzare la tua esperienza e a prepararci per i requisiti di conformità.",
        "emailPlaceholder": "john@company.com",
        "emailRequired": "Email *",
        "enterCompanyName": "Inserisci il nome dell'azienda",
        "enterPhoneNumber": "Inserisci il tuo numero di telefono",
        "forContractsAndLegal": "Per contratti e documenti legali",
        "foundedYear": "Anno di fondazione",
        "fullNamePlaceholder": "John Doe",
        "fullNameRequired": "Nome completo *",
        "industry": "Settore",
        "legalEntityName": "Nome dell'entità legale",
        "legalEntityPlaceholder": "es. Company Inc., Company Ltd.",
        "legalInfo": {
          "description": "Per la preparazione della conformità e dei contratti (opzionale ma consigliato per le imprese)",
          "title": "Informazioni legali"
        },
        "linkedinCompanyPage": "Pagina aziendale LinkedIn",
        "phone": "Telefono",
        "primaryContact": {
          "description": "Il principale punto di contatto per la tua organizzazione",
          "title": "Contatto principale"
        },
        "registeredCountry": "Paese registrato",
        "registeredCountryDesc": "Dove è legalmente registrata la tua azienda",
        "registeredCountryRequired": "Paese registrato *",
        "requiredForEnterprise": "Richiesto per la fatturazione delle imprese",
        "roleJobTitle": "Ruolo / Titolo di lavoro",
        "selectCountry": "Seleziona paese",
        "selectIndustry": "Seleziona settore",
        "selectRole": "Seleziona ruolo",
        "selectSize": "Seleziona dimensione",
        "selectYear": "Seleziona anno",
        "taxIdPlaceholder": "es. DE123456789",
        "taxIdVat": "ID fiscale / Numero di partita IVA",
        "title": "Profilo aziendale",
        "website": "Sito web",
        "industries": {
          "technology": "Tecnologia",
          "healthcare": "Assistenza sanitaria",
          "finance": "Finanza",
          "manufacturing": "Manifattura",
          "retail": "Vendita al dettaglio",
          "hospitality": "Ospitalità",
          "construction": "Costruzione",
          "education": "Istruzione",
          "consulting": "Consulenza",
          "logistics": "Logistica",
          "energy": "Energia",
          "telecommunications": "Telecomunicazioni",
          "mediaEntertainment": "Media e intrattenimento",
          "realEstate": "Immobiliare",
          "other": "Altro"
        },
        "companySizes": {
          "size1to50": "1-50 dipendenti",
          "size51to200": "51-200 dipendenti",
          "size201to500": "201-500 dipendenti",
          "size501to1000": "501-1000 dipendenti",
          "size1000plus": "1000+ dipendenti"
        },
        "contactRoles": {
          "ceoFounder": "CEO / Fondatore",
          "hrDirector": "Direttore HR",
          "headOfTalentAcquisition": "Responsabile acquisizione talenti",
          "mobilityManager": "Manager mobilità",
          "hrBusinessPartner": "HR Business partner",
          "peopleOperations": "Operazioni persone",
          "recruiter": "Recruiter",
          "other": "Altro"
        }
      },
      "complete": "Onboarding completato!",
      "confirmCard": {
        "backToConfirm": "Torna alla vista precompilata",
        "dataFrom": "Dati da",
        "description": "Abbiamo estratto queste informazioni dal sito web pubblico della tua azienda. Conferma che sia corretto.",
        "editDetails": "Modifica dettagli",
        "loading": "Ricerca della tua azienda...",
        "loadingDesc": "Di solito ci vogliono 2–3 secondi.",
        "manualDesc": "Non siamo riusciti a rilevare automaticamente la tua azienda. Per favore, compila le informazioni di base qui sotto.",
        "multipleSources": "fonti multiple",
        "retry": "Riprova il rilevamento automatico",
        "thatsUs": "Siamo noi",
        "title": "Sei tu?",
        "yourRole": "Il tuo ruolo in {{company}}"
      },
      "errors": {
        "cohortCreation": "Impossibile creare la coorte. Riprova.",
        "completion": "Impossibile finalizzare l'onboarding. Riprova.",
        "programCreation": "Impossibile creare il programma. Riprova."
      },
      "geographicSetup": {
        "addAnotherCountry": "Aggiungi un altro paese...",
        "addBranchOffice": "Aggiungi filiale",
        "branchOfficesDesc": "Aggiungi altre sedi che possono ricevere talenti trasferiti (facoltativo)",
        "branchOfficesTitle": "Filiali",
        "canReceiveTalent": "Può ricevere talenti",
        "city": "Città",
        "cityName": "Nome della città",
        "cityPlaceholder": "ad es., Lisbona, Berlino, Amsterdam",
        "cityRequired": "Città *",
        "country": "Paese",
        "countryRequired": "Paese *",
        "description": "Configura le sedi della tua azienda e i mercati di assunzione target. Questo ci aiuta a pre-configurare i percorsi di migrazione e i requisiti di conformità.",
        "headquartersDesc": "La tua sede principale dove i talenti trasferiti lavoreranno principalmente",
        "headquartersTitle": "Sede centrale",
        "languageRequirementsDesc": "Quali lingue dovrebbero parlare i candidati? (Facoltativo)",
        "languageRequirementsTitle": "Requisiti linguistici",
        "migrationRoutesDesc": "In base alla tua configurazione, questi percorsi di migrazione saranno pre-configurati",
        "migrationRoutesPreview": "Anteprima dei percorsi di migrazione",
        "officeName": "Nome dell'ufficio",
        "officeNamePlaceholder": "ad es., Ufficio di Berlino",
        "popularSourceMarkets": "Mercati di origine popolari",
        "selectCountry": "Seleziona paese",
        "selectedMarkets": "Mercati selezionati ({{count}})",
        "targetHiringMarketsDesc": "Da dove prevedi di assumere? Seleziona i tuoi mercati di origine.",
        "targetHiringMarketsTitle": "Mercati di assunzione target",
        "workArrangementDesc": "Quale tipo di accordo di lavoro offri per i talenti trasferiti?",
        "workArrangementTitle": "Modalità di lavoro",
        "languages": {
          "english": "Inglese",
          "spanish": "Spanish",
          "portuguese": "Portuguese",
          "german": "German",
          "french": "French",
          "dutch": "Dutch",
          "italian": "Italian",
          "polish": "Polish",
          "arabic": "Arabic",
          "chineseMandarin": "Cinese (Mandarino)",
          "japanese": "Japanese",
          "korean": "Korean"
        },
        "languageLevels": {
          "a1": "A1 — Principiante",
          "a2": "A2 — Elementare",
          "b1": "B1 — Intermedio",
          "b2": "B2 — Intermedio superiore",
          "c1": "C1 — Avanzato",
          "c2": "C2 — Competente"
        },
        "workArrangements": {
          "onsite": "In sede",
          "onsiteDesc": "Presenza in ufficio a tempo pieno",
          "hybrid": "Ibrido",
          "hybridDesc": "Mix di ufficio e remoto",
          "flexible": "Flessibile",
          "flexibleDesc": "Scelta del dipendente"
        },
        "minimumLevelFor": "Livello minimo di {{language}}",
        "otherMarketLabel": "Altro mercato di assunzione",
        "addMarket": "Aggiungi mercato",
        "addLanguage": "Aggiungi {{language}}"
      },
      "hiringContext": {
        "annualHiringVolume": "Volume annuale di assunzioni internazionali",
        "description": "Aiutaci a comprendere i tuoi obiettivi e la tua strategia di assunzione. Questo ci consente di personalizzare la tua esperienza e fornire raccomandazioni pertinenti.",
        "hiringGoalsDesc": "Cosa vuoi raggiungere? Seleziona tutto ciò che si applica.",
        "hiringGoalsTitle": "Obiettivi di assunzione",
        "mobilityProgramMaturity": "Maturità del programma di mobilità",
        "primaryUseCaseDesc": "Qual è il tuo principale motivo per utilizzare Tonnie? Seleziona l'opzione che descrive meglio la tua situazione.",
        "primaryUseCaseTitle": "Caso d'uso principale",
        "scaleTimelineDesc": "Aiutaci a comprendere l'ambito e l'urgenza delle tue esigenze di assunzione.",
        "scaleTimelineTitle": "Scala e tempistiche",
        "targetRoleTypesDesc": "Quali tipi di ruoli stai principalmente assumendo? Seleziona tutto ciò che si applica.",
        "targetRoleTypesTitle": "Tipi di ruolo target",
        "topChallengesDesc": "Quali sono le tue maggiori sfide con le assunzioni internazionali? Seleziona le tue 3 principali.",
        "topChallengesTitle": "Principali sfide",
        "useCases": {
          "costOptimization": "Ottimizzazione dei costi",
          "costOptimizationDesc": "Accesso ai talenti da diversi mercati",
          "diversity": "Diversità e inclusione",
          "diversityDesc": "Costruire team internazionali diversificati",
          "globalExpansion": "Espansione globale",
          "globalExpansionDesc": "Espandere le operazioni in nuovi mercati con talenti locali",
          "internationalHiring": "Assunzioni internazionali",
          "internationalHiringDesc": "Assumere talenti internazionali per trasferirsi nei tuoi uffici",
          "remoteToRelocation": "Da remoto a trasferimento",
          "remoteToRelocationDesc": "Convertire i lavoratori remoti in dipendenti trasferiti",
          "talentShortage": "Carenza di talenti",
          "talentShortageDesc": "Affrontare le lacune di talenti locali con sourcing globale"
        },
        "volumes": {
          "enterprise": "Scala aziendale",
          "established": "Programma consolidato",
          "growing": "Programma in crescita",
          "starting": "Iniziare"
        },
        "whenPlanToStart": "Quando prevedi di iniziare?",
        "goals": {
          "reduceTimeToHire": "Ridurre il tempo di assunzione per candidati internazionali",
          "improveCandidateExperience": "Migliorare l'esperienza del candidato durante la relocation",
          "increaseRetention": "Aumentare la retention dei dipendenti trasferiti",
          "streamlineCompliance": "Snellire i processi di conformità e visto",
          "trackMobilityRoi": "Monitorare e misurare il ROI della mobilità",
          "reduceRelocationCosts": "Ridurre i costi di relocation",
          "buildTalentPipeline": "Costruire un pipeline di talenti sostenibile",
          "improveOnboarding": "Migliorare l'onboarding e l'adattamento post-arrivo"
        },
        "challenges": {
          "immigrationVisa": "Complessità di immigrazione e visto",
          "findingCandidates": "Trovare candidati internazionali qualificati",
          "candidateDropoff": "Abbandono del candidato durante la relocation",
          "postArrival": "Adattamento e retention post-arrivo",
          "complianceLegal": "Complessità legale e di conformità",
          "costManagement": "Gestione dei costi",
          "trackingReporting": "Monitoraggio e reporting"
        },
        "timeframes": {
          "immediate": "Immediato",
          "immediateDesc": "Pronto a iniziare ora",
          "planningDesc": "Fase di pianificazione",
          "futureDesc": "Pipeline futura",
          "strategicDesc": "Pianificazione strategica"
        },
        "maturity": {
          "firstTime": "Prima volta",
          "firstTimeDesc": "Nuovo all'assunzione internazionale",
          "someExperience": "Alcuna esperienza",
          "someExperienceDesc": "Fatti alcuni trasferimenti",
          "establishedProgram": "Programma stabilito",
          "establishedProgramDesc": "Funzione di mobilità matura"
        },
        "roleTypes": {
          "engineering": "Ingegneria",
          "product": "Prodotto",
          "design": "Design",
          "dataScience": "Data science",
          "devops": "DevOps / Infrastruttura",
          "marketing": "Marketing",
          "sales": "Vendite",
          "customerSuccess": "Successo del cliente",
          "finance": "Finanza",
          "hrPeople": "HR / Persone",
          "operations": "Operazioni",
          "executive": "Esecutivo / Leadership",
          "other": "Altro"
        }
      },
      "hiringSignals": {
        "annualVolume": "Volume di assunzioni annuale",
        "annualVolumeDesc": "Quante assunzioni internazionali ti aspetti nei prossimi 12 mesi?",
        "description": "Due domande rapide per personalizzare il tuo spazio di lavoro.",
        "primaryUseCase": "Caso d'uso principale",
        "title": "Cosa ti porta a Tonnie?"
      },
      "loadingProgress": "Caricamento dei tuoi progressi...",
      "markets": {
        "description": "Seleziona fino a 3 mercati. Puoi sempre aggiungerne di più in seguito.",
        "headquarters": "Sede centrale",
        "targetMarkets": "Mercati di assunzione target",
        "title": "Da dove stai assumendo?"
      },
      "progressRestored": "I tuoi progressi sono stati ripristinati",
      "progressSaved": "Progresso salvato",
      "validation": {
        "requiredFields": "Completa i campi obbligatori prima di continuare."
      },
      "review": {
        "editDescription": "Rivedi i tuoi dettagli e salva quando sei pronto. Puoi sempre tornare a questo wizard dalla pagina delle Impostazioni.",
        "editTitle": "Il profilo della tua organizzazione",
        "firstTimeDescription": "Ecco cosa abbiamo catturato per iniziare. Puoi sempre aggiungere ulteriori dettagli in seguito dal tuo dashboard.",
        "firstTimeNotice": "Tocca Completa Configurazione per attivare il tuo spazio di lavoro. I dettagli opzionali mancanti appariranno come promemoria sulla tua dashboard.",
        "firstTimeTitle": "Sei a posto",
        "jumpToAdditional": "Torna ai dettagli aggiuntivi",
        "missingFieldsNotice_one": "Hai ancora {{count}} dettaglio facoltativo da inserire. Compilarlo migliora il matching con l'IA e sblocca la fatturazione.",
        "missingFieldsNotice_other": "Hai ancora {{count}} dettagli facoltativi da inserire. Compilarli migliora il matching con l'IA e sblocca la fatturazione."
      },
      "roles": {
        "founderExec": "Fondatore / Esecutivo",
        "hrPeople": "HR / Persone",
        "mobilityManager": "Manager mobilità",
        "talentAcquisition": "Acquisizione talenti"
      },
      "saveFailed": "Impossibile salvare i progressi",
      "steps": {
        "addTalents": {
          "badge": "Chiave",
          "description": "Attiva il tuo account aggiungendo talenti",
          "title": "Aggiungi i primi talenti"
        },
        "additionalDetails": {
          "description": "Campi opzionali per migliorare il matching e sbloccare la fatturazione.",
          "title": "Dettagli aggiuntivi"
        },
        "companyProfile": {
          "description": "Parlaci della tua organizzazione",
          "title": "Profilo aziendale"
        },
        "geographicSetup": {
          "description": "Località e percorsi di migrazione",
          "title": "Impostazione geografica"
        },
        "hiringContext": {
          "description": "I tuoi obiettivi e la strategia di assunzione",
          "title": "Contesto di assunzione"
        },
        "review": {
          "description": "Conferma ciò che abbiamo acquisito e termina la configurazione.",
          "title": "Rivedi e completa"
        }
      },
      "updated": "Profilo aggiornato",
      "wizard": {
        "completeSetup": "Completa configurazione",
        "completing": "Configurazione in corso...",
        "progressSaved": "I tuoi progressi verranno salvati automaticamente",
        "saveChanges": "Salva modifiche",
        "skipInfo": "Puoi saltare e completare in seguito",
        "subtitle": "Onboarding aziendale",
        "title": "Tonnie Business"
      }
    },
    "businessSettings": {
      "branding": {
        "a11yBrandConsistency": "Mantieni la coerenza del marchio garantendo l'accessibilità",
        "a11yColorBlind": "Testa con simulatori di daltonismo",
        "a11yContrast": "Assicurati di avere un contrasto sufficiente tra testo e sfondo (WCAG AA: 4.5:1)",
        "accessibilityGuidelines": "Linee guida per l'accessibilità",
        "activateTheme": "Attiva tema",
        "activateThisTheme": "Attiva questo tema",
        "active": "Attivo",
        "appIcon": "Icona dell'app",
        "appIconDesc": "L'icona quadrata mostrata nelle schede del browser e sui telefoni",
        "assets": "Risorse",
        "colors": "Colori",
        "customDesc": "I colori del tuo brand",
        "customMode": "Modalità personalizzata",
        "dark": "Scuro",
        "darkDesc": "Testo chiaro su sfondo scuro",
        "dashboard": "Cruscotto",
        "description": "Il tuo logo, i colori e il tema in tutto il portale",
        "draft": "Bozza",
        "enterPreviewDesc": "Guarda il portale con il tuo brand prima di salvarlo",
        "enterPreviewMode": "Entra in modalità anteprima",
        "exitPreview": "Esci dalla anteprima",
        "favicon": "Favicon",
        "faviconDesc": "La piccola icona nella scheda del browser",
        "fileFormatsHint": "{{formats}} (max {{maxSize}})",
        "heroImageN": "Immagine hero {{number}}",
        "heroImages": "Immagini hero",
        "heroImagesDesc": "Immagini di intestazione mostrate in cima alle tue pagine",
        "light": "Chiaro",
        "lightDesc": "Testo scuro su sfondo chiaro",
        "loginPage": "Pagina di accesso",
        "preview": "Anteprima",
        "previewModeActive": "Modalità anteprima attiva",
        "primaryLogo": "Logo primario",
        "primaryLogoDesc": "Mostrato nella barra laterale e nei documenti che condividi",
        "replace": "Sostituisci",
        "saveDraft": "Salva bozza",
        "secondaryLogo": "Logo secondario",
        "secondaryLogoDesc": "Una versione compatta per spazi ridotti",
        "switchToCustomAssets": "Passa a risorse personalizzate",
        "switchToCustomColors": "Passa a colori personalizzati",
        "switchToCustomPreview": "Passa a anteprima personalizzata",
        "themeMode": "Modalità tema",
        "themeModeDesc": "Chiaro, scuro o i tuoi colori",
        "title": "Branding",
        "upload": "Carica",
        "uploading": "Caricamento…",
        "colorNames": {
          "primary": "Primario",
          "secondary": "Secondario",
          "accent": "Accento",
          "success": "Successo",
          "warning": "Avviso",
          "error": "Errore",
          "background": "Sfondo",
          "foreground": "Testo"
        },
        "colorPickerLabel": "Selettore colore: {{name}}",
        "colorHexLabel": "Codice esadecimale: {{name}}"
      },
      "care": {
        "description": "Come funziona Care per i tuoi talenti: pilastri, check-in e obiettivi",
        "enterpriseDescription": "Le impostazioni personalizzate di Care fanno parte del piano Enterprise",
        "features": {
          "checkpointSchedule": "Piano di controllo",
          "checkpointScheduleDesc": "Quando ai talenti viene chiesto il check-in di Care",
          "customPillars": "Pilastri personalizzati",
          "customPillarsDesc": "Quali pilastri di benessere valutano i tuoi talenti",
          "feedbackConfig": "Configurazione feedback",
          "feedbackConfigDesc": "Chi dà feedback sugli obiettivi, e con quale frequenza",
          "talentObjectives": "Obiettivi dei talenti",
          "talentObjectivesDesc": "Gli obiettivi verso cui lavorano i tuoi talenti",
          "title": "Funzionalità"
        },
        "saveFailed": "Impossibile salvare la configurazione di Care. Riprova.",
        "saved": "Configurazione di Care salvata",
        "title": "Care"
      },
      "compliance": {
        "actionLabels": {
          "system_template_dispatched_pre_clerk": "Email di sistema inviata",
          "talent_bulk_imported": "Talenti importati in blocco",
          "talent_invitation_created": "Invito creato",
          "talent_invitation_email_failed": "Email di invito non inviata",
          "talent_invitation_revoked": "Invito revocato",
          "talent_invitation_sent": "Invito inviato",
          "talent_invited_to_vetting": "Invitato alla selezione",
          "account_email_changed": "Email dell'account modificata",
          "account_name_changed": "Nome dell'account modificato",
          "affiliate_payout_cancelled": "Pagamento affiliato annullato",
          "affiliate_payout_invoice_attached": "Fattura allegata al pagamento affiliato",
          "affiliate_payout_requested": "Pagamento affiliato richiesto",
          "affiliate_platform_overview_viewed": "Panoramica della piattaforma affiliati consultata",
          "communications_relinked_to_account": "Messaggi collegati all'account",
          "evidence_blob_read": "File di evidenza aperto",
          "evidence_blob_released": "File di evidenza rilasciato",
          "evidence_capture_expired": "Registro di decisione scaduto",
          "evidence_capture_read": "Registro di decisione aperto",
          "evidence_diff_viewed": "Registro di decisione confrontato con oggi",
          "evidence_item_redacted": "Elemento di evidenza oscurato",
          "feature_flags_write": "Funzionalità attivate modificate",
          "invitation_claimed": "Invito riscattato",
          "pool_bulk_imported": "Candidati importati in blocco",
          "pool_candidate_ingested": "Candidato aggiunto al bacino",
          "pool_cv_viewed": "CV del candidato consultato",
          "service_credential_created": "Credenziale di servizio creata",
          "service_credential_revoked": "Credenziale di servizio revocata",
          "talent_invitation_deleted": "Invito eliminato",
          "talent_invitation_superseded": "Invito sostituito da uno nuovo",
          "account_name_reconciled": "Nome dell'account riconciliato",
          "ops_vault_orphan_delete": "File orfano rimosso",
          "talent_invitation_declined": "Invito rifiutato"
        },
        "allActions": "Tutte le azioni",
        "allUsers": "Tutti gli utenti",
        "auditLogs": "Log di audit",
        "auditLogsDesc": "Monitora chi ha fatto cosa, quando e dove nella tua azienda.",
        "date": "Data",
        "description": "Registri di audit, conservazione dei dati e impostazioni di privacy dell'azienda",
        "loadMore": "Carica di più",
        "loading": "Caricamento…",
        "noResults": "Nessun evento di audit corrisponde ai tuoi filtri.",
        "resourceLabels": {
          "journey_invitation": "Invito al viaggio",
          "message_template": "Modello di messaggio",
          "tenant": "Organizzazione",
          "affiliate_payout": "Pagamento affiliato",
          "affiliate_platform": "Piattaforma affiliati",
          "engagement_evidence_blob": "File di evidenza",
          "engagement_evidence_capture": "Registro di decisione",
          "engagement_evidence_item": "Elemento di evidenza",
          "platform_configs": "Impostazioni della piattaforma",
          "service_credential": "Credenziale di servizio",
          "talent": "Talento",
          "user": "Utente",
          "vault_file": "File dell'archivio"
        },
        "showing": "Mostrando {{shown}} di {{total}}",
        "systemActor": "Sistema",
        "title": "Conformità",
        "filterByUser": "Filtra per utente",
        "filterByAction": "Filtra per azione"
      },
      "description": "La tua organizzazione, il team, il brand e le preferenze",
      "enterpriseLock": {
        "badge": "Enterprise",
        "description": "Questa funzione è disponibile nel piano Enterprise.",
        "title": "Bloccato",
        "upgrade": "Aggiorna a Enterprise"
      },
      "organization": {
        "annualVolume": "Volume annuale",
        "billingAddress": "Indirizzo di fatturazione",
        "billingCity": "Città",
        "billingCountry": "Paese",
        "billingLegal": "Informazioni legali",
        "billingLegalDesc": "Utilizzato su fatture, contratti e documenti fiscali.",
        "billingState": "Stato / Regione",
        "branchOffices": "Filiali",
        "businessType": "Tipo di attività",
        "companyName": "Nome dell'azienda",
        "companyProfile": "Profilo aziendale",
        "companyProfileDesc": "Il nome, il settore e i contatti della tua azienda",
        "companySetup": "Impostazione aziendale",
        "companySize": "Dimensione dell'azienda",
        "complement": "Appartamento, suite, ecc.",
        "contactEmail": "Email di contatto",
        "contactPhone": "Telefono di contatto",
        "contactRole": "Ruolo di contatto",
        "description": "Il profilo della tua azienda, le sedi e il contesto di assunzione",
        "editInOnboardingWizard": "Modifica nel wizard di onboarding",
        "foundedYear": "Fondato",
        "geographicSetup": "Impostazione geografica",
        "geographicSetupDesc": "Dove ha sede la tua azienda e dove si trasferiscono i talenti",
        "headquarters": "Sede centrale",
        "hiringContext": "Contesto di assunzione",
        "hiringContextDesc": "I ruoli per cui assumi e le sfide che affronti",
        "hiringGoals": "Obiettivi di assunzione",
        "industry": "Settore",
        "languageRequirements": "Requisiti linguistici",
        "legalName": "Nome legale",
        "linkedin": "LinkedIn",
        "maturityLevel": "Livello di maturità",
        "postalCode": "Codice postale",
        "primaryContact": "Contatto principale",
        "primaryUseCase": "Caso d'uso principale",
        "registeredCountry": "Paese registrato",
        "targetHiringMarkets": "Mercati di assunzione target",
        "targetRoles": "Ruoli target",
        "taxId": "ID fiscale / IVA",
        "timeframe": "Intervallo di tempo",
        "title": "Organizzazione",
        "topChallenges": "Principali sfide",
        "website": "Sito web",
        "workArrangement": "Modalità di lavoro"
      },
      "preferences": {
        "dateFormat": "Formato data",
        "description": "Lingua, notifiche e come funziona il portale per te",
        "discardChanges": "Scarta",
        "emailNotifications": "Notifiche email",
        "emailNotificationsDesc": "Quali aggiornamenti ricevi via email",
        "language": "Lingua",
        "localization": "Localizzazione",
        "localizationDesc": "La tua lingua, il fuso orario e il formato della data",
        "moreComingSoon": "Altre preferenze sono in arrivo: lingue aggiuntive, fusi orari e controlli delle notifiche appariranno qui man mano che li implementiamo.",
        "pushNotifications": "Notifiche push",
        "pushNotificationsDesc": "Quali aggiornamenti compaiono come notifiche del browser",
        "saveFailed": "Impossibile salvare le preferenze. Riprova.",
        "savePreferences": "Salva preferenze",
        "quietHours": "Ore di silenzio",
        "quietHoursDesc": "Sospendi le notifiche push durante queste ore.",
        "quietHoursEnd": "Alle",
        "quietHoursStart": "Dalle",
        "saved": "Preferenze aggiornate",
        "timezone": "Fuso orario",
        "title": "Preferenze",
        "unsavedChanges": "Hai modifiche non salvate",
        "channelsTitle": "Canali di notifica",
        "channelsDesc": "Come ricevi le notifiche.",
        "categoriesTitle": "Di cosa ricevi notifiche",
        "categoriesDesc": "Scegli quali tipi di aggiornamenti ricevi.",
        "category": {
          "hero": "Percorso del talento",
          "heroDesc": "Progressi di CheckUp, Care e mobilità dei tuoi talenti.",
          "system": "Account e sistema",
          "systemDesc": "Sicurezza, account e manutenzione della piattaforma.",
          "social": "Persone e pipeline",
          "socialDesc": "Valutazioni, team e interazioni con i candidati.",
          "alert": "Avvisi e fatturazione",
          "alertDesc": "Sensibili a tempo o denaro: fatturazione, pagamenti e scadenze."
        }
      },
      "sections": {
        "branding": "Branding",
        "brandingDesc": "Tema, colori e risorse",
        "care": "Care",
        "careDesc": "Configurazione e pilastri di Care",
        "compliance": "Conformità",
        "complianceDesc": "Registri di audit, conservazione dei dati ed esportazioni",
        "organization": "Organizzazione",
        "organizationDesc": "Profilo aziendale e configurazione",
        "preferences": "Preferenze",
        "preferencesDesc": "Notifiche, lingua e località",
        "profile": "Profilo",
        "profileDesc": "Le tue informazioni personali e avatar",
        "security": "Sicurezza",
        "securityDesc": "Autenticazione, password e accesso",
        "team": "Team",
        "teamDesc": "Membri, ruoli e permessi",
        "serviceCredentials": "Credenziali di servizio",
        "serviceCredentialsDesc": "Token di sola lettura per script e strumenti di reporting"
      },
      "security": {
        "accountDeleteFailed": "Impossibile eliminare l'account",
        "accountDeleted": "Account eliminato",
        "confirmDelete": "Elimina per sempre",
        "confirmDeleteOrg": "Elimina organizzazione per sempre",
        "dangerZone": "Zona pericolosa",
        "dangerZoneDesc": "Azioni irreversibili. Assicurati di essere certo.",
        "deleteAccount": "Elimina account",
        "deleteAccountConfirmPrompt": "Digita DELETE per confermare:",
        "deleteAccountDesc": "Rimuovi permanentemente il tuo account utente e tutti i dati associati.",
        "deleteAccountTitle": "Elimina account",
        "deleteAccountWarning": "Questa azione è permanente e non può essere annullata. Tutti i tuoi dati saranno rimossi.",
        "deleteOrg": "Elimina organizzazione",
        "deleteOrgConfirmPrompt": "Digita il nome dell'organizzazione per confermare:",
        "deleteOrgFailed": "Impossibile eliminare l'organizzazione. Riprova o contatta il supporto.",
        "deleteOrgSuccess": "Organizzazione eliminata.",
        "deleteOrgTitle": "Elimina organizzazione",
        "deleteOrgWarning": "Questo eliminerà permanentemente l'organizzazione, tutte le appartenenze al team, i programmi, i gruppi e i dati sui talenti.",
        "deleteOrganization": "Elimina questa organizzazione",
        "deleteOrganizationDesc": "Rimuovi l'organizzazione, tutti i membri del team, i programmi e i dati. Questo non può essere annullato.",
        "deleting": "Eliminazione…",
        "description": "Accesso, sessioni ed eliminazione della tua organizzazione",
        "title": "Sicurezza",
        "deleteOrgStripeWarning_one": "Organizzazione eliminata. {{count}} abbonamento non è stato annullato automaticamente — contatta il supporto se hai domande sulla fatturazione.",
        "deleteOrgStripeWarning_other": "Organizzazione eliminata. {{count}} abbonamenti non sono stati annullati automaticamente — contatta il supporto se hai domande sulla fatturazione."
      },
      "team": {
        "description": "Gestisci i membri del team e le inviti",
        "enterpriseDescription": "Gestione completa del team con accesso basato sui ruoli",
        "features": {
          "activityTracking": "Tracciamento attività",
          "activityTrackingDesc": "Vedi quando i membri del team hanno accesso per l'ultima volta alla piattaforma",
          "roleBasedAccess": "Accesso basato sui ruoli",
          "roleBasedAccessDesc": "Assegna ruoli per controllare cosa può vedere e fare ciascun membro",
          "stakeholderIdentification": "Gestione degli stakeholder",
          "stakeholderIdentificationDesc": "Identifica i proprietari del budget e i campioni del programma",
          "title": "Funzionalità",
          "unlimitedMembers": "Membri illimitati",
          "unlimitedMembersDesc": "Invita l'intero team — nessun limite di posti"
        },
        "invitationResent": "Invito reinviato",
        "invitationRevoked": "Invito revocato",
        "invitations": {
          "description": "Gestisci gli inviti in sospeso al tuo spazio di lavoro.",
          "expired": "Scaduto",
          "pending": "In Attesa",
          "resend": "Reinvia",
          "revoke": "Revoca",
          "sentOn": "Inviato",
          "title": "Inviti in sospeso"
        },
        "inviteDesc": "Invia un invito via email per unirti alla tua organizzazione.",
        "inviteEmailLabel": "Indirizzo email",
        "inviteFailed": "Impossibile inviare l'invito",
        "inviteRoleLabel": "Ruolo",
        "inviteSent": "Invito inviato",
        "inviteTitle": "Invita un membro del team",
        "memberRemoved": "Membro del team rimosso",
        "members": {
          "description": "Membri attivi del team con accesso alla tua organizzazione",
          "inviteMember": "Invita membro",
          "title": "Membri"
        },
        "removeConfirm": "Rimuovere {{name}} dal team?",
        "removeFailed": "Impossibile rimuovere il membro del team",
        "resendFailed": "Impossibile reinviare l'invito",
        "revokeFailed": "Impossibile revocare l'invito",
        "roleAdmin": "Admin",
        "roleTeamMember": "Membro del team",
        "roles": {
          "adminDesc": "Accesso completo — gestisci team, fatturazione, programmi e impostazioni",
          "description": "Ruoli disponibili e le loro autorizzazioni",
          "teamMemberDesc": "Accesso a programmi, talenti e dashboard di mobilità",
          "title": "Ruoli"
        },
        "sendInvite": "Invia invito",
        "sending": "Invio…",
        "stats": {
          "pendingInvitations": "Inviti in sospeso",
          "teamMembers": "Totale membri"
        },
        "title": "Team"
      },
      "title": "Impostazioni",
      "inviteEmailPlaceholder": "colleague@company.com",
      "serviceCredentials": {
        "title": "Credenziali di servizio",
        "description": "Token di sola lettura che permettono a uno script o a uno strumento di reporting di estrarre i dati del cohort senza che nessuno acceda.",
        "howToTitle": "Come usare una credenziale",
        "howToBody": "Invia il token nell’header Authorization: Authorization: Bearer <token>. Può solo leggere gli snapshot di cohort e programma, non modifica nulla e smette di funzionare nel momento in cui la revochi o scade.",
        "empty": "Nessuna credenziale",
        "emptyHint": "Creane una quando uno script o uno strumento di reporting deve leggere i dati del cohort da sé.",
        "create": "Nuova credenziale",
        "createTitle": "Nuova credenziale di servizio",
        "createDescription": "Vedrai il token una sola volta. Salvalo prima di chiudere.",
        "nameLabel": "Nome",
        "namePlaceholder": "Report trimestrale del cohort",
        "nameHint": "Per distinguere questa credenziale dalle altre in seguito.",
        "scopeLabel": "Accesso",
        "scopeCohortRead": "Leggere i dati del cohort",
        "scopeHint": "Sola lettura. Una credenziale non modifica mai i dati né gestisce credenziali.",
        "cohortModeLabel": "Cohort",
        "cohortAll": "Tutti i cohort",
        "cohortPick": "Solo i cohort che scelgo",
        "cohortsLabel": "Quali cohort",
        "cohortsHint": "Scegline almeno uno.",
        "expiryLabel": "Scade tra",
        "expiryHint": "Le credenziali scadono sempre. Novanta giorni è il massimo.",
        "revealTitle": "Copia subito il token",
        "revealWarning": "Questo token viene mostrato una sola volta. Salvalo ora: non potrà essere mostrato di nuovo.",
        "copy": "Copia",
        "copied": "Copiato",
        "storedConfirm": "Ho salvato questo token in un posto sicuro",
        "done": "Fatto",
        "statusActive": "Attiva",
        "statusExpired": "Scaduta",
        "statusRevoked": "Revocata",
        "allCohorts": "Tutti i cohort",
        "neverUsed": "Mai usata",
        "revoke": "Revoca",
        "revokeTitle": "Revocare questa credenziale?",
        "revokeDescription": "Tutto ciò che la usa smette di funzionare immediatamente. L’operazione non è annullabile.",
        "revokeReasonLabel": "Motivo (facoltativo)",
        "revokeConfirm": "Revoca credenziale",
        "issued": "Credenziale creata",
        "revoked": "Credenziale revocata",
        "issueFailed": "Impossibile creare la credenziale",
        "revokeFailed": "Impossibile revocare la credenziale",
        "loadFailed": "Impossibile caricare le credenziali",
        "expiryDays_one": "{{count}} giorno",
        "expiryDays_other": "{{count}} giorni",
        "cohortCount_one": "{{count}} cohort",
        "cohortCount_other": "{{count}} cohort",
        "expiringSoon_one": "Scade tra {{count}} giorno",
        "expiringSoon_other": "Scade tra {{count}} giorni"
      }
    },
    "care": {
      "config": {
        "addCustomObjective": "Aggiungi obiettivo personalizzato",
        "addToCatalog": "Aggiungi al catalogo",
        "baselineDescription": "Configura le impostazioni predefinite di Care per la tua organizzazione. Queste impostazioni saranno automaticamente ereditate da tutti i Programmi e le Coorti. I Programmi o le Coorti individuali possono personalizzare se necessario.",
        "cadences": {
          "monthly": "Mensile",
          "quarterlyRecommended": "Trimestrale (consigliato)",
          "semiannual": "Semestrale"
        },
        "careModelSummary": "Riepilogo del modello Care",
        "carePillars": "Pilastri di Care",
        "carePillarsDescription": "Seleziona quali dimensioni di stabilità i talenti riporteranno autonomamente durante i check-in. I programmi e le coorti possono abilitare/disabilitare questi.",
        "pillarCatalog": {
          "housing_stability": {
            "name": "Stabilità abitativa",
            "description": "Monitora le transizioni e la stabilità abitativa dopo l'arrivo"
          },
          "schooling_childcare": {
            "name": "Istruzione e assistenza all'infanzia",
            "description": "Monitora l'istruzione e le disposizioni per l'assistenza all'infanzia dei bambini"
          },
          "work_fit": {
            "name": "Idoneità al lavoro",
            "description": "Monitora l'adattamento al posto di lavoro, l'integrazione nel team e la produttività"
          },
          "wellbeing_social": {
            "name": "Benessere e sociale",
            "description": "Monitora il benessere, le connessioni sociali e il coinvolgimento nella comunità"
          }
        },
        "carePillarsScheduleDesc": "Pilastri di Care + programma di controllo: I talenti completano i check-in autonomi su dimensioni di benessere selezionate a intervalli di traguardo. I programmi/Coorti possono abilitare/disabilitare i pilastri e regolare il timing dei controlli.",
        "catalogWorkDescription": "Abilita qui gli obiettivi per renderli disponibili per i Programmi e i Gruppi. Ogni Programma/Gruppo può quindi scegliere quali obiettivi monitorare per i propri talenti.",
        "changesApplyNote": "Le modifiche si applicheranno a tutti i Programmi e Gruppi che non hanno personalizzato le proprie impostazioni",
        "checkpointSchedule": "Piano di controllo",
        "checkpointScheduleDescription": "Timing predefinito per i check-in del Pilastro Care (traguardi post-arrivo). I Programmi e le Coorti possono regolare la ricorrenza.",
        "common": "Comune",
        "companyCareBaseline": "Baseline dell'azienda Care",
        "customObjectiveAdded": "Obiettivo personalizzato aggiunto al catalogo",
        "detailedFeedbackDescription": "Seleziona i ruoli che possono vedere il testo di feedback dettagliato (altri vedono solo i riassunti)",
        "detailedFeedbackVisibility": "Visibilità del feedback dettagliato",
        "feedbackCadenceDescription": "Con quale frequenza gli agenti aziendali e i talenti scambiano feedback sugli obiettivi",
        "feedbackCadenceLabel": "Cadenza di feedback",
        "feedbackConfigDescription": "Con quale frequenza gli agenti aziendali forniscono feedback sugli Obiettivi dei Talenti e quando i talenti si autovalutano",
        "feedbackConfiguration": "Configurazione del feedback",
        "feedbackFlowDescription": "A ciascun intervallo di cadenza, i fornitori selezionati inviano feedback sugli obiettivi dei talenti. Il talento riceve una notifica e può visualizzare il feedback + inviare la propria autovalutazione.",
        "feedbackFlowTitle": "Flusso di feedback:",
        "feedbackProviders": "Fornitori di feedback",
        "forObjectives": "Per obiettivi",
        "forPillars": "Per piloni",
        "howCatalogWorks": "Come funziona il catalogo:",
        "milestones": {
          "monthNine": "Mese 9",
          "monthOne": "Mese 1",
          "monthSix": "Mese 6",
          "monthThree": "Mese 3",
          "monthTwelve": "Mese 12"
        },
        "objectivePlaceholder": "ad es., Completa la formazione sulla consapevolezza della sicurezza",
        "objectivesCatalogDescription": "Biblioteca aziendale di obiettivi di adattamento. Abilita quelli comunemente usati — i Programmi e i Gruppi possono quindi selezionare quali applicare.",
        "primaryConfig": "Configurazione primaria",
        "providers": {
          "admin": {
            "description": "Possiede il programma di cura — rivede segnali sensibili e fornisce feedback strategico sugli obiettivi."
          },
          "teamMember": {
            "description": "Contatto quotidiano — fornisce feedback su adattamento, idoneità lavorativa e progresso rispetto agli obiettivi."
          }
        },
        "recommended": "Consigliato",
        "riskSignalsDescription": "Seleziona i ruoli che possono vedere indicatori di rischio sensibili e avvisi di stabilità",
        "riskSignalsVisibility": "Visibilità dei segnali di rischio",
        "saveConfiguration": "Salva configurazione",
        "schedules": {
          "intensive": "Intensivo",
          "intensiveCadence": "Cadenza: ogni trimestre + controllo di assestamento mese-1 (5 checkpoint)",
          "intensiveDescription": "Programmi ad alto contatto che necessitano di monitoraggio ravvicinato nelle fasi iniziali e segnali trimestrali extra.",
          "light": "Contatto leggero",
          "lightCadence": "Cadenza: semestrale (2 checkpoint)",
          "lightDescription": "Cura minima praticabile — solo il segnale del primo trimestre e il punto decisionale annuale.",
          "standard": "Standard",
          "standardCadence": "Cadenza: primo mese, poi trimestrale fino al mese 12 (4 checkpoint)",
          "standardDescription": "Checkpoint bilanciati che coprono assestamento, adattamento e retention annuale."
        },
        "talentCheckIns": "Check-in dei talenti",
        "talentObjectivesCatalog": "Catalogo degli obiettivi dei talenti",
        "talentObjectivesFeedbackDesc": "Obiettivi dei talenti + feedback: Abilita gli obiettivi nel tuo catalogo. I programmi/Gruppi selezionano quali obiettivi monitorare. Gli agenti aziendali forniscono feedback e i talenti si autovalutano.",
        "visibilityDescription": "Controlla chi può vedere i dati sensibili di Care in base al proprio ruolo",
        "visibilityPrivacy": "Visibilità & privacy",
        "pillarRequired": "Richiesto",
        "pillarMakeRequired": "Rendi richiesto",
        "objectives": {
          "language_level": "Raggiungi una competenza lavorativa nella lingua locale",
          "office_visits": "Partecipa regolarmente all'ufficio ogni periodo",
          "onboarding": "Completa il programma di onboarding dell'azienda",
          "team_integration": "Stabilisci relazioni lavorative produttive con il team",
          "role_competency": "Dimostra competenza nel ruolo attraverso la revisione dei traguardi",
          "culture_fit": "Comprendi e abbraccia la cultura e i valori dell'azienda",
          "communication": "Comunicazione efficace con le parti interessate",
          "tools_systems": "Competenza con gli strumenti e i sistemi aziendali",
          "network_building": "Costruisci una rete professionale interna",
          "feedback_giving": "Partecipa attivamente ai cicli di feedback",
          "goal_setting": "Imposta e monitora gli obiettivi di sviluppo personale",
          "mentorship": "Interagisci con il mentore/buddy assegnato"
        },
        "objectiveCategory": {
          "Adaptation": "Adattamento",
          "Onboarding": "Onboarding",
          "Performance": "Performance",
          "Culture": "Cultura",
          "Skills": "Competenze",
          "Technical": "Tecnico",
          "Growth": "Crescita",
          "Custom": "Personalizzato"
        },
        "enabled_one": "{{count}} abilitato",
        "enabled_other": "{{count}} abilitati",
        "pillarsEnabledCount_one": "{{count}} pilastro abilitato. Programmi e gruppi lo ereditano e possono scegliere quali pilastri sono attivi nel loro contesto.",
        "pillarsEnabledCount_other": "{{count}} pilastri abilitati. Programmi e gruppi li ereditano e possono scegliere quali pilastri sono attivi nel loro contesto."
      },
      "customizeModal": {
        "cancel": "Annulla",
        "carePillars": "Pilastri di Care",
        "carePillarsDesc": "Dimensioni per i check-in dei talenti",
        "checkpointSchedule": "Piano di controllo",
        "checkpointScheduleDesc": "Quando i talenti completano i check-in di Care",
        "cohorts": "Cohorti",
        "configSaved": "Configurazione di Care personalizzata per {{name}}",
        "customized": "Personalizzato",
        "feedbackConfig": "Configurazione del feedback",
        "feedbackConfigDesc": "Con quale frequenza viene fornito feedback sugli obiettivi",
        "feedbackFrequencyInfo": "HRBP e manager forniscono feedback sugli obiettivi dei talenti con questa frequenza",
        "feedbackMonthly": "Mensile",
        "feedbackMonthlyDesc": "Una volta al mese",
        "feedbackQuarterly": "Trimestrale",
        "feedbackQuarterlyDesc": "Ogni 3 mesi",
        "inherited": "Ereditato",
        "inheritedInfo": "Le impostazioni sono ereditate da {{from}}. Attiva le sezioni qui sotto per personalizzare per questo {{level}}.",
        "objectivesAllApply": "Nessun obiettivo selezionato — si applicano tutti gli obiettivi aziendali. Scegli un sottoinsieme per restringerli a questo ambito.",
        "objectivesNoneEnabled": "Nessun obiettivo è ancora abilitato nella configurazione aziendale di Care. Abilita alcuni nelle Impostazioni aziendali per definirli qui.",
        "oneMonth": "1 mese",
        "overrideDesc": "Sovrascrivi le impostazioni di Care per {{name}}. {{inheritors}} erediteranno queste a meno che non abbiano le proprie personalizzazioni.",
        "pillarHousing": "Alloggio",
        "pillarHousingDesc": "Stabilità della situazione abitativa",
        "pillarWellbeing": "Benessere",
        "pillarWellbeingDesc": "Salute e benessere mentale",
        "pillarWork": "Lavoro",
        "pillarWorkDesc": "Adattamento al lavoro e alla carriera",
        "resetAllToInherited": "Reimposta tutto su ereditato",
        "saveChanges": "Salva modifiche",
        "scheduleIntensive": "Intensivo",
        "scheduleIntensiveDesc": "Check-in frequenti per i nuovi arrivati",
        "scheduleLight": "Contatto leggero",
        "scheduleLightDesc": "Check-in minimi per talenti stabilizzati",
        "scheduleStandard": "Standard",
        "scheduleStandardDesc": "Programma di checkpoint bilanciato",
        "sixMonths": "6 mesi",
        "talentObjectives": "Obiettivi dei talenti",
        "talentObjectivesDesc": "Scegli quali obiettivi aziendali si applicano a questo ambito",
        "talents": "Talenti",
        "threeMonths": "3 mesi",
        "title": "Personalizza modale",
        "twelveMonths": "12 mesi",
        "pillarSchooling": "Istruzione e assistenza all'infanzia",
        "pillarSchoolingDesc": "Monitora l'istruzione e le disposizioni per l'assistenza all'infanzia dei bambini",
        "nineMonths": "9 mesi",
        "feedbackSemiannual": "Semestrale",
        "feedbackSemiannualDesc": "Feedback raccolto due volte all'anno",
        "objectivesSelected_one": "{{count}} obiettivo selezionato. Gli agenti aziendali forniscono feedback su di esso",
        "objectivesSelected_other": "{{count}} obiettivi selezionati. Gli agenti aziendali forniscono feedback su questi",
        "pillarsActive_one": "{{count}} pilastro attivo. I talenti lo valutano durante i check-in",
        "pillarsActive_other": "{{count}} pilastri attivi. I talenti valuteranno ogni pilastro durante i check-in"
      },
      "effectiveCard": {
        "cadence": "Cadenza",
        "careConfiguration": "Configurazione di Care",
        "carePillars": "Pilastri di Care",
        "customized": "Personalizzato",
        "customizedFor": "Personalizzato per {{level}}",
        "inherited": "Ereditato",
        "inheritedFrom": "Ereditato da {{source}}",
        "providers": "Fornitori",
        "talentObjectives": "Obiettivi dei talenti"
      },
      "feedback": {
        "commentWithheld": "Commento nascosto dalle impostazioni di visibilità della tua azienda",
        "modal": {
          "description": "Valuta ogni obiettivo rispetto al suo target, poi rivedi l'intera cronologia.",
          "provideTab": "Fornire",
          "historyTab": "Storia",
          "submit": "Invia feedback",
          "giveFeedback": "Fornisci feedback",
          "cycleDue": "Scadenza {{date}}",
          "awaitingSelfEval": "In attesa di auto-valutazione",
          "noOpenCycle": "Nessun ciclo aperto",
          "historyEmpty": "Nessun feedback è stato registrato finora.",
          "archivedObjective": "Obiettivo archiviato",
          "providerValue": "Azienda",
          "selfValue": "Autonomo"
        }
      },
      "objective": {
        "measureType": {
          "number": "Conteggio",
          "scale": "Livello",
          "percent": "Percentuale",
          "milestone": "Traguardo",
          "rating": "Valutazione"
        },
        "currentLabel": "Attuale",
        "targetLabel": "Target",
        "baselineLabel": "Baseline",
        "recordValueLabel": "Questo periodo",
        "valuePlaceholder": "Seleziona…",
        "milestoneDone": "Fatto",
        "milestoneNotYet": "Non ancora",
        "editTarget": "Modifica obiettivo",
        "dashboard": {
          "byObjective": "Per obiettivo",
          "onTargetShare": "In linea con l'obiettivo",
          "avgProgress": "Progresso medio",
          "empty": "Nessun obiettivo è ancora tracciato. Configurali nella strategia di Care e appariranno man mano che i talenti vengono onboardati.",
          "talentsCount_one": "{{count}} talento",
          "talentsCount_other": "{{count}} talenti"
        },
        "targetSaved": "Obiettivo aggiornato",
        "targetSaveFailed": "Impossibile salvare l'obiettivo. Riprova.",
        "nothingToSubmit": "Registra un valore o un commento per almeno un obiettivo prima.",
        "feedbackSubmitted": "Feedback registrato",
        "feedbackSubmitFailed": "Impossibile registrare il feedback. Riprova.",
        "errors": {
          "unitTooLong": "L'unità deve essere di 24 caratteri o meno",
          "targetRequired": "Imposta una baseline o un obiettivo",
          "ratingRange": "La valutazione deve essere da 1 a 5",
          "commentTooLong": "Il commento deve essere di 2000 caratteri o meno",
          "entryEmpty": "Aggiungi un valore, una valutazione o un commento"
        },
        "noOpenCycle": "Non c'è ancora un ciclo di feedback aperto per questo talento, quindi non c'è nulla da inviare."
      },
      "intervention": {
        "actAria": "Intervieni su {{name}}",
        "actLabel": "Intervieni",
        "assigneeLabel": "Proprietario",
        "assigneeUnassigned": "Non assegnato",
        "inbox": {
          "title": "Follow-up",
          "empty": "Sei a posto — nessun follow-up aperto.",
          "overdue": "Scaduto",
          "open": "Apri",
          "done": "Fatto",
          "mine": "Mio",
          "all": "Tutti",
          "due": "Scadenza {{date}}",
          "search": "Cerca per talento…",
          "groupByTalent": "Per talento",
          "flat": "Elenco",
          "noMatch": "Nessuna interazione corrisponde a quel talento.",
          "expandAll": "Espandi tutto",
          "collapseAll": "Comprimi tutto",
          "overdueCount_one": "{{count}} scaduto",
          "overdueCount_other": "{{count}} scaduti"
        },
        "manageLabel": "Programma e proprietario",
        "markDoneLabel": "Registra esito + minuti",
        "markDoneHint": "Copia e incolla qui i verbali della riunione o le note della registrazione (se le hai) — solo interno, conservato per una valutazione futura.",
        "markDone": "Segna come fatto",
        "ataPlaceholder": "Incolla qui i minuti / ciò che è stato discusso (solo interno)…",
        "commentsLabel": "Commenti",
        "commentsEmpty": "Nessun commento ancora.",
        "commentPlaceholder": "Aggiungi un commento…",
        "commentSend": "Invia",
        "rescheduledToast": "Interazione riprogrammata",
        "reassignedToast": "Interazione riassegnata",
        "actionFailed": "Azione non riuscita. Riprova.",
        "bulkAllFailed": "Nessuna azione può essere creata. Riprova.",
        "bulkPartial": "{{m}} non può essere creato",
        "bulkSummary": "{{n}} programmato, {{m}} non riuscito",
        "cancel": "Annulla",
        "cancelFailed": "Impossibile annullare.",
        "cancelledToast": "Intervento annullato",
        "descriptionLabel": "Descrizione",
        "descriptionPlaceholder": "Aggiungi qualsiasi contesto per questa azione…",
        "dialogDescription": "Registra un'azione o contatta — scegli un tipo e ci occuperemo del resto. Le azioni rivolte ai talenti sono sempre senza punteggio.",
        "dialogTitle": "Intervieni",
        "effect": {
          "logOnly": "Solo per registrazione interna — non raggiunge mai il talento.",
          "talentTouch": "Idoneo per un contatto caldo, senza punteggio, su base volontaria con il talento."
        },
        "errors": {
          "descriptionTooLong": "La descrizione deve contenere 2000 caratteri o meno",
          "editClosed": "Questa interazione è chiusa e non può più essere modificata.",
          "invalidDate": "Inserisci una data valida",
          "resolutionTooLong": "La risoluzione deve contenere 2000 caratteri o meno",
          "titleRequired": "È richiesto un titolo",
          "titleTooLong": "Il titolo deve contenere 200 caratteri o meno"
        },
        "errorToast": "Impossibile creare l'azione. Riprova.",
        "edit": "Modifica",
        "save": "Salva modifiche",
        "saveSuccess": "Interazione aggiornata",
        "saveFailed": "Impossibile salvare le modifiche. Riprova.",
        "wizard": {
          "stepType": "Tipo",
          "stepDetails": "Dettagli",
          "stepReview": "Revisione",
          "next": "Avanti",
          "back": "Indietro",
          "progressLabel": "Progresso della configurazione dell'interazione",
          "reviewBulk_one": "Questo sarà creato per {{count}} talento.",
          "reviewBulk_other": "Questo sarà creato per {{count}} talenti."
        },
        "notesLabel": "Note",
        "notesPlaceholder": "Note interne (opzionale)…",
        "outcome": {
          "completed": "Completato",
          "noShow": "Assente",
          "rescheduled": "Riprogrammato",
          "declined": "Rifiutato"
        },
        "outcomeLabel": "Esito",
        "priority": {
          "high": "Alto",
          "low": "Basso",
          "medium": "Medio",
          "urgent": "Urgente"
        },
        "priorityLabel": "Priorità",
        "resolutionLabel": "Nota di risoluzione",
        "resolutionPlaceholder": "Cosa è successo? (opzionale)",
        "resolve": "Risolvi",
        "resolveFailed": "Impossibile risolvere.",
        "resolvedToast": "Intervento risolto",
        "submit": "Crea",
        "submitting": "Salvataggio…",
        "successToast": "Azione creata",
        "titleLabel": "Titolo",
        "titlePlaceholder": "ad es. check-in di benessere 1:1",
        "scheduledAtLabel": "Data e ora",
        "locationOrLinkLabel": "Link / posizione della riunione",
        "locationOrLinkPlaceholder": "ad es. https://meet… o un indirizzo",
        "requestCheckinHint": "Aggiunge un check-in una tantum alla timeline del talento che alimenta il loro indice di benessere.",
        "type": {
          "call": "Chiamata",
          "video_call": "Videochiamata",
          "in_person_meeting": "Riunione di persona",
          "message": "Messaggio",
          "internal_note": "Nota interna",
          "request_checkin": "Richiedi un check-in",
          "buddy_connect": "Collegati con un amico",
          "checkpoint_trigger": "Attiva un checkpoint",
          "coaching_note": "Nota di coaching",
          "manager_alert": "Avvisa un manager",
          "mission_recommend": "Raccomanda una missione",
          "personal_check_in": "Check-in personale",
          "reminder": "Imposta un promemoria",
          "support_resource": "Condividi una risorsa di supporto"
        },
        "typeLabel": "Tipo di interazione",
        "bulkAppliesTo_one": "Questo piano si applica a {{count}} talento:",
        "bulkAppliesTo_other": "Questo piano si applica a {{count}} talenti:",
        "dialogTitleBulk_one": "Intervenire su {{count}} talento",
        "dialogTitleBulk_other": "Intervenire su {{count}} talenti",
        "submitBulk_one": "Crea {{count}} azione",
        "submitBulk_other": "Crea {{count}} azioni",
        "bulkAppliesToMatching_one": "Questo piano raggiunge il {{count}} talento che corrisponde ai tuoi filtri e ha bisogno di un intervento.",
        "bulkAppliesToMatching_other": "Questo piano raggiunge tutti i {{count}} talenti che corrispondono ai tuoi filtri e hanno bisogno di un intervento."
      },
      "effectiveCare": {
        "scheduleLabel": "Programma {{schedule}}",
        "providersList": "Fornitori: {{providers}}",
        "customize": "Personalizza",
        "detailsTitle": "Dettagli di configurazione Care",
        "fullConfigFor": "Configurazione completa per {{name}}",
        "inheritedFromSuffix": "(ereditato da {{source}})",
        "activeCarePillars": "Pilastri attivi Care",
        "checkpointSchedule": "Piano di controllo",
        "scheduleTitle": "Programma {{schedule}}",
        "talentObjectivesCount": "Obiettivi di talento ({{count}})",
        "feedbackConfiguration": "Configurazione del feedback",
        "inheritanceInfoCustomized": "Questo {{level}} ha impostazioni Care personalizzate. Clicca su \"Ripristina\" per tornare alle impostazioni di {{source}}.",
        "inheritanceInfoInherited": "Questo {{level}} eredita tutte le impostazioni Care da {{source}}. Clicca su \"Personalizza\" per sovrascrivere impostazioni specifiche solo per questo {{level}}.",
        "activeCount_one": "{{count}} attivo",
        "activeCount_other": "{{count}} attivi",
        "moreObjectives_one": "+{{count}} obiettivo aggiuntivo",
        "moreObjectives_other": "+{{count}} obiettivi aggiuntivi"
      }
    },
    "carePage": {
      "act": "Intervieni",
      "actAria": "Intervenire per {{name}}",
      "activeTab": "Attivo",
      "activeTracking": "Monitoraggio attivo",
      "archivedTab": "Archiviato",
      "commitmentDistribution": "Distribuzione dell'impegno",
      "startedSummary": "{{started}} di {{total}} iniziati",
      "awaitingCheckin": "In attesa del primo check-in",
      "pillarsCardSubtitle": "Benessere per pilastro all'interno del gruppo",
      "pillarsEmptyHint": "La salute del pilastro appare una volta che i talenti completano il loro primo check-in di Care.",
      "bandChampion": "Campione",
      "bandCommitted": "Impegnato",
      "bandEngaged": "Coinvolto",
      "bandAtRisk": "A rischio",
      "bandFlightRisk": "Rischio di abbandono",
      "bandTracked": "Monitorato",
      "clearSelection": "Cancella selezione",
      "errors": {
        "notesTooLong": "Le note devono contenere 2000 caratteri o meno"
      },
      "feedbackPending": "Feedback in attesa",
      "interveneAria": "Intervenire per {{name}}",
      "talentRowActionsAria": "Azioni per {{name}}",
      "viewAllRisks": "Visualizza tutti i rischi",
      "viewDetails": "Visualizza dettagli",
      "viewDetailsAria": "Visualizza dettagli di cura per {{name}}",
      "aiCommitmentInsights": "AI commitment insights",
      "allCohorts": "Tutte le coorti",
      "allLevels": "Tutti i livelli",
      "allPillars": "Tutti i pilastri",
      "atRiskFilter": "a rischio",
      "carePillar": "Pilastro di Care",
      "carePillarsHealth": "Salute dei pilastri di Care",
      "champions": "Campioni",
      "championsDesc": "I tuoi talenti più impegnati, dal Commitment Index più alto",
      "championsFilter": "Campioni",
      "commitment": "Impegno",
      "commitmentChampions": "Campioni dell'impegno",
      "commitmentLabel": "Impegno",
      "commitmentPercent": "{{value}}%",
      "commitmentRiskAlert": "Avviso di rischio di impegno",
      "coldStartDesc": "Non appena un talento invitato completa la propria valutazione di Care o il primo check-in, il loro Indice di Impegno e la salute del pilastro appaiono qui.",
      "coldStartTitle": "Nessuna attività di Care ancora",
      "committedFilter": "Impegnato",
      "description": "Benessere, impegno e interventi per i tuoi talenti sponsorizzati",
      "engagedFilter": "Coinvolto",
      "filterByCohort": "Filtra per coorte",
      "filterByPillar": "Pilastro",
      "flightRiskCount_one": "{{count}} talenti a rischio di volo",
      "flightRiskCount_other": "{{count}} talenti a rischio di volo",
      "flightRiskFilter": "Rischio di abbandono",
      "healthy": "Sano",
      "inCare": "In Care",
      "insights": "Approfondimenti",
      "intervene": "Intervieni",
      "interventionQueue": "Coda di intervento",
      "interventionQueueDesc": "Talenti che hanno bisogno di un intervento o devono un feedback, i più urgenti prima",
      "needCare": "Necessita di Care",
      "decliningCommitment": "In declino",
      "commitmentIndexLabel": "Indice di impegno",
      "awaitingSelfEvalCount_one": "+{{count}} in attesa di auto-valutazione",
      "awaitingSelfEvalCount_other": "+{{count}} in attesa di auto-valutazione",
      "overdueCheckpoints": "Checkpoint scaduti",
      "needIntervention": "Necessita di intervento",
      "noTalentsFound": "Nessun talento trovato",
      "overallTalentLoyalty": "Fedeltà complessiva dei talenti",
      "overdue": "Scaduto",
      "pendingFeedback": "Feedback in attesa",
      "pillars": "Piloni",
      "searchTalents": "Cerca talenti",
      "selectAllVisible": "Seleziona tutti in questa pagina",
      "selectTalentAria": "Seleziona {{name}} per intervento di massa",
      "smartRecommendations": "Raccomandazioni intelligenti",
      "talentsLabel": "Talenti",
      "title": "Care",
      "tracked": "Monitorato",
      "tryAdjustingFilters": "Prova a regolare i filtri",
      "frequency": {
        "weekly": "Settimanale",
        "biweekly": "Bi-settimanale",
        "monthly": "Mensile",
        "quarterly": "Trimestrale",
        "semiannual": "Semestrale"
      },
      "commitmentIndexHeading": "Indice di impegno",
      "gettingStartedBadge": "Iniziare",
      "allClearTitle": "Tutto chiaro",
      "allClearDescription": "Nessun talento necessita di intervento immediato",
      "clearFilters": "Cancella filtri",
      "routineStatus": {
        "overdue": "Scaduto",
        "in_progress": "In corso",
        "scheduled": "Programmato",
        "completed": "Completato",
        "open": "Apri",
        "resolved": "Risolto",
        "cancelled": "Annullato"
      },
      "commitmentHealth": "Salute dell'impegno",
      "viewPillarTalentsAria": "Visualizza talenti sotto {{pillar}}",
      "weakOnPillar": "Debole in {{pillar}}",
      "pillarName": {
        "housing_stability": "Alloggio",
        "schooling_childcare": "Istruzione",
        "work_fit": "Lavoro",
        "wellbeing_social": "Benessere"
      },
      "pillarStatus": {
        "healthy": "Sano",
        "moderate": "Moderato",
        "concern": "Preoccupazione"
      },
      "insightsRecommendations": {
        "socialPillar": "Il pilastro sociale è al {{value}}% — considera attività di team bonding",
        "schedule1on1s": "Pianifica 1:1",
        "planActivities": "Pianifica attività",
        "createProgram": "Crea programma",
        "flightRisk_one": "{{count}} talento è a rischio di uscita — pianifica subito un 1:1 con l'HRBP",
        "flightRisk_other": "{{count}} talenti sono a rischio di uscita — pianifica subito degli 1:1 con l'HRBP",
        "championsProgram_one": "{{count}} campione identificato — considera un programma di ambasciatori",
        "championsProgram_other": "{{count}} campioni identificati — considera un programma di ambasciatori"
      },
      "trendMetrics": {
        "avgCommitmentIndex": "Indice di impegno medio",
        "champions": "Campioni",
        "flightRisk": "Rischio di uscita"
      },
      "scored": "Punteggiato",
      "objectivesTitle": "Obiettivi e feedback",
      "objectivesEmpty": "Nessun obiettivo è stato assegnato a questo talento. Configurali nella strategia di Care.",
      "objectivesLoadError": "Impossibile caricare gli obiettivi.",
      "objectivesRetry": "Riprova",
      "objectiveFeedbackCycleStatus": {
        "provider_submitted": "Fornitore inviato",
        "completed": "Completato",
        "overdue": "Scaduto"
      },
      "objectiveFeedbackNoCycle": "Nessun ciclo di feedback è aperto in questo momento. Gli obiettivi sono elencati di seguito; un modulo appare quando si apre il prossimo ciclo.",
      "objectiveFeedbackProviderLabel": "Fornitore",
      "objectiveFeedbackSelfLabel": "Auto-valutazione",
      "objectiveFeedbackCommentLabel": "Commento (facoltativo)",
      "objectiveFeedbackCommentPlaceholder": "Condividi feedback specifico e attuabile…",
      "objectiveFeedbackSubmitting": "Invio in corso…",
      "objectiveFeedbackDueTitle": "Feedback dovuto",
      "objectiveFeedbackDueEmpty": "Nessun ciclo di feedback aperto in questo momento. Sei aggiornato.",
      "objectiveFeedbackDueLoadError": "Impossibile caricare l'elenco dei feedback dovuti.",
      "objectiveFeedbackDueRow": "Scadenza {{date}}",
      "objectiveFeedbackDueCurrent": "Visualizzazione",
      "feedbackStrategyScope": "Configurazione feedback risolta · {{scope}}",
      "feedbackStrategyLoading": "Caricamento…",
      "feedbackStrategyError": "Impossibile caricare la strategia di feedback.",
      "feedbackCadenceLabel": "Cadenza",
      "feedbackProvidersLabel": "Fornitori",
      "feedbackProvidersNone": "Nessun fornitore configurato",
      "feedbackProvider": {
        "admin": "Admin",
        "team_member": "Membro del team"
      },
      "scopeCompanyWide": "A livello aziendale",
      "scopeCohort": "Coorte selezionata",
      "tabs": {
        "feedback": "Feedback",
        "interactions": "Interazioni"
      },
      "objectivesProgress": {
        "title": "Progresso degli obiettivi",
        "desc": "Quota in linea e progresso medio per obiettivo, su tutti i talenti."
      },
      "objectiveFeedback": {
        "title": "Feedback sugli obiettivi",
        "desc": "Feedback strutturato, basato sugli obiettivi, alla cadenza configurata. Valuta ogni talento rispetto ai loro obiettivi; completano un'autovalutazione in cambio.",
        "dueKpi": "Feedback dovuto",
        "awaitingSelfEvalKpi": "In attesa di autovalutazione",
        "caughtUp": "Tutto aggiornato — nessun feedback dovuto in questo momento.",
        "rowStatusOpen": "Ha bisogno della tua valutazione",
        "rowStatusProviderSubmitted": "In attesa dell'autovalutazione del talento",
        "notProvider": "Non sei un fornitore di feedback configurato per questo ambito. Chiedi a un Admin di aggiungere il tuo ruolo nelle impostazioni di Care.",
        "loadError": "Impossibile caricare la casella di posta del feedback."
      },
      "objectiveFeedbackNotGoverning": "Un'altra azienda gestisce il Care di questo talento, quindi solo lei dà feedback e fissa gli obiettivi. Puoi leggere le autovalutazioni del talento.",
      "commitmentAtAGlance": "Impegno in sintesi",
      "commitmentAtAGlanceDesc": "A che punto sono oggi i tuoi talenti valutati",
      "ofScored": "{{value}} su {{total}} valutati",
      "bulkInterveneCta_one": "Pianifica un intervento per {{count}} talento",
      "bulkInterveneCta_other": "Pianifica un intervento per {{count}} talenti",
      "pendingCount_one": "{{count}} in attesa",
      "pendingCount_other": "{{count}} in attesa",
      "selectedCount_one": "{{count}} selezionato",
      "selectedCount_other": "{{count}} selezionati",
      "gettingStartedNote_one": "+ {{count}} agli inizi (non ancora abbastanza check-in per un punteggio)",
      "gettingStartedNote_other": "+ {{count}} agli inizi (non ancora abbastanza check-in per un punteggio)",
      "interveneAllMatching_one": "Intervieni sul {{count}} corrispondente",
      "interveneAllMatching_other": "Intervieni su tutti i {{count}} corrispondenti",
      "interveneAllFlightRisk_one": "Intervieni sul {{count}} a rischio di uscita",
      "interveneAllFlightRisk_other": "Intervieni su tutti i {{count}} a rischio di uscita"
    },
    "heroOverview": {
      "title": "Panoramica del percorso",
      "subtitle": "Monitora progresso",
      "acquisition": {
        "title": "Acquisizione",
        "description": "Talenti invitati che non hanno ancora accettato.",
        "open": "Apri acquisizione nel Pipeline",
        "pendingInvites": "invito in attesa",
        "statusLabel": "Stato",
        "awaitingAcceptance": "In attesa di accettazione",
        "ttl": "TTL invito di 14 giorni",
        "viewInPipeline": "Visualizza nel pipeline",
        "empty": "Tutti gli invitati hanno accettato. Nuove inviti arriveranno qui."
      },
      "vetting": {
        "title": "Verifica",
        "description": "Funnel pre-sponsorizzazione — invitati, screening, completati.",
        "open": "Apri verifica",
        "inVetting": "In verifica",
        "passRate": "Tasso di passaggio",
        "funnel": "Funnel",
        "inProgress": "screening",
        "completed": "completati",
        "done": "fatto"
      },
      "sponsored": {
        "title": "Sponsorizzato",
        "empty": "Nessun talento sponsorizzato ancora. Una volta che un talento è sponsorizzato, la loro Mobilità, Adattamento e coinvolgimento in Care appariranno qui.",
        "headcount_one": "{{count}} talento",
        "headcount_other": "{{count}} talenti"
      },
      "mobility": {
        "title": "Mobilità",
        "activeOfTotal_one": "{{count}} di {{total}} attivo",
        "activeOfTotal_other": "{{count}} di {{total}} attivi"
      },
      "adaptation": {
        "title": "Adattamento",
        "activeOfTotal_one": "{{count}} di {{total}} attivo",
        "activeOfTotal_other": "{{count}} di {{total}} attivi"
      },
      "care": {
        "title": "Care",
        "activeOfTotal_one": "{{count}} di {{total}} attivo",
        "activeOfTotal_other": "{{count}} di {{total}} attivi"
      },
      "notStartedYet_one": "{{count}} sponsorizzato · non ancora iniziato",
      "notStartedYet_other": "{{count}} sponsorizzati · non ancora iniziati",
      "notStartedMore_one": "+{{count}} altro",
      "notStartedMore_other": "+{{count}} altri"
    },
    "cohorts": {
      "activeCohorts": "Coorti in corso",
      "addTalents": "Aggiungi talenti",
      "adjustFilters": "Regola filtri",
      "alerts": "Avvisi",
      "all": "Tutti",
      "allPrograms": "Tutti i programmi",
      "allStatus": "Tutti gli stati",
      "askCoPilot": "Chiedi a CoPilot",
      "atRisk": "a rischio",
      "atRiskLabel": "a rischio",
      "avgProgress": "Media progresso",
      "backToCohorts": "Torna alle coorti",
      "biWeekly": "Ogni due settimane",
      "blocked": "Bloccato",
      "care": "Care",
      "careRequiresEnterprise": "Care richiede Enterprise",
      "careSettingsReset": "Ripristino delle impostazioni di Care",
      "careSettingsSaved": "Strategia di Care salvata",
      "cohortCreated": "Coorte creata",
      "cohortDeleted": "Coorte eliminata",
      "cohortNameLabel": "Nome della coorte",
      "cohortNamePlaceholder": "Inserisci il nome della coorte...",
      "cohortPaused": "Coorte in pausa",
      "cohortResumed": "Coorte ripresa",
      "cohortUpdated": "Coorte aggiornata",
      "createCohort": "Crea cohorte",
      "createDialogDescription": "Una coorte è un gruppo di talenti che stai portando insieme nel percorso — stessa finestra di inizio, stessa destinazione, stesso programma.",
      "createFirstCohort": "Crea prima coorte",
      "createNewCohort": "Crea nuovo gruppo",
      "deleteCohort": "Elimina coorte",
      "deleteConfirmDescription": "Questo eliminerà permanentemente la coorte. Questa azione non può essere annullata.",
      "deleteConfirmTitle": "Eliminare questa coorte?",
      "deleteFailed": "Impossibile eliminare la coorte",
      "description": "Raggruppa i talenti per ingresso per seguirli insieme",
      "editCohort": "Modifica coorte",
      "editDialogDescription": "Aggiorna i dettagli della coorte qui sotto.",
      "exportCsv": "Esporta CSV",
      "exportCsvFailed": "Non è stato possibile esportare questa coorte. Riprova.",
      "exportCsvTruncated": "Questa esportazione include solo i primi 500 talenti — questa coorte ne ha di più.",
      "exportingCsv": "Esportazione…",
      "warningRosterTruncated": "Visualizzazione di {{exported}} di {{total}} talenti — questa coorte è più grande di quanto l'elenco possa mostrare.",
      "warningAcceptedWithoutJourney_one": "{{count}} invito accettato non ha ancora un percorso registrato.",
      "warningAcceptedWithoutJourney_other": "{{count}} inviti accettati non hanno ancora un percorso registrato.",
      "feedbackCadence": "Cadenza di feedback",
      "fillRequiredFields": "Compila i campi richiesti",
      "filterByProgram": "Filtra per programma",
      "getMoreInsights": "Ottieni maggiori informazioni",
      "insights": "Approfondimenti",
      "insightsDescription": "Come sta procedendo questa coorte",
      "insightCompletionRate": "Il {{percent}}% dei talenti attivi di questa coorte ha raggiunto la fase Prove.",
      "insightSponsoredWithoutCare_one": "{{count}} talento sponsorizzato non ha punti di contatto Care attivi — verifica la cadenza dei check-in.",
      "insightSponsoredWithoutCare_other": "{{count}} talenti sponsorizzati non hanno punti di contatto Care attivi — verifica la cadenza dei check-in.",
      "insightsEmpty": "Non ci sono ancora risultati per questa coorte.",
      "inviteToVetting": "Invita alla Selezione",
      "iqulture": "iQulture",
      "journeyOverview": "Panoramica del percorso",
      "latestUpdates": "Ultimi aggiornamenti",
      "messageCohort": "Messaggio alla coorte",
      "monthly": "Mensile",
      "noCohortsFound": "Nessuna coorte trovata",
      "noProgramUnassigned": "Nessun programma non assegnato",
      "notFound": "Coorte non trovata",
      "notFoundDesc": "Questa coorte non esiste o è stata eliminata. Prova a tornare all'elenco delle coorti.",
      "onTrack": "In corso",
      "overview": "Panoramica",
      "pauseCohort": "Pausa coorte",
      "programOptional": "Programma facoltativo",
      "progress": "Progresso",
      "quarterly": "Trimestrale",
      "recentActivity": "Attività recenti",
      "requestUpdate": "Richiedi aggiornamento",
      "resumeCohort": "Riprendi coorte",
      "searchCohorts": "Cerca gruppi",
      "searchTalents": "Cerca talenti",
      "selectProgram": "Seleziona programma",
      "sendMessage": "Invia messaggio",
      "stability": "Stabilità",
      "startDateLabel": "Data di inizio",
      "started": "Iniziato",
      "status": "Stato",
      "statusChangeFailed": "Impossibile cambiare lo stato della coorte",
      "targetArrival": "Arrivo previsto",
      "talents": "Talenti",
      "title": "Cohorti",
      "totalTalents": "Talenti totali",
      "trackProgress": "Monitora progresso",
      "unassigned": "Non assegnato",
      "updateFailed": "Impossibile aggiornare la coorte",
      "viewDetails": "Visualizza dettagli",
      "viewProfile": "Visualizza profilo",
      "whatHappensNext": "Cosa succede dopo",
      "whatHappensNextDescription": "Atterrerai sulla pagina dei dettagli della coorte dove puoi invitare direttamente i talenti, assegnarli dal Pool e seguire i loro progressi attraverso il Vetting e i parallel Sponsored heroes (Mobilità, Adattamento, Care).",
      "errors": {
        "nameRequired": "Il nome della coorte è obbligatorio",
        "nameTooLong": "Il nome della coorte deve contenere 200 caratteri o meno",
        "descriptionTooLong": "La descrizione deve contenere 2000 caratteri o meno",
        "planLimit": "Il piano gratuito consente 1 coorte attiva. Aggiorna a Enterprise per coorti illimitate."
      },
      "cohortActionsAria": "Azioni per {{name}}",
      "emptyTalentsTitle": "Nessun talento in questa coorte ancora",
      "emptyTalentsDescription": "Invita talenti o importa un elenco per iniziare a tracciarli attraverso la Verifica e la Sponsorizzazione.",
      "addTalentsAria": "Aggiungi talenti a {{name}}",
      "descriptionLabel": "Descrizione",
      "descriptionPlaceholder": "Note facoltative su questa coorte",
      "targetShort": "Target",
      "startDateUnset": "Data di inizio non impostata",
      "feedbackCadenceAria": "Frequenza feedback: {{cadence}}",
      "targetArrivalAria": "Arrivo target: {{date}}",
      "talentRowActionsAria": "Azioni per {{name}}",
      "archiveSuccess": "{{name}} spostato in archiviato.",
      "archiveFailed": "Impossibile archiviare la coorte",
      "restoreSuccess": "{{name}} ripristinato.",
      "restoreFailed": "Impossibile ripristinare la coorte",
      "activeTab": "Attivo",
      "archivedTab": "Archiviato",
      "manageArchivedOnPipeline": "Gestisci nella pipeline",
      "archivedReadOnly": "Gli ingaggi archiviati qui sono di sola lettura. Ripristinali dalla Pipeline.",
      "archivedEmptyTitle": "Nessun ingaggio archiviato in questa coorte",
      "selectAllAria": "Seleziona tutti i talenti",
      "selectAllCount": "Seleziona tutto ({{selected}}/{{total}})",
      "viewInPipeline": "Visualizza talenti nel Pipeline",
      "disabledPausedCohort": "Riprendi la coorte per abilitare questa azione",
      "disabledPausedProgram": "Riprendi il programma principale per abilitare questa azione",
      "archive": "Archivia",
      "restore": "Ripristina",
      "archiveConfirmTitle": "Archiviare la coorte?",
      "archiveConfirmDescription": "{{name}} si sposta nella scheda Archiviato. Ripristina in qualsiasi momento da lì. I talenti esistenti non sono influenzati.",
      "scope": {
        "active": "Attivo",
        "archived": "Archiviato"
      },
      "form": {
        "talentCountPlaceholder": "ad es., 20"
      },
      "atRiskCount_one": "{{count}} a rischio",
      "atRiskCount_other": "{{count}} a rischio",
      "blockedCount_one": "{{count}} bloccato",
      "blockedCount_other": "{{count}} bloccati",
      "inviteCountToVetting_one": "Invita {{count}} a Vetting",
      "inviteCountToVetting_other": "Invita {{count}} a Vetting",
      "selectedCount_one": "{{count}} selezionato",
      "selectedCount_other": "{{count}} selezionati"
    },
    "common": {
      "add": "Aggiungi",
      "back": "Indietro",
      "cancel": "Annulla",
      "change": "Cambia",
      "clear": "Cancella",
      "close": "Chiudi",
      "confidence": "fiducia",
      "confirm": "Conferma",
      "continue": "Continua",
      "founded": "Fondato",
      "loading": "Caricamento...",
      "of": "di",
      "optional": "Facoltativo",
      "other": "Altro",
      "save": "Salva",
      "select": "Seleziona",
      "tryAgain": "Riprova",
      "view": "Visualizza",
      "yourCompany": "la tua azienda",
      "error": {
        "sectionTitle": "Impossibile caricare questa sezione",
        "sectionDescription": "Qualcosa è andato storto nel recupero dei dati. Riprova — se il problema persiste, contatta il supporto.",
        "retry": "Riprova"
      },
      "relativeTime": {
        "justNow": "proprio adesso",
        "today": "Oggi",
        "yesterday": "Ieri",
        "weekAgo": "1 settimana fa",
        "monthAgo": "1 mese fa"
      },
      "contactPlaceholder": "contact@tonnie.ai"
    },
    "components": {
      "addTalentsWizard": {
        "assignToCohort": "Assegna al gruppo",
        "back": "Indietro",
        "cancel": "Annulla",
        "chooseCohortTalentsDesc": "Scegli la coorte a cui si uniscono questi talenti",
        "bringFromPool": "Porta dal Tonnie Pool",
        "browsePool": "Esplora Pool",
        "chooseImportMethod": "Scegli metodo di importazione",
        "confirmAndImport": "Conferma & importa",
        "confirmImport": "Conferma importazione",
        "createNewCohort": "Crea nuovo gruppo",
        "createNewProgram": "Crea nuovo programma",
        "importing": "Importazione in corso...",
        "mapColumns": "Mappa colonne",
        "mapColumnsDesc": "Abbina le colonne del foglio ai campi di Tonnie",
        "needHelpChoosing": "Hai bisogno di aiuto per scegliere",
        "needHelpDescriptionNoATS": "Carica file Excel o CSV, oppure porta talenti dal tuo Tonnie Talent Pool (Enterprise), per aggiungerli alla tua pipeline. L'integrazione ATS sarà disponibile in una versione futura.",
        "next": "Avanti",
        "reviewData": "Rivedi dati",
        "reviewDataDesc": "Controlla ogni riga prima dell'importazione",
        "selectImportDesc": "Importa da un foglio di calcolo o dal tuo ATS",
        "selectTargetCohort": "Seleziona coorte target",
        "uploadExcelCsv": "Carica Excel csv",
        "uploadFile": "Carica file",
        "uploadFileDesc": "Un file Excel o CSV con un talento per riga"
      },
      "addToCohort": {
        "addToCohortBtn": "Aggiungi alla coorte",
        "afterAdding": "Dopo aver aggiunto",
        "cancel": "Annulla",
        "chooseCohort": "Scegli coorte",
        "cohortDetails": "Dettagli del gruppo",
        "currentTalents": "Talenti correnti",
        "pleaseSelectCohort": "Si prega di selezionare una coorte",
        "program": "Programma",
        "selectCohort": "Seleziona gruppo",
        "title": "Aggiungi alla coorte",
        "unassigned": "Non assegnato",
        "description_one": "Seleziona una coorte a cui aggiungere il {{count}} talento selezionato",
        "description_other": "Seleziona una coorte a cui aggiungere i {{count}} talenti selezionati",
        "talentsAdded_one": "{{count}} talento aggiunto alla coorte",
        "talentsAdded_other": "{{count}} talenti aggiunti alla coorte",
        "talentsSelected_one": "{{count}} talento selezionato",
        "talentsSelected_other": "{{count}} talenti selezionati",
        "talentCount_one": "{{count}} talento",
        "talentCount_other": "{{count}} talenti"
      },
      "confirmDialog": {
        "processing": "Elaborazione"
      },
      "countrySelect": {
        "noResults": "Nessun risultato",
        "placeholder": "Segnaposto",
        "search": "Cerca"
      },
      "pageHeader": {
        "coPilot": "CoPilot",
        "goBack": "Torna indietro"
      }
    },
    "consent": {
      "objectivesNotShared": "Questo talento non condivide Care con la tua azienda, quindi i suoi obiettivi non vengono mostrati.",
      "withheld": {
        "care_one": "{{count}} talento non condivide Care",
        "care_other": "{{count}} talenti non condividono Care",
        "checkup_one": "{{count}} talento non condivide il risultato del CheckUp",
        "checkup_other": "{{count}} talenti non condividono il risultato del CheckUp",
        "passport_stamps_one": "{{count}} talento non condivide il Passport",
        "passport_stamps_other": "{{count}} talenti non condividono il Passport",
        "qultureup_one": "{{count}} talento non condivide QultureUp",
        "qultureup_other": "{{count}} talenti non condividono QultureUp",
        "teleportal_one": "{{count}} talento non condivide TelePortal",
        "teleportal_other": "{{count}} talenti non condividono TelePortal"
      }
    },
    "copilot": {
      "open": "Apri CoPilot"
    },
    "dashboard": {
      "activeJourneys": "Viaggi attivi",
      "addToTalentPool": "Aggiungi al pool di talenti",
      "aiCoPilot": "AI CoPilot",
      "allClear": "Tutto chiaro",
      "allClearTitle": "Tutto chiaro",
      "askCoPilot": "Chiedi a CoPilot",
      "attention": "Richiede attenzione",
      "averageScore": "Punteggio medio",
      "coPilotDescription": "Chiedi al tuo assistente AI informazioni sulla mobilità dei talenti, raccomandazioni sui programmi e analisi dei dati.",
      "conversionRate": "{{rate}}% di conversione",
      "createCohort": "Crea cohorte",
      "critical": "Critico",
      "evidence": "Prove",
      "exploreHeroes": "Esplora eroi",
      "healthy": "Sano",
      "heroes": {
        "assessReadiness": "Valuta la prontezza dei talenti e l'adattamento culturale",
        "checkupAndPool": "CheckUp & Pool",
        "commitment": "Impegno",
        "culturalAdaptation": "Adattamento culturale & iQulture",
        "legalTravelSetup": "Impostazione legale, viaggi e trasferimenti",
        "wellbeingLoyalty": "Monitoraggio del benessere e della fedeltà",
        "inTransitCount_one": "{{count}} in transito",
        "inTransitCount_other": "{{count}} in transito",
        "learningCount_one": "{{count}} in apprendimento",
        "learningCount_other": "{{count}} in apprendimento",
        "talentsCount_one": "{{count}} talento",
        "talentsCount_other": "{{count}} talenti",
        "thrivingCount_one": "{{count}} in crescita",
        "thrivingCount_other": "{{count}} in crescita"
      },
      "importTalents": "Importa talenti",
      "inCheckUp": "In CheckUp",
      "iqulture": "iQulture",
      "journeyFlow": "Flusso di viaggio",
      "launchProgram": "Lancia programma",
      "milesAndStamps": "{{miles}} miglia · {{stamps}} timbri",
      "navigateToDashboards": "Naviga verso dashboard specializzati",
      "needAttention": "Necessita attenzione",
      "needsAttention": "Richiede attenzione",
      "attentionMyTasks": "I miei compiti",
      "attentionAtRisk": "A rischio",
      "noRecentEvents": "Nessun evento recente",
      "noUrgentItems": "Nessun elemento urgente che richiede attenzione",
      "onTrack": "In corso",
      "organizeTalents": "Organizza i talenti in gruppi",
      "pipeline": "Pipeline",
      "portfolioHealth": "Salute del portfolio",
      "portfolioSummary": "Gestendo {{programs}} programmi e {{cohorts}} coorti",
      "profileCompletion": {
        "addRemainingDetails": "Aggiungi i dettagli rimanenti",
        "complexFieldNotice": "Questo campo è modificabile dal wizard di onboarding. Clicca su 'Completa nel wizard di onboarding' per aggiornarlo.",
        "description": "Aggiungi qualche dettaglio in più per sbloccare un abbinamento migliore e una fatturazione più rapida.",
        "descriptionAlmostThere": "Sei quasi lì — completa qualche dettaglio in più per finire il tuo profilo.",
        "dialogDesc": "Questo richiede alcuni secondi e rende l'abbinamento dei talenti più accurato.",
        "fields": {
          "annualHiringVolume": "Volume di assunzioni annuale",
          "branches": "Uffici secondari",
          "businessType": "Tipo di attività",
          "companyName": "Nome dell'azienda",
          "companySize": "Dimensione dell'azienda",
          "contactPhone": "Telefono di contatto",
          "contactRole": "Ruolo di contatto",
          "foundedYear": "Anno di fondazione",
          "hiringGoals": "Obiettivi di assunzione",
          "hiringTimeframe": "Tempistica di assunzione",
          "hqCountry": "Paese della sede",
          "industry": "Settore",
          "languages": "Requisiti linguistici",
          "legalName": "Nome dell'entità legale",
          "mobilityMaturity": "Maturità della mobilità",
          "primaryUseCase": "Caso d'uso principale",
          "targetMarkets": "Mercati target",
          "targetRoleTypes": "Tipi di ruoli target",
          "taxId": "ID fiscale / IVA",
          "topChallenges": "Principali sfide",
          "website": "Sito web",
          "workArrangement": "Modalità di lavoro"
        },
        "finishInWizard": "Completa nel wizard di onboarding",
        "seeAll": "Vedi tutto ({{count}})",
        "title": "Completa il tuo profilo",
        "descriptionWithCount_one": "{{count}} dettaglio ancora da inserire — ci vuole circa un minuto.",
        "descriptionWithCount_other": "{{count}} dettagli ancora da catturare — ci vuole circa un minuto."
      },
      "quickActions": "Azioni veloci",
      "recentActivity": "Attività recenti",
      "sendCheckUp": "Invia CheckUp",
      "sponsored": "Sponsorizzato",
      "stages": {
        "adaptation": "Adattamento",
        "care": "Care",
        "mobility": "Mobilità",
        "vetting": "Verifica"
      },
      "startNewMobility": "Inizia un nuovo programma di mobilità",
      "startVettingProcess": "Inizia il processo di verifica",
      "talentDistribution": "Distribuzione dei talenti nelle fasi del percorso",
      "topPerformers": "Top performer",
      "urgent": "Urgente",
      "myCareTasks": {
        "title": "I miei compiti critici",
        "viewAll": "Visualizza tutto in Care"
      },
      "viewAllEvents": "Visualizza tutti gli eventi",
      "viewAllIssues": "Visualizza tutti i problemi",
      "viewAnalytics": "Visualizza analisi",
      "welcomeBackBusiness": "Bentornato, {{name}}!",
      "onboarding": {
        "title": "Benvenuto in Tonnie. Configuriamo i tuoi primi talenti.",
        "body": "Il tuo cruscotto si riempie non appena importi talenti e li raggruppi in un programma. Due passaggi e sei attivo in acquisizione, selezione e sponsorizzazione.",
        "importTitle": "Importa talenti",
        "importBody": "Carica un CSV o XLSX, o aggiungi candidati uno alla volta. Le inviti verranno inviate non appena confermi.",
        "programTitle": "Crea il tuo primo programma",
        "programBody": "I programmi raggruppano le coorti e mostrano metriche di acquisizione / selezione / sponsorizzazione in un unico posto.",
        "helperHint": "Suggerimento: puoi fare prima uno dei due passaggi — si collegano automaticamente una volta che entrambi esistono.",
        "skipToPipeline": "Vai al pipeline",
        "skipToPool": "Sfoglia il Pool"
      },
      "todayPanel": {
        "blockedSubtitle": "Apri il cassetto per rimuovere il blocco",
        "atRiskSubtitle": "Un piccolo incoraggiamento oggi mantiene questo viaggio in carreggiata",
        "title": "Priorità di oggi",
        "blockedItem": "{{name}}: bloccato",
        "atRiskItem": "{{name}}: a rischio",
        "countLabel_one": "{{count}} azione",
        "countLabel_other": "{{count}} azioni"
      },
      "weeklySummary": {
        "thisWeek": "Questa settimana"
      },
      "blockedFallback": "Processo bloccato",
      "riskFallback": "A rischio",
      "attentionAdaptationRisk": "Scarso coinvolgimento nell'adattamento",
      "attentionCareRisk": "Impegno a rischio",
      "atRiskCount_one": "{{count}} a rischio",
      "atRiskCount_other": "{{count}} a rischio",
      "blockedCount_one": "{{count}} bloccato",
      "blockedCount_other": "{{count}} bloccati",
      "attentionOverdue_one": "{{count}} scaduto",
      "attentionOverdue_other": "{{count}} scaduti",
      "welcomeBackBusinessNoName": "Bentornato!"
    },
    "evidence": {},
    "evidencePage": {
      "activeTab": "Attivo",
      "activity": "Attività",
      "archivedTab": "Archiviato",
      "adaptation": "Adattamento",
      "allClear": "Tutto chiaro",
      "allCohorts": "Tutte le coorti",
      "allStages": "Tutte le fasi",
      "analysis": "Analisi",
      "cohortLabel": "Coorte",
      "irrTrendsEmpty": "Non ci sono ancora dati IRR sufficienti — il grafico di evoluzione si sblocca dopo almeno due mesi di attività.",
      "mesh": {
        "motivation": "Motivazione",
        "english": "Inglese",
        "softSkills": "Competenze trasversali",
        "hardSkills": "Competenze tecniche"
      },
      "openPassportAria": "Apri il passaporto per {{name}}",
      "sponsoredBadge": "Sponsorizzato",
      "stageNotShared": "Non condiviso",
      "talentRowActionsAria": "Azioni per {{name}}",
      "totalBadges": "Totale badge",
      "totalStamps": "Francobolli totali",
      "averageIQultureScore": "Punteggio medio iQulture",
      "avgIQulture": "Media iQulture",
      "avgProgress": "Media progresso",
      "careLabel": "Care",
      "carePillarsHealth": "Salute dei pilastri di Care",
      "carePillarsHealthDesc": "Come i tuoi talenti valutano ogni pilastro di Care",
      "checkUpProgress": "Avanzamento del CheckUp",
      "citizenBadges": "Citizen badge",
      "citizenBadgesDesc": "Badge che i tuoi talenti hanno ottenuto nei loro percorsi",
      "common": "Comune",
      "description": "La prova del percorso di ogni talento: passaporti, timbri e badge",
      "epic": "Epico",
      "estimatedContribution": "Contributo stimato",
      "events": "Eventi",
      "iqultureBadgeDist": "Distribuzione badge iQulture",
      "irrEvolution": "Evoluzione IRR",
      "irrEvolutionDesc": "Come sono cresciute nel tempo le evidenze dei tuoi talenti",
      "legendary": "Leggendario",
      "levelsDistributionDesc": "Quanti talenti hanno raggiunto ciascun livello cittadino",
      "meshScoreBreakdown": "Dettaglio MESH",
      "meshScoreDesc": "Punteggi MESH medi dei tuoi talenti valutati",
      "milesAndStamps": "{{miles}} miglia · {{stamps}} timbri",
      "milesFromAchievements": "Miles da risultati",
      "mobility": "Mobilità",
      "needsAttention": "Richiede attenzione",
      "overallHealthScore": "Punteggio di salute complessivo",
      "overview": "Panoramica",
      "passports": "Passaporti",
      "rare": "Raro",
      "uncommon": "Non comune",
      "noEvents": "Nessun evento ancora",
      "noPassports": "Nessun passaporto corrisponde ai tuoi filtri.",
      "rarityDistribution": "Distribuzione rarità",
      "recentEvents": "Eventi recenti",
      "searchTalents": "Cerca talenti",
      "sponsoredTalents": "Talenti sponsorizzati",
      "stageLabel": "Fase",
      "stampsBadges": "Risultati",
      "stampsCollection": "Collezione di francobolli",
      "stampsCollectionDesc": "Timbri che i tuoi talenti hanno raccolto a ogni traguardo",
      "talentReadinessLevels": "Livelli di prontezza dei talenti",
      "title": "Prove",
      "topPerformers": "Top performer",
      "totalMiles": "Miles totali",
      "vettingPool": "Pool di verifica",
      "talentStatus": {
        "on-track": "In corso",
        "at-risk": "A rischio",
        "blocked": "Bloccato",
        "completed": "Completato",
        "unknown": "Stato in attesa"
      },
      "pillarScoresPending": "I punteggi Care per pilastro appariranno qui una volta che la proiezione del backend Care sarà disponibile.",
      "stages": {
        "vetting": "Verifica",
        "mobility": "Mobilità",
        "adaptation": "Adattamento",
        "care": "Care"
      },
      "blockedCount_one": "{{count}} bloccato",
      "blockedCount_other": "{{count}} bloccati",
      "earned_one": "{{count}} guadagnato",
      "earned_other": "{{count}} guadagnati",
      "passportCount_one": "{{count}} passaporto",
      "passportCount_other": "{{count}} passaporti",
      "talentCount_one": "{{count}} talento",
      "talentCount_other": "{{count}} talenti"
    },
    "feedback": {
      "additionalFeedbackHint": "Puoi fornire feedback dettagliato, allegare screenshot o file per aiutarci a comprendere meglio la tua esperienza.",
      "attachFiles": "Allega file",
      "categoryDescription": "Seleziona la categoria che descrive meglio il tuo feedback",
      "categoryQuestion": "Che tipo di feedback è questo?",
      "characterCount": "{{current}}/{{max}} caratteri",
      "context": {
        "hero": "Eroe",
        "heroPlaceholder": "ad es., CheckUp, TelePortal",
        "notDetected": "Nessun contesto rilevato",
        "page": "Pagina",
        "pagePlaceholder": "ad es., /dashboard, /checkup"
      },
      "contextInfo": "Informazioni sul contesto",
      "contextSaved": "Informazioni sul contesto salvate",
      "detailsDescription": "Si prega di fornire dettagli sul proprio feedback",
      "detailsPlaceholder": "Descrivi il tuo feedback in dettaglio...",
      "detailsQuestion": "Dicci di più",
      "editContext": "Modifica",
      "fileSizeError": "La dimensione del file supera il limite di {{maxSize}}",
      "fileUploadDescription": "Aggiungi screenshot, PDF o altri file (fino a 20MB ciascuno) per aiutarci a comprendere meglio il tuo feedback.",
      "optional": "Facoltativo",
      "privacyNote": "Il tuo feedback è anonimo e ci aiuta a migliorare Tonnie",
      "ratingDescription": "Valuta la tua soddisfazione complessiva",
      "ratingQuestion": "Com'è stata la tua esperienza?",
      "selectRatingAndCategory": "Si prega di selezionare sia la valutazione che la categoria",
      "submit": "Invia",
      "submitError": "Invio del feedback non riuscito. Si prega di riprovare.",
      "submitSuccess": "Grazie! Il tuo feedback è stato inviato.",
      "submitting": "Invio in corso...",
      "subtitle": "Aiutaci a migliorare la tua esperienza",
      "successMessage": "Apprezziamo che tu abbia dedicato del tempo per aiutarci a migliorare Tonnie. Il tuo feedback è stato ricevuto e sarà esaminato dal nostro team.",
      "successTitle": "Grazie per il tuo feedback!",
      "title": "Feedback",
      "toggle": "Invia feedback",
      "totalFileSize": "{{size}} / {{maxSize}}",
      "uploadFiles": "Carica file",
      "validationError": "Si prega di completare tutti i campi obbligatori"
    },
    "affiliate": {
      "availableBalance": "Saldo disponibile",
      "codeCopied": "Codice coupon copiato",
      "colActions": "Azioni",
      "colAmount": "Importo",
      "colAmountPaid": "Importo pagato",
      "colCommission": "Commissione",
      "colDate": "Data",
      "colProgress": "Progresso",
      "colRequested": "Richiesto",
      "colRoute": "Percorso",
      "colScenario": "Scenario",
      "colStatus": "Stato",
      "daysWaiting": "{{count}}d in attesa",
      "paidOn": "Pagato {{date}}",
      "commission": "Commissione",
      "copyCode": "Copia codice",
      "discountGiven": "Sconto applicato",
      "exportCsv": "Esporta CSV",
      "exporting": "Esportazione in corso…",
      "exportReady": "Esportazione pronta",
      "exportFailed": "Impossibile esportare i riscatti",
      "filters": {
        "granularityLabel": "Raggruppa per",
        "granularity": {
          "day": "Giorno",
          "month": "Mese",
          "year": "Anno"
        },
        "rangeLabel": "Periodo",
        "range": {
          "30d": "30 giorni",
          "90d": "90 giorni",
          "12m": "12 mesi",
          "all": "Tutto il tempo"
        },
        "scenarioLabel": "Scenario",
        "scenarioAll": "Tutti gli scenari",
        "statusLabel": "Stato",
        "statusAll": "Tutti gli stati"
      },
      "scenario": {
        "unlock": "Sblocco viaggio",
        "renewal": "Rinnovo",
        "pro": "Pro",
        "other": "Altro"
      },
      "noRedemptionsForFilters": "Nessun riscatto corrisponde a questi filtri.",
      "redemptionsTitle": "Riscatti",
      "rowsPerPage": "Righe per pagina",
      "showingRange": "{{from}}–{{to}} di {{total}}",
      "goToPage": "Vai alla pagina {{page}}",
      "prev": "Precedente",
      "next": "Avanti",
      "checkout": "Tonnie checkout",
      "checkoutSecure": "Sicuro · Stripe",
      "customerView": "Cosa vede il tuo cliente",
      "howTitle": "Come funziona il programma",
      "howStep1Title": "Condividi il tuo codice",
      "howStep1Body": "Dai {{code}} alle persone che riferisci a Tonnie.",
      "howStep2Title": "Risparmiano {{percent}}%",
      "howStep2Body": "Il codice viene applicato al checkout — il prezzo diminuisce prima che paghino.",
      "howStep3Title": "Guadagni {{rate}}%",
      "howStep3Body": "Su ogni conversione pagata, {{rate}}% di ciò che pagano viene accreditato al tuo saldo.",
      "howStep4Title": "Preleva",
      "howStep4Body": "Una volta che il tuo saldo raggiunge {{amount}}, richiedi un pagamento e carica la tua fattura per essere pagato.",
      "refundsNote": "La commissione si accumula solo quando un pagamento ha successo. I rimborsi all'interno della finestra annullano automaticamente la commissione corrispondente.",
      "sampleProduct": "Pro journey",
      "sampleProductSub": "Abbonamento mensile",
      "invoiceOnFile": "Fattura ricevuta",
      "invoiceUploaded": "Fattura caricata",
      "invoiceUploadFailed": "Caricamento fattura fallito",
      "minimumPayout": "Pagamento minimo: {{amount}}",
      "noPayoutsYet": "Nessun pagamento richiesto finora.",
      "noRedemptionsYet": "Nessun riscatto finora.",
      "notEnrolledBody": "Questa organizzazione non è iscritta al programma affiliati Tonnie. Contatta Tonnie per iniziare.",
      "notEnrolledTitle": "Non sei ancora un affiliato",
      "awaitingApproval": "In attesa di approvazione",
      "cancel": "Annulla",
      "payoutCancelled": "Pagamento annullato — saldo rilasciato",
      "payoutCancelFailed": "Impossibile annullare il pagamento",
      "payoutFailed": "Impossibile richiedere il pagamento",
      "payoutHistory": "Storico dei pagamenti",
      "payoutRequested": "Pagamento richiesto",
      "payoutStep1Title": "Richiesta",
      "payoutStep1Body": "Richiedi un pagamento del tuo saldo disponibile.",
      "payoutStep2Title": "Approvazione",
      "payoutStep2Body": "Tonnie esamina e approva la tua richiesta.",
      "payoutStep3Title": "Fattura",
      "payoutStep3Body": "Carichi la tua fattura per l'importo.",
      "payoutStep4Title": "Pagamento",
      "payoutStep4Body": "Tonnie ti paga tramite bonifico bancario.",
      "payoutStatus": {
        "approved": "Approvato",
        "cancelled": "Annullato",
        "invoice_received": "Fattura ricevuta",
        "paid": "Pagato",
        "rejected": "Rifiutato",
        "requested": "Richiesto"
      },
      "percentOff": "{{percent}}% di sconto",
      "platform": {
        "colCommission": "Commissione",
        "colDiscount": "Sconto",
        "colIssuer": "Affiliato",
        "colPaid": "Pagato",
        "colRedemptions": "Riscatti",
        "errorHint": "Riprova o verifica il tuo accesso come staff Tonnie.",
        "errorTitle": "Impossibile caricare la panoramica della piattaforma",
        "issuersTitle": "Per affiliato",
        "noIssuers": "Ancora nessun riscatto pagato.",
        "totalCommission": "Commissione totale",
        "totalDiscount": "Sconto totale concesso",
        "totalPaid": "Totale pagato",
        "totalRedemptions": "Riscatti totali"
      },
      "yourCommission": "Guadagni {{rate}}%",
      "discountHint": "Lo sconto che i tuoi clienti ricevono al momento del pagamento.",
      "commissionHint": "La tua commissione su ogni importo che pagano.",
      "redemptionsOverTime": "Riscatti nel tempo",
      "redemptionStatus": {
        "paid": "Pagato",
        "pending": "In Attesa",
        "refunded": "Rimborsato"
      },
      "requestPayout": "Richiedi pagamento",
      "subtitle": "Monitora i riscatti del tuo coupon e ritira la tua commissione.",
      "tabHowItWorks": "Come funziona",
      "tabOverview": "Panoramica",
      "tabPayouts": "Pagamenti",
      "tabPlatform": "Piattaforma",
      "title": "Programma di affiliazione",
      "totalCommission": "Commissione totale",
      "totalRedemptions": "Riscatti",
      "uploadInvoice": "Carica fattura",
      "uploading": "Caricamento…",
      "yourCode": "Il tuo codice coupon"
    },
    "layout": {
      "adaptation": "Adattamento",
      "affiliates": "Affiliati",
      "billing": "Fatturazione",
      "business": "Business",
      "care": "Care",
      "cohorts": "Cohorti",
      "evidence": "Prove",
      "home": "Home",
      "logout": "Esci",
      "messages": "Messaggi",
      "mobility": "Mobilità",
      "pipeline": "Pipeline",
      "pool": "Pool",
      "programs": "Programmi",
      "settings": "Impostazioni",
      "vetting": "Verifica"
    },
    "legal": {
      "aboutUs": "Chi siamo",
      "backToDashboard": "Torna alla dashboard",
      "dataProtection": "Protezione dei dati",
      "dataProtectionBody": "Organo di protezione dei dati",
      "gdprBody": "Organo GDPR",
      "gdprCompliance": "Conformità GDPR",
      "privacyBody": "Organo della privacy",
      "privacyDescription": "Come Tonnie raccoglie, usa e protegge i dati personali",
      "privacyPolicy": "Informativa sulla privacy",
      "rightsDescription": "I tuoi diritti sui dati conservati da Tonnie, e come esercitarli",
      "subtitle": "Sottotitolo",
      "termsBody": "Organo dei termini",
      "termsDescription": "I termini che regolano l'uso di Tonnie da parte della tua azienda",
      "termsOfService": "Termini di servizio",
      "title": "Termini e privacy",
      "viewPrivacy": "Visualizza privacy",
      "viewTerms": "Visualizza termini",
      "yourRights": "I tuoi diritti"
    },
    "mobilityPage": {
      "activeTab": "Attivo",
      "archivedTab": "Archiviato",
      "allStatus": "Tutti gli stati",
      "allTracks": "Tutti i percorsi",
      "analytics": "Analisi",
      "acrossAllTracks": "In tutti i percorsi",
      "avgProgress": "Media progresso",
      "blocked": "Bloccato",
      "blockingDocs": "Documenti bloccanti",
      "complete": "Completo",
      "viewAll": "Visualizza tutto",
      "detailsBtn": "Dettagli",
      "detailsAria": "Apri i dettagli di CoPilot per {{name}}",
      "viewTalentAria": "Visualizza i dettagli per {{name}}",
      "talentRowActionsAria": "Azioni per {{name}}",
      "blockingDocsPending": "Documenti bloccanti in attesa",
      "coTasks": "Compiti",
      "companyActions": "Azioni aziendali",
      "atRiskTalents": "A rischio",
      "overdueTasks": "Attività scadute",
      "companyActionsRequired": "Azioni aziendali richieste",
      "companyDocsPending": "Documenti aziendali in attesa",
      "companyActionsSectionTitle": "Attività aziendali",
      "companyTasksDesc": "Obblighi di proprietà aziendale per i tuoi talenti sponsorizzati — raggruppati per talento.",
      "companyTasksPending": "Attività aziendali in attesa",
      "companyTasksPendingCount_one": "{{count}} attività aziendale in attesa",
      "companyTasksPendingCount_other": "{{count}} attività aziendali in attesa",
      "companyTasksTitle": "Attività aziendali",
      "companyTasksOpenTab": "Aperto ({{count}})",
      "companyTasksCompletedTab": "Completato ({{count}})",
      "companyTasksEmpty": "Nessuna attività qui.",
      "attachUpload": "Allega e carica",
      "awaitingUpload": "In attesa di caricamento",
      "docsAttachedCount": "{{uploaded}}/{{total}} documenti",
      "noDocsRequired": "Nessun documento richiesto — contrassegna come completato quando hai finito.",
      "replaceDocument": "Sostituisci",
      "reopenTaskAria": "Riapri {{title}}",
      "requiredDocuments": "Documenti richiesti",
      "docsRequiredToCompleteTitle": "Carica documenti richiesti",
      "docsUploadedProgress": "{{uploaded}} di {{total}} documenti caricati",
      "allDocsUploadedReadyToComplete": "Tutti i documenti caricati — puoi completare questo compito.",
      "taskReopened": "Riaperto \"{{title}}\"",
      "taskReopenFailed": "Impossibile riaprire \"{{title}}\". Riprova.",
      "completed": "Completato",
      "completionRate": "Tasso di completamento",
      "description": "Visti, viaggio e sistemazione nei trasferimenti dei tuoi talenti sponsorizzati",
      "documentUploadedSuccess": "{{name}} caricato",
      "done": "Fatto",
      "dueDate": "Scadenza: {{date}}",
      "filterStatus": "Stato",
      "filterTrack": "Monitora",
      "for": "Per",
      "forTalent": "Per {{name}}",
      "inMobility": "In mobilità",
      "inMobilitySplit": "{{inProgress}} in corso · {{completed}} completati",
      "statusInProgress": "In corso",
      "engaged": "Coinvolto",
      "inProgressShort": "in corso",
      "noTalentsInTrack": "Nessun talento in questo percorso ancora",
      "viewCompletedTalents": "Visualizza talenti completati",
      "viewBlockedTalents": "Visualizza talenti bloccati",
      "viewAtRiskTalents": "Visualizza talenti a rischio",
      "trackCompletion": "Completamento del percorso",
      "trackCompletionDescription": "Quanti talenti hanno terminato ciascun percorso",
      "doneOfEngaged": "{{name}} · {{done}}/{{engaged}}",
      "legal": "Legale",
      "milestones": "Traguardi",
      "mobilityTracks": "Percorsi di mobilità",
      "overall": "Globale",
      "noDueDate": "Nessuna data di scadenza",
      "noPendingTasks": "Nessuna attività in attesa",
      "noTalentsFound": "Nessun talento trovato",
      "noTalentsInMobility": "Nessun talento nella mobilità",
      "onTrack": "In corso",
      "pendingTasks": "Attività in attesa",
      "reminderSent": "Promemoria inviato per {{title}}",
      "searchTalents": "Cerca talenti",
      "setup": "Impostazione",
      "statusAtRisk": "Stato a rischio",
      "statusBlocked": "Stato bloccato",
      "statusOnTrack": "Stato in corso",
      "talentProgress": "Progresso del talento",
      "talentsBlocked": "Talenti bloccati",
      "taskMarkedComplete": "{{title}} contrassegnato come completato",
      "taskCompleteFailed": "Impossibile contrassegnare \"{{title}}\" come completato. Riprova.",
      "title": "Mobilità",
      "trackOverview": "Panoramica tracciamento",
      "travel": "Viaggio",
      "tryAdjustingFilters": "Prova a regolare i filtri",
      "underReview": "In revisione",
      "validated": "Convalidato",
      "waitingOnCompanyCount": "In attesa dell'azienda",
      "actionNeeded": "Azione necessaria",
      "allTasksCompletedTitle": "Tutti i compiti completati!",
      "clearFiltersButton": "Cancella filtri",
      "trackProgressOverview": "Panoramica progresso tracciamento",
      "companyActionsSection": "Azioni aziendali",
      "completeTaskAria": "Contrassegna {{title}} come completato",
      "waitingOnCompany": "In attesa dell'azienda",
      "statusLabels": {
        "completed": "Completato",
        "on-track": "In corso",
        "blocked": "Bloccato",
        "at-risk": "A rischio"
      },
      "trackStatusLegend": {
        "done": "Fatto",
        "inProgress": "In corso",
        "blocked": "Bloccato",
        "notStarted": "Non iniziato"
      },
      "lastActivityUnknown": "Nessuna attività ancora",
      "tracks": {
        "legal": {
          "name": "Legale",
          "description": "Visto, permessi di lavoro, documentazione"
        },
        "travel": {
          "name": "Viaggio",
          "description": "Voli, logistica, coordinamento arrivo"
        },
        "setup": {
          "name": "Impostazione",
          "description": "Alloggio, banca, registrazione locale"
        }
      },
      "urgentTasksSummary_one": "{{count}} attività urgente necessita attenzione",
      "urgentTasksSummary_other": "{{count}} attività urgenti necessitano attenzione",
      "documentUploadFailed": "Caricamento non riuscito. Riprova.",
      "reminderTooSoonGeneric": "Promemoria inviato di recente.",
      "reminderFailed": "Impossibile inviare il promemoria. Riprova.",
      "uploadTooLarge": "Il file è più grande di 25 MB. Riduci o comprimi e riprova.",
      "docsStillOutstanding_one": "{{count}} documento necessario",
      "docsStillOutstanding_other": "{{count}} documenti necessari",
      "daysOverdue_one": "{{count}} giorno di ritardo",
      "daysOverdue_other": "{{count}} giorni di ritardo",
      "dueInDays_one": "Scade tra {{count}} giorno",
      "dueInDays_other": "Scade tra {{count}} giorni",
      "talentCount_one": "{{count}} talento",
      "talentCount_other": "{{count}} talenti",
      "pendingCount_one": "{{count}} in attesa",
      "pendingCount_other": "{{count}} in attesa",
      "talentCountCompleted_one": "{{count}} di {{total}} {{label}}",
      "talentCountCompleted_other": "{{count}} di {{total}} {{label}}",
      "reminderTooSoon_one": "Promemoria inviato di recente. Riprova tra {{count}} ora.",
      "reminderTooSoon_other": "Promemoria inviato di recente. Riprova tra {{count}} ore."
    },
    "nav": {
      "home": "Home"
    },
    "notFound": {
      "description": "La pagina che stai cercando non esiste o è stata spostata.",
      "goHome": "Vai a home",
      "title": "Pagina non trovata"
    },
    "notifications": {
      "justNow": "Appena adesso",
      "noNotifications": "Nessuna notifica",
      "title": "Notifiche",
      "tabAll": "Tutte",
      "unread": "Non lette",
      "noUnread": "Nessuna notifica non letta",
      "markAllRead": "Segna tutte come lette",
      "bellLabel_one": "Notifiche, {{count}} non letta",
      "bellLabel_other": "Notifiche, {{count}} non lette",
      "clearRead": "Cancella lette",
      "moreActions": "Altre azioni",
      "markReadAction": "Segna come letta",
      "dismiss": "Ignora",
      "dismissed": "Notifica ignorata",
      "undo": "Annulla",
      "viewDismissed": "Vedi ignorate",
      "dismissedTitle": "Ignorate",
      "restore": "Ripristina",
      "noDismissed": "Nessuna notifica ignorata",
      "seeAll": "Vedi tutte le notifiche",
      "showMore": "Mostra altro",
      "showLess": "Mostra meno",
      "daysAgo_one": "{{count}} giorno fa",
      "daysAgo_other": "{{count}} giorni fa",
      "hoursAgo_one": "{{count}} ora fa",
      "hoursAgo_other": "{{count}} ore fa",
      "minutesAgo_one": "{{count}} minuto fa",
      "minutesAgo_other": "{{count}} minuti fa"
    },
    "onboarding": {
      "challenges": {
        "candidateDropoff": "Abbandono del candidato durante la relocation",
        "complianceLegal": "Complessità legale e di conformità",
        "costManagement": "Gestione dei costi",
        "findingCandidates": "Trovare candidati internazionali qualificati",
        "immigrationVisa": "Complessità di immigrazione e visto",
        "postArrival": "Adattamento e retention post-arrivo",
        "trackingReporting": "Monitoraggio e reporting"
      },
      "exitSetup": "Impostazione uscita",
      "geographicSetup": {
        "moreRoutes_one": "+{{count}} altro",
        "moreRoutes_other": "+{{count}} altri"
      },
      "hiringContext": {
        "selectedChallenges": "Selezionati: {{count}}/3 sfide"
      },
      "hiringGoals": {
        "buildPipeline": "Costruire un pipeline di talenti sostenibile",
        "improveExperience": "Migliorare l'esperienza del candidato durante la relocation",
        "improveOnboarding": "Migliorare l'onboarding e l'adattamento post-arrivo",
        "increaseRetention": "Aumentare la retention dei dipendenti trasferiti",
        "reduceCosts": "Ridurre i costi di relocation",
        "reduceTime": "Ridurre il tempo di assunzione per candidati internazionali",
        "streamlineCompliance": "Snellire i processi di conformità e visto",
        "trackRoi": "Monitorare e misurare il ROI della mobilità"
      },
      "hiringTimeframes": {
        "immediate": "Immediato — pronto per iniziare ora",
        "long": "A lungo termine (6–12 mesi)",
        "medium": "A medio termine (3–6 mesi)",
        "short": "A breve termine (1–3 mesi)"
      },
      "maturity": {
        "established": "Programma consolidato — funzione di mobilità matura",
        "firstTime": "Prima volta — nuovo nell'assunzione internazionale",
        "someExperience": "Alcuna esperienza — effettuato alcune trasferte"
      },
      "personalInfo": {
        "addressDetailsError": "Impossibile ottenere i dettagli dell'indirizzo. Riprova.",
        "addressHint": "Seleziona il tuo indirizzo dalle suggerimenti",
        "addressPlaceholder": "Inizia a digitare il tuo indirizzo...",
        "addressSearchError": "Impossibile cercare indirizzi. Riprova.",
        "loadingAddressDetails": "Caricamento dettagli dell'indirizzo...",
        "searchAddress": "Cerca indirizzo",
        "searchAddressDescription": "Digita il tuo indirizzo e seleziona dai suggerimenti di Google Places"
      },
      "saving": "Salvataggio...",
      "step": "Passo",
      "workArrangements": {
        "flexible": "Flessibile",
        "hybrid": "Ibrido",
        "onsite": "In sede"
      }
    },
    "pipelinePage": {
      "activeTab": "Attivo",
      "addTalents": "Aggiungi talenti",
      "allCohorts": "Tutte le coorti",
      "allPrograms": "Tutti i programmi",
      "archivedSubtitle": "Candidati i cui percorsi sono terminati — account archiviati dall'amministratore o auto-eliminati",
      "archivedTab": "Archiviato",
      "avgIQulture": "Media iQulture",
      "bucketAcquisition": "Acquisizione",
      "bucketAcquisitionDescription": "Sourcing / Importato",
      "bucketSponsored": "Sponsorizzato",
      "bucketSponsoredDescription": "Mobilità · Adattamento · Care",
      "bucketVetting": "Verifica",
      "bucketVettingDescription": "CheckUp in corso",
      "clearAll": "Cancella tutto",
      "cohort": "Coorte",
      "description": "Ogni talento dal primo contatto alla sponsorizzazione, fase per fase",
      "filters": "Filtri",
      "formerCandidate": "Ex candidato",
      "inPipeline": "In pipeline",
      "needAttention": "Necessita attenzione",
      "noCohortFound": "Nessun gruppo trovato",
      "noProgramFound": "Nessun programma trovato",
      "onTrack": "In corso",
      "pipelineView": "Vista della pipeline",
      "scrollNext": "Colonna successiva",
      "scrollPrev": "Colonna precedente",
      "program": "Programma",
      "searchCohorts": "Cerca gruppi",
      "searchPlaceholder": "Inserisci ricerca...",
      "searchPrograms": "Cerca programmi",
      "status": "Stato",
      "statusAtRisk": "A rischio",
      "statusBlocked": "Bloccato",
      "statusCompleted": "Completato",
      "statusOnTrack": "In corso",
      "title": "Pipeline",
      "bulkBarAria": "Azioni di massa per i talenti selezionati",
      "bulkAddToCohort": "Aggiungi alla coorte",
      "bulkAddToCohortFailed": "Impossibile assegnare i talenti selezionati",
      "bulkAddToCohortPartial": "{{added}} assegnati alla coorte · {{skipped}} non è stato possibile assegnarli",
      "cardTag": "Etichetta della scheda",
      "selectWholeColumn": "Seleziona l'intera colonna",
      "talentsInPipeline_one": "{{count}} talento nella pipeline",
      "talentsInPipeline_other": "{{count}} talenti nella pipeline",
      "bulkAddToCohortSuccess_one": "{{count}} talento assegnato alla coorte",
      "bulkAddToCohortSuccess_other": "{{count}} talenti assegnati alla coorte",
      "searchLabel": "Cerca talenti"
    },
    "vettingCard": {
      "acceptedAgo": "Accettato {{when}}",
      "checkupProgress": "CheckUp {{percent}}% · {{done}} di {{total}} passaggi",
      "iqultureProgress": "iQulture {{percent}}%",
      "lastSeenAgo": "Ultima vista {{when}}",
      "missingSteps": "Mancante: {{steps}}",
      "notYetActive": "Non ancora attivo",
      "startedAgo": "Iniziato {{when}}",
      "stateAwaitingScore": "Calcolo iQulture…",
      "stateNotStarted": "Non iniziato",
      "step": {
        "assistantChat": "Chat con assistente",
        "languageTests": "Test di lingua",
        "motivationalAnswers": "Motivazione",
        "pitchVideo": "Video di presentazione",
        "videosWatched": "Guarda i video"
      },
      "submittedAgo": "Inviato {{when}}",
      "testitComplete": "TestIt completato",
      "testitInvited": "TestIt invitato",
      "testitProgress": "TestIt · {{done}}/{{total}}",
      "scoredAgo": "Punteggio calcolato {{when}}",
      "completedAgo": "Completato {{when}}",
      "sharingWithdrawnAgo": "Condivisione revocata {{when}}"
    },
    "pipelineView": {
      "activateAgain": "Riattiva",
      "addTalentsCta": "Aggiungi talenti",
      "archive": "Archivia",
      "archiveSponsoredConfirmDescription": "In questo modo il viaggio sponsorizzato di {{name}} viene archiviato: la scheda esce dalla tua pipeline e {{name}} perde l'accesso a questa opportunità. I risultati del CheckUp e la cronologia del viaggio restano archiviati per conformità. Puoi ripristinarlo dalla scheda Archiviati.",
      "archiveSponsoredConfirmTitle": "Archivia talento sponsorizzato",
      "archiving": "Archiviazione…",
      "askForCheckup": "Invita al CheckUp completo",
      "askForTestit": "Invita a test specifici",
      "bulkArchiveCta": "Archivia {{count}}",
      "bulkArchiveFailed": "Impossibile archiviare i talenti",
      "bulkArchivePartial": "{{archived}} archiviati · {{failed}} falliti",
      "bulkClear": "Cancella",
      "bulkSendConfirmCta": "Invia inviti",
      "bulkSendConfirmTitle": "Invia inviti a Verifica",
      "bulkSendPartial": "{{sent}} inviati · {{failed}} falliti",
      "bulkSending": "Invio…",
      "bulkSendingProgress": "Invio inviti… {{sent}}/{{total}}",
      "bulkSponsorCta": "Sponsorizza {{count}}",
      "bulkSponsorFailed": "Impossibile sponsorizzare i talenti",
      "bulkSponsorPartial": "{{sponsored}} sponsorizzati · {{failed}} falliti",
      "citizenLeft": "Candidato ha lasciato la piattaforma",
      "citizenLeftTooltip": "Questo candidato ha eliminato il proprio account Tonnie. Il loro viaggio è conservato per audit; i dettagli identificativi sono stati rimossi.",
      "clearSearch": "Pulisci filtro",
      "delete": "Elimina",
      "deleteConfirmDescription": "Questo rimuoverà permanentemente {{name}} e l'intera cronologia di importazione (eventi di pipeline, viaggi, messaggi). Questa azione non può essere annullata.",
      "deleteConfirmTitle": "Elimina talento",
      "deleteInvitationConfirmDescription": "Questo rimuoverà permanentemente l'invito per {{name}}. Non potranno accettare il link dell'email. Questa azione non può essere annullata.",
      "deleteInvitationConfirmTitle": "Elimina invito",
      "deleteInvitationFailed": "Impossibile eliminare l'invito",
      "deleteInvitationSuccess": "Invito eliminato",
      "deleting": "Eliminazione…",
      "dragNotAllowed": "Impossibile spostare da {{from}} a {{to}} — usa il menu kebab per l'azione corretta",
      "imported": "Importato {{when}}",
      "invitationDeleteFailed": "Impossibile rimuovere l'invito",
      "invitationDeleted": "Invito di {{name}} rimosso",
      "invitationResendFailed": "Impossibile reinviare",
      "invitationResent": "Invito reinviato",
      "invitationRevokeFailed": "Impossibile revocare",
      "invitationRevoked": "Invito revocato",
      "invitationSendFailed": "Impossibile inviare l'invito",
      "invitationSent": "Invito inviato",
      "invitationSentHint": "{{name}} riceverà l'email e la scheda passa a Verifica.",
      "inviteToVetting": "Invita a Verifica",
      "noMatches": "Nessuna corrispondenza per \"{{query}}\"",
      "noTalentsInStage": "Nessun talento in questa fase",
      "removeFromPipeline": "Rimuovi dal pipeline",
      "removeVettingConfirmDescription": "In questo modo {{name}} esce dalla tua pipeline e {{name}} perde l'accesso a questa opportunità. I dati del CheckUp e la cronologia restano archiviati per conformità. Puoi ripristinarlo dalla scheda Archiviati.",
      "removeVettingConfirmTitle": "Rimuovi talento dal pipeline",
      "invitationEmailNotSent": "L’invito è salvato, ma non è stato possibile inviare l’e-mail",
      "resendInvitationFailed": "Impossibile reinviare l'invito",
      "resendInvitationSuccess": "Invito reinviato",
      "revokeInvitationFailed": "Impossibile revocare l'invito",
      "revokeInvitationSuccess": "Invito revocato",
      "searchPlaceholder": "Filtra nome, email, ruolo…",
      "selectAllCount": "Seleziona tutto ({{selected}}/{{total}})",
      "selectAllMatching": "Seleziona tutte le corrispondenze ({{visible}})",
      "statusArchived": "Archiviato",
      "stageStatus": {
        "onTrack": "In corso",
        "blocked": "Bloccato",
        "atRisk": "A rischio",
        "completed": "Completato"
      },
      "statusAwaitingAcceptance": "In attesa di accettazione",
      "statusDraft": "Bozza",
      "subStage": {
        "mobility": "Mobilità",
        "adaptation": "Adattamento",
        "care": "Care",
        "evidence": "Prove"
      },
      "talentArchiveFailed": "Impossibile archiviare il talento",
      "talentArchived": "{{name}} archiviato",
      "talentDeleteFailed": "Impossibile eliminare il talento",
      "talentDeleted": "{{name}} è stato rimosso",
      "talentSponsored": "Talento sponsorizzato! Istanza di viaggio creata con percorso {{origin}} → {{destination}}",
      "talentSponsoredFailed": "Impossibile sponsorizzare il talento",
      "unarchiveFailed": "Impossibile ripristinare il talento",
      "unarchiveSuccess": "Talento ripristinato — viaggio attivo di nuovo",
      "updated": "Aggiornato {{when}}",
      "selectCandidate": "Seleziona candidato",
      "signedUpNotAccepted": "Registrato, non accettato",
      "signedUpNotAcceptedTooltip": "Questa persona ha già un account Tonnie ma non ha accettato il tuo invito. Reinviare ha buone probabilità di raggiungerla. Il suo percorso e il suo CheckUp restano privati finché non accetta.",
      "tag": {
        "inviteProblem": "Problema con l’invito",
        "onboardingIncomplete": "Completamento profilo",
        "waitingForCheckup": "In attesa del CheckUp",
        "checkupInProgress": "CheckUp in corso",
        "awaitingScore": "Calcolo del punteggio",
        "awaitingReview": "Pronto per la revisione",
        "testitPending": "Test in sospeso",
        "testitComplete": "Test completati",
        "testitPassed": "Approvato",
        "testitDeclined": "Rifiutato",
        "checkupNotRequested": "CheckUp non richiesto",
        "inviteDeclined": "Ha rifiutato",
        "inviteExpired": "Invito scaduto",
        "sponsorshipOffered": "Sponsorizzazione offerta",
        "checkupWithheld": "In attesa del consenso del talento",
        "consentWithdrawn": "Condivisione revocata"
      },
      "since": {
        "delivered": "Consegnato {{when}}",
        "opened": "Aperto {{when}}",
        "landed": "Ha aperto la pagina {{when}}",
        "bounced": "Respinto {{when}}",
        "sent": "Invitato {{when}}",
        "signedUp": "Si è registrato {{when}}",
        "asked": "Richiesto {{when}}",
        "expired": "Scaduto {{when}}"
      },
      "alreadyArchived": "Questo talento era già archiviato. La bacheca è aggiornata.",
      "alreadyRestored": "Questo percorso era già stato ripristinato. La bacheca è aggiornata.",
      "invitationAlreadyAccepted": "Questo invito è già stato accettato.",
      "bulkArchiveConfirmTitle_one": "Archivia {{count}} talento",
      "bulkArchiveConfirmTitle_other": "Archivia {{count}} talenti",
      "bulkArchiveConfirmCta_one": "Archivia {{count}} talento",
      "bulkArchiveConfirmCta_other": "Archivia {{count}} talenti",
      "bulkArchiveConfirmDescription_one": "{{count}} talento uscirà dalla tua pipeline attiva. I risultati del CheckUp e la cronologia del viaggio restano archiviati per conformità. Puoi ripristinarlo dalla scheda Archiviati.",
      "bulkArchiveConfirmDescription_other": "{{count}} talenti usciranno dalla tua pipeline attiva. I risultati del CheckUp e la cronologia del viaggio restano archiviati per conformità. Puoi ripristinarli dalla scheda Archiviati.",
      "bulkArchiveSuccess_one": "{{count}} talento archiviato",
      "bulkArchiveSuccess_other": "{{count}} talenti archiviati",
      "atRiskCount_one": "{{count}} a rischio",
      "atRiskCount_other": "{{count}} a rischio",
      "blockedCount_one": "{{count}} bloccato",
      "blockedCount_other": "{{count}} bloccati",
      "bulkSelectedCount_one": "{{count}} selezionato",
      "bulkSelectedCount_other": "{{count}} selezionati",
      "bulkSendCta_one": "Invia {{count}} invito a Vetting",
      "bulkSendCta_other": "Invia {{count}} inviti a Vetting",
      "searchLabel": "Filtra i talenti in {{stage}}",
      "declinedWhen": "Ha rifiutato {{when}}",
      "expiredWhen": "Scaduto {{when}}",
      "invitationSentAgain": "Invito inviato di nuovo",
      "leftProgramme": "Ha lasciato il programma · {{date}}",
      "leftProgrammeTooltip": "Questo talento ha lasciato il tuo programma, terminando la relazione. Non vedi più ciò che ha condiviso. Inviagli un nuovo invito per tornare a lavorare insieme.",
      "restoreRefusedLeft": "Questo talento ha lasciato il tuo programma. Inviagli un nuovo invito per tornare a lavorare insieme.",
      "resendInvitationMessageMismatch": "Il messaggio di questo invito è stato scritto per un’altra richiesta. Invialo di nuovo dalla finestra dell’invito per scriverne il messaggio."
    },
    "pool": {
      "smartSearch": {
        "downloadCv": "Scarica CV",
        "cvUnavailable": "CV non disponibile",
        "selectCandidate": "Seleziona candidato",
        "clearSelection": "Cancella",
        "bulkAddTitle": "Aggiungi ad acquisizione",
        "stepReview": "Rivedi e ordina",
        "how1": "Incolla una o più descrizioni di lavoro.",
        "how2": "L'IA estrae competenze, seniority e focus.",
        "how3": "Ordiniamo il tuo Pool di Talenti per pertinenza.",
        "extracting": "Lettura della descrizione del lavoro…",
        "extractError": "Non è stato possibile analizzare questa descrizione. Riprova.",
        "skillsTitle": "Competenze trovate",
        "skillsHint": "Rimuovi quelle non pertinenti o aggiungi le tue: la classifica si aggiorna in tempo reale.",
        "ranking": "Ordinamento…",
        "noSkills": "Nessuna competenza estratta",
        "noSkillsHint": "Aggiungi qui sotto le competenze chiave per questo ruolo.",
        "addSkillPlaceholder": "Aggiungi una competenza…",
        "viewResults": "Vedi risultati ordinati",
        "rankedTitle": "Pool ordinato per pertinenza al ruolo",
        "rankedForTitle": "Ordinato per {{title}}",
        "clear": "Cancella",
        "nSelected_one": "{{count}} selezionato",
        "nSelected_other": "{{count}} selezionati",
        "addNToAcquisition_one": "Aggiungi {{count}} ad acquisizione",
        "addNToAcquisition_other": "Aggiungi {{count}} ad acquisizione",
        "bulkAddDesc_one": "Aggiungi {{count}} candidato selezionato alla fase di Acquisizione della tua pipeline.",
        "bulkAddDesc_other": "Aggiungi {{count}} candidati selezionati alla fase di Acquisizione della tua pipeline.",
        "bulkAdded_one": "{{count}} aggiunto ad acquisizione",
        "bulkAdded_other": "{{count}} aggiunti ad acquisizione",
        "bulkFailed_one": "{{count}} non è stato aggiunto",
        "bulkFailed_other": "{{count}} non sono stati aggiunti",
        "analyzing_one": "Analisi di {{count}} descrizione di lavoro…",
        "analyzing_other": "Analisi di {{count}} descrizioni di lavoro…",
        "resultsFound_one": "{{count}} candidato corrisponde",
        "resultsFound_other": "{{count}} candidati corrispondono",
        "bulkDuplicates_one": "{{count}} già in questa coorte",
        "bulkDuplicates_other": "{{count}} già in questa coorte",
        "addSkillLabel": "Aggiungi una competenza"
      },
      "matchReason": {
        "mustHaves": "Requisiti: {{met}}/{{total}}",
        "seniority": "Livello {{level}}",
        "semantic": "{{score}}% corrispondenza profilo",
        "skills": "{{count}}/{{total}} competenze: {{skills}}",
        "readiness": "Prontezza {{score}}",
        "location": "A {{location}}",
        "niceToHaves_one": "+{{count}} preferenziale",
        "niceToHaves_other": "+{{count}} preferenziali"
      },
      "savedSearch": {
        "title": "Ricerche salvate",
        "savedCount": "Salvate ({{count}})",
        "save": "Salva",
        "saved": "Ricerca salvata",
        "saveFailed": "Impossibile salvare la ricerca",
        "delete": "Elimina ricerca salvata",
        "deleteFailed": "Impossibile eliminare la ricerca",
        "noSkills": "Nessuna competenza",
        "saveTitle": "Salva questa ricerca",
        "saveDesc": "Assegna un nome per rieseguire questa ricerca per descrizione del lavoro in seguito.",
        "nameLabel": "Nome",
        "namePlaceholder": "es. Ingegnere Backend Senior",
        "errors": {
          "name": "Il nome è obbligatorio"
        }
      },
      "detail": {
        "unavailable": "Candidato non disponibile",
        "unavailableHint": "Questo candidato non è più nel pool.",
        "curriculum": "Curriculum",
        "openCv": "Apri in nuova scheda",
        "noCv": "Nessun CV disponibile",
        "noCvHint": "Questo candidato non ha ancora allegato un CV.",
        "experience": "Esperienza",
        "seniority": "Livello",
        "origin": "Origine",
        "inPoolSince": "Nel pool dal",
        "languages": "Lingue",
        "linkedin": "Profilo LinkedIn",
        "availOpen": "Aperto a offerte",
        "availConsideration": "In valutazione",
        "availUnavailable": "Non disponibile",
        "experienceValue_one": "{{count}} anno",
        "experienceValue_other": "{{count}} anni"
      },
      "view": {
        "cards": "Schede",
        "list": "Elenco"
      },
      "advancedSearch": {
        "addAtLeastOneJob": "Si prega di aggiungere almeno una descrizione del lavoro",
        "addedSuccessfully": "Aggiunto con successo",
        "enterJobDescription": "Si prega di inserire una descrizione del lavoro o un URL",
        "stepInput": "Input",
        "titleAi": "Ricerca di talenti potenziata dall'aI",
        "subtitle": "Estrai competenze dalle descrizioni dei lavori e trova candidati corrispondenti",
        "jobDescriptionN": "Descrizione del lavoro {{count}}",
        "jobPlaceholder": "Incolla qui una descrizione del lavoro...\n\nEsempio: Stiamo cercando un Senior Software Engineer con oltre 5 anni di esperienza in React, TypeScript e Node.js...",
        "addToList": "Aggiungi alla lista",
        "emptyTitle": "Nessuna descrizione del lavoro ancora",
        "emptyHint": "Aggiungi descrizioni del lavoro per estrarre parole chiave",
        "jobN": "Lavoro {{count}}",
        "howItWorks": "Come funziona",
        "extractBtn": "Estrai parole chiave",
        "jobsAdded_one": "{{count}} descrizione di lavoro aggiunta",
        "jobsAdded_other": "{{count}} descrizioni del lavoro aggiunte",
        "wordCount_one": "{{count}} parola",
        "wordCount_other": "{{count}} parole",
        "jobDescriptionLabel": "Descrizione del lavoro"
      },
      "startAdvancedSearch": "Inizia ricerca avanzata",
      "addToPipeline": "Aggiungi al pipeline",
      "searching": "Ricerca nel Talent Pool…",
      "talentCard": {
        "noCheckup": "Nessun CheckUp",
        "preVetted": "Tonnie pre-vettori",
        "inPipeline": "In pipeline",
        "whyMatched": "Perché abbinato:",
        "iqultureScore": "Punteggio iQulture",
        "skills": "Competenze",
        "added": "Aggiunto",
        "addToVet": "Aggiungi a vet",
        "matchPercent": "{{score}}% corrispondenza",
        "top": "TOP",
        "moreCount_one": "+{{count}} altro",
        "moreCount_other": "+{{count}} altri"
      },
      "nSelected_one": "{{count}} selezionato",
      "nSelected_other": "{{count}} selezionati",
      "talentsFound_one": "{{count}} talento trovato",
      "talentsFound_other": "{{count}} talenti trovati"
    },
    "poolImport": {
      "errors": {
        "country": "Il paese deve essere un codice di 3 lettere",
        "email": "Email non valida",
        "empty": "Nessuna riga da importare",
        "tooMany": "Troppe righe (max 1000)"
      },
      "failed": "Importazione non riuscita",
      "placeholder": "Incolla CSV o TSV con una riga di intestazione: email, nome, cognome, titolo di lavoro, paese, città, competenze",
      "subtitle": "Incolla i candidati selezionati per aggiungerli al Talent Pool pubblico. I profili esistenti vengono aggiornati.",
      "success": "Importati: {{created}} creati, {{updated}} aggiornati",
      "title": "Importa profili",
      "import_one": "Importa {{count}} profilo",
      "import_other": "Importa {{count}} profili",
      "parsedCount_one": "{{count}} riga valida pronta per l'importazione",
      "parsedCount_other": "{{count}} righe valide pronte per l'importazione"
    },
    "poolPage": {
      "addToVettingDesc": "Aggiungi {{name}} al tuo pipeline di valutazione",
      "addToVettingPipeline": "Aggiungi al pipeline di valutazione",
      "advancedSearch": "Ricerca avanzata",
      "advancedSearchDesc": "Trova talenti che corrispondono a una descrizione di lavoro",
      "alphabetical": "Alfabetico",
      "alreadyInPipeline": "Già nel pipeline",
      "available": "Disponibile",
      "description": "Cerca talenti che hanno scelto di farsi trovare",
      "failedToAdd": "Impossibile aggiungere",
      "inPipeline": "In pipeline",
      "iqultureHighToLow": "iQulture alto a basso",
      "iqultureLowToHigh": "iQulture basso ad alto",
      "iqultureScore": "Punteggio iQulture",
      "location": "Posizione",
      "noCohortsYet": "Nessun gruppo ancora: creane uno per aggiungere talenti alla pipeline.",
      "noLocationsFound": "Nessuna posizione trovata",
      "noRolesFound": "Nessun ruolo trovato",
      "noSkillsFound": "Nessuna competenza trovata",
      "noTalentsFound": "Nessun talento trovato",
      "relevance": "Rilevanza",
      "role": "Ruolo",
      "searchError": "Ricerca non riuscita",
      "searchErrorHint": "Qualcosa è andato storto durante il caricamento dei talenti. Riprova.",
      "searchLocations": "Cerca posizioni",
      "searchPlaceholder": "Inserisci ricerca...",
      "searchRoles": "Cerca ruoli",
      "searchSkills": "Cerca competenze",
      "selectACohort": "Seleziona un gruppo",
      "selectCohort": "Seleziona gruppo",
      "selectLocations": "Seleziona posizioni",
      "selectRoles": "Seleziona ruoli",
      "selectSkills": "Seleziona competenze",
      "skills": "Competenze",
      "sortBy": "Ordina Per",
      "talentAdded": "{{name}} aggiunto al pipeline",
      "title": "Pool",
      "tryAdjustingFilters": "Prova a regolare i filtri",
      "upgradeDescription": "Cerca e aggiungi talenti pre-valutati dal Tonnie Talent Pool direttamente nella tua pipeline.",
      "results": "Risultati",
      "bestMatch": "Corrispondenza migliore",
      "lowestMatch": "Corrispondenza minore",
      "searchLabel": "Cerca talenti"
    },
    "profile": {
      "accountDescription": "Dettagli sul tuo account che non possono essere modificati qui.",
      "accountTitle": "Account",
      "avatarDescription": "Mostrato nel menu in alto a destra e in tutta la piattaforma.",
      "avatarHelper": "PNG, JPG o GIF fino a 5 MB. Trascina e rilascia, o clicca per sfogliare.",
      "avatarRemoveConfirm": "La tua foto profilo sarà sostituita dalle tue iniziali. Puoi caricarne una nuova in qualsiasi momento.",
      "avatarRemoveConfirmAction": "Rimuovi foto",
      "avatarRemoveFailed": "Impossibile rimuovere la foto. Riprova.",
      "avatarRemoveTitle": "Rimuovere la foto del profilo?",
      "avatarRemoved": "Foto rimossa",
      "avatarTitle": "Foto profilo",
      "avatarTooLarge": "La foto è troppo grande. Max 5 MB.",
      "avatarUploadFailed": "Caricamento foto non riuscito. Si prega di riprovare.",
      "avatarUploaded": "Foto aggiornata",
      "avatarWrongType": "Sono supportati solo file immagine.",
      "changeAvatar": "Cambia foto profilo",
      "description": "Gestisci le tue informazioni personali, avatar e dettagli dell'account.",
      "email": "Email",
      "emailManagedByClerk": "Gestito tramite accesso",
      "firstName": "Nome",
      "lastName": "Cognome",
      "memberSince": "Membro dal",
      "nameDescription": "Come appare il tuo nome in tutta la piattaforma.",
      "nameTitle": "Il tuo nome",
      "remove": "Rimuovi",
      "role": "Ruolo",
      "roleDescription": "Impostato dall'amministratore della tua organizzazione.",
      "saveChanges": "Salva modifiche",
      "saveFailed": "Impossibile salvare le modifiche. Riprova.",
      "saved": "Profilo aggiornato",
      "title": "Profilo",
      "uploadPhoto": "Carica foto"
    },
    "programs": {
      "activePrograms": "Programmi in corso",
      "adjustFilters": "Regola filtri",
      "allCohorts": "Tutte le coorti",
      "allStatus": "Tutti gli stati",
      "askCoPilot": "Chiedi a CoPilot",
      "avgProgress": "Media progresso",
      "backToPrograms": "Torna ai programmi",
      "care": "Care",
      "careRequiresEnterprise": "Care richiede Enterprise",
      "careSettingsReset": "Ripristino delle impostazioni di Care",
      "cohorts": "Cohorti",
      "createCohort": "Crea cohorte",
      "createDialogDescription": "Un programma è il livello organizzativo principale per i talenti che sponsorizzi o inviti. Le coorti e i percorsi vivono al suo interno.",
      "createFirstProgram": "Crea primo programma",
      "createNewProgram": "Crea nuovo programma",
      "createProgram": "Crea programma",
      "created": "Creato",
      "description": "I tuoi programmi di trasferimento e le coorti che includono",
      "descriptionLabel": "Descrizione",
      "descriptionPlaceholder": "Inserisci descrizione...",
      "editDialogDescription": "Aggiorna i dettagli del programma qui sotto.",
      "editProgram": "Modifica programma",
      "filterByStatus": "Filtra per stato",
      "getMoreInsights": "Ottieni maggiori informazioni",
      "insightPassRate": "Tasso di passaggio",
      "insights": "Approfondimenti",
      "insightsDescription": "Come sta procedendo questo programma",
      "iqulture": "iQulture",
      "latestUpdates": "Ultimi aggiornamenti",
      "manageCohorts": "Gestisci cohorti",
      "noProgramsFound": "Nessun programma trovato",
      "notFound": "Programma non trovato",
      "notFoundDesc": "Questo programma non esiste o è stato eliminato. Prova a tornare all'elenco dei programmi.",
      "overview": "Panoramica",
      "pauseProgram": "Metti in pausa programma",
      "programCreated": "Programma creato",
      "programNameLabel": "Nome programma",
      "programNamePlaceholder": "Inserisci nome programma...",
      "programPaused": "Programma in pausa",
      "programResumed": "Programma ripreso",
      "programUpdated": "Programma aggiornato",
      "progress": "Progresso",
      "progressLabel": "Progresso",
      "recentActivity": "Attività recenti",
      "resumeProgram": "Riprendi programma",
      "searchPrograms": "Cerca programmi",
      "stability": "Stabilità",
      "stabilityValue": "{{value}}% stabilità",
      "statusChangeFailed": "Impossibile cambiare stato del programma",
      "talents": "Talenti",
      "title": "Programmi",
      "totalCohorts": "Cohorti totali",
      "totalTalents": "Talenti totali",
      "viewDetails": "Visualizza dettagli",
      "whatHappensNext": "Cosa succede dopo",
      "whatHappensNextDescription": "Verrai portato alla pagina dei dettagli del programma dove puoi creare coorti, invitare talenti e monitorare il loro percorso attraverso le fasi di Verifica e Sponsorizzato.",
      "errors": {
        "nameRequired": "Il nome del programma è obbligatorio",
        "nameTooLong": "Il nome del programma deve contenere 200 caratteri o meno",
        "descriptionTooLong": "La descrizione deve contenere 2000 caratteri o meno",
        "planLimit": "Il piano gratuito consente 1 programma attivo. Aggiorna a Enterprise per programmi illimitati.",
        "createFailed": "Impossibile creare il programma"
      },
      "programActionsAria": "Azioni per {{name}}",
      "updateFailed": "Impossibile aggiornare il programma",
      "archiveSuccess": "{{name}} spostato in archiviato.",
      "archiveFailed": "Impossibile archiviare il programma",
      "restoreSuccess": "{{name}} ripristinato.",
      "restoreFailed": "Impossibile ripristinare il programma",
      "activeTab": "Attivo",
      "archivedTab": "Archiviato",
      "viewInPipeline": "Visualizza talenti nel Pipeline",
      "archive": "Archivia",
      "restore": "Ripristina",
      "archiveConfirmTitle": "Archiviare il programma?",
      "archiveConfirmDescription": "{{name}} si sposta nella scheda Archiviato. Ogni coorte attiva sotto questo programma è archiviata anche essa. Ripristinare il programma in seguito NON ripristina automaticamente le coorti — devi riattivarle singolarmente dalla scheda Coorti Archiviato.",
      "insightCareGap": "Talenti sponsorizzati ma nessun punto di contatto attivo Care — verifica la cadenza di check-in.",
      "cohortScopeAria": "Ambito della coorte",
      "cohortsEmptyActive": "Nessuna coorte attiva in questo programma ancora. Creane una per iniziare a invitare talenti.",
      "cohortsEmptyArchived": "Nessuna coorte archiviata. Le coorti che archivi — o che sono state archiviate a cascata con il programma — appariranno qui.",
      "cohortCreated": "Coorte creata.",
      "talentCount_one": "{{count}} talento",
      "talentCount_other": "{{count}} talenti",
      "archiveSuccessWithCascade_one": "{{base}} {{count}} coorte è stata archiviata insieme.",
      "archiveSuccessWithCascade_other": "{{base}} {{count}} coorti sono state archiviate insieme.",
      "restoreSuccessWithCohorts_one": "{{base}} {{count}} coorte è ancora archiviata — ripristinala dalla scheda Coorti.",
      "restoreSuccessWithCohorts_other": "{{base}} {{count}} coorti sono ancora archiviate — ripristinale dalla scheda Coorti."
    },
    "sendToVetting": {
      "assessmentIntroTalent": "Questi talenti hanno già un percorso con questa azienda, quindi solo la valutazione è nuova — la destinazione resta invariata.",
      "back": "Indietro",
      "branchCustom": "Destinazione personalizzata…",
      "branchLabel": "Filiale / ufficio",
      "branchPlaceholder": "Seleziona una filiale o inserisci personalizzato",
      "bulkSendingProgress": "Invio inviti… {{sent}}/{{total}}",
      "bulkTitle": "Invia inviti a Verifica",
      "customizeToggle": "Personalizza messaggio",
      "description": "Creeremo un modello di viaggio gratuito CheckUp e invieremo un'email al candidato. Puoi sponsorizzare l'intero viaggio in seguito se decidi di farlo.",
      "descriptionTestit": "Creeremo un percorso gratuito per i test specifici che scegli e invieremo un’email al candidato. I risultati sono riutilizzabili.",
      "destinationLabel": "Paese di destinazione",
      "destinationPlaceholder": "Dove lavoreranno?",
      "destinationSettingsLink": "Impostazioni dell'azienda",
      "destinationSource": "Dalle impostazioni dell'azienda (sede e filiali).",
      "destinationUnset": "Nessuna sede o filiale nelle Impostazioni — scegline una per questo lotto, o aggiungila una volta nelle Impostazioni.",
      "failed": "Invio dell'invito non riuscito. Per favore riprova.",
      "freeCheckUpHint": "Nessun costo fino a quando non decidi di sponsorizzare il viaggio. Il candidato riceve il CheckUp e tu vedi i loro risultati MESH + iQulture in Vetting.",
      "freeCheckUpTitle": "CheckUp gratuito · Sponsorizza in seguito se vuoi",
      "freeTestitHint": "Nessun costo: il candidato completa solo i test che scegli e i risultati possono essere riutilizzati per opportunità future. Li vedi in Valutazione.",
      "freeTestitTitle": "Gratis · risultati riutilizzabili",
      "next": "Avanti",
      "opportunityIntro": "Scegli cosa completa il candidato e dove si trova il ruolo.",
      "outcomeAwaiting": "Restano in Acquisizione finché non accettano.",
      "outcomeMixed": "{{moved}} passati a Valutazione · {{awaiting}} in attesa di accettazione.",
      "partial": "{{sent}} inviati · {{failed}} falliti",
      "reviewAssessment": "Completeranno",
      "reviewDestination": "Destinazione",
      "reviewEmailHint": "Questo è ciò che arriva nella loro casella.",
      "reviewRecipients": "Destinatari",
      "sending": "Invio…",
      "singleCta": "Invia invito",
      "singleSuccess": "Invito inviato a {{name}}",
      "singleTitle": "Invia invito a {{name}}",
      "stepMessage": "Messaggio",
      "stepOf": "Passo {{current}} di {{total}}",
      "stepOpportunity": "Valutazione",
      "stepReview": "Rivedi e invia",
      "workLocationLabel": "Luogo di lavoro",
      "workLocationPlaceholder": "Città, ufficio o remoto",
      "bulkCta_one": "Invia {{count}} invito",
      "bulkCta_other": "Invia {{count}} inviti",
      "bulkRecipientCount_one": "{{count}} candidato",
      "bulkRecipientCount_other": "{{count}} candidati",
      "bulkSuccess_one": "{{count}} invito inviato",
      "bulkSuccess_other": "{{count}} inviti inviati",
      "outcomeRequested_one": "Gli è stato chiesto di condividere di più: non cambia nulla finché non risponde.",
      "outcomeRequested_other": "È stato chiesto a {{count}} di condividere di più: non cambia nulla finché non rispondono.",
      "outcomeMoved_one": "Passato a Valutazione.",
      "outcomeMoved_other": "{{count}} passati a Valutazione.",
      "reviewAskNotice_one": "Questo talento lavora già con te, quindi riceve il messaggio adatto alla sua situazione: una richiesta di condividere ciò che ha già, oppure un promemoria di ciò che resta da fare.",
      "reviewAskNotice_other": "Questi {{count}} talenti lavorano già con te, quindi ciascuno riceve il messaggio adatto alla sua situazione: una richiesta di condividere ciò che ha già, oppure un promemoria di ciò che resta da fare."
    },
    "settings": {
      "customModeActiveDesc": "La modalità personalizzata è attiva. Personalizza i tuoi colori nella scheda Colori e carica risorse nella scheda Risorse.",
      "draftSaved": "Bozza salvata con successo!",
      "fileSizeError": "La dimensione del file deve essere inferiore a 2MB",
      "invalidFileFormat": "Formato file non valido. Si prega di utilizzare PNG, JPG o SVG",
      "itemRemoved": "{{title}} rimosso",
      "themeActivated": "Tema attivato con successo! Passato alla modalità personalizzata.",
      "uploadSuccess": "{{type}} caricato con successo!"
    },
    "shared": {
      "noPhoneCodeFound": "Nessun codice telefonico trovato.",
      "searchPhoneCode": "Cerca codice telefonico..."
    },
    "shell": {
      "viewportGuard": {
        "description": "Questa applicazione è ottimizzata per schermi desktop. Si prega di utilizzare un dispositivo con uno schermo più grande per la migliore esperienza.",
        "hint": "Larghezza minima dello schermo: 1024px",
        "title": "Desktop richiesto"
      }
    },
    "theme": {
      "configure": "Configura",
      "custom": "Personalizzato",
      "dark": "Scuro",
      "light": "Chiaro",
      "system": "Sistema",
      "theme": "Tema"
    },
    "userMenu": {
      "billing": "Fatturazione",
      "logout": "Esci",
      "openMenu": "Apri menu utente",
      "preferences": "Preferenze",
      "profile": "Profilo",
      "roleAdmin": "Admin",
      "roleMember": "Membro del team"
    },
    "vetting": {
      "adjustFilters": "Regola filtri",
      "allBadges": "Tutti i badge",
      "allCohorts": "Tutte le coorti",
      "allStatus": "Tutti gli stati",
      "allTalents": "Tutti i talenti",
      "analytics": "Analisi",
      "avgIQulture": "Media iQulture",
      "badgeDistribution": "Distribuzione badge",
      "badgeDistributionDesc": "Quanti talenti hanno ciascun badge iQulture",
      "byCohort": "Per coorte",
      "checkUpCompleted": "CheckUp completato",
      "clearFilters": "Cancella filtri",
      "description": "Valuta i talenti con il CheckUp prima di sponsorizzarli",
      "explain": "Spiega",
      "explainAria": "Apri la spiegazione di CoPilot per {{name}}",
      "openTalentAria": "Apri il profilo talento per {{name}}",
      "percentDone": "{{value}}% completato",
      "insightBodies": {
        "proInsightBody_one": "{{count}} talento ha ottenuto l'80%+ su iQulture — una prontezza eccezionale per la mobilità internazionale.",
        "proInsightBody_other": "{{count}} talenti hanno ottenuto l'80%+ su iQulture, indicando un'eccezionale prontezza per la mobilità internazionale.",
        "potentialInsightBody_one": "{{count}} talento mostra un forte potenziale. Considera QultureUp per aumentarne il punteggio.",
        "potentialInsightBody_other": "{{count}} talenti mostrano un forte potenziale. Considera QultureUp per aumentare i loro punteggi.",
        "pendingInsightBody_one": "{{count}} talento non ha ancora completato il CheckUp. Invia un promemoria per accelerare la selezione.",
        "pendingInsightBody_other": "{{count}} talenti non hanno ancora completato CheckUp. Invia promemoria per accelerare il vetting."
      },
      "sponsorAria": "Sponsorizza {{name}}",
      "filterByCohort": "Filtra per coorte",
      "inVetting": "In Verifica",
      "iqultureAssessed": "iQulture valutato",
      "iqultureBadge": "iQulture distintivo",
      "loading": "Caricamento…",
      "loadingDescription": "Caricamento dettagli talento",
      "mesh": {
        "englishNative": "Inglese",
        "hardOther": "Competenze tecniche",
        "motivation": "Motivazione",
        "notScored": "Non valutato",
        "softCultural": "Soft skill e cultura"
      },
      "noTalentsFound": "Nessun talento trovato",
      "noTalentsInVetting": "Nessun talento in verifica",
      "noobOnly": "Solo noob",
      "notFound": "Talento non trovato",
      "notFoundDesc": "Questo talento non esiste o non hai accesso per visualizzare il loro record.",
      "pendingAction": "Azione pendente",
      "pendingCheckUp": "In attesa di CheckUp",
      "percentageReadyForMobility": "Percentuale pronta per la mobilità",
      "potential": "Potenziale",
      "potentialInsight": "Insight sul potenziale",
      "potentialOnly": "Solo potenziale",
      "proAndPotentialWithCheckUp": "Pro e potenziale con CheckUp",
      "proBadges": "Badge Pro",
      "proInsight": "Insight Pro",
      "proOnly": "Solo Pro",
      "readyToSponsor": "Pronto per sponsorizzare",
      "searchTalents": "Cerca talenti",
      "sponsor": "Sponsor",
      "sponsorshipFunnel": "Funnel di sponsorizzazione",
      "sponsorshipFunnelDesc": "Dall'invito alla sponsorizzazione, fase per fase",
      "sponsorshipReadyRate": "Tasso di prontezza per sponsorizzazione",
      "statusCompleted": "Stato completato",
      "statusInProgress": "Stato in corso",
      "statusLabel": "Stato",
      "statusPending": "Stato in attesa",
      "talentDetail": {
        "analysis": "Analisi",
        "archivedReadOnly": "Questo percorso non è più attivo. Il record è conservato per audit; le azioni non sono disponibili.",
        "exportCsv": "Esporta CSV",
        "exportFailed": "Impossibile esportare questo report. Riprova.",
        "exportPdf": "Esporta PDF",
        "vettingCompleteReadOnly": "La verifica è completata — questo è uno snapshot in sola lettura della valutazione.",
        "askCoPilot": "Chiedi CoPilot",
        "confidence": "Fiducia",
        "copyEmail": "Copia email",
        "copyEmailSuccess": "Email copiata negli appunti",
        "culturalRiskAnalysis": "Analisi del rischio culturale",
        "lowRiskCras": "CRAs a basso rischio",
        "moderateRiskCras": "CRAs a rischio moderato",
        "highRiskCras": "CRAs ad alto rischio",
        "archetypesSeverityChip": "{{low}} basso · {{moderate}} moderato · {{high}} alto",
        "topRisksTitle": "Principali rischi culturali",
        "topRisksDescription": "Gli archetipi Tonnie segnalati come il rischio di sponsorizzazione più alto per questo candidato.",
        "topRisksEmpty": "Nessun archetipo ad alto rischio segnalato.",
        "topRisks": {
          "severityShort": {
            "high": "Alto",
            "moderate": "Mod"
          },
          "a11yLabel": {
            "high": "Rischio alto: {{score}} percento",
            "moderate": "Rischio moderato: {{score}} percento"
          }
        },
        "meshTagline": {
          "motivation": "Perché questo candidato vuole trasferirsi.",
          "english": "Prontezza nella lingua di lavoro.",
          "softCultural": "Adattamento culturale e come collaborano.",
          "hardOther": "Capacità tecnica e operativa."
        },
        "pillars": {
          "spreadTitle": "Distribuzione dei pilastri",
          "spreadDescription": "Tutti e sette i pilastri su un radar — più ciascun asse si avvicina al bordo esterno, più forte è la valutazione del candidato su quel pilastro.",
          "topGreenFlagsTitle": "Principali punti di forza tra i pilastri",
          "topRedFlagsTitle": "Principali preoccupazioni tra i pilastri",
          "topFlagsEmpty": "Nessun problema segnalato.",
          "plan90Days": {
            "title": "Piano suggerito di 90 giorni",
            "description": "Sequenza raccomandata di Tonnie per i primi 90 giorni dopo la sponsorizzazione.",
            "empty": "Nessun piano generato.",
            "stepDuration": "Giorno {{day}}"
          },
          "fullName": {
            "ICM": "Motivazione internazionale Career",
            "MA": "Adattabilità multiculturale",
            "WMF": "Flessibilità del modello di lavoro",
            "CP": "Competenza nella comunicazione",
            "CP_ENGLISH": "Comunicazione in Inglese",
            "CP_NATIVE_TARGET": "Lingua madre / Lingua obiettivo",
            "GPE": "Esperienza professionale globale",
            "AR": "Prontezza accademica",
            "PRM": "Resilienza psicologica per la mobilità"
          }
        },
        "pitch": {
          "sentimentLabel": "Sentimento",
          "sentimentValue": {
            "positive": "Positivo",
            "neutral": "Neutro",
            "negative": "Negativo"
          },
          "deliveryMetric": {
            "communicationClarity": "Chiarezza della comunicazione",
            "confidenceLevel": "Livello di fiducia",
            "energyLevel": "Livello di energia",
            "pacing": "Ritmo",
            "articulation": "Articolazione",
            "fillerWords": "Parole riempitive"
          },
          "noPitchTitle": "Nessun pitch registrato ancora",
          "noPitchDescription": "{{name}} non ha registrato la sua introduzione di 60 secondi. Invia un promemoria per sollecitarli — il pitch è uno dei segnali qualitativi più forti prima di sponsorizzare.",
          "pendingAnalysisTitle": "Pitch registrato — analisi in corso",
          "pendingAnalysisDescription": "Il pitch di {{name}} è stato caricato ma Brain non ha ancora finito di analizzarlo. La trascrizione e le intuizioni AI appariranno qui tra pochi minuti.",
          "playbackMissingTitle": "Analisi pronta — riproduzione non disponibile",
          "playbackMissingDescription": "Tonnie ha il trascritto e l'analisi del pitch qui sotto, ma il file video non può essere caricato in questo momento. Ricarica tra un momento per riprovare, o controlla il vault del cittadino.",
          "videoOnlyTitle": "Pitch registrato — analisi in attesa",
          "videoOnlyDescription": "Il pitch di {{name}} è pronto per essere guardato sopra, ma il trascritto, il sentimento e l'analisi della consegna di Tonnie non sono ancora allegati a questo CheckUp. Nella maggior parte dei casi, ciò significa che l'analizzatore non è stato eseguito per questo tentativo — riattivalo qui sotto per riempire i segnali mancanti.",
          "rerunAnalysis": "Rieseguire l'analisi del pitch",
          "rerunAnalysisInProgress": "Rieseguendo l'analisi del pitch…",
          "rerunAnalysisError": "Impossibile rieseguire l'analisi del pitch",
          "videoFallback": "Il tuo browser non può riprodurre questo formato video.",
          "duration": "Durata: {{value}}",
          "recordedAt": "Registrato {{date}}",
          "statusReady": "Pronto per la revisione",
          "statusAnalyzing": "Analizzando",
          "statusPending": "In attesa di caricamento",
          "statusFailed": "Analisi fallita",
          "statusEstimated": "Stima",
          "failedTitle": "Non è stato possibile analizzare il pitch",
          "failedDescription": "La registrazione di {{name}} non ha prodotto alcuna analisi. Nulla in questa scheda ne è una valutazione.",
          "heuristicTitle": "Questi segnali sono stime, non un'analisi dell'IA",
          "heuristicDescription": "L'analisi dell'IA non era disponibile, quindi il sentiment e le metriche di esposizione qui sotto derivano da una semplice euristica basata sul conteggio delle parole. Non basare una decisione su di esse: esegui di nuovo l'analisi.",
          "failedReason": {
            "noInput": "L'analisi è stata eseguita senza registrazione. Esegui di nuovo l'analisi.",
            "videoNotFound": "Nessuna registrazione di {{name}} è stata trovata nell'archivio.",
            "storageFetchFailed": "Non è stato possibile leggere la registrazione dall'archivio. Esegui di nuovo l'analisi.",
            "serviceComponentMissing": "Al servizio di analisi manca un componente necessario. Il nostro team è stato avvisato: esegui di nuovo l'analisi quando sarà risolto.",
            "noAudioTrack": "La registrazione non ha audio. Chiedi a {{name}} di registrare di nuovo con il microfono attivo.",
            "unreadableRecording": "Non è stato possibile decodificare il formato della registrazione. Chiedi a {{name}} di registrare di nuovo.",
            "timedOut": "L'elaborazione della registrazione ha richiesto troppo tempo. Esegui di nuovo l'analisi.",
            "noSpeech": "Nella registrazione non è stato rilevato parlato. Chiedi a {{name}} di registrare di nuovo.",
            "serviceRejected": "Il servizio di trascrizione ha rifiutato la registrazione. Il nostro team è stato avvisato.",
            "serviceUnavailable": "Il servizio di trascrizione non era disponibile. Esegui di nuovo l'analisi.",
            "internalError": "Un errore imprevisto ha interrotto l'analisi. Il nostro team è stato avvisato.",
            "unrecorded": "Questo risultato è stato prodotto prima che i motivi degli errori venissero registrati. Esegui di nuovo l'analisi per scoprirne il motivo."
          },
          "heuristicReason": {
            "modelUnavailable": "Motivo: nessun modello di IA era configurato per l'analisi.",
            "invalidResponse": "Motivo: non è stato possibile utilizzare la risposta dell'IA.",
            "serviceRejected": "Motivo: il servizio di IA ha rifiutato la richiesta.",
            "serviceUnavailable": "Motivo: il servizio di IA non era disponibile.",
            "unrecorded": "Motivo: non registrato — questo risultato è precedente a tale registrazione."
          }
        },
        "skills": {
          "softHardCombinedTitle": "Competenze principali soft e hard",
          "softHardCombinedDescription": "Il profilo di ogni elenco a colpo d’occhio e, sotto, ogni competenza ordinata per punteggio di forza, con la fascia in cui Tonnie l’ha classificata. Il numero di ogni asse è la sua riga.",
          "additionalSkillsTitle": "Competenze aggiuntive",
          "additionalSkillsDescription": "Capacità oltre l'elenco principale di competenze soft/hard, classificate per punteggio di potenza.",
          "additionalSkillsEmpty": "Nessuna competenza aggiuntiva emersa.",
          "softEmpty": "Nessuna competenza trasversale emersa finora — l'analisi di Tonnie non ha restituito un set di competenze principali per questo candidato.",
          "hardEmpty": "Nessuna competenza tecnica emersa finora — l'analisi di Tonnie non ha restituito un set di competenze principali per questo candidato.",
          "softShapeLabel": "Profilo delle principali competenze trasversali, assi numerati per posizione — {{summary}}",
          "hardShapeLabel": "Profilo delle principali competenze tecniche, assi numerati per posizione — {{summary}}"
        },
        "deliveryMetrics": "Metriche di consegna",
        "drawerDescription": "Revisione del vetting per {{name}} — progresso di CheckUp, dati del profilo e azioni amministrative.",
        "evaluationPillars": "Piloni di valutazione",
        "evaluationPillarsDesc": "Punteggio per pilastro, fiducia e prove — la traccia di audit dietro il verdetto di {{name}} su iQulture.",
        "evidenceLabel": "Prove",
        "greenFlags": "Bandierine verdi",
        "hideDetails": "Nascondi dettagli",
        "interviewFirst": "Intervista prima",
        "interviewConfirmTitle": "Inviare invito all'intervista?",
        "interviewConfirmDescription": "Tonnie invierà a {{name}} un invito a un colloquio pre-sponsorizzazione. Puoi ritirarti in seguito, ma l'email verrà inviata immediatamente.",
        "interviewConfirmCancel": "Annulla",
        "interviewConfirmAction": "Invia invito",
        "lastSeenAgo_one": "Ultima vista {{count}} giorno fa",
        "lastSeenAgo_other": "Ultima vista {{count}} giorni fa",
        "lastSeenToday": "Ultima vista oggi",
        "menuLabel": "Altre azioni",
        "messageSendError": "Non siamo riusciti a inviare il messaggio. Per favore riprova.",
        "messageSent": "Messaggio inviato a {{name}}",
        "messageSentDescription": "È in arrivo — lo vedrai nel registro dei messaggi a breve.",
        "meshAnalysis": "Analisi MESH",
        "meshAnalysisDesc": "Come {{name}} si posiziona sui quattro fondamenti su cui si basa ogni sponsorizzazione sicura.",
        "neverSeen": "Non ha ancora aperto l'app",
        "calculating": {
          "title": "Il punteggio del CheckUp è in fase di calcolo",
          "description": "Il nuovo punteggio di {{name}} apparirà qui non appena il calcolo sarà terminato."
        },
        "noneIdentified": "Nessuno identificato",
        "pitchVideoAnalysis": "Analisi video di presentazione",
        "pitchVideoDesc": "{{name}}'s pitch di 60 secondi — trascrizione, sentiment e metriche di consegna con le proprie parole.",
        "recommendations": "Raccomandazioni",
        "redFlags": "Bandierine rosse",
        "reminderSendError": "Non siamo riusciti a inviare il promemoria. Per favore riprova.",
        "reminderSent": "Promemoria inviato a {{name}}",
        "reminderSentDescription": "{{name}} riceverà un promemoria via email per completare CheckUp.",
        "reminderTemplateMissing": "Il modello di promemoria CheckUp non è stato impostato. Visita Messaggi per crearlo.",
        "sendMessage": "Invia messaggio",
        "sendMessageDescription": "Personalizza l'oggetto e il messaggio prima di inviare — il talento lo riceve come un'email.",
        "sendMessageTitle": "Invia un messaggio",
        "sendNow": "Invia ora",
        "sendReminder": "Invia promemoria",
        "sending": "Invio…",
        "showDetails": "Mostra dettagli",
        "sponsoredDrawerDescription": "Monitoraggio dei talenti sponsorizzati per {{name}} — progressi, prove e azioni amministrative.",
        "sponsorJourney": "Percorso sponsor",
        "sponsorship": {
          "cancelTitle": "Annullare la sponsorizzazione?",
          "cancelLoading": "Calcolo dell'importo del rimborso…",
          "cancelDescription": "Tonnie rimborserà {{refundAmount}} ({{monthsRemaining}} di {{durationMonths}} mesi rimanenti) e il viaggio di {{name}} tornerà all'accesso di base. Questa azione non può essere annullata.",
          "cancelNoRefundDescription": "Questa sponsorizzazione non ha un saldo rimborsabile — l'intero periodo di {{durationMonths}} mesi è stato consumato. L'annullamento riporterà il viaggio di {{name}} all'accesso di base senza rimborso.",
          "cancelKeep": "Mantieni la sponsorizzazione",
          "cancelAction": "Annulla e rimborso di {{refundAmount}}",
          "cancelNoRefund": "Annulla sponsorizzazione (senza rimborso)",
          "cancelSuccess": "Sponsorizzazione annullata — {{amount}} rimborsati sulla tua carta.",
          "cancelFailed": "Impossibile annullare la sponsorizzazione in questo momento."
        },
        "tagsHint": "Suggerimento: partire da un modello compila automaticamente il nome del talento e altri dettagli. I messaggi personalizzati vengono inviati così come sono.",
        "waitingDays_one": "In attesa di {{count}}d",
        "waitingDays_other": "In attesa di {{count}}d",
        "waitingOverdue_one": "{{count}}d in ritardo",
        "waitingOverdue_other": "{{count}}d in ritardo",
        "phase": {
          "adaptation": {
            "awaiting": {
              "description": "QultureUp è sbloccato. {{name}} non ha ancora iniziato nessuna missione di preparazione culturale.",
              "title": "In attesa della prima attività"
            },
            "locked": {
              "description": "QultureUp si attiva dopo che {{name}} è sponsorizzato. Le missioni di preparazione culturale si costruiscono automaticamente in base alla destinazione.",
              "title": "L'adattamento si sblocca dopo la sponsorizzazione"
            }
          },
          "action": {
            "careIntervention": "Intervento di Care",
            "sendReminder": "Invia promemoria",
            "viewKit": "Visualizza kit"
          },
          "care": {
            "awaiting": {
              "description": "Care è sbloccato. {{name}} non ha ancora registrato un check-in — un promemoria gentile potrebbe aiutare.",
              "title": "In attesa del primo check-in"
            },
            "locked": {
              "description": "Care si attiva dopo che {{name}} è sponsorizzato. Il programma di benessere si costruisce attorno al loro percorso di ambientamento.",
              "title": "Care si sblocca dopo la sponsorizzazione"
            }
          },
          "checkup": {
            "awaiting": {
              "description": "{{name}} ha accettato l'invito ma non ha ancora iniziato CheckUp. Un promemoria di solito li spinge a iniziare.",
              "title": "CheckUp non ancora iniziato"
            },
            "locked": {
              "description": "CheckUp si attiva non appena {{name}} accetta l'invito e viene creato un viaggio.",
              "title": "CheckUp non ancora attivato"
            },
            "inProgress": {
              "title": "CheckUp in corso",
              "description": "{{name}} sta completando il suo CheckUp — {{done}} di {{total}} passaggi completati."
            },
            "awaitingScore": {
              "title": "CheckUp inviato",
              "description": "{{name}} ha completato il suo CheckUp. Stiamo calcolando il punteggio iQulture."
            }
          },
          "evidence": {
            "awaiting": {
              "description": "Nessun timbro del passaporto ancora. I timbri e le miglia si accumulano man mano che {{name}} progredisce attraverso gli eroi.",
              "title": "In attesa dei primi traguardi"
            },
            "locked": {
              "description": "Passport si attiva dopo la sponsorizzazione. I traguardi di ogni eroe guadagnano timbri automaticamente.",
              "title": "Le prove si sbloccano dopo il patrocinio"
            }
          },
          "mobility": {
            "awaiting": {
              "description": "Il kit di TelePortal è pronto. {{name}} non ha ancora iniziato nessun compito.",
              "title": "In attesa della prima attività"
            },
            "locked": {
              "description": "TelePortal costruirà automaticamente un kit di trasferimento personalizzato una volta che {{name}} sarà sponsorizzato.",
              "title": "La mobilità si sblocca dopo il patrocinio"
            }
          }
        },
        "phaseStrip": {
          "scrollNext": "Mostra le fasi successive",
          "scrollPrevious": "Mostra le fasi precedenti",
          "sponsored": {
            "accepted": "Accettato",
            "ariaLabel": "Fase di patrocinio",
            "offered": "Offerto",
            "sponsored": "Sponsorizzato",
            "thriving": "Fiorente"
          },
          "vetting": {
            "ariaLabel": "Fase di verifica",
            "invited": "Invitato",
            "scored": "Punteggiato",
            "started": "Iniziato",
            "submitted": "Inviato",
            "verdict": "Verdetto"
          }
        },
        "summary": "Riepilogo",
        "topHardSkills": "Top competenze tecniche",
        "topSoftSkills": "Top competenze trasversali",
        "transcript": "Trascrizione",
        "citizenAccountDeletedTitle": "Account Citizen eliminato",
        "citizenAccountDeletedBody": "Questo candidato ha eliminato il proprio account Tonnie. Il loro profilo + attività sono conservati in forma di sola lettura per i tuoi registri; non possono essere intraprese ulteriori azioni.",
        "interviewInvitationQueued": "Richiesta di colloquio in coda per {{name}}. Email inviata; integrazione broker ATS in attesa.",
        "interviewInvitationFailed": "Impossibile inviare la richiesta di colloquio. Riprova.",
        "scoreEstimate": {
          "title": "Parti di questo punteggio sono stime, non misurazioni",
          "pitchFailed": "Pitch: non analizzato — il punteggio è stato calcolato senza di esso.",
          "pitchHeuristic": "Esposizione del pitch (Motivazione): stimata dal conteggio delle parole — l'analisi dell'IA non era disponibile.",
          "pillarsM": "Motivazione: alcuni pilastri sono stati stimati con un metodo semplificato — la valutazione dell'IA non era disponibile.",
          "pillarsE": "Inglese: alcuni pilastri sono stati stimati con un metodo semplificato — la valutazione dell'IA non era disponibile.",
          "pillarsS": "Competenze trasversali e culturali: alcuni pilastri sono stati stimati con un metodo semplificato — la valutazione dell'iA non era disponibile.",
          "pillarsH": "Competenze tecniche: alcuni pilastri sono stati stimati con un metodo semplificato — la valutazione dell'iA non era disponibile."
        },
        "languages": {
          "title": "Lingue",
          "none": "Nessun risultato linguistico ancora."
        },
        "leftProgrammeTitle": "Ha lasciato il tuo programma il {{date}}",
        "leftProgrammeBody": "La relazione è terminata, quindi questo record è di sola lettura e ciò che ha condiviso non è più visibile. Invia un nuovo invito per tornare a lavorare insieme: decide lui se accettare."
      },
      "title": "Verifica",
      "topCandidates": "Candidati principali",
      "topCandidatesDescription": "I punteggi migliori, pronti per la sponsorizzazione",
      "topPick": "Scelta principale",
      "totalCandidates": "Candidati totali",
      "viewPending": "Visualizza in attesa",
      "viewPotentialTalents": "Visualizza talenti potenziali",
      "viewProTalents": "Visualizza talenti professionali",
      "completed": "Completato",
      "badge": {
        "pro": "PRO",
        "potential": "POTENZIALE",
        "noob": "NOOB",
        "pending": "In attesa di CheckUp"
      },
      "talentsCount_one": "{{count}} talento",
      "talentsCount_other": "{{count}} talenti",
      "readyOfTotal": "{{completed}} di {{total}} pronti",
      "talentRowActionsAria": "Azioni per {{name}}",
      "testitCandidates": "Candidati TestIt",
      "readyCount_one": "{{count}} pronto",
      "readyCount_other": "{{count}} pronti"
    },
    "invitationDetail": {
      "acceptedAt": "Accettato",
      "accessibleDescription": "Stato dell'invito: {{status}}",
      "accessibleDescriptionLoading": "Caricamento dei dettagli dell'invito",
      "accessibleTitle": "Dettagli dell'invito",
      "acquisitionEyebrow": "Acquisizione",
      "assessment": "Valutazione",
      "branch": "Filiale",
      "createdAt": "Creato",
      "delete": "Elimina",
      "destination": "Destinazione",
      "email": "Email",
      "errorDescription": "L'invito potrebbe essere stato eliminato o il server non è raggiungibile.",
      "errorTitle": "Impossibile caricare l'invito",
      "expiresAt": "Scade",
      "historyTitle": "Storia",
      "name": "Nome",
      "noHistory": "Nessuna modifica di stato registrata.",
      "opportunityTitle": "Opportunità",
      "recipientTitle": "Destinatario",
      "resend": "Reinvia",
      "resendHint": "Il reinvio rigenera il token e ripristina la scadenza.",
      "revoke": "Revoca",
      "scenario": "Scenario",
      "scenarioValue": {
        "pre_immigration": "Pre-immigrazione",
        "already_abroad": "Già all'estero",
        "relocation_only": "Solo rilocazione",
        "integration_only": "Solo integrazione"
      },
      "send": "Invia invito",
      "sentAt": "Inviato",
      "status": {
        "draft": "Bozza",
        "pending": "In attesa di accettazione",
        "accepted": "Accettato",
        "expired": "Scaduto",
        "revoked": "Revocato",
        "declined": "Rifiutato",
        "email_queued": "Email in coda",
        "email_skipped": "Email saltata",
        "email_failed": "Email non inviata",
        "email_sent": "Email inviata",
        "email_delivered": "Consegnata",
        "email_opened": "Aperta",
        "email_clicked": "Link cliccato",
        "email_bounced": "Respinta",
        "landed": "Ha aperto la pagina dell’invito",
        "email_mismatch": "L’accesso non corrisponde",
        "matched_signup": "Si è registrato su Tonnie",
        "deferred": "Rimandato dal candidato",
        "email_reminded": "Promemoria inviato",
        "claimed": "Rivendicato da un altro account"
      },
      "tokenPreview": "Anteprima del token",
      "tokenTitle": "Token e scadenza",
      "workLocation": "Luogo di lavoro",
      "reason": {
        "deleted_sentinel": "Non inviata — il destinatario ha eliminato il proprio account Tonnie.",
        "email_mismatch": "Aveva effettuato l’accesso con un account diverso.",
        "email_unverified": "L’indirizzo è sul suo account ma non è ancora verificato.",
        "expired": "L’invito era già scaduto.",
        "expiry_sweep": "Scaduto senza risposta.",
        "jit": "Rilevato al primo accesso.",
        "lazy_expire_on_open": "Era già scaduto quando la pagina è stata aperta.",
        "matched_signup_unaccepted": "Scaduto anche se questa persona è già su Tonnie — reinviarlo ha buone probabilità di raggiungerla.",
        "ok": "L’invito era aperto e pronto per essere accettato.",
        "onboarding": "Rilevato durante l’onboarding.",
        "opted_out": "Non inviata — il destinatario ha rifiutato le email.",
        "revoked": "L’invito era già stato revocato.",
        "webhook": "Rilevato alla creazione dell’account."
      },
      "byActor": "da {{name}}",
      "hasAccountChip": "Registrato, non accettato",
      "resendNudge": "Questa persona ha già un account Tonnie — reinviare ha buone probabilità di raggiungere qualcuno che può accedere subito.",
      "resendPromoted": "Reinvia invito",
      "candidateRole": "Ruolo",
      "candidateLocation": "Posizione",
      "candidateSkills": "Competenze",
      "inviteAgain": "Invita di nuovo",
      "closed": {
        "declinedTitle": "Ha rifiutato l'invito il {{when}}",
        "expiredTitle": "L'invito è scaduto il {{when}}",
        "body": "Invita di nuovo per inviargli una nuova email con un link nuovo, oppure elimina l'invito per toglierlo dalla tua pipeline."
      }
    },
    "talentRowMenu": {
      "viewDetails": "Visualizza dettagli",
      "sendInvitation": "Invia invito",
      "resendInvitation": "Reinvia invito",
      "revoke": "Revoca",
      "delete": "Elimina",
      "sponsorJourney": "Sponsorizza il viaggio",
      "askCoPilot": "Chiedi CoPilot",
      "askTonnieServices": "Chiedi i servizi di Tonnie",
      "inviteAgain": "Invita di nuovo"
    },
    "vettingPage": {
      "activeTab": "Attivo",
      "archivedTab": "Archiviato"
    },
    "motivationalForm": {
      "questionCard": {
        "required": "Richiesto",
        "optional": "Facoltativo",
        "maxCharsHint_one": "Max. {{max}} carattere • Rispondi solo in inglese",
        "maxCharsHint_other": "Max. {{max}} caratteri • Rispondi solo in inglese",
        "answerLabel": "La tua risposta",
        "answerPlaceholder": "Scrivi la tua risposta qui in inglese…",
        "answerPlaceholderOptional": "Scrivi la tua risposta qui in inglese… (opzionale)",
        "noComment": "Nessun commento",
        "optionalHint": "Domanda facoltativa – puoi lasciarla vuota.",
        "validationComment": "Commento di validazione:"
      }
    },
    "quickEdit": {
      "companyPlaceholder": "Acme Corporation, Inc.",
      "taxIdPlaceholder": "EIN, IVA o ID fiscale nazionale"
    },
    "additionalDetails": {
      "languagePlaceholder": "Inglese"
    },
    "acceptInvite": {
      "notFound": "Invito non trovato",
      "failedToLoad": "Impossibile caricare l'invito",
      "failedToAccept": "Impossibile accettare l'invito",
      "roleAdmin": "Admin",
      "roleTeamMember": "Membro del team",
      "invalidLink": "Link di invito non valido. Nessun token fornito.",
      "goToLogin": "Vai al login",
      "welcomeTo": "Benvenuto in {{company}}!",
      "joinedAs": "Sei entrato come {{role}}. Reindirizzamento alla dashboard...",
      "expiredTitle": "Invito scaduto",
      "expiredBody": "Questo invito a unirti a {{company}} è scaduto. Si prega di chiedere all'amministratore del team di inviare un nuovo invito.",
      "alreadyTitle": "Già accettato",
      "alreadyBody": "Questo invito è già stato accettato.",
      "title": "Invito al team",
      "joinCompany": "Unisciti a {{company}}",
      "invitedAsRole": "Sei stato invitato a unirti come {{role}}",
      "signedInAs": "Accesso come {{email}}",
      "accepting": "Accettando...",
      "accept": "Accetta invito",
      "emailMismatch": "Questo invito è stato inviato a {{invited}}, ma sei connesso come {{current}}. Per favore, disconnettiti e accedi con l'indirizzo email corretto.",
      "invitedToJoin": "Sei stato invitato a unirti a {{company}}",
      "joinAsRole": "Unisciti come {{role}}",
      "invitationSentTo": "Invito inviato a {{email}}",
      "signUpOrLogIn": "Registrati o accedi per accettare questo invito e unirti al team.",
      "haveAccount": "Hai già un account? Accedi",
      "emailUnverified": "Verifica {{email}} sul tuo account, poi accetta di nuovo l'invito."
    },
    "weeklySummary": {
      "title": "Riepilogo settimanale",
      "insightsFor": "Approfondimenti generati dall'AI per {{period}}",
      "keyAchievements": "Risultati chiave",
      "areasNeedingAttention": "Aree che necessitano attenzione",
      "trends": "Tendenze",
      "insights": "Approfondimenti",
      "viewFullReport": "Visualizza rapporto completo"
    },
    "nextBestActions": {
      "title": "Prossime migliori azioni",
      "empty": "Nessuna azione richiede attenzione immediata. Ottimo lavoro!",
      "explainCopilot": "Raccomandazioni alimentate dall'AI per i tuoi programmi di mobilità",
      "pipelineCopilot": "Raccomandazioni alimentate dall'AI allineate al tuo pipeline",
      "categoryCheckup": "CheckUp in attesa",
      "categorySponsorship": "Decisione di sponsorizzazione",
      "categoryMobility": "Blocco della mobilità",
      "categoryCare": "Checkpoint di Care",
      "categoryRisk": "Segnale di rischio",
      "urgency": {
        "high": "alto",
        "medium": "medio",
        "low": "basso"
      },
      "reason": "Motivo: {{reason}}",
      "explain": "Spiega"
    },
    "iqultureBadge": {
      "pending": "In Attesa",
      "description": {
        "pro": "Prontezza eccezionale per opportunità internazionali",
        "potential": "Forte potenziale con margini di crescita",
        "noob": "Inizio del percorso di prontezza",
        "noBadge": "CheckUp non ancora completato"
      },
      "corporateInsight": {
        "pro": "Talento di alto livello pronto per mobilità immediata",
        "potential": "Candidato forte — considera con piano di preparazione",
        "noob": "Fase iniziale — monitora i progressi tramite QultureUp",
        "noBadge": "In attesa della valutazione di iQulture"
      }
    },
    "routeFlags": {
      "srLabel": "{{origin}} a {{destination}}"
    },
    "inviteMessage": {
      "bodyHint": "Modifica liberamente. I tag vengono compilati per destinatario — l’anteprima mostra il risultato.",
      "editingSource": "Stai modificando il messaggio solo per questo invio. Il modello del tenant non cambia.",
      "linkPresent": "Link di accettazione presente",
      "linkRequired": "Mantieni il link di accettazione — senza di esso il candidato non può iniziare."
    },
    "attentionReason": {
      "invitation_never_sent": "Invito mai inviato",
      "invitation_bounced": "E-mail respinta — verifica l’indirizzo",
      "invitation_expired": "Invito scaduto",
      "signed_up_not_accepted": "Si è registrato ma non ha accettato — reinvia",
      "invite_ignored": "Nessuna risposta da {{days}} giorni",
      "onboarding_stalled": "Profilo incompleto da {{days}} giorni",
      "checkup_never_requested": "CheckUp mai richiesto",
      "checkup_never_started": "CheckUp non iniziato da {{days}} giorni",
      "checkup_stalled": "CheckUp fermo da {{days}} giorni",
      "scoring_stalled": "Calcolo in ritardo di {{days}} giorni",
      "awaiting_company_review": "In attesa della tua revisione da {{days}} giorni",
      "testit_awaiting_review": "Test completati — in attesa del tuo giudizio",
      "citizen_left": "Il candidato ha lasciato la piattaforma",
      "mobility_track_blocked": "Sponsorizzato ma nessun percorso avviato",
      "sponsorship_offer_unanswered": "Offerta di sponsorizzazione senza risposta da {{days}} giorni",
      "checkup_not_shared": "Risultato del CheckUp non condiviso da {{days}} giorni",
      "sharing_withdrawn": "Condivisione revocata {{days}} giorni fa"
    },
    "companyProfile": {
      "industry": {
        "technology": "Tecnologia",
        "healthcare": "Sanità",
        "finance": "Finanza",
        "manufacturing": "Manifattura",
        "retail": "Vendita al dettaglio",
        "hospitality": "Ospitalità",
        "construction": "Edilizia",
        "education": "Istruzione",
        "consulting": "Consulenza",
        "logistics": "Logistica",
        "energy": "Energia",
        "telecommunications": "Telecomunicazioni",
        "mediaEntertainment": "Media e intrattenimento",
        "realEstate": "Immobiliare",
        "other": "Altro"
      },
      "roleType": {
        "engineering": "Ingegneria",
        "product": "Prodotto",
        "design": "Design",
        "dataScience": "Data science",
        "devops": "DevOps e infrastruttura",
        "marketing": "Marketing",
        "sales": "Vendite",
        "customerSuccess": "Customer success",
        "finance": "Finanza",
        "hrPeople": "Risorse umane",
        "operations": "Operazioni",
        "executive": "Direzione e leadership",
        "other": "Altro"
      },
      "employeesRange": "{{range}} dipendenti",
      "hiresRange": "{{range}} assunzioni all'anno",
      "openLinkedIn": "Apri profilo ↗"
    },
    "lifecycleStatus": {
      "draft": "Bozza",
      "active": "In corso",
      "paused": "In pausa",
      "completed": "Completato",
      "archived": "Archiviato"
    },
    "taskPriority": {
      "high": "Alta priorità"
    },
    "iqulture": {
      "provisional": {
        "label": "Provvisorio",
        "tooltip": "Mancano alcuni dati di questo talento, quindi il punteggio è il minimo possibile. Con i dati completi potrebbe arrivare fino a {{max}}."
      }
    },
    "shareRequest": {
      "badge": {
        "pendingCheckup": "CheckUp richiesto — in attesa del talento",
        "pendingTests": "Altri test richiesti — in attesa del talento",
        "declinedCheckup": "Richiesta di CheckUp rifiutata · {{date}}",
        "declinedTests": "Richiesta di test rifiutata · {{date}}",
        "pendingTooltip": "Richiesto il {{date}}. Non viene condiviso altro finché il talento non risponde.",
        "declinedTooltip": "Vedi ciò che il talento ha condiviso prima. Puoi chiedere di nuovo più tardi."
      },
      "notice": {
        "pendingCheckupTitle": "CheckUp richiesto — in attesa del talento",
        "pendingTestsTitle": "Altri test richiesti — in attesa del talento",
        "pendingBody": "Richiesto il {{date}}. Non viene condiviso altro finché non rispondono: continui a vedere ciò che avevano accettato.",
        "declinedCheckupTitle": "Il talento ha rifiutato la tua richiesta di vedere il suo CheckUp",
        "declinedTestsTitle": "Il talento ha rifiutato la tua richiesta di altri test",
        "declinedBody": "Rifiutato il {{date}}. Non è cambiato nulla: vedi ciò che hanno condiviso prima. Puoi chiedere di nuovo più tardi."
      }
    }
  },
  "capture": {
    "uploadFailedDefault": "Caricamento fallito. Riprova."
  },
  "care": {
    "additionalComments": "Commenti aggiuntivi (facoltativo)",
    "allStatuses": "Tutti gli stati",
    "alreadyCheckedIn": "Già registrato oggi",
    "appOnlyNotice": {
      "message": "Questo cruscotto è la tua panoramica in sola lettura. Apri l'app Tonnie per registrare il tuo umore, eseguire check-in rapidi e completare i checkpoint.",
      "title": "I check-in giornalieri avvengono nell'app"
    },
    "askCopilotAboutThis": "Chiedi a CoPilot di questo",
    "askCopilotFirst": "Chiedi a CoPilot Brain first",
    "assessedOn": "Valutato il {{date}}",
    "assessment": {
      "completeTitle": "Valutazione completata",
      "completed": "Completato",
      "gateTitle": "Valutazione di Care",
      "loading": "Caricamento valutazione…",
      "redirecting": "Reindirizzamento…",
      "retake": "Ripeti la valutazione",
      "saving": "Salvataggio…",
      "subtitle": "Un breve check-in per valutare quanto bene ti stai adattando. Ci vogliono circa 5 minuti.",
      "title": "Valutazione di Care"
    },
    "assessmentEstimatedTime": "Circa 5 minuti",
    "assessmentInfoDescription": "Le tue risposte aiutano Care a personalizzare i check-in, suggerire risorse locali e fornire supporto quando ne hai bisogno.",
    "assessmentInfoIntro": "Ti faremo alcune domande sul tuo benessere in relazione alla salute, alle finanze e alla comunità.",
    "baseline": {
      "anxiety": "Ansia attuale riguardo al trasferimento",
      "concerns": "Principali aree di preoccupazione",
      "desc": "Seleziona l'opzione che descrive meglio il tuo stato emotivo attuale.",
      "familyConfidence": "Fiducia nell'adattamento della famiglia",
      "minimal": "Minimale",
      "notConfident": "Non sicuro",
      "selectMultiple": "seleziona tutte le opzioni che si applicano",
      "significant": "Significativa",
      "supportNeed": "Di quanto supporto pensi di avere bisogno?",
      "title": "Come ti senti riguardo al trasferimento?",
      "veryConfident": "Molto sicuro"
    },
    "carePillars": "Pilastri di Care",
    "challengePlaceholder": "Descrivi la tua sfida o domanda...",
    "checkin": {
      "responseField": {
        "qc_concern": "Preoccupazioni",
        "qc_notes": "Note"
      },
      "responses": "Risposte"
    },
    "checkinType": {
      "daily_mood": "Umore giornaliero",
      "evening_checkin": "Controllo serale",
      "morning_checkin": "Controllo mattutino",
      "quick_checkin": "Check-in veloce",
      "weekly_checkin": "Controllo settimanale"
    },
    "checkpoint": {
      "complete": {
        "milesEarned": "+{{miles}} Miles guadagnate",
        "nextCheckpoint": "Prossimo checkpoint: {{date}}",
        "recorded": "Risposte registrate nel tuo Passport",
        "subtitle": "Grazie per aver condiviso. Le tue risposte ci aiutano a supportarti meglio.",
        "title": "Checkpoint completato!"
      },
      "completed": "Completato",
      "confirmSubmit": {
        "message": "Sei pronto a inviare le tue risposte al checkpoint? Non potrai modificare le tue risposte dopo averle inviate.",
        "title": "Inviare il checkpoint?"
      },
      "due": "Scadenza",
      "feedbackLabel": "Ulteriori feedback? (opzionale)",
      "feedbackPlaceholder": "Condividi i tuoi pensieri...",
      "loading": "Caricamento checkpoint...",
      "notFound": "Checkpoint non trovato",
      "unavailableTitle": "Check-in non disponibile",
      "unavailableBody": "Non siamo riusciti a caricare le domande per questo check-in in questo momento. Per favore riprova più tardi.",
      "overallScore": "Punteggio complessivo",
      "overdue": "Scaduto",
      "previous": "Precedente",
      "reviewSubmit": "Rivedi e invia",
      "scaleLabels": [
        "Molto insoddisfatto",
        "Insoddisfatto",
        "Neutrale",
        "Soddisfatto",
        "Molto soddisfatto"
      ],
      "scheduled": "Programmato",
      "scoresSummary": "Riepilogo dei tuoi punteggi:",
      "skipped": "Saltato",
      "stepOf": "Passo {{current}} di {{total}}",
      "submit": "Invia",
      "title": "Checkpoint",
      "typeNames": {
        "ad_hoc": "Check-in",
        "annual": "Checkpoint annuale",
        "custom": "Checkpoint",
        "month_1": "Checkpoint di 1 mese",
        "month_12": "Checkpoint di 12 mesi",
        "month_3": "Checkpoint di 3 mesi",
        "month_6": "Checkpoint di 6 mesi",
        "month_9": "Checkpoint di 9 mesi",
        "onboarding": "Checkpoint di onboarding",
        "pre_move_baseline": "Baseline pre-movimento",
        "week_1": "Checkpoint della settimana 1",
        "week_2": "Checkpoint della settimana 2"
      },
      "framing": {
        "expectations": "Prima del tuo trasferimento — le tue aspettative",
        "reality": "Ambientamento — come sono realmente le cose",
        "settling": "Trovare il tuo ritmo",
        "established": "Stabilizzarsi",
        "thriving": "Guardando avanti"
      },
      "focusPillar": "Focus",
      "miles_one": "{{count}} Mile",
      "miles_other": "{{count}} Miles",
      "pillarsTime_one": "{{count}} pilastro · {{time}} min",
      "pillarsTime_other": "{{count}} pilastri · {{time}} min"
    },
    "checkpointCommentsPlaceholder": "Condividi eventuali pensieri o preoccupazioni sulla stabilità della tua famiglia e integrazione...",
    "checkpointCompleted": "Checkpoint completato con successo!",
    "checkpointDescription": "Autovalutazione per benessere e integrazione",
    "checkpointEvolution": "Evoluzione del checkpoint",
    "checkpointFormDescription": "Completa questo checkpoint per monitorare i tuoi progressi. Puoi anche completarlo su mobile.",
    "checkpointHistory": "Storia del checkpoint",
    "checkpointMonth": "Checkpoint di {{month}} mesi",
    "checkpointTitle": "Checkpoint di Care",
    "checkpoints": {
      "status": {
        "completed": "Completato",
        "due": "Scadenza ora",
        "in_progress": "In corso",
        "overdue": "Scaduto",
        "pending": "In Arrivo",
        "scheduled": "In Arrivo",
        "skipped": "Saltato"
      },
      "title": "Checkpoint"
    },
    "checkpointsCompleted": "Checkpoint completati",
    "checkpointsDescription": "Visualizza i checkpoint e completali nell'app mobile",
    "commitment": {
      "at_risk": "A rischio",
      "champion": "Campione",
      "committed": "Impegnato",
      "engaged": "Coinvolto",
      "flight_risk": "Richiede attenzione"
    },
    "companyFeedback": "Feedback aziendale",
    "companyRating": "Valutazione dell'azienda",
    "completeCheckinMobile": "Completa il check-in su mobile",
    "completeCheckpointMobile": "Completa in mobile",
    "completeFirstCycle": "Completa il tuo primo ciclo di feedback per vederlo qui",
    "completedOn": "Completato il",
    "concern": {
      "family": "Famiglia",
      "finances": "Finanze",
      "healthcare": "Assistenza sanitaria",
      "housing": "Alloggio",
      "language": "Lingua",
      "loneliness": "Solitudine",
      "schooling": "Istruzione",
      "title": "Preoccupazioni",
      "work": "Lavoro"
    },
    "continue": {
      "description": "Hai iniziato la tua valutazione Care. Riprendi esattamente da dove hai interrotto su Citizen Web — le tue risposte finora sono salvate.",
      "title": "Continua la tua valutazione di Care"
    },
    "continueOnWeb": "Continua su Citizen Web",
    "continueOnWebDesc": "Riprendi la tua valutazione Care da dove l'hai interrotta sul portale web Citizen.",
    "copilotSuggestions": "💡 suggerimenti di CoPilot Brain",
    "copilotSuggestionsText": "Prima di inviare, prova a chiedere a CoPilot Brain aiuto immediato. Può suggerire lezioni, compiti o risorse.",
    "createdOn": "Creato il",
    "current": "Attuale",
    "description": "Monitora il tuo benessere",
    "due": "Scadenza",
    "dueNow": "Scadenza ora",
    "error": {
      "description": "Tira per aggiornare, o tocca riprova. Se continua a non funzionare, controlla la tua connessione.",
      "title": "Non siamo riusciti a caricare i tuoi dati di Care"
    },
    "excellent": "5 — Eccellente",
    "familyMasterOnly": "Solo il Family Master può rispondere ai checkpoint di Care",
    "feedbackComment1": "Ottima performance nel progetto recente. Continua così!",
    "feedbackComment2": "Buon progresso, continua a praticare il portoghese.",
    "feedbackComment3": "Ti senti più sicuro nelle conversazioni in portoghese al lavoro.",
    "feedbackComment4": "Ancora in fase di adattamento alla cultura lavorativa, ma stai facendo progressi.",
    "feedbackPillars": "Piloni di feedback",
    "from": "Da",
    "getHelpWith": "Ottieni aiuto con {{topic}}",
    "heroBanner": {
      "assessmentComplete": "Valutazione completata",
      "awaitingFirstCheckin": "Inizia il tuo primo check-in dell'umore",
      "focusFromAssessment": "Aree di focus dalla tua valutazione",
      "title": "Il tuo benessere",
      "wellbeing": "Benessere",
      "gettingStarted": "Iniziare"
    },
    "heroMiles": "Miles di Care",
    "householdAware": "Consapevole della Famiglia",
    "householdAwareDescription": "Questo pilastro considera il contesto della tua famiglia (partner, figli) nella valutazione",
    "improving": "Miglioramento",
    "manager": "Manager",
    "mood": {
      "amazing": "Incredibile",
      "checkedIn": "Controllato oggi!",
      "earnMiles": "Guadagna miglia controllando quotidianamente",
      "good": "Buono",
      "great": "Ottimo",
      "howAreYou": "Come ti senti oggi?",
      "label1": "In difficoltà",
      "label2": "Va bene",
      "label3": "Buono",
      "label4": "Ottimo",
      "label5": "Incredibile",
      "okay": "Va bene",
      "struggling": "In difficoltà",
      "streakDays_one": "{{count}} giorno di fila",
      "streakDays_other": "{{count}} giorni di fila"
    },
    "mySupportRequests": "Le mie richieste di supporto",
    "mySupportRequestsDesc": "Monitora e rivedi le tue richieste di supporto inviate",
    "needSupport": "Hai bisogno di supporto?",
    "needsImprovement": "1 — Necessita di miglioramento",
    "newRequest": "Nuova richiesta",
    "noCheckins": "Nessun controllo ancora. Inizia a monitorare il tuo umore!",
    "noCheckpointsScheduled": "Nessun checkpoint programmato ancora",
    "noDataYet": "Nessun dato ancora",
    "noHistory": "Nessuna cronologia feedback ancora",
    "noSupportRequests": "Nessuna richiesta di supporto corrisponde a questo filtro",
    "noUpdatesYet": "Nessun aggiornamento ancora",
    "objectiveChildcareArrangement": "Organizza assistenza all'infanzia",
    "objectiveDefinitiveHousing": "Assicura un alloggio definitivo",
    "objectiveHousingStress": "Riduci lo stress legato all'abitazione",
    "objectiveSchoolEnrollment": "Completa l'iscrizione scolastica",
    "objectiveSocialIntegration": "Costruisci connessioni sociali",
    "objectiveTemporaryHousing": "Assicurati un alloggio temporaneo",
    "objectiveWellbeingSupport": "Accedi al supporto al benessere",
    "objectiveWorkAdaptation": "Adattati alla cultura lavorativa",
    "objectiveWorkplaceCulture": "Comprendi la cultura del posto di lavoro",
    "objectives": {
      "title": "I tuoi obiettivi",
      "subtitle": "Cosa il tuo team sponsor ti sta aiutando a raggiungere.",
      "categoryFallback": "Obiettivo",
      "currentLabel": "Ora",
      "targetLabel": "Obiettivo",
      "milestoneDone": "Fatto",
      "milestoneNotYet": "Non ancora",
      "feedbackReadyBadge": "Feedback pronto",
      "viewFeedbackCta": "Visualizza feedback e auto-valutati",
      "sourceCompany": "Dalla tua azienda",
      "sourcePersonal": "Il tuo obiettivo personale",
      "currentCycleHeading": "Il feedback di questo ciclo",
      "selfEmpty": "Non hai ancora aggiunto la tua auto-valutazione per questo obiettivo.",
      "ratingValue": "{{label}} ({{value}}/5)",
      "cadenceNote": "Il feedback viene esaminato {{cadence}}.",
      "cadence": {
        "bi-weekly": "ogni due settimane",
        "monthly": "mensile",
        "quarterly": "trimestrale"
      },
      "selfEvalBanner": {
        "title": "Il tuo team ha condiviso nuovo feedback",
        "message": "C'è un ciclo di feedback aperto in attesa della tua auto-valutazione. Aggiungilo nell'app Tonnie per riflettere su ogni obiettivo.",
        "cta": "Aggiungi la tua auto-valutazione nell'app"
      }
    },
    "objectiveFeedback": {
      "title": "Obiettivi e feedback",
      "intro": "Il tuo team sponsor ha condiviso feedback sui tuoi obiettivi. Rifletti su ciascuno e aggiungi la tua onesta auto-valutazione — rimane tra te e il tuo team.",
      "providerHeading": "Il feedback del tuo team",
      "providerEmpty": "Il tuo team non ha ancora aggiunto una nota per questo obiettivo.",
      "selfHeading": "La tua auto-valutazione",
      "ratingPrompt": "Come stai andando su questo?",
      "valuePlaceholder": "Inserisci il tuo numero",
      "ratingLabel1": "Appena iniziato",
      "ratingLabel2": "Trovando il mio equilibrio",
      "ratingLabel3": "Faccio progressi",
      "ratingLabel4": "Sto andando bene",
      "ratingLabel5": "Fiorente",
      "commentLabel": "C'è qualcosa che vorresti aggiungere? (opzionale)",
      "commentPlaceholder": "Cosa sta andando bene, cosa è stato difficile, di cosa hai bisogno…",
      "submit": "Invia auto-valutazione",
      "submitting": "Invio in corso…",
      "noRatingHint": "Valuta almeno un obiettivo per inviare.",
      "loadingTitle": "Caricamento dei tuoi obiettivi…",
      "emptyTitle": "Nessun obiettivo ancora",
      "emptyBody": "Una volta che il tuo team sponsor imposta gli obiettivi per te, appariranno qui.",
      "allCaughtUpTitle": "Sei aggiornato",
      "allCaughtUpBody": "Non c'è attualmente un ciclo di feedback aperto. Ti faremo sapere quando il tuo team condivide nuovi feedback.",
      "errorTitle": "Non siamo riusciti a caricare i tuoi obiettivi",
      "errorBody": "Tira per aggiornare, o tocca riprova. Se continua a non funzionare, controlla la tua connessione.",
      "successTitle": "Autovalutazione condivisa",
      "successBody": "Grazie per aver riflettuto. Il tuo team può vedere la tua valutazione insieme ai loro feedback.",
      "successDone": "Fatto",
      "dueOn": "Scadenza {{date}}",
      "cadenceNote": "Il tuo team rivede questi {{cadence}}.",
      "cadence": {
        "weekly": "settimanale",
        "bi-weekly": "ogni due settimane",
        "biweekly": "ogni due settimane",
        "monthly": "mensile",
        "quarterly": "trimestrale",
        "semiannual": "due volte all'anno",
        "annual": "annuale"
      },
      "trust": {
        "why": "La tua autovalutazione aiuta il tuo team sponsor a comprendere i tuoi obiettivi dal tuo punto di vista.",
        "who": "Solo tu e il tuo team di sponsor Tonnie possono vedere le tue risposte. Non viene mai condiviso con altri colleghi.",
        "how": "Riflettere sui tuoi obiettivi mantiene il tuo supporto personale e in carreggiata."
      }
    },
    "overdue": "Scaduto",
    "phase": {
      "adapting": "Adattamento",
      "preMove": "Prima del trasferimento",
      "settlingIn": "Ambientamento",
      "thriving": "Fiorente"
    },
    "pillar": {
      "housing_stability": {
        "desc": "Alloggio temporaneo e definitivo, stress e rischio",
        "name": "Stabilità abitativa"
      },
      "schooling_childcare": {
        "desc": "Istruzione e organizzazione dell'assistenza all'infanzia",
        "name": "Istruzione e assistenza all'infanzia"
      },
      "wellbeing_social": {
        "desc": "Salute mentale, connessioni sociali e benessere generale",
        "name": "Benessere e sociale"
      },
      "work_fit": {
        "desc": "Adattamento al lavoro e al posto di lavoro",
        "name": "Adattamento al lavoro"
      },
      "housing": {
        "name": "Stabilità abitativa",
        "description": "Trovare, ambientarsi e sentirsi sicuri nella propria casa.",
        "obj1": "Assicurati un alloggio stabile e adatto",
        "obj2": "Riduci lo stress legato all'abitazione",
        "obj3": "Ambientati nel quartiere",
        "q1": "Quanto sei soddisfatto della tua attuale situazione abitativa?",
        "q1_hh": "Quanto è soddisfatta la tua famiglia della sua attuale situazione abitativa?",
        "q2": "Quanto ti senti sicuro riguardo ai tuoi accordi abitativi?",
        "q2_hh": "Quanto si sente sicura la tua famiglia riguardo ai suoi accordi abitativi?",
        "q3": "Quanto conosci bene la tua zona locale e i servizi?",
        "qPreMove": "Quanto ti senti preparato riguardo ai tuoi accordi abitativi per il trasloco?"
      },
      "schooling": {
        "name": "Istruzione e assistenza all'infanzia",
        "description": "L'istruzione e gli accordi di assistenza all'infanzia dei tuoi figli.",
        "obj1": "Iscrivi i bambini in una scuola adatta",
        "obj2": "Organizza un'assistenza all'infanzia affidabile",
        "obj3": "Aiuta i bambini ad ambientarsi socialmente",
        "q1": "Quanto sei soddisfatto degli accordi scolastici dei tuoi figli?",
        "q2": "Quanto si sono ambientati bene i tuoi figli nella loro nuova scuola?",
        "q3": "Quanto è gestibile la tua situazione di assistenza all'infanzia?"
      },
      "work": {
        "name": "Idoneità al lavoro",
        "description": "Quanto ti sei adattato al tuo nuovo ruolo e posto di lavoro.",
        "obj1": "Adattati al nuovo ruolo",
        "obj2": "Integra con il team",
        "obj3": "Comprendi la cultura del posto di lavoro",
        "q1": "Quanto ti senti a tuo agio nel tuo posto di lavoro?",
        "q2": "Quanto sono chiari il tuo ruolo e le tue responsabilità?",
        "q3": "Quanto ti senti supportato dal tuo team?",
        "q4": "Quanto sei sicuro nel tuo lavoro quotidiano?",
        "qMonth3": "Dopo tre mesi, quanto ti senti ambientato nel tuo ruolo?"
      },
      "wellbeing": {
        "name": "Benessere e sociale",
        "description": "Il tuo benessere generale e le connessioni sociali.",
        "obj1": "Mantieni il benessere emotivo",
        "obj2": "Costruisci connessioni sociali",
        "obj3": "Supporta l'integrazione dei compagni",
        "q1": "Come valuteresti il tuo benessere generale?",
        "q1_hh": "Come valuteresti il benessere generale della tua famiglia?",
        "q2": "Quanto ti senti connesso alle persone intorno a te?",
        "q2_hh": "Quanto si sente connessa la tua famiglia alle persone intorno a loro?",
        "q3": "Quanto stai gestendo bene la vita quotidiana qui?",
        "q4": "Quanto sei ottimista riguardo all'ambientamento?",
        "q4_hh": "Quanto è ottimista la tua famiglia riguardo all'ambientamento?",
        "qMonth1": "Dopo un mese, quanto ti senti connesso alle persone qui finora?"
      }
    },
    "pillarCommunication": "Comunicazione",
    "pillarHousingStability": "Stabilità abitativa",
    "pillarHousingStabilityDesc": "Alloggio temporaneo/definitivo, stress, rischio",
    "pillarIntegration": "Comportamento e adattamento",
    "pillarSchoolingChildcare": "Stabilità scolastica/assistenza all'infanzia",
    "pillarSchoolingChildcareDesc": "Disposizioni per l'istruzione e l'assistenza all'infanzia (se applicabile)",
    "pillarSelector": {
      "conditional": "Condizionale",
      "desc": "Raccomandiamo questi pilastri in base al tuo profilo. Puoi modificarli.",
      "selected": "selezionato",
      "title": "Scegli le tue aree di focus"
    },
    "pillarTechnical": "Competenze tecniche",
    "pillarWellbeing": "Benessere e adattamento sociale",
    "pillarWellbeingDesc": "Salute mentale, connessioni sociali e benessere generale",
    "pillarWorkFit": "Adattamento e idoneità lavorativa",
    "pillarWorkFitDesc": "Adattamento al lavoro e al posto di lavoro",
    "pillars": {
      "housingStability": "Stabilità abitativa",
      "schoolingChildcare": "Istruzione e assistenza all'infanzia",
      "title": "Pilastri di Care",
      "wellbeingSocial": "Benessere e sociale",
      "workFit": "Adattamento al lavoro"
    },
    "plan": {
      "active": "Scadenza ora",
      "assessmentDone": "Valutazione completata",
      "completed": "Completato",
      "encouragement": "Ogni checkpoint ci aiuta a capire come ti stai ambientando e come possiamo supportarti meglio.",
      "focusAreas": "Le tue aree di focus",
      "locked": "In Arrivo",
      "milesReward": "+{{miles}} Miles",
      "milestones": "Traguardi del checkpoint"
    },
    "preferences": {
      "afternoon": "Pomeriggio",
      "daily": "Giornaliero",
      "desc": "Comunica a Care quando e con quale frequenza controllare con te. Puoi cambiare questo in qualsiasi momento.",
      "evening": "Sera",
      "frequencyLabel": "Frequenza",
      "moodReminder": "Promemoria dell'umore",
      "moodReminderDesc": "Ricevi un gentile promemoria per registrare come ti senti.",
      "morning": "Mattina",
      "timeLabel": "Orario preferito",
      "title": "Preferenze Care",
      "weekdays": "Giorni feriali",
      "weekly": "Settimanale"
    },
    "proFeature": "Funzione Pro — Aggiorna per accedere",
    "proFeatureDescription": "Aggiorna a Pro per accedere a tutte le funzionalità Care, ai cicli di feedback e al supporto.",
    "proFeatureTitle": "Care & supporto — Funzione Pro",
    "progressOverTime": "I tuoi progressi nel tempo",
    "quickCheckin": {
      "concern": "Qualsiasi area che desideri segnalare?",
      "continue": "Continua",
      "notes": "Qualcos'altro che desideri condividere?",
      "overall": "Come ti senti questa settimana in generale?",
      "copilotPrompts": {
        "concern": "Qualsiasi area che desideri segnalare?",
        "notes": "Qualcos'altro che desideri condividere?",
        "overall": "Come ti senti in generale questa settimana?"
      },
      "error": {
        "message": "Non siamo riusciti a salvare il tuo check-in. Per favore riprova.",
        "title": "Qualcosa è andato storto"
      },
      "finish": "Fine",
      "intro": {
        "quickEasy": "Veloce e facile",
        "quickEasyDesc": "Solo 3-5 domande, ci vogliono 2 minuti",
        "subtitle": "CoPilot ti guiderà attraverso alcune domande",
        "trackProgress": "Monitora progresso",
        "trackProgressDesc": "Confronta con i tuoi check-in precedenti"
      },
      "processing": {
        "subtitle": "CoPilot sta preparando le tue intuizioni...",
        "title": "Analizzando le tue risposte"
      },
      "questionOf": "Domanda {{current}} di {{total}}",
      "questions": {
        "notesPlaceholder": "Scrivi qui i tuoi pensieri...",
        "qcConcern": "Qualsiasi area che desideri segnalare?",
        "qcNotes": "Qualcos'altro che desideri condividere?",
        "qcOverall": "Come ti senti questa settimana in generale?",
        "qcOverallLabels": ["Molto male", "Male", "Così così", "Bene", "Benissimo"]
      },
      "results": {
        "areasOfConcern": "Aree di preoccupazione",
        "milesEarned": "+{{miles}} Miles guadagnate",
        "moodScoreOf": "Punteggio dell'umore di {{score}}",
        "nextStep1": "Continua i tuoi check-in giornalieri per monitorare il tuo benessere nel tempo",
        "title": "Check-in completo!",
        "today": "Oggi",
        "trendTitle": "Tendenza",
        "whatsNext": "Cosa c'è dopo",
        "yesterday": "Ieri",
        "yourNotes": "Le tue note",
        "concernHint": "CoPilot seguirà queste aree",
        "nextStep2": "CoPilot monitorerà le tue tendenze nel tempo",
        "nextStep3": "Riceverai suggerimenti personalizzati per le aree segnalate"
      },
      "selectAll": "Seleziona tutto ciò che si applica",
      "alreadyDone": {
        "title": "Sei a posto per oggi",
        "message": "Hai già completato il check-in di oggi. Torna domani!"
      },
      "doneToday": "Completato oggi",
      "shortDesc": "Controllo del benessere giornaliero veloce",
      "startButton": "Inizia il check-in",
      "title": "Check-in veloce",
      "milesReward_one": "+{{count}} Mile",
      "milesReward_other": "+{{count}} Miles"
    },
    "rateProgress": "Come valuteresti i tuoi progressi?",
    "recentCycles": "I tuoi recenti checkpoint",
    "requestSupport": "Richiedi supporto",
    "responses": "risposte",
    "retakeAssessment": "Ripeti la valutazione",
    "retakeOnWeb": "Ritenta la valutazione sul web",
    "retakeOnWebDesc": "Per ripetere la tua valutazione Care, utilizza il portale web Citizen.",
    "returnToDashboard": "Torna alla dashboard",
    "risk": {
      "checkinGap": "È passato molto tempo dall'ultimo check-in",
      "crossHeroStall": "Nessuna attività TelePortal o QultureUp negli ultimi 30+ giorni",
      "isolation": "Punteggi sociali/benessere bassi nei recenti checkpoint",
      "missedCheckpoint": "Un checkpoint è in ritardo di {{overdueDays}} giorni",
      "moodDecline": "Umore basso per {{consecutive}} check-in consecutivi",
      "pillarDrop": "{{pillar}} è sceso di {{drop}} punti dall'ultimo checkpoint"
    },
    "selectPillarOrTheme": "Seleziona pilastro o tema",
    "selectPillarOrThemePlaceholder": "Scegli un pilastro o tema",
    "selectSeverity": "Seleziona gravità (opzionale)",
    "selfFeedback": "Auto-Riscontro",
    "severity": {
      "high": "Alto",
      "low": "Basso",
      "medium": "Medio",
      "urgent": "Urgente"
    },
    "severityHigh": "Alto",
    "severityLow": "Basso",
    "severityMedium": "Medio",
    "shareThoughts": "Condividi i tuoi pensieri su {{pillar}}...",
    "startCheckpoint": "Inizia il checkpoint",
    "startOnWeb": "Inizia su Citizen Web",
    "startOnWebDesc": "Imposta la tua valutazione Care sul portale web Citizen (circa 5 minuti). Una volta fatto, i check-in quotidiani e i checkpoint avvengono qui nell'app.",
    "status": {
      "closed": "Chiuso",
      "in_progress": "In corso",
      "open": "Apri",
      "resolved": "Risolto"
    },
    "statusInProgress": "In corso",
    "statusOpen": "Apri",
    "statusResolved": "Risolto",
    "streak": {
      "awesome": "Fantastico!",
      "bonusMiles": "+{{miles}} Miles bonus",
      "dayStreak": "{{days}}-giorni di streak!"
    },
    "submitCheckpoint": "Invia checkpoint",
    "submitRequest": "Invia richiesta",
    "suggestionMicroLearning": "Raccomandazioni di micro-apprendimento",
    "suggestionQultureUp": "Lezioni consigliate QultureUp",
    "suggestionSelfHelp": "Contenuti di auto-aiuto",
    "suggestionTelePortal": "Attività TelePortal",
    "support": {
      "footer": "Seleziona un argomento per ricevere raccomandazioni personalizzate da Tonnie CoPilot o richiedere supporto umano dal nostro team.",
      "openRequests": "Richieste di supporto aperte",
      "statusInProgress": "In corso",
      "statusOpen": "Apri",
      "subtitle": "Ottieni aiuto con sfide specifiche",
      "title": "Hai bisogno di supporto?",
      "topics": {
        "communication": "Comunicazione",
        "culturalFit": "Adattamento culturale",
        "technical": "Tecnico",
        "wellbeing": "Benessere"
      }
    },
    "supportCommunication": "Comunicazione",
    "supportCultural": "Adattamento culturale",
    "supportDescription": "Ottieni aiuto con sfide specifiche",
    "supportHelpText": "Seleziona un argomento per ricevere raccomandazioni personalizzate da Tonnie CoPilot o richiedere supporto umano dal nostro team.",
    "supportHousing": "Alloggio",
    "supportRequestActions": "Azioni",
    "supportRequestDetails": "Dettagli richiesta di supporto",
    "supportRequestDetailsDesc": "Visualizza dettagli e aggiornamenti per la tua richiesta di supporto",
    "supportRequestSubmitted": "Richiesta di supporto inviata! Il nostro team ti risponderà presto.",
    "supportRequestsOpen": "Richieste aperte",
    "supportSchooling": "Istruzione",
    "supportTeamWillRespond": "Il nostro team di supporto risponderà alla tua richiesta presto.",
    "supportTechnical": "Tecnico",
    "supportWellbeing": "Benessere",
    "tabs": {
      "checkins": "Check-in",
      "checkpoints": "Checkpoint",
      "objectives": "Obiettivi",
      "overview": "Panoramica",
      "support": "Supporto"
    },
    "teamLead": "Team lead",
    "thermometer": {
      "mood": "Umore",
      "settlement": "Liquidazione",
      "wellbeing": "Benessere"
    },
    "title": "Care & supporto",
    "todaysCare": "Oggi Care",
    "tonnieSupport": "Supporto Tonnie",
    "topic": "Argomento",
    "trust": {
      "checkpoint": {
        "how": "Aiuta Tonnie a fornire supporto e guida mirati.",
        "who": "Le tue risposte sono private. Le aziende vedono solo riassunti aggregati.",
        "why": "I checkpoint ci aiutano a capire come ti stai adattando e dove è necessario supporto."
      },
      "questions": {
        "how": "Aiuta a identificare opzioni di supporto su misura per te.",
        "who": "Solo tu e il supporto Tonnie possono vedere le tue risposte. Le aziende vedono tendenze aggregate.",
        "why": "Poniamo queste domande per capire il tuo attuale adattamento."
      },
      "quickCheckin": {
        "how": "Aiuta a personalizzare il supporto e mantenere il tuo adattamento sulla buona strada.",
        "who": "Solo tu e il supporto Tonnie possono vedere le tue risposte. Le aziende vedono solo tendenze aggregate.",
        "why": "Check-in rapidi ci aiutano a capire il tuo benessere quotidiano e a individuare precocemente le esigenze di supporto."
      },
      "results": {
        "how": "Le intuizioni aiutano CoPilot a fornire migliori raccomandazioni.",
        "who": "Solo tu e il supporto Tonnie. Le aziende vedono solo tendenze aggregate.",
        "why": "I tuoi dati di check-in ci aiutano a monitorare il tuo benessere nel tempo."
      }
    },
    "tryAgainLater": "Per favore riprova più tardi.",
    "unableToLoadData": "Impossibile caricare i dati Care",
    "upcoming": "In Arrivo",
    "updates": "Aggiornamenti",
    "weekPulse": {
      "title": "Settimana pulse"
    },
    "welcome": {
      "description": "Care ti supporta durante il tuo viaggio di rilocazione. Questa configurazione una tantum richiede circa 5 minuti su Citizen Web — dopo di che, i tuoi check-in quotidiani e il supporto al benessere vivono proprio qui nell'app.",
      "familyStep": "Famiglia & lavoro",
      "familyStepDesc": "Monitora l'adattamento della famiglia, la scuola e l'integrazione nel posto di lavoro",
      "letsStart": "Iniziamo",
      "settlingStep": "Ambientamento",
      "settlingStepDesc": "Monitora la stabilità abitativa e il comfort della vita quotidiana",
      "timeEstimate": "Richiede circa 5 minuti per completare",
      "title": "Benvenuto in Care",
      "wellbeingStep": "Benessere e sociale",
      "wellbeingStepDesc": "Controlla la tua salute emotiva e le connessioni sociali"
    },
    "yourChallenge": "la tua sfida",
    "yourRating": "La tua valutazione",
    "interactions": {
      "title": "Con il tuo team",
      "subtitle": "Chiamate e riunioni organizzate dal tuo team di sponsor",
      "upcoming": "In Arrivo",
      "past": "Fatto",
      "type": {
        "call": "Chiamata",
        "video_call": "Videochiamata",
        "in_person_meeting": "Riunione di persona",
        "message": "Messaggio",
        "request_checkin": "Check-in"
      }
    },
    "momentum": {
      "event": {
        "checkin": "Hai effettuato il check-in",
        "checkpoint": "Checkpoint completato",
        "feedback": "Hai condiviso feedback",
        "intervention": "Il tuo team ti ha contattato",
        "generic": "Attività Care"
      }
    },
    "zone": {
      "youToday": "Tu oggi",
      "forYou": "Per te",
      "yourProgress": "Il tuo progresso"
    },
    "assessmentDimension": {
      "baseline": "Baseline emotivo",
      "baselineDesc": "Il tuo umore attuale, energia e livelli di stress",
      "pillars": "Pilastri del benessere",
      "pillarsDesc": "Seleziona le aree di focus che contano di più per te",
      "preferences": "Preferenze di check-in",
      "preferencesDesc": "Come e quando desideri essere supportato"
    },
    "milesAwarded_one": "+{{count}} Mile",
    "milesAwarded_other": "+{{count}} Miles"
  },
  "career": {
    "achievementsSummary": "Risultati rilevanti per Career",
    "allLocations": "Tutte le posizioni",
    "allOpportunities": "Tutte le opportunità",
    "allTypes": "Tutti i tipi",
    "apply": "Applica",
    "avgMatch": "Media match",
    "careerOverviewDesc": "Panoramica della tua prontezza professionale e profilo",
    "careerReadiness": "Prontezza Career",
    "careerReady": "Career pronto",
    "categoryCareer": "Servizi Career",
    "categoryEducation": "Istruzione",
    "categoryNetworking": "Networking",
    "checkBackLater": "Controlla più tardi per nuove corrispondenze",
    "contract": "Contratto",
    "copilotAnalysis": "Analisi del cervello CoPilot per {{title}}",
    "createCV": "Crea CV",
    "createOrEditCV": "Crea o modifica CV",
    "createYourFirstCV": "Crea il tuo primo CV professionale per mostrare le tue competenze",
    "cv": {
      "downloadError": "Impossibile scaricare il CV",
      "generateError": "Impossibile generare il CV"
    },
    "cvDownloaded": "{{format}} CV per {{opportunityTitle}} scaricato con successo",
    "cvView": "Costruttore CV",
    "cvViewDescription": "Crea e gestisci il tuo CV professionale per le candidature",
    "cvsGenerated": "CV generati",
    "description": "Scopri opportunità e fai crescere la tua carriera",
    "disableProactive": "Disabilita candidature proattive",
    "downloadCV": "Scarica CV",
    "downloadPDF": "Scarica PDF",
    "downloadWord": "Scarica word",
    "ecosystemPartners": "Partner dell'ecosistema",
    "editCV": "Modifica CV",
    "enableProactive": "Abilita candidature proattive",
    "experience": "Esperienza",
    "experienceMatchDesc": "La tua esperienza corrisponde al ruolo",
    "fullTime": "Tempo pieno",
    "gotIt": "Capito",
    "highMatchOpportunities": "Opportunità di alta corrispondenza",
    "iWantIt": "Lo voglio...",
    "improveMatchText": "Considera di migliorare le competenze o i livelli linguistici pertinenti per aumentare il tuo punteggio di corrispondenza.",
    "languages": "Lingue",
    "lastGenerated": "Ultima generazione",
    "lastUpdated": "Ultimo aggiornamento",
    "learnMore": "Scopri di più",
    "letCompaniesFind": "Lascia che le aziende ti trovino",
    "levelLabel": "Livello",
    "lisbon": "Lisbon",
    "location": "Posizione",
    "locationMatchDesc": "La posizione lavorativa si adatta alle tue preferenze",
    "mainRole": "Ruolo principale",
    "match": "Corrispondenza",
    "matchQuality": "Qualità della corrispondenza",
    "matchScore": "Punteggio di corrispondenza",
    "matchScoreLabel": "Punteggio di corrispondenza",
    "matchingOpportunities": "Opportunità di corrispondenza",
    "mostRecentCV": "CV più recente",
    "noCVsYet": "Nessun CV creato ancora",
    "noDescription": "Nessuna descrizione disponibile",
    "noOpportunities": "Nessuna opportunità trovata",
    "noSavedOpportunities": "Nessuna opportunità salvata ancora",
    "notSpecified": "Non specificato",
    "opportunitiesFound": "Opportunità trovate",
    "opportunitiesSaved": "Opportunità salvate",
    "opportunitiesView": "Opportunità",
    "opportunityRemoved": "Opportunità rimossa dai salvati",
    "opportunityRequirements": "Requisiti dell'opportunità",
    "opportunitySaved": "Opportunità salvata",
    "partTime": "Part-time",
    "partnerCVDesc": "Revisione e ottimizzazione del CV",
    "partnerLinguaDesc": "Corsi di lingua professionale",
    "partnerNetworkDesc": "Eventi di networking professionale",
    "partnersDescription": "Partner Tonnie-Checked per accelerare il tuo viaggio di carriera",
    "porto": "Porto",
    "proactiveApplications": "Candidature proattive",
    "proactiveDescription": "Abilita il tuo profilo per essere visibile a reclutatori e aziende in cerca di talenti come te.",
    "proactiveDisabled": "Candidature proattive disabilitate. Il tuo profilo non è più visibile ai reclutatori.",
    "proactiveEnabled": "Candidature proattive abilitate! Le aziende possono ora trovarti.",
    "professionalCV": "CV professionale",
    "profileComplete": "Profilo completo",
    "profileCompleteness": "Completezza del profilo",
    "profileLabel": "Profilo",
    "readinessLabel": "Prontezza",
    "readinessMessage": "Sei ben preparato per opportunità internazionali. Continua a migliorare le tue competenze linguistiche!",
    "readyToApply": "Pronto per candidarti",
    "recentCVs": "CV recenti",
    "remote": "Remoto",
    "removeFromSaved": "Rimuovi dai salvati",
    "requiredSkills": "Competenze richieste",
    "save": "Salva",
    "saveOpportunitiesMessage": "Salva le opportunità per visualizzarle qui in seguito",
    "saved": "Salvato",
    "savedJobs": "Lavori salvati",
    "savedOpportunities": "Opportunità salvate ({{count}})",
    "savedOpportunitiesTab": "Opportunità salvate",
    "savedOpportunitiesTitle": "Opportunità salvate",
    "sharedKeyAchievements": "Risultati chiave e traguardi Passport",
    "sharedProfileSnapshot": "Panoramica del profilo (ruolo, competenze, esperienza)",
    "sharedReadinessScore": "Punteggio di prontezza (iQulture) e suddivisione MESH",
    "skills": "Competenze",
    "skillsMatchDesc": "Le tue competenze sono in linea con i requisiti del lavoro",
    "targetCountries": "Paesi target",
    "tipsToImprove": "💡 suggerimenti per migliorare la corrispondenza:",
    "title": "Career, opportunità & costruttore di CV",
    "total": "Totale",
    "type": "Tipo",
    "unsave": "Annulla salvataggio",
    "untitledCV": "CV senza titolo",
    "viewAllCVs": "Visualizza tutti i CV ({{count}})",
    "whatWillBeShared": "Cosa sarà condiviso:",
    "why": "Perché?",
    "whyMatch": "Perché questa corrispondenza?",
    "years": "anni",
    "yourCV": "Il tuo CV",
    "yourReadiness": "La tua prontezza",
    "highMatchCount_one": "{{count}} alta corrispondenza",
    "highMatchCount_other": "{{count}} alte corrispondenze",
    "rolesFound_one": "{{count}} ruolo trovato",
    "rolesFound_other": "{{count}} ruoli trovati",
    "savedOpportunitiesDescription_one": "{{count}} opportunità salvata da rivedere più tardi",
    "savedOpportunitiesDescription_other": "{{count}} opportunità salvate da rivedere più tardi"
  },
  "checkup": {
    "aboutDescription": "Questa valutazione valuta la tua prontezza su più dimensioni:",
    "achievement": "Risultato",
    "additionalSkills": "Competenze aggiuntive",
    "aiTalentSnapshot": "Panoramica AI talent",
    "allSet": "Sei a posto",
    "allSetDesc": "Il tuo CheckUp è completo. Possiamo ora costruire il tuo viaggio.",
    "analyzingTitle": "Analizzando il tuo profilo iQulture",
    "areasToWatch": "Aree da monitorare",
    "assessmentDescription": "Valuta la tua prontezza internazionale",
    "assessmentHistory": "Storico delle valutazioni",
    "assessmentResults": "Risultati della valutazione",
    "assessmentSubmitted": "Valutazione inviata",
    "assessmentTitle": "Valutazione CheckUp",
    "badge": {
      "explorer": "Esploratore",
      "explorerTagline": "Inizio del tuo viaggio internazionale",
      "globalPro": "Professionista globale",
      "globalProTagline": "Pronto per il successo internazionale",
      "risingStar": "Stella nascente",
      "risingStarTagline": "Costruire solide fondamenta"
    },
    "badgeAlt": "{{badge}} badge",
    "band": {
      "noob": "NOOB",
      "potential": "POTENZIALE",
      "pro": "PRO"
    },
    "bandLabels": {
      "emerging": "Emergente",
      "growing": "In crescita",
      "power": "Potere",
      "strong": "Forte"
    },
    "buildJourneyCta": "Costruisci il mio percorso",
    "buildJourneyTitle": "Pronto a costruire il tuo percorso?",
    "calcTimeEstimate": "Circa 30 secondi",
    "calculateScore": "Calcola il mio punteggio",
    "calculating": "Calcolo in corso…",
    "calculatingAriaLabel": "Calcolando il tuo punteggio",
    "calculatingDesc": "Analizzando le tue risposte per generare la tua valutazione personalizzata MESH...",
    "calculatingScore": "Calcolo del tuo punteggio in corso…",
    "calculatingTitle": "Calcolando il tuo punteggio iQulture…",
    "calculationComplete": "Calcolo completato",
    "calculationError": "Impossibile avviare il calcolo. Riprova.",
    "calculationFailed": "Calcolo fallito. Riprova.",
    "calculationTimedOut": "Il calcolo del tuo CheckUp è scaduto. Per favore, riprova.",
    "cancelConfirm": {
      "error": "Impossibile annullare il tuo CheckUp. Per favore, riprova.",
      "success": "CheckUp annullato. Puoi iniziarne uno nuovo in qualsiasi momento."
    },
    "capture": {
      "acceptedFormats": "Accetta foto, PDF, documenti Word e altro",
      "backToTask": "Torna al compito",
      "backToTelePortal": "Torna a TelePortal",
      "cameraPermissionRequired": "L'accesso alla fotocamera è necessario per scansionare documenti.",
      "cameraScanHint": "Punta la tua fotocamera sul documento per la migliore scansione di qualità",
      "chooseAnother": "Scegli un altro",
      "docTypeBank": "Estratto conto bancario",
      "docTypeBankDesc": "Estratto conto bancario o prova",
      "docTypeCertificate": "Certificato",
      "docTypeCertificateDesc": "Certificato di nascita, matrimonio o altro",
      "docTypeContract": "Contratto",
      "docTypeContractDesc": "Contratto di lavoro o di affitto",
      "docTypeIdCard": "Carta d'identità",
      "docTypeIdCardDesc": "Carta d'identità nazionale",
      "docTypeInsurance": "Assicurazione",
      "docTypeInsuranceDesc": "Documento di assicurazione sanitaria o di viaggio",
      "docTypeOther": "Altro",
      "docTypeOtherDesc": "Qualsiasi altro documento",
      "docTypePassport": "Passport",
      "docTypePassportDesc": "Passaporto di viaggio o pagina ID",
      "docTypePhoto": "Foto",
      "docTypePhotoDesc": "Foto in stile Passport",
      "docTypeResidencePermit": "Permesso di soggiorno",
      "docTypeResidencePermitDesc": "Carta o permesso di soggiorno",
      "docTypeTax": "Documento fiscale",
      "docTypeTaxDesc": "NIF, certificato fiscale o dichiarazione dei redditi",
      "docTypeVisa": "Visto",
      "docTypeVisaDesc": "Visto o permesso d'ingresso",
      "docTypeWorkPermit": "Permesso di lavoro",
      "docTypeWorkPermitDesc": "Autorizzazione al lavoro",
      "fieldDocType": "Tipo di documento",
      "fieldFile": "File",
      "removeFile": "Rimuovi",
      "retakeCamera": "Ritenta",
      "selectDocType": "Seleziona tipo di documento",
      "selectTypeFirst": "Seleziona un tipo di documento sopra per iniziare a caricare",
      "sourceCamera": "Scansione con fotocamera",
      "sourceFiles": "Sfoglia file",
      "sourceGallery": "Libreria foto",
      "tapSelectDocType": "Tocca per selezionare il tipo di documento",
      "tryAgain": "Riprova",
      "uploadButton": "Carica documento",
      "uploadFailed": "Caricamento non riuscito",
      "uploaded": "Documento caricato",
      "uploadedDesc": "Il tuo {{type}} è stato caricato e allegato.",
      "uploading": "Caricamento del tuo documento…",
      "uploadingNote": "Questo potrebbe richiedere un momento"
    },
    "chat": {
      "clickToUpload": "Clicca per caricare",
      "notAtAll": "Per niente",
      "typeMessage": "Scrivi un messaggio…",
      "typeYourAnswer": "Scrivi la tua risposta…",
      "veryMuch": "Molto"
    },
    "checkAgain": "Controlla di nuovo",
    "checkAgainHelp": "Completa i requisiti sopra e poi clicca su 'Controlla di nuovo'",
    "checkupHistory": "Storia CheckUp",
    "checkupHistoryDesc": "Visualizza le tue valutazioni CheckUp precedenti",
    "companyAverage": "La media della tua azienda",
    "companyCohort": "Coorte aziendale",
    "comparisonsDescription": "Il tuo punteggio rispetto agli altri",
    "comparisonsTitle": "Come ti confronti",
    "completeMoreCheckUps": "Completa più CheckUp per vedere la tua evoluzione",
    "completeTitle": "Valutazione completata!",
    "conclusionDesc": "Analisi completa della tua prontezza internazionale",
    "congratulations": "Congratulazioni per aver completato il tuo iQulture CheckUp!",
    "copilotGuideDescription": "Rispondi a domande sul tuo background e obiettivi",
    "copilotGuideTitle": "Guida CoPilot",
    "couldNotLoadResults": "Non siamo riusciti a caricare i tuoi risultati CheckUp. Per favore, riprova.",
    "description": "Valutazione internazionale completa di prontezza 360°",
    "didYouKnow": "Lo sapevi?",
    "dimensionInternational": "Esperienza internazionale",
    "dimensionLanguage": "Competenza linguistica",
    "dimensionMotivation": "Motivazione e mentalità",
    "dimensionProfessional": "Background professionale e competenze",
    "dontCloseWarning": "Per favore non chiudere questa pagina.",
    "downloadReport": "Scarica il rapporto completo",
    "elapsed": "trascorso",
    "errorDescription": "Qualcosa è andato storto nel caricamento del tuo CheckUp. Per favore, riprova.",
    "errorMessage": "Impossibile calcolare il tuo CheckUp. Per favore, riprova.",
    "errorTitle": "Oops! Qualcosa è andato storto",
    "estimated": "Stimato",
    "estimatedRemaining": "~{{minutes}}m rimasti",
    "estimatedTime": "Tempo stimato",
    "evaluationRadar": "Radar di valutazione",
    "exportGenerating": "Generazione esportazione...",
    "exportPDFDescription": "In produzione, questo genererebbe un PDF con i tuoi risultati CheckUp.",
    "exportResults": "Esporta risultati",
    "exportSuccess": "Risultati CheckUp esportati con successo",
    "filePickUnavailable": "La selezione dei file non è attualmente disponibile.",
    "finalMessage": "Hai completato una valutazione completa di prontezza internazionale 360°. Il tuo badge {{badge}} riflette solide basi in motivazione, adattabilità culturale e comunicazione. Concentrati sul {{plan}} per rafforzare le tue competenze tecniche e sarai pronto per opportunità globali.",
    "finalScore": "Punteggio finale",
    "goToCheckUp": "Vai a CheckUp",
    "goToQultureUp": "Vai a QultureUp",
    "goToTelePortal": "Vai a TelePortal",
    "greenFlags": "Bandierine verdi",
    "heroMiles": "Miles CheckUp",
    "iqultureBand": "Band iQulture",
    "journeyStepsSubtitle": "Ecco cosa ci serve per valutare la tua prontezza.",
    "languageTests": {
      "analyzeResult": "Carica e analizza",
      "analyzing": "Analizzando...",
      "attention": "Attenzione:",
      "attentionText": "Salva il tuo risultato come screenshot, oppure scaricalo come PDF con testo selezionabile ",
      "changeFile": "Cambia file",
      "completedTest": "Test completato",
      "dropHere": "Clicca per selezionare il file del tuo risultato",
      "englishTests": "Test di inglese",
      "iUnderstand": "Capisco, continua",
      "immediatelyAfter": "immediatamente dopo aver completato il test",
      "importantInstructions": "Istruzioni importanti",
      "instructions": "Carica il tuo risultato come screenshot (PNG, JPG, WEBP o GIF), PDF con testo selezionabile o documento Word (.docx). Leggiamo il livello automaticamente.",
      "languageTests": "Test di lingua",
      "listening": "Ascoltando",
      "lowConfidenceHint": "Abbiamo rilevato un risultato ma non siamo riusciti a leggerlo con certezza. Per favore rivedi e conferma.",
      "modalDesc": "Aggiungi un risultato di test linguistico per rafforzare il tuo profilo.",
      "openPlatform": "Apri piattaforma di test",
      "openPlatformHint": "Apri la piattaforma di test per scaricare il tuo certificato.",
      "pending": "In attesa di revisione",
      "portugueseTests": "Test di portoghese",
      "reUpload": "Ricarica",
      "readCarefully": "Per favore leggi attentamente il certificato prima di caricarlo.",
      "reading": "Lettura",
      "readyToStart": "Pronto per sostenere il test?",
      "referenceHint": "Utilizza un certificato recente (meno di 2 anni).",
      "referenceImage": "Riferimento: pagina risultati attesi",
      "resultDetected": "Risultato rilevato",
      "resultLowConfidence": "Risultato rilevato — per favore conferma",
      "retakeWarning": "Hai già un risultato per questo test. Caricare uno nuovo sostituirà il punteggio precedente.",
      "sampleHint": "Certificati di esempio: PDF, JPG, PNG.",
      "sampleResults": "Pagina risultati di esempio",
      "screenshotReminder": "Ricorda di catturare i tuoi risultati",
      "screenshotReminderDetail": "Assicurati che il tuo nome e il punteggio siano visibili nel file che carichi.",
      "speaking": "Parlando",
      "stepConfirm": "Conferma",
      "stepInstructions": "Istruzioni",
      "stepTakeTest": "Sostieni il test",
      "stepUpload": "Carica",
      "submitResult": "Invia risultato",
      "submitted": "Risultato inviato!",
      "submittedHint": "Hai inviato un risultato. Lo esamineremo e aggiorneremo il tuo punteggio a breve.",
      "supportedFormats": "Formati supportati: PNG, JPG, WEBP, GIF, PDF (con testo selezionabile), DOCX. Un PDF scansionato o un’immagine dentro un file Word non può essere letto.",
      "testOpened": "Piattaforma di test aperta in una nuova scheda",
      "uploadFailed": "Caricamento non riuscito. Riprova.",
      "uploadFailedError": "Caricamento fallito. Riprova.",
      "uploadSuccess": "Risultato del test inviato al tuo Vault",
      "uploading": "Caricamento...",
      "useThisExtension": "usa questa estensione",
      "alt": {
        "screenshotPreview": "Anteprima dello screenshot",
        "reference": "Riferimento",
        "sampleResults": "Risultati di esempio",
        "uploadedResult": "Risultato caricato"
      },
      "failed": {
        "title": "Non siamo riusciti a leggere un risultato da questo file",
        "languageMismatch": "Questo certificato sembra attestare una lingua diversa da quella di questo test. Carica il certificato della lingua di questo test.",
        "unsupportedDocument": "Non riusciamo a leggere questo file. Carica un'immagine PNG, JPG, WEBP o HEIC, un PDF o un documento Word (.docx).",
        "archiveTooLarge": "Questo documento Word è troppo grande per essere letto. Carica invece il risultato come immagine (PNG, JPG o HEIC) o come PDF.",
        "docxEmpty": "Questo documento Word non contiene testo né immagini leggibili. Carica invece il risultato come immagine (PNG, JPG o HEIC) o come PDF.",
        "tooManyPages": "Questo documento ha più di {{max}} pagine. Carica solo le pagine che mostrano il tuo risultato.",
        "noLevelFound": "Non abbiamo trovato un livello QCER (A1–C2) in questo file. Verifica che il risultato mostri il tuo livello e riprova.",
        "serviceUnavailable": "Il nostro servizio di analisi non è riuscito a elaborare il file in questo momento. Riprova tra qualche minuto.",
        "notCompletedHint": "Questo test non risulta completato finché non viene letto un livello dal tuo certificato."
      },
      "cefrLevel": {
        "a1": "Principiante",
        "a2": "Elementare",
        "b1": "Intermedio",
        "b2": "Intermedio superiore",
        "c1": "Avanzato",
        "c2": "Padronanza",
        "native": "Madrelingua"
      }
    },
    "lastAssessment": "Ultima valutazione: {{date}}",
    "lastCheckup": "Ultimo CheckUp",
    "legend": {
      "attention": "Attenzione",
      "critical": "Critico",
      "excellent": "Eccellente",
      "good": "Buono"
    },
    "loadingAssessment": "Caricamento valutazione…",
    "measureReadiness": "Misura la tua prontezza",
    "mesh": {
      "english": "Inglese / Realtà linguistica",
      "englishDesc": "Le tue competenze linguistiche sono forti, con un'eccellente padronanza dell'inglese e buoni progressi in portoghese.",
      "englishRec1": "Continua a praticare il portoghese nelle conversazioni quotidiane",
      "englishRec2": "Considera corsi di lingua avanzati",
      "hardSkills": "Competenze tecniche / Competenza professionale",
      "hardSkillsDesc": "La tua esperienza tecnica è eccellente e ben allineata con il mercato di riferimento.",
      "hardSkillsRec1": "Rimani aggiornato sulle ultime tecnologie",
      "hardSkillsRec2": "Considera certificazioni nel tuo campo",
      "motivation": "Motivazione",
      "motivationDesc": "La tua motivazione e mentalità verso il trasferimento internazionale sono forti. Mostri obiettivi chiari e un atteggiamento positivo.",
      "motivationRec1": "Mantieni il tuo atteggiamento positivo",
      "motivationRec2": "Stabilisci obiettivi e traguardi chiari",
      "softSkills": "Competenze soft & comportamenti",
      "softSkillsDesc": "Hai una buona comprensione delle differenze culturali, ma c'è margine di miglioramento nell'adattamento al posto di lavoro.",
      "softSkillsRec1": "Completa QultureUp lezioni sulla cultura locale",
      "softSkillsRec2": "Interagisci con le comunità locali"
    },
    "meshAnalysisDesc": "Motivazione • Inglese • soft culturale • hard & altro",
    "meshAssessmentIntro": "La valutazione MESH misura i quattro pilastri della prontezza a una carriera internazionale: Motivazione, Inglese, Soft skills e Hard skills.",
    "meshBreakdown": "MESH analisi",
    "meshBreakdownDesc": "La tua prontezza in Motivazione, Inglese, Competenze Soft e Competenze Hard",
    "meshInfo": {
      "E": "Inglese",
      "H": "Competenze tecniche",
      "M": "Motivazione",
      "S": "Competenze trasversali"
    },
    "meshReadinessEvaluation": "Valutazione della prontezza MESH",
    "monthsAgo": "mesi fa",
    "motivational": {
      "questionNumber": "Domanda {{number}}"
    },
    "nextStepsDesc": "Azioni per migliorare la tua prontezza",
    "noAssessmentYet": "Nessuna valutazione ancora",
    "noCheckUpForJourney": "Questo viaggio non ha ancora un CheckUp.",
    "noHistory": "Ancora nessun CheckUp precedente",
    "noResultsDesc": "Non hai ancora completato il tuo CheckUp. Completa per vedere il tuo punteggio di prontezza.",
    "noResultsForJourneyDesc": "Questo viaggio non ha ancora risultati CheckUp. Completa la valutazione per vedere il tuo punteggio.",
    "noResultsForJourneyTitle": "Nessun risultato per questo viaggio",
    "noResultsTitle": "Nessun risultato ancora",
    "notReadyMessage": "Completa prima questi passaggi, poi fai il tuo CheckUp.",
    "notReadyTitle": "Quasi ci siamo!",
    "now": "Ora",
    "phase": {
      "dataCollection": "Raccolta dati",
      "iqultureScoring": "Punteggio iQulture",
      "meshAnalysis": "Analisi MESH",
      "reportGeneration": "Generazione report"
    },
    "photoLibraryUnavailable": "La libreria foto non è attualmente disponibile.",
    "pillar": {
      "AR": {
        "brief": "Le tue credenziali, certificazioni e apprendimento continuo",
        "name": "Prontezza accademica"
      },
      "CP": {
        "brief": "La tua efficacia complessiva nella comunicazione e nella lingua",
        "name": "Competenza nella comunicazione"
      },
      "CP_ENGLISH": {
        "brief": "La tua competenza nella lingua inglese per contesti professionali",
        "name": "Comunicazione in Inglese"
      },
      "CP_NATIVE_TARGET": {
        "brief": "La tua competenza nelle lingue native e di mercato target",
        "name": "Lingua nativa/Target"
      },
      "GPE": {
        "brief": "Il tuo curriculum di lavoro internazionale/transfrontaliero",
        "name": "Esperienza professionale globale"
      },
      "ICM": {
        "brief": "Quanto è chiaro e impegnato il tuo piano di carriera internazionale",
        "name": "Motivazione internazionale Career"
      },
      "MA": {
        "brief": "La tua capacità di adattarti e prosperare attraverso le culture",
        "name": "Adattabilità multiculturale"
      },
      "PRM": {
        "brief": "La tua prontezza mentale e le strategie di coping per il trasferimento",
        "name": "Resilienza psicologica per la mobilità"
      },
      "WMF": {
        "brief": "La tua apertura a diverse modalità di lavoro (remoto/ibrido/in sede)",
        "name": "Flessibilità del modello di lavoro"
      }
    },
    "pillarsDesc": "Sette dimensioni chiave della prontezza internazionale",
    "pillarsPassed": "Piloni superati",
    "plan90Days": "Piano d'azione di 90 giorni",
    "pollingError": "Impossibile controllare lo stato del calcolo. Riprova.",
    "previousScore": "Il tuo punteggio precedente",
    "processingInitializing": "Inizializzazione del calcolo iQulture...",
    "processingStatus": "Stato di elaborazione",
    "processingSubtitle": "Questo potrebbe richiedere fino a 5 minuti. Per favore, non chiudere questa pagina.",
    "processingTitle": "Analizzando il tuo profilo iQulture",
    "progressTitle": "Progresso della valutazione",
    "readinessCheckError": "Impossibile controllare la prontezza. Riprova.",
    "readinessScore": "Otterrai il tuo punteggio di prontezza",
    "readyForJourney": "Sei pronto per il tuo viaggio",
    "recommendation1Description": "Inizia a conoscere la cultura portoghese e le norme lavorative",
    "recommendation1Title": "Completa la valutazione QultureUp",
    "recommendation2Description": "Ottieni la tua lista di controllo personalizzata per il trasferimento",
    "recommendation2Title": "Inizia la valutazione TelePortal",
    "recommendation3Description": "Il tuo punteggio di comunicazione è buono, ma la pratica rende perfetti",
    "recommendation3Title": "Continua l'apprendimento della lingua",
    "recommendations": "Raccomandazioni",
    "recommendedNextSteps": "Passi successivi raccomandati",
    "redirecting": "Reindirizzamento ai tuoi risultati...",
    "requirementMissing": "Requisito mancante",
    "requirementsTitle": "Lista di controllo dei requisiti",
    "results": {
      "activateSubtitle": "Il tuo CheckUp è completo. Ecco il tuo percorso da seguire.",
      "activateTitle": "Attiva il tuo viaggio",
      "activeJourney": "Attivo",
      "areasRequiringAttention": "Aree che richiedono attenzione",
      "areasToWatch": "Aree da monitorare",
      "assessedOn": "Valutato {{date}}",
      "backToTop": "Torna in cima",
      "bandAttention": "Attenzione",
      "bandAttentionDesc": "In Sviluppo — miglioramento mirato raccomandato",
      "bandAttentionRange": "60-69",
      "bandCritical": "Critico",
      "bandCriticalDesc": "Richiede attenzione prioritaria prima di procedere",
      "bandCriticalRange": "Sotto 60",
      "bandExcellent": "Eccellente",
      "bandExcellentDesc": "Forte e coerente — un chiaro valore aggiunto",
      "bandExcellentRange": "80-100",
      "bandGood": "Buono",
      "bandGoodDesc": "Base solida con margine di miglioramento",
      "bandGoodRange": "70-79",
      "careDesc": "Ottieni supporto post-arrivo e assistenza all'integrazione",
      "caveat": {
        "lowMotivationSignal": "Le tue risposte motivazionali erano molto brevi, quindi questo punteggio è meno affidabile degli altri. Una risposta più completa lo renderebbe più preciso.",
        "noMotivationData": "Non hai scritto nulla nella valutazione motivazionale, quindi non abbiamo potuto valutare la Motivazione. Completala e ricalcola per vedere questa dimensione.",
        "noPitch": "Non hai ancora registrato un video di presentazione, quindi la Motivazione si basa solo sulle tue risposte scritte.",
        "pitchAnalysisFailed": "Non è stato possibile analizzare il tuo video di presentazione, quindi la Motivazione si basa solo sulle risposte scritte.",
        "pitchHeuristicScoring": "L'analisi completa del tuo video di presentazione non era disponibile, quindi la sua parte di questo punteggio è una stima semplificata.",
        "pillarsEstimated": "Parte di questo punteggio è stata stimata con un metodo semplificato perché la nostra analisi completa non era disponibile.",
        "skillsInferenceEmpty": "Non siamo ancora riusciti a individuare le tue competenze da ciò che hai condiviso, quindi Competenze tecniche & altro non è valutato. Aggiungi competenze ed esperienza al tuo profilo e ricalcola."
      },
      "confidence": "Fiducia: {{value}}%",
      "description": "La tua valutazione di prontezza internazionale",
      "doctorsRecommendation": "Raccomandazione del medico",
      "errorDescription": "C'è stato un problema nel recuperare i tuoi risultati CheckUp. Per favore riprova.",
      "errorTitle": "Impossibile caricare i risultati",
      "examCount_one": "{{count}} esame",
      "examCount_other": "{{count}} esami",
      "explore": "Esplora",
      "freeAssessmentNote": "Valutazione gratuita completata • Aggiorna per accedere a tutti gli eroi",
      "greenFlags": "Bandierine verdi",
      "growthSubtitle": "Dove il tuo slancio può accelerare",
      "growthTitle": "Le tue aree di crescita",
      "historyTitle": "Storia CheckUp",
      "journeys": "Viaggi",
      "meshDnaSubtitle": "Quattro pilastri che definiscono la tua prontezza internazionale",
      "meshDnaTitle": "Il tuo DNA MESH",
      "meshE": "Inglese & comunicazione",
      "meshELbl": "Inglese",
      "meshH": "Competenze tecniche & altro",
      "meshHLbl": "Competenze tecniche",
      "meshM": "Motivazione",
      "meshMLbl": "Motivazione",
      "meshS": "Competenze culturali soft",
      "meshSLbl": "Culturale",
      "moreCheckupsNeeded": "Completa più CheckUps per vedere la tua evoluzione nel tempo",
      "navActivate": "Attiva il viaggio",
      "navGrowth": "Le tue aree di crescita",
      "navHistory": "Storia CheckUp",
      "navMeshDna": "DNA MESH",
      "navPillars": "Risultati della valutazione",
      "navPrescription": "Prescrizione di 90 giorni",
      "navStrengths": "I tuoi punti di forza",
      "nextSection": "Prossimo: {{label}}",
      "notScored": "Non valutato",
      "overallScore": "Punteggio di prontezza complessivo",
      "pillarOverview": "Panoramica dei pilastri",
      "pillarPerformance": "Le tue prestazioni in tutte le dimensioni di valutazione",
      "pillarTapHint": "Tocca un pilastro per vedere cosa misura",
      "pillarSubtitle": "Come un rapporto di laboratorio medico, ogni pilastro misura una dimensione specifica della tua preparazione internazionale — quanto sei pronto per il tuo viaggio in un altro paese. Ogni dimensione è valutata da 0 a 100: più alto è il punteggio, più forte è quell'area.",
      "pillarTitle": "I tuoi risultati della valutazione",
      "positiveIndicators": "Indicatori positivi",
      "prescriptionSubtitle": "Un piano strutturato per convertire il potenziale in prestazioni",
      "prescriptionTitle": "La tua prescrizione di 90 giorni",
      "progressOverTime": "Il tuo progresso nel tempo",
      "qultureupDesc": "Migliora la tua prontezza culturale con un training personalizzato",
      "scaleCaption": "La tua posizione sulla scala",
      "scaleToNext": "{{points}} pts a {{tier}}",
      "scaleMax": "Hai raggiunto il livello massimo",
      "readingResults": "Leggere i tuoi risultati",
      "recommendedNextSteps": "Passi successivi raccomandati",
      "scoreOutOf": "/ 100",
      "scrollBackTop": "Scorri verso l'alto",
      "scrollToNext": "Scorri verso la sezione successiva",
      "strengthsSubtitle": "Cosa rende il tuo profilo unico",
      "strengthsTitle": "I tuoi punti di forza",
      "teleportalDesc": "Inizia il tuo piano di mobilità con verifica dei documenti e guida per il visto",
      "title": "Risultati CheckUp",
      "topHardSkills": "Top competenze tecniche",
      "topSoftSkills": "Top competenze trasversali",
      "unlockJourney": "Sblocca il tuo viaggio completo",
      "snapshotFallback": "La tua valutazione iQulture è completa.",
      "badgeReasonFallback": "Basato sulla tua performance complessiva di valutazione.",
      "provisional": {
        "label": "Provvisorio",
        "body": "Mancano alcuni tuoi dati, quindi questo è il punteggio minimo possibile. Con i dati completi potrebbe arrivare fino a {{max}}.",
        "unlock": {
          "M": "Completa le risposte sulla Motivazione o registra il tuo pitch — fino a +{{gain}}",
          "E": "Aggiungi i tuoi livelli di lingua, compresa la lingua madre — fino a +{{gain}}",
          "S": "Completa il CheckUp per misurare le tue soft skill — fino a +{{gain}}",
          "H": "Aggiungi competenze ed esperienza al tuo profilo — fino a +{{gain}}"
        }
      },
      "skillsNotEnoughEvidence": "Non ci sono ancora informazioni sufficienti per misurare queste competenze."
    },
    "resultsError": "Impossibile recuperare i risultati. Riprova.",
    "retakeAssessment": "Ripeti la valutazione",
    "retakeOnWeb": "Ritenta la valutazione sul web",
    "retakeOnWebDesc": "Per ripetere la tua valutazione CheckUp, utilizza il portale web Citizen su un browser desktop.",
    "score": "Punteggio",
    "scoreEvolution": "Evoluzione del punteggio",
    "scrollForDetails": "Scorri per dettagli",
    "scrollForDetailsHint": "Tocca per scorrere ai tuoi risultati dettagliati",
    "selected": "Selezionato",
    "selectedCheckupDetails": "Dettagli CheckUp selezionati",
    "shareResults": "Condividi risultati",
    "similarProfiles": "Profili Simili",
    "somethingWentWrong": "Qualcosa è andato storto",
    "startFailed": "Impossibile avviare CheckUp. Per favore riprova.",
    "startOnWeb": "Inizia su Citizen Web",
    "startOnWebDesc": "Completa la tua prima valutazione CheckUp sul portale web Citizen per un'esperienza completa.",
    "step": {
      "assistantChat": "Chat con assistente",
      "assistantChatMsg": "Chatta con il nostro assistente AI per darci più contesto sulla tua situazione.",
      "chatDone": "Chat completata",
      "chatDoneDesc": "Hai terminato la chat con l'assistente.",
      "journeyInstance": "Impostazione del viaggio",
      "journeyInstanceMsg": "Dicci dove ti stai trasferendo e da dove.",
      "languageTests": "Test di lingua",
      "languageTestsDesc": "Aggiungi risultati di competenza linguistica.",
      "languageTestsMsg": "Carica i tuoi certificati di lingua per rafforzare il tuo punteggio di prontezza.",
      "motivational": "Motivazione",
      "motivationalMsg": "Aiutaci a capire cosa ti spinge a trasferirti.",
      "onboarding": "Informazioni di base sul profilo",
      "onboardingMsg": "Dettagli rapidi su di te per personalizzare il resto.",
      "pitch": "Video di presentazione",
      "pitchMsg": "Registra un video di 30 secondi per presentarti.",
      "pitchRecorded": "Pitch registrato",
      "pitchRecordedDesc": "Il tuo video di pitch è pronto per la revisione.",
      "videos": "Guarda i video",
      "videosMsg": "Guarda alcuni brevi video sulla tua destinazione.",
      "profileComplete": "Completa il tuo profilo",
      "profileCompleteMsg": "Il tuo punteggio richiede alcuni dati identificativi.",
      "profileCompletePercentMsg": "Il tuo profilo è completo al {{percent}}%. Il punteggio lo richiede tutto."
    },
    "stuckMessage": "Bloccato? Facci sapere — possiamo aiutarti.",
    "suggestedNextSteps": "Passaggi successivi suggeriti",
    "tabAnalysis": "Analisi",
    "tabComparisons": "Confronti",
    "tabConclusion": "Conclusione 360°",
    "tabHistory": "Storia",
    "tabInsights": "Approfondimenti",
    "tabMESH": "Analisi MESH",
    "tabNextSteps": "Passaggi successivi",
    "tabOverview": "Panoramica",
    "tabPillars": "Piloni di valutazione",
    "tabSkills": "Termometro delle competenze",
    "tapToCollapse": "Tocca per ridurre",
    "tapToReadMore": "Tocca per leggere il riepilogo completo",
    "tip": {
      "1": "Il tuo punteggio MESH misura Motivazione, Inglese, Competenze trasversali e Competenze tecniche — i 4 pilastri della prontezza alla carriera internazionale.",
      "2": "I badge iQulture (Esploratore, Stella nascente, Professionista globale) riflettono la tua preparazione complessiva per lavorare all'estero.",
      "3": "La nostra IA analizza il tuo video di pitch, la tua competenza linguistica e le tue risposte motivazionali per costruire un profilo a 360°.",
      "4": "Il tuo piano d'azione personalizzato di 90 giorni includerà passaggi specifici per migliorare le tue aree più deboli.",
      "5": "La Valutazione del Rischio Culturale identifica le potenziali sfide di adattamento e come superarle."
    },
    "title": "iQulture CheckUp",
    "tonnieDatabaseAverage": "Media del database Tonnie",
    "top10Hard": "Top 10 competenze tecniche",
    "top10Soft": "Top 10 competenze trasversali",
    "topHardSkills": "Top competenze tecniche",
    "topSoftSkills": "Top competenze trasversali",
    "triggerFailed": "Impossibile avviare il calcolo. Riprova.",
    "tryAgain": "Riprova",
    "unableToLoad": "Impossibile caricare CheckUp",
    "unknownDate": "Data sconosciuta",
    "verifiedByTonnieGuard": "Verificato da Tonnie guard",
    "vsAverage": "vs media",
    "vsPrevious": "vs precedente",
    "welcome": {
      "chatStep": "Conversazione guidata",
      "chatStepDesc": "Rispondi a qualche domanda con il nostro assistente IA",
      "description": "Scopri la tua prontezza internazionale con la nostra valutazione MESH. Valuta la tua Motivazione, Inglese, Competenze Trasversali e Competenze Tecniche per generare il tuo punteggio iQulture personalizzato.",
      "languageStep": "Controllo della lingua",
      "languageStepDesc": "Valutazione rapida delle tue competenze linguistiche",
      "letsStart": "Iniziamo",
      "pitchStep": "Video di pitch breve",
      "pitchStepDesc": "Registra un breve video per presentarti",
      "timeEstimate": "Richiede circa 10-15 minuti per completare",
      "title": "Benvenuto in CheckUp"
    },
    "scoreOutOfSuffix": "/100",
    "missingSteps": {
      "journey_instance": {
        "label": "Istanza di viaggio",
        "message": "Devi creare un Viaggio prima di iniziare il tuo CheckUp."
      },
      "onboarding_complete": {
        "label": "Onboarding",
        "message": "Completa il tuo profilo di onboarding per sbloccare CheckUp."
      },
      "assistant_chat": {
        "label": "Assessment chat",
        "message": "Completa la conversazione di valutazione guidata."
      },
      "motivational_answers": {
        "label": "Domande motivazionali",
        "message": "Rispondi alle domande motivazionali sui tuoi obiettivi."
      },
      "pitch_video": {
        "label": "Video di presentazione",
        "message": "Registra o carica il tuo video di presentazione."
      },
      "generic": "Questo passaggio deve essere completato.",
      "videos_watched": {
        "label": "Guarda i video introduttivi",
        "message": "Una breve introduzione prima di iniziare."
      },
      "language_tests": {
        "label": "Test linguistici",
        "message": "Dicci quali lingue parli e a che livello."
      },
      "profile_complete": {
        "label": "Completa il tuo profilo",
        "message": "Il tuo punteggio richiede alcuni dati identificativi. Completali sul portale web."
      }
    },
    "reuse": {
      "title": "Riutilizzare il risultato salvato?",
      "subtitle": "Hai già completato questo test. Riutilizzalo per questa valutazione oppure svolgine uno nuovo.",
      "takenOn": "Svolto il {{date}}",
      "reuseCta": "Riutilizza questo risultato",
      "newCta": "Fanne uno nuovo",
      "daysLeft_one": "{{count}} giorno rimasto",
      "daysLeft_other": "{{count}} giorni rimasti"
    },
    "calculatingPct": "Calcolo… {{pct}}%",
    "requestedBy": {
      "badge": "Richiesto da {{company}}",
      "purpose": "Il tuo punteggio determina i consigli che ricevi e il supporto che possono offrirti.",
      "whatTheySee": "Vedono il tuo punteggio e la tua preparazione, mai le tue risposte."
    },
    "reusedFrom": {
      "title": "Riutilizzato dal tuo CheckUp per {{destination}}",
      "body": "Le tue risposte e i test ancora validi sono stati ripresi da quel CheckUp. Il tuo punteggio viene ricalcolato per questa destinazione."
    },
    "profileGate": {
      "progressLabel": "Profilo",
      "percent": "{{percent}}%",
      "cta": "Completa il profilo",
      "field": {
        "name": "Nome",
        "dateOfBirth": "Data di nascita",
        "nationality": "Cittadinanza",
        "currentCountry": "Paese attuale",
        "currentCity": "Città attuale",
        "phone": "Telefono"
      },
      "fieldMissing": "Mancante"
    },
    "readyToCalculate": {
      "title": "La tua valutazione è completa",
      "description": "Hai risposto a tutto. Il tuo punteggio non è ancora stato generato.",
      "ctaTitle": "Genera il tuo punteggio",
      "ctaDescription": "Un tocco. Richiede qualche minuto e ti inviamo una notifica quando il punteggio è pronto.",
      "cta": "Calcola il mio punteggio"
    },
    "awaitingProfile": {
      "assessmentDone": "Valutazione completata",
      "assessmentDoneDetail": "Tutti i passaggi sono fatti — le tue risposte sono salvate.",
      "calculateLocked": "Completa il tuo profilo per sbloccare il punteggio."
    }
  },
  "common": {
    "active": "Attivo",
    "appName": "Tonnie Citizen",
    "appShortName": "Citizen",
    "applicationError": "Errore di applicazione",
    "availableSoon": "Disponibile a breve",
    "back": "Indietro",
    "backToDashboard": "Torna alla dashboard",
    "cancel": "Annulla",
    "clear": "Cancella",
    "clearFilters": "Cancella filtri",
    "close": "Chiudi",
    "collapse": "Riduci",
    "comingSoon": "In arrivo",
    "completed": "Completato",
    "confirm": "Conferma",
    "continue": "Continua",
    "continueAssessment": "Continua valutazione",
    "continueSetup": "Continua configurazione",
    "copiedToClipboard": "{{label}} copiato negli appunti",
    "copilot": "CoPilot",
    "copyFailed": "Impossibile copiare {{label}}",
    "countries": {
      "AE": "Emirati Arabi Uniti",
      "AU": "Australia",
      "BR": "Brasile",
      "CA": "Canada",
      "CN": "Cina",
      "DE": "Germania",
      "ES": "Spagna",
      "FR": "Francia",
      "GB": "Regno Unito",
      "IE": "Irlanda",
      "IN": "India",
      "IT": "Italia",
      "JP": "Giappone",
      "KR": "Corea del Sud",
      "NL": "Paesi Bassi",
      "NZ": "Nuova Zelanda",
      "PT": "Portogallo",
      "SG": "Singapore",
      "UK": "Regno Unito",
      "US": "Stati Uniti",
      "AF": "Afghanistan",
      "AL": "Albania",
      "DZ": "Algeria",
      "AD": "Andorra",
      "AO": "Angola",
      "AG": "Antigua e Barbuda",
      "AR": "Argentina",
      "AM": "Armenia",
      "AT": "Austria",
      "AZ": "Azerbaigian",
      "BS": "Bahamas",
      "BH": "Bahrein",
      "BD": "Bangladesh",
      "BB": "Barbados",
      "BY": "Bielorussia",
      "BE": "Belgio",
      "BZ": "Belize",
      "BJ": "Benin",
      "BT": "Bhutan",
      "BO": "Bolivia",
      "BA": "Bosnia ed Erzegovina",
      "BW": "Botswana",
      "BN": "Brunei",
      "BG": "Bulgaria",
      "BF": "Burkina Faso",
      "BI": "Burundi",
      "CV": "Capo Verde",
      "KH": "Cambogia",
      "CM": "Camerun",
      "CF": "Repubblica Centrafricana",
      "TD": "Ciad",
      "CL": "Cile",
      "CO": "Colombia",
      "KM": "Comore",
      "CG": "Congo",
      "CD": "Congo (RDC)",
      "CR": "Costa Rica",
      "CI": "Costa d’Avorio",
      "HR": "Croazia",
      "CU": "Cuba",
      "CY": "Cipro",
      "CZ": "Cechia",
      "DK": "Danimarca",
      "DJ": "Gibuti",
      "DM": "Dominica",
      "DO": "Repubblica Dominicana",
      "EC": "Ecuador",
      "EG": "Egitto",
      "SV": "El Salvador",
      "GQ": "Guinea Equatoriale",
      "ER": "Eritrea",
      "EE": "Estonia",
      "SZ": "Eswatini",
      "ET": "Etiopia",
      "FJ": "Figi",
      "FI": "Finlandia",
      "GA": "Gabon",
      "GM": "Gambia",
      "GE": "Georgia",
      "GH": "Ghana",
      "GR": "Grecia",
      "GD": "Grenada",
      "GT": "Guatemala",
      "GN": "Guinea",
      "GW": "Guinea-Bissau",
      "GY": "Guyana",
      "HT": "Haiti",
      "HN": "Honduras",
      "HK": "Hong Kong",
      "HU": "Ungheria",
      "IS": "Islanda",
      "ID": "Indonesia",
      "IR": "Iran",
      "IQ": "Iraq",
      "IL": "Israele",
      "JM": "Giamaica",
      "JO": "Giordania",
      "KZ": "Kazakistan",
      "KE": "Kenya",
      "KI": "Kiribati",
      "KW": "Kuwait",
      "KG": "Kirghizistan",
      "LA": "Laos",
      "LV": "Lettonia",
      "LB": "Libano",
      "LS": "Lesotho",
      "LR": "Liberia",
      "LY": "Libia",
      "LI": "Liechtenstein",
      "LT": "Lituania",
      "LU": "Lussemburgo",
      "MO": "Macao",
      "MG": "Madagascar",
      "MW": "Malawi",
      "MY": "Malaysia",
      "MV": "Maldive",
      "ML": "Mali",
      "MT": "Malta",
      "MH": "Isole Marshall",
      "MR": "Mauritania",
      "MU": "Mauritius",
      "MX": "Messico",
      "FM": "Micronesia",
      "MD": "Moldavia",
      "MC": "Monaco",
      "MN": "Mongolia",
      "ME": "Montenegro",
      "MA": "Marocco",
      "MZ": "Mozambico",
      "MM": "Myanmar (Birmania)",
      "NA": "Namibia",
      "NR": "Nauru",
      "NP": "Nepal",
      "NI": "Nicaragua",
      "NE": "Niger",
      "NG": "Nigeria",
      "KP": "Corea del Nord",
      "MK": "Macedonia del Nord",
      "NO": "Norvegia",
      "OM": "Oman",
      "PK": "Pakistan",
      "PW": "Palau",
      "PS": "Palestina",
      "PA": "Panama",
      "PG": "Papua Nuova Guinea",
      "PY": "Paraguay",
      "PE": "Perù",
      "PH": "Filippine",
      "PL": "Polonia",
      "QA": "Qatar",
      "RO": "Romania",
      "RU": "Russia",
      "RW": "Ruanda",
      "KN": "Saint Kitts e Nevis",
      "LC": "Saint Lucia",
      "VC": "Saint Vincent e Grenadine",
      "WS": "Samoa",
      "SM": "San Marino",
      "ST": "São Tomé e Príncipe",
      "SA": "Arabia Saudita",
      "SN": "Senegal",
      "RS": "Serbia",
      "SC": "Seychelles",
      "SL": "Sierra Leone",
      "SK": "Slovacchia",
      "SI": "Slovenia",
      "SB": "Isole Salomone",
      "SO": "Somalia",
      "ZA": "Sudafrica",
      "SS": "Sud Sudan",
      "LK": "Sri Lanka",
      "SD": "Sudan",
      "SR": "Suriname",
      "SE": "Svezia",
      "CH": "Svizzera",
      "SY": "Siria",
      "TW": "Taiwan",
      "TJ": "Tagikistan",
      "TZ": "Tanzania",
      "TH": "Thailandia",
      "TL": "Timor Est",
      "TG": "Togo",
      "TO": "Tonga",
      "TT": "Trinidad e Tobago",
      "TN": "Tunisia",
      "TR": "Turchia",
      "TM": "Turkmenistan",
      "TV": "Tuvalu",
      "UG": "Uganda",
      "UA": "Ucraina",
      "UY": "Uruguay",
      "UZ": "Uzbekistan",
      "VU": "Vanuatu",
      "VA": "Città del Vaticano",
      "VE": "Venezuela",
      "VN": "Vietnam",
      "YE": "Yemen",
      "ZM": "Zambia",
      "ZW": "Zimbabwe"
    },
    "delete": "Elimina",
    "destination": "Destinazione",
    "discard": "Scarta",
    "discardChanges": "Scartare le modifiche?",
    "discardChangesBody": "Le tue modifiche non salvate andranno perse.",
    "discardProgress": "Scartare i progressi?",
    "discardProgressBody": "I tuoi progressi in questa schermata andranno persi.",
    "dismiss": "Ignora",
    "done": "Fatto",
    "download": "Scarica",
    "earned": "Guadagnato",
    "earnedDateMiles": "Guadagnato {{date}} • +{{miles}} Miles",
    "edit": "Modifica",
    "email": "Email",
    "error": "Errore",
    "errorTitle": "Errore",
    "estimatedTime": "Tempo stimato",
    "expand": "Espandi",
    "export": "Esporta",
    "familyWillLose": "I membri della tua famiglia perderanno",
    "filter": "Filtra",
    "free": "Gratuito",
    "goBack": "Torna indietro",
    "heroes": {
      "care": "Care",
      "checkup": "CheckUp",
      "qultureup": "QultureUp",
      "teleportal": "TelePortal"
    },
    "inProgress": "In corso",
    "info": "Info",
    "keepEditing": "Continua a modificare",
    "keepFamily": "Mantieni famiglia",
    "keepPro": "Mantieni Pro",
    "loading": "Caricamento...",
    "locked": "Bloccato",
    "logout": "Esci",
    "miles": "Miles",
    "minutes": "minuti",
    "more": "di più",
    "next": "Avanti",
    "no": "No",
    "notAvailable": "Non disponibile",
    "of": "di",
    "openInApp": "Apri nell'app",
    "optional": "Facoltativo",
    "origin": "Origine",
    "other": "Altro",
    "page": "Pagina",
    "pending": "In Attesa",
    "plan": {
      "basic": "Base",
      "pro": "Pro"
    },
    "pleaseRetryLater": "Per favore riprova più tardi.",
    "previous": "Precedente",
    "progress": "Progresso",
    "refresh": "Aggiorna",
    "remove": "Rimuovi",
    "reset": "Ripristina",
    "resumeWhereYouLeftOff": "Riprendi da dove hai lasciato",
    "retake": "Ritenta",
    "retry": "Riprova",
    "routeSrLabel": "{{origin}} a {{destination}}",
    "review": "Revisione",
    "save": "Salva",
    "selected": "Selezionato",
    "selectLanguage": "Seleziona lingua",
    "send": "Invia",
    "settings": "Impostazioni",
    "share": "Condividi",
    "skip": "Salta",
    "soon": "Presto",
    "submit": "Invia",
    "success": "Successo",
    "successTitle": "Successo",
    "time": {
      "daysAgo": "{{n}}d fa",
      "hoursAgo": "{{n}}h fa",
      "minutesAgo": "{{n}}m fa",
      "monthsAgo": "{{n}}mo fa",
      "now": "proprio adesso",
      "weeksAgo": "{{n}}w fa",
      "yesterday": "ieri"
    },
    "to": "A",
    "toast": {
      "documentUploaded": "Documento caricato",
      "moodFailed": "Impossibile salvare l'umore, riprova",
      "moodRecorded": "Umor registrato",
      "settingFailed": "Impossibile aggiornare l'impostazione",
      "settingSaved": "Impostazione salvata",
      "somethingWentWrong": "Qualcosa è andato storto, per favore riprova",
      "taskCompleted": "Compito completato",
      "taskFailed": "Impossibile aggiornare il compito",
      "taskReopened": "Compito riaperto"
    },
    "today": "Oggi",
    "tonnieChecked": "Tonnie-Controllato",
    "traveler": "Viaggiatore",
    "trust": {
      "howItHelps": "Come ti aiuta",
      "tapToSee": "Tocca per vedere come proteggiamo i tuoi dati",
      "whoCanSee": "Chi può vedere questo",
      "whyAsking": "Perché stiamo chiedendo",
      "yourDataProtected": "I tuoi Dati sono Protetti"
    },
    "tryAgain": "Riprova",
    "upload": "Carica",
    "uploading": "Caricamento…",
    "view": "Visualizza",
    "viewAll": "Visualizza tutto",
    "welcome": "Benvenuto",
    "working": "In lavorazione…",
    "yes": "Sì",
    "yesterday": "Ieri",
    "youWillLose": "Perderai l'accesso a",
    "beta": {
      "bannerMessage": "Accesso anticipato — aiuta a plasmare Tonnie 💜",
      "bannerMessageMobile": "Accesso anticipato — evolvi con Tonnie 💜",
      "bannerCta": "Fornisci feedback"
    },
    "openActionTitle": "Apri {{action}}",
    "copy": "Copia",
    "network": {
      "a11y": {
        "retry": "Riprova le richieste non riuscite",
        "dismiss": "Chiudi il banner di errore di rete",
        "showDetails": "Mostra dettagli dell'errore",
        "hideDetails": "Nascondi dettagli dell'errore",
        "copy": "Copia i dettagli dell'errore negli appunti"
      },
      "hideDetails": "Nascondi dettagli",
      "detailsCount": "Dettagli · {{count}}",
      "noDetails": "Nessun dettaglio catturato ancora.",
      "copy": {
        "unstable": {
          "title": "La connessione è instabile",
          "subtitle": "Abbiamo messo in pausa i tentativi automatici per risparmiare batteria. Tocca Riprova per riprovare.{{countHint}}"
        },
        "network": {
          "title": "Impossibile raggiungere il server",
          "subtitle": "Controlla la tua connessione internet.{{countHint}}"
        },
        "timeout": {
          "title": "Connessione lenta",
          "subtitle": "Le richieste stanno impiegando più tempo del solito.{{countHint}}"
        },
        "server": {
          "title": "Qualcosa è andato storto",
          "subtitle": "Il nostro team è stato avvisato. Riprova tra un momento.{{countHint}}"
        },
        "default": {
          "title": "Problema di connessione",
          "subtitle": "Stiamo avendo problemi a caricare i tuoi dati.{{countHint}}"
        },
        "countHint_one": " ({{count}} richiesta non riuscita)",
        "countHint_other": " ({{count}} richieste non riuscite)"
      }
    },
    "apiError": {
      "network": "Non possiamo raggiungere il server. Controlla la tua connessione.",
      "timeout": "La richiesta ha impiegato troppo tempo. Riproveremo automaticamente.",
      "unauthorized": "La tua sessione è scaduta. Per favore, accedi di nuovo.",
      "forbidden": "Non hai il permesso per farlo.",
      "notFound": "Risorsa non trovata.",
      "badRequest": "Qualcosa nella richiesta non era valido.",
      "serverError": "Qualcosa è andato storto dalla nostra parte. Ci stiamo lavorando.",
      "unknown": "Qualcosa è andato storto."
    },
    "relativeTime": {
      "justNow": "Appena adesso",
      "minutesAgo_one": "{{count}} minuto fa",
      "minutesAgo_other": "{{count}} minuti fa",
      "hoursAgo_one": "{{count}} ora fa",
      "hoursAgo_other": "{{count}} ore fa",
      "daysAgo_one": "{{count}} giorno fa",
      "daysAgo_other": "{{count}} giorni fa"
    },
    "device": {
      "unknown": "Dispositivo sconosciuto",
      "mobile": "Mobile",
      "desktop": "Desktop"
    },
    "browser": {
      "unknown": "Browser sconosciuto"
    },
    "location": {
      "unknown": "Posizione sconosciuta"
    },
    "searchCountry": "Cerca paese...",
    "noCountryFound": "Nessun paese trovato.",
    "phoneCode": "Codice",
    "searchPhoneCode": "Cerca codice telefonico...",
    "noPhoneCodeFound": "Nessun codice telefonico trovato.",
    "untitled": "Senza titolo",
    "unassigned": "Non assegnato",
    "unknown": "Sconosciuto",
    "member": "Membro",
    "phoneCountryCodeLabel": "Prefisso internazionale",
    "pageOf": "Pagina {{page}} di {{total}}",
    "pagination": "Pagine",
    "daysAgo_one": "{{count}} giorno fa",
    "daysAgo_other": "{{count}} giorni fa",
    "rewardMiles_one": "Ricompensa: {{count}} Mile",
    "rewardMiles_other": "Ricompensa: {{count}} Miles",
    "removeItem": "Rimuovi {{name}}",
    "milesGained_one": "+{{miles}} Mile",
    "milesGained_other": "+{{miles}} Miles",
    "aiBadge": "IA",
    "list": {
      "two": "{{first}} e {{second}}"
    }
  },
  "copilot": {
    "beta": {
      "badge": "Beta",
      "tooltipTitle": "Tonnie CoPilot è in beta",
      "tooltipBody": "Stiamo migliorando attivamente — valuta le risposte con 👍 o 👎 per aiutarci a migliorarle.",
      "ariaLabel": "Informazioni sulla beta di Tonnie CoPilot"
    },
    "action": {
      "dismiss": "Ignora",
      "goTo": "Vai a",
      "open": "Apri"
    },
    "aiDisclaimer": "CoPilot utilizza l'IA. Le risposte potrebbero non essere sempre accurate.",
    "answered": "Risposto",
    "answersSubmitted": "Le tue risposte sono state inviate",
    "askAnything": "Chiedi qualsiasi cosa...",
    "billingPage": "Pagina di fatturazione",
    "brainAssessment": {
      "errorTitle": "Impossibile caricare le domande",
      "evaluating": {
        "subtitle": "La nostra AI sta controllando la tua risposta",
        "title": "Valutando la tua risposta…"
      },
      "feedback": {
        "correct": "Corretto!",
        "incorrectEncouragement": "Prenditi un momento — vedrai di nuovo questo concetto.",
        "incorrectHeadline": "Quasi — ecco la risposta",
        "movingOn": "Passando alla prossima domanda…",
        "next": "Prossima domanda",
        "theAnswerIs": "La risposta è"
      },
      "level": {
        "advanced": {
          "label": "Avanzato",
          "desc_one": "Eccellente! {{count}} missione è contrassegnata come facoltativa.",
          "desc_other": "Eccellente! {{count}} missioni sono contrassegnate come facoltative."
        },
        "beginner": {
          "desc": "Stai iniziando il tuo viaggio! Tutte le lezioni sono sbloccate e pronte per te.",
          "label": "Principiante"
        },
        "intermediate": {
          "label": "Intermedio",
          "desc_one": "Ottima conoscenza! {{count}} missione per principianti è contrassegnata come facoltativa.",
          "desc_other": "Ottima conoscenza! {{count}} missioni per principianti sono contrassegnate come facoltative."
        }
      },
      "loading": "Caricamento domande di valutazione…",
      "noQuestions": "Nessuna domanda disponibile per questo mondo.",
      "question": {
        "next": "Prossima domanda",
        "openAnswerHint": "La tua risposta sarà valutata dall'AI. Prenditi il tuo tempo!",
        "openAnswerCounter": "{{count}} / {{max}} caratteri",
        "openAnswerMinHint": "Minimo {{min}} caratteri ({{remaining}} rimanenti)",
        "openAnswerPlaceholder": "Scrivi la tua risposta qui…",
        "submitFinal": "Invia e vedi i risultati"
      },
      "results": {
        "continue": "Continua",
        "correct": "Corretto",
        "questionDetails": "Dettagli della domanda",
        "retake": "Ritenta",
        "score": "Punteggio",
        "total": "Totale",
        "yourAnswer": "La tua risposta",
        "skipNote_one": "{{count}} missione sarà contrassegnata come facoltativa per il tuo livello. Puoi comunque completarla per guadagnare Miles.",
        "skipNote_other": "{{count}} missioni saranno contrassegnate come facoltative per il tuo livello. Puoi comunque completarle per guadagnare Miles."
      }
    },
    "brainSubtitle": "Powered by Tonnie Brain",
    "bringFamily": "Stai portando la tua famiglia?",
    "bringingFamilyNoProgram": "Portare la famiglia (nessun programma)",
    "cameraError": "Errore della fotocamera",
    "cameraErrorTitle": "Fotocamera non disponibile",
    "cameraPermissionDenied": "Permesso della fotocamera negato. Consenti l'accesso alla fotocamera nel tuo browser per registrare un video.",
    "chatLog": "Messaggi della chat",
    "playVideo": "Riproduci video",
    "clickToPlay": "Clicca per avviare il video",
    "close": "Chiudi CoPilot",
    "confidence": "Fiducia",
    "contextualGreeting": "Ciao! Sono Tonnie CoPilot, il tuo assistente AI contestuale. {{context}}Cosa vorresti sapere?",
    "couldImprove": "Potrebbe migliorare",
    "createMyJourney": "Crea il mio viaggio",
    "dailyQuotaReached": "Quota giornaliera raggiunta",
    "destination": "Dove stai andando?",
    "disclaimer": "Le tue risposte sono private e utilizzate solo per personalizzare il tuo viaggio.",
    "errorLoadingQuestions": "Errore nel caricamento delle domande",
    "errorTitle": "Qualcosa è andato storto",
    "familyAddon": "Add-on Famiglia incluso",
    "familyComingSoonNote": "Il Programma Famiglia sarà disponibile presto. Per ora, il tuo viaggio è configurato per uso individuale.",
    "familyConfig": "Configurazione familiare",
    "familyFeature1": "Invita membri della famiglia (Compagno e Membri della Famiglia)",
    "familyFeature2": "Controlla i permessi di accesso per ogni eroe",
    "familyFeature3": "Monitora i progressi consapevoli della famiglia",
    "familyFeature4": "Gestisci il viaggio della famiglia insieme",
    "familyJoinQuestion": "I membri della famiglia ti accompagneranno in questo viaggio?",
    "familyJoining": "I membri della famiglia parteciperanno al tuo viaggio",
    "familyProgramAddon": "Add-on programma famiglia",
    "familyProgramDesc": "Gestisci il viaggio della tua famiglia insieme con accesso condiviso e monitoraggio dei progressi",
    "familyProgramEnabled": "Programma famiglia abilitato",
    "findings": {
      "emptyProfile": "Il tuo profilo non ha ancora risultati.",
      "expand": "Espandi",
      "looksGood": "Sembra buono",
      "profile": "Profilo",
      "profileIntro": "Ecco cosa abbiamo raccolto sul tuo profilo dalle tue risposte.",
      "profileTitle": "Risultati del profilo"
    },
    "fixErrors": "Correggi errori",
    "formSubmittedNote": "Il tuo modulo è stato inviato. Grazie!",
    "goBack": "Torna indietro",
    "greeting": "Ciao! Sono Tonnie CoPilot, il tuo assistente AI. {{context}}Cosa vorresti sapere?",
    "guide": {
      "newMessages": "Nuovi messaggi",
      "typeHere": "Scrivi qui...",
      "avatarAlt": "CoPilot assistente AI",
      "aria": {
        "stepOf": "Passo {{step}} di {{total}}"
      },
      "taskFallback": "Valutazione"
    },
    "guideCompleted": "Guida completata",
    "guideCompletedDesc": "Hai completato questa guida.",
    "guideTitle": "Guida Tonnie CoPilot",
    "household": {
      "addChild": "Aggiungi bambino",
      "addPet": "Aggiungi animale domestico",
      "cat": "Gatto",
      "child": "Bambino",
      "childN": "Bambino {{n}}",
      "children": "Bambini",
      "childrenDetails": "Parlaci di ogni bambino che si trasferisce con te.",
      "description": "Dicci chi si trasferisce con te in modo da poter personalizzare il tuo viaggio.",
      "dog": "Cane",
      "hasPassport": "Ha passaporto",
      "name": "Nome",
      "namePlaceholder": "Nome completo",
      "nationality": "Nazionalità",
      "other": "Altro",
      "partner": "Partner",
      "partnerDetails": "Parlaci del tuo partner.",
      "pet": "Animale domestico",
      "petN": "Animale domestico {{n}}",
      "petName": "Nome dell'animale domestico",
      "petNamePlaceholder": "Qual è il nome del tuo animale domestico?",
      "petVaccination": "Vaccinazioni aggiornate",
      "pets": "Animali domestici",
      "petsDetails": "Parlaci di ogni animale domestico che si trasferisce con te.",
      "relocating": "Si trasferisce con me",
      "selectCountry": "Seleziona paese",
      "species": "Specie",
      "title": "La tua famiglia",
      "vaccinationOk": "Vaccinazioni OK",
      "prefilledFromOnboarding": "Precompilato con le risposte date durante l'iscrizione. Controlla e modifica ciò che è diverso: nulla viene salvato finché non confermi.",
      "you": "Tu"
    },
    "hybrid": {
      "complete": "Tutto fatto! Le tue risposte sono state registrate.",
      "error": "Qualcosa è andato storto. Proviamo di nuovo.",
      "escapeHatch": "Preferirei non rispondere a questo",
      "placeholder": "Scrivi la tua risposta...",
      "progress": "Progresso",
      "selectOption": "Seleziona un'opzione",
      "stepOf": "Passo {{current}} di {{total}}",
      "title": "Intervista guidata",
      "typeAnswer": "Scrivi la tua risposta",
      "openingFallback": "Iniziamo."
    },
    "includedFeatures": "Funzionalità incluse",
    "individualJourney": "Percorso individuale",
    "inputPlaceholder": "Chiedi a Tonnie qualsiasi cosa...",
    "journeyPurpose": "Scopo del viaggio",
    "journeyPurposes": "Scopi del viaggio",
    "journeyReady": "Il tuo viaggio è pronto per essere sbloccato!",
    "journeyRoute": "Percorso del viaggio",
    "journeyRouteDesc": "Seleziona i tuoi paesi di origine e destinazione",
    "journeySummary": "Riepilogo del tuo viaggio",
    "justMe": "Solo io",
    "lifecycle": {
      "acknowledge": {
        "default": "Capisco che questa azione non può essere annullata."
      },
      "autosave": {
        "justNow": "proprio adesso",
        "offline": "Offline — riproverà",
        "saved": "Salvato · {{relative}}",
        "saving": "Salvataggio…",
        "unsaved": "Salvataggio in attesa"
      },
      "completion": {
        "errorBody": "Qualcosa è andato storto durante il salvataggio delle tue risposte. Puoi riprovare — il tuo lavoro è ancora qui.",
        "errorRetry": "Riprova",
        "errorTitle": "Impossibile salvare i tuoi risultati",
        "saving": "Salvataggio dei tuoi risultati…",
        "successBody": "Le tue risposte sono salvate. Ti porterò al tuo dashboard.",
        "successContinue": "Continua",
        "successRedirect": "Reindirizzamento in {{seconds}}…",
        "successStay": "Rimani qui",
        "successTitle": "Tutto fatto!"
      },
      "confirm": {
        "stepLabel": "Passo {{currentStep}} di {{totalSteps}} · {{progress}}%"
      },
      "discard": {
        "body": "Sei al {{progress}}%. Se annulli ora, il tuo lavoro in questo tentativo verrà eliminato.",
        "bodyNoProgress": "Se annulli ora, il tuo lavoro in questo tentativo verrà eliminato.",
        "bodyTeleportalSetup": "I tuoi compiti TelePortal esistenti rimangono come sono. Le tue risposte bozza di questa sessione non verranno salvate.",
        "cancel": "Rimani",
        "confirm": "Sì, scarta",
        "confirmSkip": "Sì, salta",
        "keep": {
          "history": "Qualsiasi risultato completato in precedenza",
          "teleportalTasks": "I tuoi compiti TelePortal esistenti"
        },
        "lose": {
          "answers": "Le tue risposte attuali ({{progress}}%)",
          "position": "Il tuo posto al passo {{currentStep}}",
          "teleportalDraft": "Le risposte bozza di questa sessione",
          "teleportalPosition": "Perderai i tuoi progressi TelePortal in questo viaggio"
        },
        "title": "Scartare il tuo progresso {{hero}}?",
        "titleTeleportalSetup": "Saltare la configurazione per ora?",
        "confirmTeleportalSetup": "Sì, scarta questo tentativo"
      },
      "hero": {
        "care_assessment": "valutazione Care",
        "checkup": "CheckUp",
        "journey_builder": "viaggio",
        "qultureup": "test di livello QultureUp",
        "teleportal_setup": "Configurazione TelePortal"
      },
      "keep": {
        "empty": "Niente viene trasferito.",
        "title": "Mantenendo"
      },
      "leave": {
        "body": "Il tuo progresso attraverso il passo {{currentStep}} è già salvato. Puoi riprendere in qualsiasi momento.",
        "bodyNoProgress": "Il tuo progresso è salvato. Puoi riprendere in qualsiasi momento.",
        "cancel": "Rimani",
        "confirm": "Sì, allontanati",
        "keep": {
          "answers": "Ogni risposta che hai completato",
          "progress": "Il tuo progresso finora ({{progress}}%)"
        },
        "title": "Allontanati per ora?"
      },
      "lose": {
        "empty": "Niente viene eliminato.",
        "title": "Perdita"
      },
      "restart": {
        "body": "Le tue risposte attuali verranno cancellate. Inizierai da capo dal passo 1.",
        "bodyJourneyBuilder": "Inizierai di nuovo il costruttore di viaggi. Le tue risposte in corso verranno cancellate.",
        "bodyTeleportalSetup": "Le tue risposte precedenti verranno precompilate. La conversazione ricomincia dall'inizio e la tua lista di compiti si ricostruisce.",
        "cancel": "Rimani",
        "confirm": "Sì, riavvia",
        "keep": {
          "history": "Il tuo risultato precedente (se presente)"
        },
        "lose": {
          "answers": "Le tue risposte attuali ({{progress}}%)",
          "builderAnswers": "Le tue risposte in corso del costruttore",
          "position": "Il tuo posto al passo {{currentStep}}"
        },
        "title": "Riavviare dal passo 1?",
        "titleJourneyBuilder": "Riavviare il costruttore di viaggi?",
        "titleTeleportalSetup": "Ripristinare la tua impostazione TelePortal?"
      },
      "resume": {
        "btnContinue": "Continua dal passo {{currentStep}}",
        "btnContinueShort": "Continua da dove hai lasciato",
        "btnDiscard": "Scarta questo tentativo",
        "btnDiscardSubtitle": "Le tue risposte verranno eliminate",
        "btnNavigateLastResultCare": "Visualizza il mio dashboard Care",
        "btnNavigateLastResultCheckup": "Visualizza il mio ultimo risultato",
        "btnNavigateLastResultQultureup": "Vai alla homepage QultureUp",
        "btnRestart": "Ricomincia",
        "btnSkip": "Salta per ora",
        "subtitleLastActive": "Ultima attività {{relativeTime}}",
        "subtitleProgress": "Passo {{currentStep}} di {{totalSteps}} · {{progress}}% completato",
        "subtitleProgressShort": "{{progress}}% completato",
        "title": "Bentornato al tuo {{hero}}",
        "welcomeBack": "Bentornato — i tuoi progressi sono salvati"
      },
      "retake": {
        "body": "Il tuo risultato precedente passa alla storia e un nuovo tentativo inizia ora.",
        "bodyCare": "La tua valutazione Care precedente è archiviata. La conversazione inizia fresca dal passo 1.",
        "bodyCheckup": "Il tuo risultato CheckUp precedente è archiviato. La conversazione inizia fresca dal passo 1.",
        "bodyQultureup": "Solo il test di livello iniziale viene ripetuto — le tue missioni e i tuoi successi rimangono intatti.",
        "bodyTeleportalSetup": "La tua configurazione precedente è archiviata. La conversazione ricomincia — i tuoi compiti esistenti rimangono fino a quando non completi la nuova configurazione.",
        "cancel": "Rimani",
        "confirm": "Sì, ripeti",
        "keep": {
          "archived": "Il tuo risultato precedente (conservato nella storia)",
          "miles": "Tutti i tuoi Miles guadagnati",
          "missions": "Il tuo progresso nelle missioni"
        },
        "lose": {
          "activeScore": "Il tuo punteggio attivo e il badge"
        },
        "reason": {
          "circumstances_changed": "La mia situazione è cambiata",
          "just_curious": "Solo curiosità / esplorazione",
          "made_a_mistake": "Ho commesso un errore",
          "other": "Altro",
          "placeholder": "— Seleziona un motivo (opzionale) —",
          "want_to_update": "Voglio aggiornare le mie risposte"
        },
        "reasonLabel": "Perché stai ripetendo? (opzionale)",
        "title": "Vuoi fare un nuovo tentativo?",
        "titleHero": "Ripetere il tuo {{hero}}?"
      },
      "reversible": {
        "no": "Non può essere annullato",
        "yes": "Puoi tornare a questo"
      },
      "stay": "Rimani",
      "toolbar": {
        "discard": "Scarta",
        "discardHint": "Annulla questo tentativo ed esci. Le tue risposte sono eliminate.",
        "restart": "Riavvia",
        "restartHint": "Elimina le tue risposte e ricomincia dal passo 1."
      },
      "topBar": {
        "exitLabel": "Lascia",
        "progressLabel": "{{progress}}% completato",
        "stepLabel": "Passo {{currentStep}} di {{totalSteps}}"
      },
      "aria": {
        "whatChanges": "Quali cambiamenti"
      }
    },
    "loadingQuestions": "Caricamento domande…",
    "maxChars": "Max {{max}} caratteri",
    "validation": {
      "required": "Questa domanda è obbligatoria.",
      "thin": "Una risposta breve va bene: qualche frase in più ci dà più materiale ({{words}} parole finora).",
      "tooLong": "Troppo lungo — per favore mantienilo sotto {{max}} caratteri.",
      "ok": "Sembra ottimo — chiaro e dettagliato."
    },
    "suggestedWords": "Punta a {{min}}+ parole",
    "typeAnswer": "Scrivi la tua risposta",
    "words_one": "{{count}} parola",
    "words_other": "{{count}} parole",
    "motivationalAssessment": "Valutazione della motivazione",
    "motivationalDesc": "Una breve riflessione per aiutarci a capire cosa ti spinge.",
    "needsFix": "Da sistemare",
    "nextVideo": "Prossimo video",
    "noCountriesFound": "Nessun paese trovato",
    "noQuestionsForPersona": "Non abbiamo ancora domande per questo profilo.",
    "noVideoData": "Nessun dato video",
    "noVideos": "Nessun video disponibile.",
    "notAnsweredYet": "Non ancora risposto",
    "optional": "Facoltativo",
    "origin": "Da dove vieni?",
    "pitch": {
      "fileTooLarge": "Questo file video è troppo grande per essere caricato. Scegli un file più piccolo o registra qui il tuo pitch.",
      "tooLong": "Questo video dura più di {{minutes}} minuti. Scegli un video più breve o registra qui il tuo pitch.",
      "uploadStalled": "Il caricamento si è interrotto perché la connessione ha smesso di inviare dati. Controlla la connessione e riprova.",
      "unreadable": "Non siamo riusciti a leggere questo video, quindi non è possibile verificarne la durata. Scegli un video MP4 o WebM riproducibile su questo dispositivo o registra qui il tuo pitch."
    },
    "pitchRecorder": "Registratore di pitch",
    "practiceNote": "Suggerimento: pratica una volta prima di registrare.",
    "previousVideo": "Video precedente",
    "progressComplete": "{{percent}}% completato",
    "questionN": "Domanda {{n}}",
    "questionNofM": "Domanda {{n}} di {{m}}",
    "questions": "Domande",
    "questionsLoadError": "Impossibile caricare le domande",
    "questionsUnavailable": "Domande non disponibili",
    "quota": {
      "exceeded": "Limite giornaliero raggiunto. Aggiorna il tuo piano per più messaggi.",
      "remaining": "Messaggi rimanenti",
      "upgrade": "Aggiorna per di più"
    },
    "quotaReached": "Quota raggiunta! Aggiorna a Pro per accesso illimitato.",
    "ready": "Pronto",
    "readyQ": "Pronto per iniziare?",
    "recordAnswer": "Registra risposta",
    "recordYourPitch": "Registra il tuo discorso",
    "required": "Richiesto",
    "responseCare": "Il tuo feedback Care mostra miglioramenti nelle Competenze di Comunicazione e Tecniche. Continua così! Per Comportamento e Adattamento, considera di unirti a comunità locali ed eventi di networking.",
    "responseCareer": "In base al tuo profilo, sei ben posizionato per opportunità in Portogallo. Le tue competenze tecniche sono forti e il tuo livello di inglese è eccellente. Ti suggerirei di concentrarti sulla pratica della lingua portoghese per aumentare il tuo tasso di corrispondenza.",
    "responseCheckup": "In base ai tuoi risultati CheckUp, vedo che stai andando bene! Il tuo punteggio di prontezza di 85 mostra una forte preparazione. Ti consiglio di concentrarti sull'adattamento culturale, che è a 75. Considera di completare lezioni QultureUp per migliorare quest'area.",
    "responseDefault": "Capisco la tua domanda. Lasciami aiutarti con questo.",
    "responseHelp": "Sono qui per aiutarti! Posso assisterti nella comprensione dei tuoi risultati CheckUp, nella navigazione delle attività TelePortal, nell'apprendimento della cultura in QultureUp, nel monitoraggio dei tuoi progressi in Care, e nella ricerca di opportunità di carriera. In quale area specifica vorresti aiuto?",
    "responseQultureup": "Ottimo che sei interessato a QultureUp! Ti consiglio di iniziare con il mondo 'Cultura Locale' per familiarizzare con le usanze e le tradizioni portoghesi. Questo ti aiuterà ad adattarti più rapidamente quando arriverai.",
    "responseScore": "Il tuo attuale punteggio di prontezza è 85/100, il che è eccellente! Sei nella categoria 'Quasi Pronto'. Le principali aree su cui concentrarsi sono Adattamento Culturale (75) e Esperienza Internazionale (70). Vuoi raccomandazioni specifiche?",
    "responseTeleportal": "Per il tuo viaggio TelePortal, vedo che sei nella fase di Preparazione del Visto. Assicurati di raccogliere tutti i documenti richiesti e di programmare il tuo colloquio. Vuoi che ti aiuti con un compito specifico?",
    "responseVisa": "Per il tuo trasferimento, ti consiglio di iniziare con la valutazione TelePortal per ottenere un elenco di controllo personalizzato. Assicurati di avere tutti i documenti richiesti pronti. Il processo di visto di solito richiede 2-3 mesi, quindi pianifica di conseguenza.",
    "restartFlow": "Riavvia",
    "reviewAnswers": "Rivedi risposte",
    "reviewDesc": "Prenditi un momento per rivedere le tue risposte prima di inviare.",
    "reviewJourney": "Rivedi la configurazione del tuo viaggio prima che la prepariamo per te",
    "reviewYourAnswers": "Rivedi le tue risposte",
    "safety": {
      "critical": "CoPilot non può fornire consigli su questo argomento. Ti preghiamo di consultare un professionista qualificato.",
      "elevated": "Questo argomento richiede una considerazione attenta. CoPilot fornisce solo indicazioni generali — consulta un professionista per consigli specifici.",
      "standard": "CoPilot utilizza l'IA. Le risposte potrebbero non essere sempre accurate. Verifica sempre le informazioni importanti.",
      "getHelp": "Ottieni aiuto",
      "rephrase": "Ho notato che il tuo messaggio contiene contenuti che non posso elaborare. Potresti riformularlo?"
    },
    "sameCountryWarning": "L'origine e la destinazione non possono essere lo stesso paese.",
    "saved": "Salvato",
    "saving": "Salvataggio…",
    "searchCountry": "Cerca paese...",
    "selectCountry": "Seleziona...",
    "selectedAsDest": "Selezionato come destinazione",
    "selectedAsOrigin": "Selezionato come origine",
    "send": "Invia",
    "situation": {
      "answered": "Risposto",
      "companyProvides": "La mia azienda fornisce questo",
      "companySponsored": "Sponsorizzato dall'azienda",
      "companySponsoredDesc": "Il mio datore di lavoro sta sponsorizzando il mio trasferimento.",
      "description": "Scegli l'opzione che descrive meglio la tua situazione.",
      "digitalNomad": "Nomade digitale",
      "digitalNomadDesc": "Lavorerò da remoto dal mio nuovo paese.",
      "employedSelf": "Sono impiegato e mi trasferisco da solo",
      "employedSponsored": "Sono impiegato e la mia azienda sponsorizza il trasferimento",
      "entrepreneur": "Imprenditore",
      "euCitizen": "Cittadino dell'UE",
      "euCitizenDesc": "Sono un cittadino dell'UE e non ho bisogno di un visto.",
      "familyReunion": "Ricongiungimento familiare",
      "familyReunionDesc": "Mi unisco a familiari già all'estero.",
      "haveHousing": "Ho già sistemazione",
      "haveVisa": "Ho già un visto",
      "haveVisaDesc": "Ho ottenuto il mio visto per questo trasferimento.",
      "housingTitle": "Situazione abitativa",
      "jobSeeking": "In cerca di lavoro",
      "legalTitle": "Situazione legale",
      "needFind": "Ho bisogno di trovare una sistemazione",
      "needTemp": "Ho bisogno di una sistemazione temporanea",
      "needVisa": "Ho bisogno di ottenere un visto",
      "needVisaDesc": "Non ho ancora fatto domanda per un visto.",
      "pathwayTitle": "Percorso per il visto",
      "pathwaysUnavailable": "Non siamo riusciti a caricare i percorsi per il visto. Puoi continuare senza sceglierne uno.",
      "credentialTitle": "Professione regolamentata",
      "credentialQuestion": "Lavori in una professione regolamentata (ad esempio medicina, infermieristica, ingegneria o giurisprudenza) nel paese in cui ti trasferisci? In tal caso, la tua qualifica deve esservi riconosciuta prima di poter esercitare.",
      "credentialYes": "Sì, la mia professione è regolamentata",
      "credentialNo": "No",
      "pathway": {
        "workPermit": "Permesso di lavoro (sponsorizzato)",
        "workPermitDesc": "Residenza sponsorizzata dal datore di lavoro",
        "techVisa": "Visto tech",
        "techVisaDesc": "Assunzione tech da azienda certificata",
        "d7": "D7 — Reddito passivo / remoto",
        "d7Desc": "Basato su reddito o lavoro remoto",
        "euFamily": "UE / ricongiungimento familiare",
        "euFamilyDesc": "Cittadino dell'UE o unendo la famiglia",
        "d1": "D1 — Visto di lavoro",
        "d1Desc": "Lavoro subordinato presso un datore di lavoro",
        "d2": "D2 — Imprenditore / lavoratore autonomo",
        "d2Desc": "Attività propria o lavoro autonomo",
        "d8": "D8 — Nomade digitale",
        "d8Desc": "Lavoro da remoto per datori di lavoro o clienti all'estero",
        "startup": "Visto per startup",
        "startupDesc": "Avvio di una startup innovativa",
        "notSure": "Non sono ancora sicuro",
        "notSureDesc": "Tonnie aiuterà a determinarlo"
      },
      "professionalTitle": "Situazione professionale",
      "retired": "Pensionato",
      "selfEmployed": "Lavoratore autonomo",
      "student": "Studente",
      "studentVisa": "Visto per studenti",
      "studentVisaDesc": "Mi trasferisco con un visto per studenti.",
      "title": "La tua situazione"
    },
    "submitFailed": "Invio non riuscito",
    "subtitle": "Il tuo assistente AI è qui per aiutarti",
    "suggestedQuestions": "Domande suggerite:",
    "thinking": "Pensando...",
    "timeEstimate": "Circa {{value}} min",
    "title": "Tonnie CoPilot",
    "launcher": {
      "label": "Chiedi a Tonnie"
    },
    "toggle": "Attiva CoPilot",
    "trace": {
      "artifactUpdate": "Artifact aggiornato",
      "cancel": "Annulla",
      "completeness": "Completezza",
      "confirm": "Conferma",
      "error": "Errore",
      "retry": "Riprova",
      "widget": "Widget"
    },
    "tryAgain": "Riprova",
    "unavailable": "CoPilot non è temporaneamente disponibile. Riprova tra un momento.",
    "unlimited": "Piano Pro: Query illimitate",
    "unlimitedQuestions": "Domande illimitate",
    "unlockNote": "Il tuo percorso personalizzato è stato creato. Sbloccalo da",
    "upgrade": "Aggiorna",
    "upgradeToPro": "Aggiorna a Pro",
    "uploadNote": "Terremo il tuo video privato — solo tu e la nostra IA lo vedrete.",
    "uploadingVideo": "Caricamento video…",
    "verifiedByTonnieGuard": "Verificato da Tonnie guard",
    "videoCompleted": "Completato",
    "videoPlayerDesc": "Riproduttore video per {{title}}. Clicca play per iniziare il video.",
    "videoResume": "Riprendi",
    "videoSent": "Video inviato",
    "videoStateInProgress": "In corso",
    "videoStatePending": "Da guardare",
    "videoStateWatched": "Guardato",
    "videoSubmitted": "Video inviato",
    "videoToWatch": "Da guardare",
    "videoUploadFailed": "Caricamento video non riuscito",
    "videoWatchedLabel": "Guardato",
    "videosWatched": "video guardati",
    "voice": {
      "error": "Scusa, non ho capito. Riprova.",
      "status": {
        "listening": "Ti ascolto...",
        "transcribing": "Trascrizione…"
      },
      "a11y": {
        "pause": "Metti in pausa l'ascolto",
        "start": "Inizia l'input vocale"
      }
    },
    "whyWeAsk": "Perché chiediamo",
    "widgetError": "Questo widget non è riuscito a caricarsi.",
    "widgetNotFound": "Widget \"{{name}}\" non trovato",
    "yesBringingFamily": "Sì, porto la famiglia",
    "aria": {
      "conversation": "Conversazione",
      "messageInput": "Messaggio",
      "resultActions": "Azioni di risultato",
      "sendMessage": "Invia messaggio",
      "answerInput": "La tua risposta"
    },
    "tools": {
      "checkingCohorts": "Controllo dei tuoi programmi…",
      "checkingJourney": "Controllando il tuo viaggio…",
      "checkingTasks": "Controllando i tuoi compiti…",
      "checkingCheckup": "Controllando il tuo CheckUp…",
      "checkingCare": "Controllando il tuo benessere…",
      "checkingObjectives": "Controllando i tuoi obiettivi Care…",
      "checkingPassport": "Controllando il tuo Passport…",
      "checkingMiles": "Controllando i tuoi chilometri…",
      "checkingNotifications": "Controllando le tue notifiche…",
      "checkingHousehold": "Controllando il tuo nucleo familiare…",
      "checkingBilling": "Controllando la tua fatturazione…",
      "checkingCareer": "Controllando le opportunità di carriera…",
      "submittingCheckpoint": "Invio del tuo checkpoint…",
      "creatingSupport": "Invio di una richiesta di supporto…",
      "schedulingCheckpoints": "Pianificazione dei tuoi checkpoint…",
      "submittingSelfEval": "Invio della tua auto-valutazione…",
      "completingMission": "Completamento della tua missione…",
      "submittingQuiz": "Invio del tuo quiz…",
      "markingRead": "Aggiornamento delle tue notifiche…",
      "addingMember": "Aggiunta di un membro della famiglia…",
      "updatingMember": "Aggiornamento di un membro della famiglia…",
      "savingOpportunity": "Salvataggio dell'opportunità…",
      "expressingInterest": "Invio del tuo interesse…",
      "checkingDocuments": "Controllo dei tuoi documenti…",
      "checkingProfile": "Controllo del tuo profilo…",
      "checkingMesh": "Controllo del tuo MESH…",
      "checkingQultureup": "Controllo del tuo QultureUp…",
      "checkingWorlds": "Controllo dei tuoi mondi…",
      "savingToVault": "Salvataggio nel tuo Vault…",
      "attachingFile": "Allegando il file…",
      "updatingTask": "Aggiornamento del compito…",
      "startingMission": "Avvio della missione…",
      "checkingProgramSetup": "Controllo della configurazione del tuo programma…",
      "reopeningTask": "Riapertura del compito…",
      "completingTask": "Completamento del compito…",
      "submittingCheckin": "Registrazione del tuo check-in…",
      "startingRetake": "Avvio del tuo CheckUp…",
      "recallingMemories": "Controllo di ciò che ricordo…",
      "rememberingFact": "Prendere nota…",
      "forgettingFact": "Dimenticare quello…",
      "searchingKnowledge": "Controllo della base di conoscenza…",
      "readingNote": "Leggere su quello…",
      "listingPipelineTalents": "Controllo del tuo pipeline di talenti…",
      "checkingTalentOverview": "Controllo della panoramica dei talenti…",
      "checkingTalentReadiness": "Controllo della prontezza dei talenti…",
      "checkingTalentMobility": "Controllo dei progressi di relocation dei talenti…",
      "checkingTalentAdaptation": "Controllo dell'adattamento dei talenti…",
      "checkingTalentRisk": "Controllo del benessere e del rischio dei talenti…",
      "checkingTalentEvidence": "Controllo delle evidenze dei talenti…",
      "checkingCohort": "Controllo della coorte…",
      "checkingProgram": "Controllo del programma…",
      "checkingPipeline": "Controllo del tuo pipeline…",
      "checkingAffiliate": "Controllo del tuo account affiliato…",
      "checkingPoolCounts": "Conteggio del tuo talent pool…",
      "checkingPoolTalent": "Controllo del talento nel pool…",
      "searchingWeb": "Ricerca sul web…",
      "sponsoringTalent": "Preparazione della sponsorizzazione…",
      "addingTalentToCohort": "Aggiunta del talento alla coorte…",
      "addingTalentNote": "Aggiunta di una nota interna…",
      "savingVettingDocument": "Salvataggio del documento di verifica…",
      "checkingMyWorkQueue": "Controllo di cosa hai bisogno…",
      "messagingTalent": "Preparazione del tuo messaggio…",
      "requestingCheckin": "Preparazione di una richiesta di check-in…",
      "schedulingMeeting": "Preparazione dell'invito…",
      "checkingCompany": "Controllo del profilo della tua azienda…",
      "checkingPrograms": "Controllo dei tuoi programmi…",
      "checkingDashboard": "Controllo della tua dashboard…",
      "checkingActivity": "Controllo delle attività recenti…",
      "checkingAnalytics": "Controllo delle tue analisi…",
      "checkingVetting": "Controllo della tua panoramica di verifica…",
      "checkingMobility": "Controllo della tua panoramica di mobilità…",
      "checkingAdaptation": "Controllo della tua panoramica di adattamento…",
      "checkingEvidence": "Controllo della tua panoramica di evidenze…",
      "checkingCareConfig": "Controllo della configurazione del tuo Care…",
      "checkingInvoices": "Controllo delle tue fatture…",
      "checkingSponsorships": "Controllo delle tue sponsorizzazioni…",
      "checkingTeam": "Controllo del tuo team…",
      "checkingMessageTemplates": "Controllo dei tuoi modelli di messaggio…",
      "checkingMessageAnalytics": "Controllo delle tue analisi dei messaggi…",
      "checkingAuditLog": "Controllo del tuo registro audit…",
      "creatingProgram": "Preparazione del nuovo programma…",
      "creatingCohort": "Preparazione della nuova coorte…",
      "invitingTeamMember": "Preparazione dell'invito al team…",
      "removingTeamMember": "Preparazione per rimuovere il membro del team…",
      "resolvingInteraction": "Aggiornamento dell'interazione Care…",
      "reschedulingInteraction": "Ripianificazione dell'interazione Care…",
      "cancellingInteraction": "Cancellazione dell'interazione Care…",
      "commentingInteraction": "Aggiunta del tuo commento…",
      "working": "Elaborazione…"
    },
    "errors": {
      "quota_exceeded": "Hai raggiunto il limite giornaliero di messaggi. Si ripristina a mezzanotte.",
      "budget_degraded": "Sto funzionando in modalità limitata in questo momento — posso comunque aiutarti con risposte concrete.",
      "provider_unavailable": "Sto avendo difficoltà a raggiungere le mie piene capacità in questo momento. Per favore riprova tra un momento.",
      "capability_disabled": "Quella funzionalità è temporaneamente non disponibile.",
      "stale_proposal": "Quella è cambiata da quando l'ho suggerita — chiedimi di nuovo e darò un'occhiata fresca.",
      "aborted": "Fermato.",
      "internal": "Qualcosa è andato storto dalla mia parte. Per favore riprova.",
      "messageRequired": "Per favore digita prima un messaggio.",
      "uploadFailed": "Caricamento fallito. Riprova.",
      "ref": "Riferimento"
    },
    "source": {
      "from": "Da",
      "why": "Perché puoi fidarti di questo",
      "cases": "{{n}} relocation simili",
      "webSources": "Fonti"
    },
    "webSearch": {
      "toggle": "Cerca sul web",
      "toggleHint": "Lascia che Tonnie cerchi informazioni attuali sul web per questa domanda"
    },
    "feedback": {
      "helpful": "Utile",
      "notHelpful": "Non utile",
      "thanks": "Grazie per il feedback"
    },
    "toolResult": {
      "success": "Fatto",
      "failed": "Non ha funzionato"
    },
    "suggestions": {
      "complete_checkup": {
        "title": "Completa il tuo CheckUp",
        "description": "Fai la valutazione per ricevere consigli personalizzati"
      },
      "explore_qultureup": {
        "title": "Esplora QultureUp",
        "description": "Inizia a conoscere la cultura della tua destinazione"
      },
      "check_passport": {
        "title": "Controlla i tuoi progressi",
        "description": "Guarda quanta strada hai fatto nel tuo percorso"
      },
      "checkup_incomplete": {
        "title": "Vuoi completare il tuo CheckUp? Posso guidarti attraverso il processo."
      },
      "tasks_blocked": {
        "title_one": "Hai {{count}} attività bloccata — vuoi aiuto per sbloccarla?",
        "title_other": "Hai {{count}} attività bloccate — vuoi aiuto per sbloccarle?"
      },
      "care_pending": {
        "title_one": "Hai {{count}} check-in in attesa — lo facciamo?",
        "title_other": "Hai {{count}} check-in in attesa — li facciamo?"
      },
      "docs_expiring": {
        "title_one": "{{count}} documento sta per scadere — vuoi rivederlo?",
        "title_other": "{{count}} documenti stanno per scadere — vuoi rivederli?"
      },
      "checkup_result_published": {
        "title": "I tuoi risultati sono pronti — vuoi che ti guidi attraverso di essi?"
      },
      "vetting_backlog": {
        "title_one": "{{count}} talento è in attesa in Vetting — vuoi rivederlo?",
        "title_other": "{{count}} talenti sono in attesa in Vetting — vuoi rivederli?"
      },
      "care_overdue": {
        "title_one": "{{count}} checkpoint di Care è scaduto — vuoi vedere chi ha bisogno di attenzione?",
        "title_other": "{{count}} checkpoint di Care sono scaduti — vuoi vedere chi ha bisogno di attenzione?"
      }
    },
    "proposal": {
      "aria": "Conferma dell'azione",
      "confirm": "Conferma",
      "confirming": "Confermo…",
      "dismiss": "Non ora",
      "expired": "Questa offerta è scaduta — chiedimi di nuovo.",
      "stale": "Questo è cambiato da quando l'ho suggerito — chiedimi di nuovo.",
      "error": "Qualcosa è andato storto. Riprova.",
      "untrustedWarning": "Questo proviene da un file caricato — rivedilo prima di confermare.",
      "typeToConfirm": "Digita {{token}} per confermare",
      "confirmed": "✓ Fatto — ho completato questo per te.",
      "alreadyCheckedIn": "Hai già registrato un check-in oggi, quindi non è stato aggiunto nulla di nuovo.",
      "attachedCompletionPending": "✓ File allegato — ma il compito non è ancora completo; mancano ancora alcuni documenti richiesti."
    },
    "attachFile": "Allega un file",
    "proactive": {
      "dismiss": "Ignora"
    },
    "newConversation": "Nuova conversazione",
    "choices": {
      "label": "Opzioni suggerite",
      "other": "Altro…"
    },
    "removeAttachment": "Rimuovi file",
    "depth": {
      "label": "Lunghezza della risposta",
      "brief": "Breve",
      "balanced": "Bilanciato",
      "detailed": "Dettagliato",
      "briefHint": "Risposte brevi e dirette",
      "balancedHint": "Dettaglio bilanciato (predefinito)",
      "detailedHint": "Risposte approfondite e dettagliate"
    },
    "rewrite": {
      "shorter": "Più breve",
      "longer": "Più lungo",
      "shorterCommand": "Rendi la tua risposta precedente più breve e diretta, nella stessa lingua.",
      "longerCommand": "Espandi la tua risposta precedente con più dettagli e spiegazioni, nella stessa lingua."
    },
    "attach": {
      "takePhoto": "Fai una foto",
      "choosePhoto": "Scegli una foto",
      "recordVideo": "Registra un video",
      "chooseVideo": "Scegli un video",
      "videoTooLarge": "Quel video è troppo grande. Registra un clip più corto (fino a 25 MB) e riprova."
    },
    "permissions": {
      "cameraTitle": "Fotocamera non disponibile",
      "cameraDenied": "Consenti l'accesso alla fotocamera nelle impostazioni del tuo dispositivo in modo da poter mostrare a Tonnie una foto o un video.",
      "libraryTitle": "Libreria foto non disponibile",
      "libraryUnavailable": "Non siamo riusciti ad aprire la tua libreria fotografica. Riprova o consenti l'accesso nelle impostazioni del tuo dispositivo.",
      "microphoneDenied": "Consenti l'accesso al microfono nelle impostazioni del tuo dispositivo in modo da poter parlare con Tonnie invece di digitare."
    },
    "history": {
      "title": "Conversazioni",
      "back": "Torna alla chat",
      "newChat": "Nuova chat",
      "searchPlaceholder": "Cerca conversazioni",
      "empty": "Nessuna conversazione ancora",
      "emptySearch": "Nessuna corrispondenza",
      "untitled": "Senza titolo",
      "rename": "Rinomina",
      "delete": "Elimina",
      "actions": "Azioni di conversazione",
      "deleteTitle": "Eliminare la conversazione?",
      "deleteBody": "Questa conversazione verrà rimossa dalla tua cronologia. Non può essere annullata.",
      "cancel": "Annulla"
    },
    "familyFromProfile": "Dal tuo profilo: cambialo se ora è diverso.",
    "originShort": "Origine",
    "destinationShort": "Destinazione",
    "actionsAvailable_one": "{{count}} azione disponibile",
    "actionsAvailable_other": "{{count}} azioni disponibili",
    "questionsRemaining_one": "{{count}} domanda rimanente oggi",
    "questionsRemaining_other": "{{count}} domande rimanenti oggi"
  },
  "coupon": {
    "applied": "Coupon {{code}} applicato con successo!",
    "apply": "Applica",
    "enterCode": "Inserisci il codice coupon",
    "error": "Impossibile applicare il coupon. Riprova.",
    "invalid": "Codice coupon non valido"
  },
  "cvBuilder": {
    "addExperience": "Aggiungi esperienza",
    "addSkill": "Aggiungi competenze",
    "aiOptimize": "Ottimizza AI per il mercato portoghese",
    "clickEditToExpand": "Clicca Modifica per espandere questa sezione",
    "complete": "completo",
    "completeAllSections": "Completa tutte le sezioni per i migliori risultati",
    "copilotSuggestions": "Suggerimenti CoPilot",
    "cvCompleteness": "Completezza CV",
    "cvSections": "Sezioni CV",
    "deleteExperience": "Elimina esperienza",
    "description": "Crea un CV professionale su misura per il tuo mercato target",
    "editExperience": "Modifica esperienza",
    "editSection": "Modifica sezione",
    "education": "Istruzione",
    "exportDescription": "In produzione, questo genererebbe il tuo file CV.",
    "exportFileDesc": "CV_{{firstName}}_{{lastName}}.{{format}} sarà scaricato.",
    "exportPDF": "Esporta PDF",
    "exportSuccess": "{{format}} esportato con successo!",
    "exportWord": "Esporta word",
    "fullName": "Nome completo",
    "generatingExport": "Generando esportazione {{format}}...",
    "importLinkedIn": "Importa da LinkedIn PDF",
    "items": "elementi",
    "languages": "Lingue",
    "location": "Posizione",
    "mockEducation1": {
      "degree": "Laurea in informatica",
      "institution": "Università della tecnologia",
      "period": "2014–2018"
    },
    "mockExperience1": {
      "company": "Tech solutions inc.",
      "description": "Guidato lo sviluppo di applicazioni web scalabili. Collaborato con team internazionali.",
      "period": "2020 — Presente",
      "role": "Ingegnere software senior"
    },
    "mockExperience2": {
      "company": "StartupXYZ",
      "description": "Costruito e mantenuto applicazioni web utilizzando React e Node.js.",
      "period": "2018–2020",
      "role": "Sviluppatore full-stack"
    },
    "personalInfo": "Informazioni personali",
    "phone": "Telefono",
    "preview": "Anteprima",
    "professionalSummary": "Riepilogo professionale",
    "quickActions": "Azioni veloci",
    "removeSkill": "Rimuovi competenza",
    "skills": "Competenze",
    "suggestAddSkills": "Aggiungi altre competenze rilevanti per il tuo ruolo target (5 consigliate)",
    "suggestExpandSummary": "Espandi la tua sintesi professionale con risultati chiave",
    "template": "Modello",
    "templates": {
      "classic": "Classico",
      "creative": "Creativo",
      "minimal": "Minimale",
      "modern": "Moderno"
    },
    "title": "Costruttore CV",
    "translateToPortuguese": "Traduci in portoghese",
    "wizard": {
      "applyChanges": "Applica modifiche",
      "applying": "Applicando...",
      "backToEdit": "Torna a modifica",
      "characters": "caratteri",
      "clickNextToGenerate": "Clicca su Genera per creare il tuo CV personalizzato",
      "company": "Azienda",
      "companyPlaceholder": "es. TechCorp Solutions",
      "completeAllSteps": "Completa tutti i passaggi prima di salvare",
      "createFirstCV": "Crea il tuo primo CV per iniziare",
      "cvDeleted": "CV eliminato con successo!",
      "cvGeneratedDescription": "Il tuo CV è stato generato e salvato. Puoi ora rivedere e modificare ogni sezione, o esportarlo direttamente.",
      "cvGeneratedSuccess": "CV generato con successo!",
      "cvSaved": "CV salvato con successo!",
      "cvUpdated": "CV aggiornato con successo!",
      "defaultJobTitle": "questa posizione",
      "deleteConfirm": "Sei sicuro di voler eliminare questo CV?",
      "deleteConfirmTitle": "Elimina CV",
      "description": "Genera CV professionali adattati alle descrizioni di lavoro utilizzando i tuoi dati di Journey",
      "done": "Fatto",
      "dragDropFile": "Trascina e rilascia un file qui, o clicca per selezionare",
      "edit": "Modifica",
      "enterPrompt": "Inserisci le istruzioni di affinamento",
      "fileSelected": "File selezionato",
      "fileUploaded": "File caricato: {{fileName}}",
      "generateCV": "Genera CV",
      "generatedEducation": "{{degree}} da {{institution}} ({{period}})",
      "generatedExperience": "{{role}} presso {{company}} ({{period}})\n{{description}}",
      "generatedReadiness": "Punteggio di prontezza internazionale: {{iqulture}}/100\nanalisi di MESH: Motivazione {{motivation}}% • Inglese {{english}}% • Competenze trasversali {{softSkills}}% • Competenze tecniche {{hardSkills}}%",
      "generatedSummary": "Professionista esperto con un punteggio di prontezza internazionale di {{iqulture}}/100. {{name}} porta una forte esperienza tecnica e una comprovata adattabilità a contesti internazionali, rendendolo un candidato ideale per {{jobTitle}}.",
      "generating": "Generando...",
      "generatingCV": "Generando il tuo CV...",
      "generatingDescription": "L'AI sta analizzando il tuo profilo e i requisiti del lavoro",
      "invalidFileType": "Tipo di file non valido. Si prega di caricare file .txt, .doc, .docx o .pdf.",
      "jobDescription": "Descrizione del lavoro",
      "jobDescriptionPlaceholder": "Incolla qui la descrizione completa del lavoro...",
      "jobTitle": "Titolo del lavoro",
      "jobTitlePlaceholder": "es. Ingegnere Software Senior",
      "newCV": "Nuovo CV",
      "next": "Avanti",
      "noCVs": "Nessun CV ancora",
      "of": "di",
      "optional": "(Facoltativo)",
      "orCreateNew": "o crea uno nuovo",
      "orUploadFile": "O carica il file della descrizione del lavoro",
      "preview": "Anteprima",
      "previous": "Precedente",
      "promptPlaceholder": "Es. Aggiungi più dettagli sull'infrastruttura cloud, concentrati sui servizi AWS...",
      "readyToGenerate": "Pronto per generare",
      "refine": "Affina",
      "refineDescription": "Inserisci istruzioni per modificare questa sezione:",
      "refineSection": "Affina sezione",
      "refinedBasedOn": "Affinato in base a",
      "refinementSuccess": "Sezione affinata con successo!",
      "saveCV": "Salva CV",
      "savedCVs": "CV salvati",
      "sections": {
        "education": "Istruzione",
        "internationalReadiness": "Prontezza internazionale",
        "professionalSummary": "Riepilogo professionale",
        "skills": "Competenze",
        "workExperience": "Esperienza lavorativa"
      },
      "selectCVToPreview": "Seleziona un CV da visualizzare in anteprima",
      "step": "Passo",
      "step1": {
        "description": "Inserisci la descrizione del lavoro per la posizione a cui ti stai candidando. Questo ci aiuterà a personalizzare il tuo CV.",
        "title": "Descrizione del lavoro"
      },
      "step2": {
        "description": "L'AI analizzerà la descrizione del lavoro e genererà sezioni di CV personalizzate in base ai tuoi dati di Journey.",
        "title": "Generazione CV"
      },
      "step3": {
        "description": "Rivedi e affina ogni sezione. Usa i suggerimenti per personalizzare i contenuti per requisiti specifici.",
        "title": "Affinamento"
      },
      "step4": {
        "description": "Rivedi il tuo CV finale e salvalo o esportalo nel formato preferito.",
        "title": "Rivedi & esporta"
      },
      "steps": {
        "generation": "Generazione",
        "jobDescription": "Descrizione del lavoro",
        "refinement": "Affinamento",
        "review": "Revisione"
      },
      "subtitle": "Crea CV specifici per il lavoro adattati a ogni opportunità",
      "supportedFormats": "Supporta: .txt, .doc, .docx, .pdf",
      "title": "Guida alla generazione di CV",
      "unsavedChanges": "Hai modifiche non salvate. Sei sicuro di voler uscire?",
      "unsavedChangesTitle": "Modifiche non salvate"
    },
    "workExperience": "Esperienza lavorativa"
  },
  "dashboard": {
    "activity": {
      "checkupUpdated": "Valutazione CheckUp aggiornata",
      "portugueseBasicsCompleted": "Completato il livello 1 di Portoghese di base",
      "twoDaysAgo": "2 giorni fa",
      "twoHoursAgo": "2 ore fa",
      "visaVerificationPending": "Verifica documenti per visto in attesa",
      "yesterday": "Ieri",
      "title": "Attività recenti",
      "showAll": "Mostra tutto"
    },
    "allCheckpointsDone": "Tutti i checkpoint completati",
    "banner": {
      "completed": "Fatto",
      "notStarted": "Non iniziato",
      "progress": "Progresso"
    },
    "care": {
      "allComplete": "Tutti i checkpoint completati",
      "assessmentDone": "Valutazione completata",
      "awaitingData": "In attesa di dati",
      "mood": "Umore:",
      "moodCta": "Come ti senti oggi?",
      "notStarted": "Monitora il tuo benessere attraverso 5 pilastri della vita con controlli regolari.",
      "startCta": "Inizia Care",
      "subtitle": "Supporto al benessere e controlli"
    },
    "checkup": {
      "assessmentDone": "Valutazione completata",
      "calculateCta": "Calcola punteggio",
      "calculating": "Calcolo in corso...",
      "calculatingDesc": "Analizzando la tua prontezza in Motivazione, Inglese, Soft Skills e Hard Skills.",
      "iqulture": "Punteggio iQulture",
      "lastAssessment": "Ultimo: {{date}}",
      "notStarted": "Scopri il tuo punteggio di prontezza in Motivazione, Inglese, Soft Skills e Hard Skills.",
      "readyToCalculate": "Il tuo punteggio di prontezza MESH è pronto per essere calcolato.",
      "startCta": "Inizia valutazione",
      "subtitle": "Misura la tua prontezza con MESH",
      "awaitingProfile": "Profilo mancante",
      "awaitingProfileDesc": "La tua valutazione è fatta. Completa il tuo profilo per ottenere il punteggio."
    },
    "continueJourney": "Continua il percorso",
    "cta": {
      "continueQultureUp": "Continua QultureUp",
      "continueTelePortal": "Continua TelePortal",
      "startCare": "Inizia Care",
      "startCheckUp": "Inizia CheckUp",
      "startQultureUp": "Inizia QultureUp",
      "startTelePortal": "Inizia TelePortal",
      "viewCheckUp": "Visualizza CheckUp",
      "viewPassport": "Visualizza Passport",
      "completeProfile": "Completa il tuo profilo",
      "continueCare": "Continua Care"
    },
    "emptyState": {
      "description": "Crea il tuo percorso di carriera internazionale per sbloccare il tuo dashboard personalizzato con monitoraggio dei progressi tra tutti gli eroi.",
      "title": "Costruisci il tuo percorso"
    },
    "errorState": {
      "description": "Qualcosa è andato storto durante il caricamento dei dati del tuo dashboard. Per favore, prova a ricaricare la pagina.",
      "title": "Impossibile caricare il dashboard"
    },
    "heroInsight": {
      "care": {
        "checkpoints": "{{done}} di {{total}} checkpoint",
        "notStarted": "Monitora il tuo benessere",
        "startCheckin": "Registra il tuo primo check-in",
        "streak": "{{n}}-giorni di fila",
        "subtitle": "Monitora il tuo benessere"
      },
      "checkup": {
        "notStarted": "Fai la tua valutazione",
        "subtitle": "Misura la tua prontezza"
      },
      "qultureup": {
        "allDone": "Tutte le missioni completate!",
        "missionsLabel": "missioni",
        "notStarted": "Scopri il tuo livello culturale",
        "subtitle": "Impara la tua nuova cultura",
        "todaysMission": "La missione di oggi"
      },
      "teleportal": {
        "allDone": "Nessuna scadenza in arrivo",
        "next": "Prossimo: {{name}}",
        "notStarted": "Costruisci il tuo piano di trasferimento",
        "overdue_one": "{{count}} scaduto",
        "overdue_other": "{{count}} scaduti",
        "subtitle": "Pianifica la tua relocation",
        "tasksLabel": "attività"
      }
    },
    "journeyProgress": "Il tuo percorso {{route}} è completato al {{percent}}%.",
    "journeyProgressDescription": "Monitora i tuoi progressi in ogni fase",
    "journeyProgressTitle": "I tuoi progressi nel percorso",
    "journeyReady": "Il tuo percorso è pronto per iniziare.",
    "miles": "Miles di viaggio",
    "moodLabel": "Umore:",
    "noActivity": "Nessuna attività recente. Inizia a esplorare i tuoi eroi!",
    "noJourney": "Nessun viaggio",
    "passport": {
      "badges": "Badge",
      "citizenLevelValue": "Lv.{{level}}",
      "level": "Livello",
      "noData": "Il tuo punteggio apparirà qui",
      "readiness": "Prontezza",
      "recentStamps": "Timbri recenti",
      "stamps": "Timbrature",
      "subtitle": "Il tuo registro di viaggio completo",
      "totalMiles": "Miles totali"
    },
    "qultureup": {
      "missions": "Missioni",
      "notStarted": "Esplora mondi culturali e completa missioni per adattarti alla tua nuova casa.",
      "startCta": "Inizia valutazione",
      "streak": "Serie di {{days}} giorni",
      "subtitle": "Adattamento culturale attraverso l'apprendimento",
      "tracks": "Tracce",
      "worlds": "Mondi"
    },
    "recentActivity": "Attività recenti",
    "recentActivityDescription": "I tuoi ultimi traguardi e aggiornamenti",
    "teleportal": {
      "docs": "Documenti pronti:",
      "notStarted": "Imposta il tuo piano di trasferimento con i percorsi Legale, Viaggio e Setup.",
      "startCta": "Inizia setup",
      "subtitle": "Pianifica ed esegui il tuo trasferimento"
    },
    "welcomeBack": "Bentornato, {{name}}! 👋",
    "hero": {
      "scoreIn": "Il tuo punteggio è pronto",
      "hello": "Ciao, {{name}}",
      "helloNoName": "Ciao di nuovo",
      "strongest": "Punto di forza: {{dimension}}",
      "toGrow": "Da sviluppare: {{dimension}}",
      "resultsLink": "Vedi i risultati completi",
      "day": "Giorno {{day}}",
      "dayLabel": "del tuo percorso"
    }
  },
  "deepLink": {
    "copyUrl": "Copia URL",
    "downloadApp": "Scarica l'app",
    "error": {
      "invalidAction": "Azione di deep link non valida",
      "noUser": "Utente non autenticato"
    },
    "fallbackDescription": "Se l'app non si apre automaticamente, installala dall'app store.",
    "landing": {
      "continueIn": "Continua in",
      "continueOnWeb": "Continua sul web",
      "copied": "Link copiato",
      "copyLink": "Copia link",
      "desktopBody": "Sei su un browser desktop. Apri l'app Tonnie sul tuo telefono o continua sul web.",
      "goHome": "Vai alla home",
      "installApp": "Installa l'app",
      "invalidBody": "Questo link non è valido o è scaduto.",
      "invalidTitle": "Link non valido",
      "mobileBody": "Apri questo link nell'app Tonnie per la migliore esperienza.",
      "openApp": "Apri nell'app",
      "publicNote": "Questa pagina è pubblica. Chiunque abbia il link può visualizzarla fino a quando non scade.",
      "retryAgain": "Riprova"
    },
    "openInMobile": "Apri nell'app mobile",
    "qr": {
      "copied": "Link copiato",
      "copyLink": "Copia link",
      "description": "Scansiona questo codice QR con il tuo telefono per aprire l'app Tonnie e continuare.",
      "dontHaveApp": "Non hai ancora l'app?",
      "note": "Il link scade dopo il tempo mostrato sopra.",
      "title": "Continua sul tuo telefono"
    },
    "urlCopied": "URL deep link copiato negli appunti"
  },
  "error": {
    "goHome": "Vai a home",
    "pageDescription": "Ci scusiamo per l'inconveniente. Per favore riprova o torna alla pagina principale.",
    "pageTitle": "Qualcosa è andato storto",
    "retry": "Riprova",
    "sectionDescription": "Questa sezione ha riscontrato un errore. Prova a ricaricare o continua con altre sezioni.",
    "sectionTitle": "Errore sezione",
    "tryAgain": "Riprova",
    "clerkMissing": {
      "title": "Servizio di autenticazione non configurato",
      "body": "Questa build manca di EXPO_PUBLIC_CLERK_PUBLISHABLE_KEY. Reinstalla una build più recente da EAS, o contatta il supporto se il problema persiste."
    }
  },
  "errorBoundary": {
    "goHome": "Vai a home",
    "pageEncounteredError": "Questa pagina ha riscontrato un errore",
    "pageMessage": "Ci scusiamo per l'inconveniente. Per favore riprova o torna alla schermata principale.",
    "reloadPage": "Ricarica pagina",
    "retry": "Riprova",
    "sectionError": "Errore sezione",
    "sectionMessage": "Questa sezione ha riscontrato un errore. Prova a ricaricare o continua con altre sezioni.",
    "somethingWentWrong": "Qualcosa è andato storto",
    "tryAgain": "Riprova",
    "unexpectedError": "Si è verificato un errore imprevisto.",
    "appErrorTitle": "Errore di applicazione"
  },
  "evidence": {
    "kind": {
      "adaptationProgress": "Progressi di adattamento",
      "careCheckins": "Check-in di Care",
      "careOverview": "Panoramica di Care",
      "checkupProgress": "Avanzamento CheckUp",
      "checkupResults": "Risultati CheckUp",
      "cv": "CV",
      "household": "Nucleo familiare",
      "mobilityDocuments": "Documenti di mobilità",
      "mobilityPlan": "Piano di mobilità",
      "passportEvidence": "Evidenze Passport",
      "pitchVideo": "Video di presentazione",
      "testitResults": "Risultati TestIt"
    },
    "redaction": {
      "reason": {
        "controllerMinimisation": "Rimosso dall’azienda per conservare solo il necessario",
        "dataSubjectRequest": "Rimosso su richiesta della persona",
        "legalObligation": "Rimosso per adempiere a un obbligo di legge"
      }
    },
    "retention": {
      "reason": {
        "decisionInForce": "Conservato come registro dell’azienda di una decisione ancora in vigore. Sarà eliminato alla data indicata, o prima se il rapporto giunge a un esito.",
        "engagementEnded": "Conservato come registro dell’azienda di una decisione di assunzione, per difendersi o rispondere a pretese legali, fino al termine del periodo di conservazione successivo alla fine del rapporto.",
        "notProgressed": "Conservato come registro dell’azienda di una decisione di non procedere, per difendersi o rispondere a pretese legali, fino al termine del periodo di conservazione."
      },
      "until": "Conservato fino al {{date}}",
      "noEndDate": "Ancora nessuna data di fine: viene fissata quando la relazione arriva a un esito."
    },
    "trigger": {
      "engagementEnd": "Rapporto concluso",
      "engagementStart": "Inizio della relazione",
      "onDemand": "Salvato su richiesta",
      "sponsorshipActivation": "Sponsorizzazione attivata",
      "stageTransition": "Fase cambiata",
      "verdict": "Decisione TestIt"
    },
    "withheld": {
      "scopeNotGranted": "Non condiviso con questa azienda quando è stata presa la decisione"
    },
    "record": {
      "title": "Registri delle decisioni",
      "description": "Ciò che la tua azienda poteva vedere su {{name}} ogni volta che ha preso una decisione. Un registro resta esattamente come è stato salvato: le modifiche successive al profilo non lo alterano.",
      "captureNow": "Salva un registro ora",
      "capturing": "Salvataggio…",
      "captureSuccess": "Registro salvato",
      "captureRefusedEnded": "Questa relazione è archiviata o è terminata, quindi non è possibile salvare un nuovo registro.",
      "captureFailed": "Non è stato possibile salvare il registro.",
      "listLabel": "Registri delle decisioni, dal più recente",
      "empty": "Ancora nessun registro delle decisioni. Un registro viene salvato ogni volta che la tua azienda sposta, decide su, sponsorizza o termina la relazione con questo candidato.",
      "loadError": "Non è stato possibile caricare i registri delle decisioni.",
      "detailLoadError": "Non è stato possibile caricare questo registro.",
      "retry": "Riprova",
      "itemsTitle": "Cosa contiene il registro",
      "actorBy": "Da {{name}}",
      "actorSystem": "Salvato automaticamente",
      "actorOutsideTeam": "Su un’azione di qualcuno esterno al tuo team",
      "decision": {
        "stageMove": "Spostato da {{from}} a {{to}}",
        "stageEntered": "Entrato in {{to}}"
      },
      "origin": {
        "backfill": "Registro precedente",
        "backfillNote": "Salvato prima che i registri fossero conservati sul server. Contiene solo ciò che il browser ha inviato in quel momento, e il consenso allora in vigore non è stato registrato."
      },
      "listTitle": "Registri · dal più recente",
      "count_one": "{{count}} registro",
      "count_other": "{{count}} registri"
    },
    "item": {
      "legacy": "Inviato dal browser · non verificato",
      "legacyNote": "Questo è ciò che il browser ha inviato con la decisione. Non è mai stato verificato sul server.",
      "redact": "Rimuovi",
      "redactAria": "Rimuovi {{kind}} da questo registro",
      "redacted": "Rimosso dal registro",
      "redactedOn": "Rimosso dal registro il {{date}}",
      "viewerRedacted": "Alcuni dettagli sono nascosti per il tuo ruolo."
    },
    "redact": {
      "title": "Rimuovi {{kind}} da questo registro",
      "description": "Il contenuto viene rimosso in modo definitivo. Il registro conserva una nota della rimozione, di quando e del perché. L’operazione non può essere annullata.",
      "reasonLabel": "Motivo",
      "reasonRequired": "Scegli un motivo.",
      "confirm": "Rimuovi definitivamente",
      "success": "Rimosso dal registro",
      "notRedactable": "Questo elemento non ha più nulla da rimuovere.",
      "failed": "Non è stato possibile rimuovere l’elemento."
    },
    "file": {
      "open": "Apri",
      "opening": "Apertura…",
      "openAria": "Apri {{name}}",
      "auditNote": "Ogni apertura viene registrata.",
      "openFailed": "Non è stato possibile aprire il file.",
      "unavailable": "Questo file non è più disponibile: è stato rimosso dal registro oppure il periodo di conservazione del registro è terminato.",
      "notInStorage": "Il file non era in archivio quando il registro è stato salvato, quindi non ne viene conservata alcuna copia."
    },
    "compare": {
      "title": "Alla decisione · Attuale",
      "show": "Confronta con l’attuale",
      "hide": "Nascondi il confronto",
      "atDecision": "Alla decisione",
      "current": "Attuale",
      "comparedAt": "Confrontato il {{date}}",
      "same": "Uguale alla decisione",
      "different": "Non uguale alla decisione",
      "notComparable": "Non confrontabile",
      "currentDated": "valore attuale datato {{date}}",
      "withheldNow": "Attualmente non condiviso con questa azienda",
      "loadError": "Non è stato possibile caricare il confronto."
    },
    "summary": {
      "nothingAtTheTime": "Niente da registrare in quel momento",
      "none": "Nessun dato registrato",
      "notScored": "Non valutato",
      "percent": "{{value}}%",
      "fraction": "{{done}} di {{total}}",
      "score": "Punteggio",
      "calculatedAt": "Calcolato",
      "completedAt": "Completato",
      "progress": "Avanzamento",
      "tasks": "Attività",
      "documents": "Documenti pronti",
      "missions": "Missioni",
      "wellbeing": "Benessere",
      "checkpoints": "Checkpoint",
      "results": "Risultati",
      "resultsSent": "Risultati inviati",
      "miles": "Miles",
      "stamps": "Timbri",
      "badges": "Badge",
      "fileName": "File",
      "fileSize": "Dimensione",
      "uploadedAt": "Caricato",
      "members": "Membri",
      "checkins": "Check-in",
      "lastCheckin": "Ultimo check-in",
      "nothingNow": "Niente da mostrare ora",
      "files": "File"
    },
    "verdict": {
      "title": "Cronologia delle decisioni",
      "earlier": "Decisioni precedenti ({{count}})",
      "replacedValue": "Ha sostituito una decisione precedente: {{verdict}}",
      "replacedNotRecorded": "Eventuali decisioni precedenti non sono state registrate",
      "viewRecord": "Vedi registro",
      "loadError": "Non è stato possibile caricare la cronologia delle decisioni."
    },
    "notice": {
      "title": "Alcune aziende conservano un registro",
      "introFile": "Il file è stato rimosso dal tuo archivio. Queste aziende hanno preso una decisione su di te che lo includeva e conservano un proprio registro di tale decisione:",
      "introAccount": "Il tuo account è stato eliminato. Queste aziende hanno preso una decisione su di te e ne conservano un proprio registro:",
      "listLabel": "Aziende che conservano un registro",
      "what": "Cosa",
      "until": "Fino al",
      "why": "Perché",
      "noEndDate": "Ancora nessuna data di fine: viene fissata quando la loro decisione arriva a un esito",
      "acknowledge": "Ho capito"
    }
  },
  "family": {
    "admin": "Admin",
    "children": "Bambini",
    "complete": "completo",
    "emailPlaceholder": "member@example.com",
    "enableFamilyPlan": "Abilita piano familiare",
    "familyPlan": "Piano familiare",
    "hasPartner": "Ha partner",
    "hasPets": "Ha animali domestici",
    "householdConfig": "La tua configurazione familiare",
    "householdContext": "Contesto familiare",
    "invalidEmail": "Inserisci un indirizzo email valido",
    "inviteFamilyMember": "Invita un membro della famiglia",
    "inviteMember": "Invita membro",
    "inviteSent": "Invito inviato a {{email}}",
    "journeys": "Viaggi",
    "manageMembers": "Gestisci membri",
    "master": "Master",
    "member": "Membro",
    "members": "Membri",
    "membersAccess": "Membri della famiglia con accesso ai viaggi condivisi",
    "noMembers": "Nessun membro della famiglia aggiunto ancora",
    "pendingName": "In Attesa",
    "removeMember": "Rimuovi membro",
    "removeMemberConfirm": "Rimuovere questo membro della famiglia?",
    "role": "Ruolo",
    "sendInvitation": "Invia un invito per unirti al tuo piano familiare",
    "sendInvite": "Invia invito",
    "shareJourney": "Condividi il tuo viaggio con i membri della famiglia e monitora i progressi insieme.",
    "sharedJourneys": "Istanze di viaggio condivise",
    "sharedJourneysSubtitle": "Viaggi condivisi con i membri della famiglia",
    "title": "Programma familiare",
    "invite": {
      "emailPlaceholder": "member@example.com"
    }
  },
  "familyProgram": {
    "accepted": "Accettato",
    "accessRevoked": "Accesso revocato con successo",
    "accessRules": "Regole di accesso",
    "accessRulesDesc": "Chi può accedere a quali funzionalità",
    "addFamilyMember": "Aggiungi membro della famiglia",
    "addMember": "Aggiungi membro",
    "care": "Care",
    "careRule": "Solo il Family Master può rispondere ai checkpoint Care. Il Companion non ha accesso.",
    "career": "Career & opportunità",
    "careerRule": "Il Family Master e il Companion possono accedere ai propri Career & Opportunità",
    "checkup": "CheckUp",
    "checkupRule": "Il Family Master e il Companion possono completare la propria valutazione CheckUp",
    "children": "Bambini",
    "childrenCount": "Conteggio bambini",
    "complete": "Completo",
    "copilotTip": "Suggerimento CoPilot",
    "description": "Gestisci l'accesso e i permessi della famiglia",
    "disabled": "Disabilitato",
    "docs": "Documenti",
    "docsComplete": "Documenti completi",
    "documents": "Documenti",
    "documentsIncompleteMessage": "I documenti di {{name}} non sono completi. Carica i documenti richiesti per procedere con la domanda di visto.",
    "editMember": "Modifica membro",
    "educationSupport": "Supporto educativo",
    "educationSupportDesc": "Assistenza per collocamento scolastico, corsi di lingua e risorse educative.",
    "emailAddress": "Indirizzo email",
    "enabled": "Abilitato",
    "familyAddonRequired": "Aggiunta famiglia richiesta",
    "familyAddonRequiredDesc": "Il Programma Famiglia richiede Pro Journey, Journey Pack o piano sponsorizzato. Aggiorna per abilitare il Programma Famiglia.",
    "familyAdmin": "Amministratore famiglia",
    "familyAdminDesc": "Può gestire i membri e le impostazioni della famiglia",
    "familyMaster": "Family master",
    "familyMember": "Membro della famiglia",
    "familyMemberDesc": "Membro della famiglia con accesso solo a Citizen",
    "familySponsored": "Sponsorizzato dalla famiglia",
    "familySupportBenefits": "Benefici di supporto familiare",
    "householdContext": "Contesto familiare",
    "householdContextDesc": "La tua configurazione familiare",
    "householdCouple": "Coppia",
    "householdCouplePets": "Coppia + animali",
    "householdFamily": "Famiglia",
    "householdFamilyPets": "Famiglia + animali",
    "householdReadinessOverTime": "Progresso di prontezza della famiglia nel tempo",
    "householdSingle": "Singolo",
    "householdSingleParent": "Genitore singolo",
    "householdSinglePets": "Singolo + animali",
    "householdType": "Tipo di famiglia",
    "incomplete": "Incompleto",
    "invalidEmail": "Inserisci un indirizzo email valido",
    "inviteError": "Invito non inviato",
    "inviteMember": "Invita membro",
    "inviteMemberDesc": "Invita un familiare a unirsi al tuo viaggio",
    "inviteNote": "I membri della famiglia riceveranno un invito via email per unirsi al tuo viaggio. Avranno accesso ai contenuti QultureUp e possono monitorare i propri progressi.",
    "inviteSent": "Invito inviato a {{email}}",
    "journeyInstance": "Istanza di viaggio",
    "management": "Gestione",
    "members": "Membri della famiglia",
    "membersDescription": "Gestisci l'accesso per i membri della famiglia",
    "milesAndLessonsPerMember": "Miles e lezioni completate per membro",
    "monitoring": "Care",
    "monitoringSection": {
      "achievements": "Risultati",
      "acrossAllMembers": "tra tutti i membri",
      "active": "attivo",
      "badgesEarned": "badge guadagnati",
      "careNote": "I checkpoint Care sono risposti dal Family Master per conto della famiglia",
      "checkup": "CheckUp",
      "dayStreak": "serie di giorni",
      "events": "eventi",
      "householdStability": "Stabilità familiare",
      "householdStabilityDesc": "Punteggi attuali dei pilastri Care (consapevole della famiglia, risposto dal Family Master)",
      "lessons": "lezioni",
      "lessonsCompleted": "lezioni completate",
      "memberProgress": "Progresso membro",
      "memberProgressDesc": "Monitoraggio del progresso individuale per ogni membro della famiglia",
      "memberReadiness": "Prontezza membro",
      "noActivity": "Nessuna attività ancora",
      "noMembersToMonitor": "Nessun membro della famiglia da seguire ancora",
      "noReadinessData": "Nessun dato di prontezza disponibile per Compagno",
      "noRecentActivity": "Nessuna attività recente",
      "notAvailable": "Non disponibile",
      "progressTrends": "Tendenze di progresso",
      "progressTrendsDesc": "Visualizza il progresso della famiglia nel tempo",
      "qultureupMiles": "QultureUp Miles",
      "qultureupProgress": "Progresso QultureUp",
      "readinessEvolution": "Evoluzione della prontezza",
      "recentActivity": "Attività recenti",
      "teleportalProgress": "TelePortal",
      "totalAchievements": "Risultati totali",
      "totalMembers": "Totale membri",
      "totalMiles": "Miles Totali",
      "totalQultureupMiles": "Totale Miles QultureUp"
    },
    "noJourneyInstance": "Nessun viaggio attivo",
    "noMembers": "Nessun membro della famiglia invitato ancora",
    "noSharedJourneys": "Nessuna istanza di viaggio condivisa",
    "passport": "Passport",
    "passportRule": "Ogni membro vede la propria vista filtrata. Il compagno accede tramite l'app mobile Tonnie Citizen.",
    "pending": "In Attesa",
    "petsPresence": "Animali domestici",
    "pillar": {
      "housingStability": "Stabilità abitativa",
      "schoolingChildcare": "Istruzione e assistenza all'infanzia",
      "wellbeing": "Benessere",
      "workFit": "Idoneità al lavoro"
    },
    "purchaseFamilyAddon": "Acquista add-on famiglia",
    "qultureup": "QultureUp",
    "qultureupPercent": "QultureUp %",
    "qultureupRule": "Tutti i membri della famiglia accedono tramite l'app mobile Tonnie Citizen (il compagno non può accedere tramite Citizen Web)",
    "readinessPercent": "Prontezza %",
    "removeError": "Impossibile rimuovere il membro",
    "removeMember": "Rimuovi membro",
    "revokeAccess": "Revoca accesso",
    "role": "Ruolo",
    "schoolReady": "Pronto per la scuola",
    "sendInvite": "Invia invito",
    "servicesAvailable": "Servizi disponibili per la tua famiglia",
    "sharedJourneyInstances": "Istanze di viaggio condivise",
    "sharedJourneyInstancesDesc": "Istanze di viaggio condivise con i membri della famiglia",
    "spouseEmployment": "Occupazione del coniuge",
    "spouseEmploymentDesc": "Supporto nella ricerca di lavoro, opportunità di networking e guida per il permesso di lavoro.",
    "status": "Stato del programma familiare",
    "statusDescription": "Stato attuale del tuo Programma Familiare",
    "teleportal": "TelePortal",
    "teleportalRule": "Solo il Family Master può controllare i compiti TelePortal. Il Companion non ha accesso.",
    "title": "Programma familiare",
    "totalMiles": "Miles totali",
    "tryAgainLater": "Per favore riprova più tardi",
    "unableToLoad": "Impossibile caricare i membri della famiglia",
    "viewDetails": "Visualizza dettagli",
    "visa": "Visto",
    "visaApproved": "Approvato",
    "visaDenied": "Negato",
    "visaInProgress": "In corso",
    "visaNotStarted": "Non iniziato",
    "visaStatus": "Stato del visto",
    "visasApproved": "Visti approvati",
    "wellbeingCare": "Benessere Care",
    "wellbeingCareDesc": "Iscrizione sanitaria, supporto per la salute mentale e integrazione sociale.",
    "yearsOld": "{{age}} anni",
    "you": "Tu",
    "sharedJourneyCount_one": "{{count}} percorso condiviso",
    "sharedJourneyCount_other": "{{count}} percorsi condivisi"
  },
  "feedback": {
    "additionalFeedbackHint": "Puoi fornire feedback dettagliato, allegare screenshot o file per aiutarci a comprendere meglio la tua esperienza.",
    "attachFiles": "Allega file",
    "attachFilesOptional": "Allega file (facoltativo)",
    "category": {
      "bug": {
        "description": "Qualcosa non funziona",
        "label": "Segnalazione di bug"
      },
      "other": {
        "description": "Qualcos'altro",
        "label": "Altro"
      },
      "praise": {
        "description": "Adoro questa funzionalità",
        "label": "Lode"
      },
      "question": {
        "description": "Ho bisogno di aiuto",
        "label": "Domanda"
      },
      "suggestion": {
        "description": "Ho un'idea",
        "label": "Suggerimento"
      }
    },
    "categoryDescription": "Seleziona la categoria che descrive meglio il tuo feedback",
    "categoryQuestion": "Che tipo di feedback è questo?",
    "characterCount": "{{current}} / {{max}} caratteri",
    "characters": "{{current}}/{{max}} caratteri",
    "close": "Chiudi feedback",
    "context": {
      "hero": "Eroe",
      "heroPlaceholder": "ad es., CheckUp, TelePortal",
      "notDetected": "Nessun contesto rilevato",
      "page": "Pagina",
      "pagePlaceholder": "ad es., /dashboard, /checkup"
    },
    "contextInfo": "Informazioni sul contesto",
    "contextSaved": "Informazioni sul contesto salvate",
    "detailsDescription": "Si prega di fornire dettagli sul proprio feedback",
    "detailsPlaceholder": "Descrivi il tuo feedback, suggerimento o problema...",
    "detailsQuestion": "Dicci di più",
    "editContext": "Modifica",
    "fileSizeError": "La dimensione del file supera il limite massimo di {{maxSize}}",
    "fileSizeLimit": "I file devono essere inferiori a 20MB",
    "fileUploadDescription": "Aggiungi screenshot, PDF o altri file (fino a 20MB ciascuno) per aiutarci a comprendere meglio il tuo feedback.",
    "optional": "Facoltativo",
    "placeholder": "Condividi i tuoi pensieri...",
    "pleaseDescribe": "Si prega di descrivere il proprio feedback in dettaglio",
    "privacyNote": "Il tuo feedback è anonimo e ci aiuta a migliorare Tonnie",
    "rating": {
      "1": "Molto insoddisfatto",
      "2": "Insoddisfatto",
      "3": "Neutro",
      "4": "Soddisfatto",
      "5": "Molto soddisfatto",
      "veryDissatisfied": "Molto insoddisfatto",
      "dissatisfied": "Insoddisfatto",
      "neutral": "Neutro",
      "satisfied": "Soddisfatto",
      "verySatisfied": "Molto soddisfatto"
    },
    "ratingDescription": "Valuta la tua soddisfazione complessiva",
    "ratingQuestion": "Com'è stata la tua esperienza?",
    "selectRatingAndCategory": "Si prega di selezionare sia la valutazione che la categoria",
    "submit": "Invia feedback",
    "submitError": "Invio del feedback non riuscito. Si prega di riprovare.",
    "submitFeedback": "Invia feedback",
    "submitSuccess": "Grazie! Il tuo feedback è stato inviato.",
    "submitted": "Il tuo feedback è stato inviato.",
    "submitting": "Invio in corso...",
    "subtitle": "Aiutaci a migliorare la tua esperienza",
    "successMessage": "Apprezziamo che tu abbia dedicato del tempo per aiutarci a migliorare Tonnie. Il tuo feedback è stato ricevuto e sarà esaminato dal nostro team.",
    "successTitle": "Grazie per il tuo feedback!",
    "tellUsMore": "Dicci di più",
    "thankYou": "Grazie!",
    "thankYouMessage": "Il tuo feedback ci aiuta a migliorare Tonnie.",
    "title": "Condividi feedback",
    "toggle": "Invia feedback",
    "totalFileSize": "Totale: {{size}} / {{maxSize}}",
    "totalSize": "Totale: {{size}} / 20MB max",
    "uploadFiles": "Carica file",
    "validationError": "Si prega di completare tutti i campi obbligatori",
    "attachImages": "Allega screenshot",
    "removeImage": "Rimuovi {{name}}",
    "aria": {
      "description": "Descrizione del feedback",
      "uploadFiles": "Carica file",
      "removeFile": "Rimuovi {{name}}",
      "satisfactionRating": "Valutazione di soddisfazione",
      "ratingOption": "{{label}} – {{value}} su 5"
    }
  },
  "form": {
    "addressSearch": {
      "city": "Città: ",
      "country": "Paese: ",
      "postalCode": "Codice postale: "
    },
    "datePicker": {
      "cancel": "Annulla",
      "done": "Fatto",
      "months": [
        "gennaio",
        "febbraio",
        "marzo",
        "aprile",
        "maggio",
        "giugno",
        "luglio",
        "agosto",
        "settembre",
        "ottobre",
        "novembre",
        "dicembre"
      ],
      "placeholder": "Seleziona data",
      "selectDate": "Seleziona data",
      "day": "Giorno",
      "month": "Mese",
      "year": "Anno"
    },
    "phoneCountryCode": {
      "clearSearch": "Cancella ricerca",
      "noCountriesFound": "Nessun paese trovato",
      "placeholder": "+XX",
      "searchPlaceholder": "Cerca paese o codice...",
      "selectCountryCode": "Seleziona codice paese"
    },
    "countrySelect": {
      "searchPlaceholder": "Cerca paesi"
    },
    "countryList": {
      "remove": "Rimuovi {{country}}"
    },
    "timePicker": {
      "hour": "Ora",
      "minute": "Minuto"
    }
  },
  "gating": {
    "upgrade": "Aggiorna",
    "lockedLabel": "Bloccato",
    "upgradeToUnlock": "Passa a Pro per sbloccare",
    "unlockJourney": {
      "title": "Sblocca il tuo Journey",
      "qultureup": "Per sbloccare questa missione di QultureUp, apri il Portale Web e sblocca il tuo journey per l'accesso completo.",
      "teleportal": "Per sbloccare questa attività di TelePortal, apri il Portale Web e sblocca il tuo journey per l'accesso completo."
    },
    "upgradeBanner": {
      "passport": "Aggiorna a Pro per sbloccare analisi del passaporto, esportazione e funzionalità di condivisione.",
      "qultureup": "Passa a Pro per accedere a tutti i mondi, lezioni e contenuti dei creatori in QultureUp.",
      "teleportal": "Passa a Pro per caricare documenti, convalidare con revisione AI e sbloccare tutte le fasi di TelePortal."
    }
  },
  "heroes": {
    "cards": {
      "actionRequired": "Azione richiesta",
      "care": {
        "description": "Benessere e supporto",
        "title": "Care"
      },
      "checkup": {
        "description": "La tua valutazione di prontezza",
        "title": "CheckUp"
      },
      "feedbackPillars": "Piloni di feedback",
      "improving": "Miglioramento",
      "inProgress": "In corso",
      "level2Basics": "Livello 2 fondamentali",
      "page": "Pagina",
      "progress": "Progresso",
      "qultureup": {
        "description": "Apprendimento culturale",
        "title": "QultureUp"
      },
      "readinessScore": "Punteggio di prontezza",
      "teleportal": {
        "description": "Compiti legali e di viaggio",
        "title": "TelePortal"
      },
      "visaProcess": "Processo di visto"
    },
    "care": {
      "description": "Checkpoint e supporto post-arrivo",
      "title": "Care"
    },
    "career": {
      "description": "Opportunità e costruttore di CV",
      "title": "Career"
    },
    "checkup": {
      "description": "Valutazione di prontezza pre-immigrazione",
      "readinessScore": "Punteggio di prontezza",
      "title": "CheckUp"
    },
    "passport": {
      "badges": "Badge",
      "description": "La tua cronologia di viaggio",
      "stamps": "Timbrature",
      "timeline": "Tempistica",
      "title": "Passport"
    },
    "qultureup": {
      "description": "Adattamento Culturale",
      "level2Basics": "Livello 2: Fondamentali",
      "title": "QultureUp"
    },
    "teleportal": {
      "actionRequired": "Azione richiesta",
      "description": "Relocazione e Mobilità",
      "title": "TelePortal",
      "visaProcess": "Processo di visto"
    },
    "vault": {
      "allDocuments": "Tutti i documenti",
      "category": {
        "care": {
          "subtopics": {
            "feedback": "Feedback",
            "supportRequests": "Richieste di supporto",
            "wellbeingReports": "Report sul benessere"
          }
        },
        "career": {
          "subtopics": {
            "applications": "Applicazioni",
            "certificates": "Certificati",
            "generatedCVs": "CV generati"
          }
        },
        "checkup": {
          "subtopics": {
            "certificates": "Certificati",
            "cvResume": "CV / Curriculum",
            "languageTests": "Test di lingua",
            "linkedin": "LinkedIn",
            "pitchVideo": "Video di presentazione",
            "profilePhoto": "Foto profilo"
          }
        },
        "other": "Altro",
        "passport": {
          "subtopics": {
            "achievements": "Risultati",
            "milestones": "Traguardi",
            "stamps": "Timbrature"
          }
        },
        "qultureup": {
          "subtopics": {
            "achievements": "Risultati",
            "certificates": "Certificati",
            "courseMaterials": "Materiali del corso"
          }
        },
        "teleportal": {
          "subtopics": {
            "legalTrack": "Percorso legale",
            "setupTrack": "Percorso di configurazione",
            "travelTrack": "Percorso di viaggio"
          }
        }
      },
      "category.care.subtopics.feedback": "Feedback",
      "category.care.subtopics.supportRequests": "Richieste di supporto",
      "category.care.subtopics.wellbeingReports": "Rapporti di benessere",
      "category.career.subtopics.applications": "Applicazioni",
      "category.career.subtopics.certificates": "Certificati",
      "category.career.subtopics.generatedCVs": "CV generati",
      "category.checkup.subtopics.certificates": "Certificati",
      "category.checkup.subtopics.cvResume": "CV e resume",
      "category.checkup.subtopics.languageTests": "Test di lingua",
      "category.checkup.subtopics.linkedin": "LinkedIn",
      "category.checkup.subtopics.pitchVideo": "Video di presentazione",
      "category.checkup.subtopics.profilePhoto": "Foto del profilo",
      "category.passport.subtopics.achievements": "Risultati",
      "category.passport.subtopics.milestones": "Traguardi",
      "category.passport.subtopics.stamps": "Timbrature",
      "category.qultureup.subtopics.achievements": "Risultati",
      "category.qultureup.subtopics.certificates": "Certificati",
      "category.qultureup.subtopics.courseMaterials": "Materiali del corso",
      "category.teleportal.subtopics.legalTrack": "Monitoraggio legale",
      "category.teleportal.subtopics.setupTrack": "Impostazione monitoraggio",
      "category.teleportal.subtopics.travelTrack": "Monitoraggio viaggio",
      "chooseCategoryDesc": "Seleziona l'eroe a cui appartiene questo documento.",
      "chooseCategoryTitle": "Scegli una categoria",
      "detail": {
        "by": "Da",
        "certification": "Certificazione",
        "details": "Dettagli",
        "documentIdentity": "Identità del documento",
        "expires": "Scade",
        "issuingAuthority": "Autorità di emissione",
        "location": "Posizione",
        "size": "Dimensione",
        "status": "Stato",
        "tags": "Tag",
        "type": "Tipo",
        "uploaded": "Caricato",
        "validation": "Validazione",
        "validityPeriod": "Periodo di validità"
      },
      "documents": "documenti",
      "downloadAll": "Scarica tutto",
      "downloadSelected": "Scarica {{count}}",
      "downloadToView": "Scarica per visualizzare",
      "selectDocument": "Seleziona documento",
      "emptyState": "I tuoi documenti da tutti gli eroi — CheckUp, TelePortal, QultureUp, Care e Passport — appariranno qui",
      "fetchError": "Impossibile caricare il vault",
      "filter": {
        "allStatus": "Tutti gli stati",
        "certification": {
          "label": "Certificazione",
          "none": "Nessuna certificazione"
        },
        "clear": "Cancella",
        "expired": "Scaduto",
        "expiringSoon": "In scadenza presto",
        "expiry": "Scadenza",
        "sort": "Ordina",
        "status": "Stato",
        "tags": "Tag",
        "valid": "Valido"
      },
      "noDocuments": "Nessun documento ancora",
      "noResults": "Nessun documento trovato",
      "previewError": "L'anteprima non può essere caricata",
      "previewUnavailable": "Anteprima non disponibile per questo tipo di file",
      "removeConfirmDesc": "Questa azione non può essere annullata. Il documento verrà rimosso permanentemente.",
      "removeDocument": "Rimuovere il documento?",
      "removeLinkedTaskWarning": "Questo documento è collegato a un'attività di TelePortal. Rimuoverlo potrebbe influire sul completamento dell'attività.",
      "searchPlaceholder": "Cerca documenti...",
      "sort": {
        "largestFirst": "Più grande per primo",
        "nameAZ": "Nome A-Z",
        "nameZA": "Nome Z-A",
        "newestFirst": "Più recente per primo",
        "oldestFirst": "Più vecchio per primo",
        "smallestFirst": "Più piccolo per primo"
      },
      "status": {
        "all": "Tutti gli stati",
        "pending": "In Attesa",
        "rejected": "Rifiutato",
        "uploaded": "Caricato",
        "validated": "Convalidato"
      },
      "subtitle": "Tutti i tuoi documenti di viaggio in un luogo sicuro",
      "tag": {
        "approved": "Approvato",
        "archived": "Archiviato",
        "expiringSoon": "In scadenza presto",
        "important": "Importante",
        "pendingReview": "In attesa di revisione",
        "urgent": "Urgente"
      },
      "tag.approved": "Approvato",
      "tag.archived": "Archiviato",
      "tag.expiringSoon": "In scadenza presto",
      "tag.important": "Importante",
      "tag.pendingReview": "In attesa di revisione",
      "tag.urgent": "Urgente",
      "title": "Vault",
      "track": {
        "legal": "Legale",
        "setup": "Impostazione",
        "travel": "Viaggio"
      },
      "track.legal": "Legale",
      "track.setup": "Impostazione",
      "track.travel": "Viaggio",
      "verifiedByTonnie": "Verificato da Tonnie",
      "view": {
        "grid": "Vista griglia",
        "list": "Visualizzazione elenco",
        "timeline": "Vista cronologia"
      },
      "viewDetails": "Visualizza dettagli",
      "documentTypes": {
        "passport": "Passport",
        "birth_certificate": "Certificato di nascita",
        "marriage_certificate": "Certificato di matrimonio",
        "criminal_record": "Certificato penale",
        "employment_contract": "Contratto di lavoro",
        "salary_proof": "Prova di stipendio",
        "proof_of_income": "Prova di reddito",
        "bank_statements": "Estratti conto bancari",
        "school_records": "Documenti scolastici",
        "drivers_license": "Patente di guida",
        "travel_insurance": "Assicurazione di viaggio",
        "health_insurance_policy": "Assicurazione sanitaria",
        "lease_agreement": "Contratto di locazione",
        "proof_of_address": "Prova di indirizzo",
        "pet_passport": "Passaporto dell'animale domestico",
        "certified_translation": "Traduzione certificata",
        "sponsor_letter": "Lettera di sponsorizzazione"
      },
      "documentActions": "Azioni sui documenti",
      "searchLabel": "Cerca documenti"
    }
  },
  "invitations": {
    "error": {
      "acceptFailedTitle": "Non siamo riusciti ad accettare questo invito",
      "alreadyAcceptedDescription": "Questo invito è già stato accettato da un altro account.",
      "alreadyAcceptedTitle": "Già accettato",
      "backHome": "Torna alla home",
      "declinedDescription": "Questo invito è stato rifiutato. Chiedi a {{company}} di inviarne uno nuovo se è stato un errore.",
      "declinedTitle": "Invito rifiutato",
      "emailMismatchDescription": "Questo invito è per {{email}}. Disconnettiti e accedi con quell'indirizzo per accettare.",
      "emailMismatchTitle": "Account errato",
      "emailUnverifiedDescription": "L'indirizzo a cui è stato inviato questo invito è sul tuo account, ma non è ancora stato verificato.",
      "emailUnverifiedTitle": "Verifica prima questo indirizzo",
      "expiredDescription": "Chiedi all'azienda con cui hai parlato di inviare un nuovo invito.",
      "expiredTitle": "Questo invito è scaduto",
      "invalidLinkDescription": "Questo link manca del token di invito. Controlla l'email che hai ricevuto e riprova.",
      "invalidLinkTitle": "Link di invito non valido",
      "notFoundDescription": "Il link potrebbe essere incompleto. Assicurati di aver utilizzato l'email più recente.",
      "notFoundTitle": "Non siamo riusciti a trovare quell'invito",
      "revokedDescription": "L'azienda ha ritirato questo invito. Contattali se pensi che sia un errore.",
      "revokedTitle": "Questo invito è stato revocato",
      "tryAgain": "Per favore riprova tra un momento.",
      "wrongPortalDescription": "Questo invito è per un account cittadino Tonnie. Accedi con il tuo account cittadino per aprirlo.",
      "wrongPortalTitle": "Usa il tuo account cittadino",
      "requestNotYoursTitle": "Questa richiesta è per un altro account",
      "requestNotYoursDescription": "Accedi con l’account con cui lavora questa azienda per rispondere.",
      "requestClosedTitle": "Non è più possibile rispondere a questa richiesta",
      "requestClosedDescription": "La tua relazione con questa azienda non è più attiva, quindi non si può condividere altro."
    },
    "preview": {
      "acceptCta": "Accetta invito",
      "accepting": "Accettando…",
      "branch": "Filiale",
      "declineCta": "Rifiuta",
      "declining": "Rifiutando…",
      "destination": "Destinazione",
      "emailHint": "Questo invito è per {{email}}",
      "expires": "Questo invito scade il {{date}}",
      "headline": "Sei stato invitato",
      "invitingYou": "Invito da",
      "loading": "Caricamento del tuo invito…",
      "location": "Posizione",
      "opportunity": "Opportunità",
      "signInCta": "Accedi per accettare",
      "signUpCta": "Registrati per accettare",
      "subheadline": "{{company}} vorrebbe che tu facessi un CheckUp per esplorare un'opportunità internazionale. È gratuito e richiede circa 20 minuti.",
      "subheadlineNamed": "Ciao {{firstName}} — {{company}} vorrebbe che tu facessi un CheckUp per esplorare un'opportunità internazionale. È gratuito e richiede circa 20 minuti.",
      "subheadlineTestit": "{{company}} vorrebbe che completassi alcuni test specifici per esplorare un’opportunità internazionale. È gratis e i tuoi risultati sono riutilizzabili.",
      "subheadlineTestitNamed": "Ciao {{firstName}} — {{company}} vorrebbe che completassi alcuni test specifici per esplorare un’opportunità internazionale. È gratis e i tuoi risultati sono riutilizzabili.",
      "testitTestsLabel": "Cosa completerai"
    },
    "identity": {
      "addEmailBody": "{{company}} ha inviato questo invito a {{email}}. Aggiungi quell'indirizzo al tuo account e verificalo per accettare senza ricominciare.",
      "addEmailCta": "Aggiungi e verifica questo indirizzo",
      "addEmailError": "Non abbiamo potuto aggiungere quell'indirizzo. Riprova tra un momento.",
      "addEmailTitle": "Questo invito è per un altro indirizzo",
      "cancelCta": "Annulla",
      "codeInvalid": "Questo codice non è corretto. Controllalo e riprova.",
      "codeLabel": "Codice di 6 cifre",
      "codeSentBody": "Abbiamo inviato un codice di 6 cifre a {{email}}. Inseriscilo qui sotto per completare la verifica.",
      "codeSentHint": "Inviato a {{email}}. Scade tra pochi minuti.",
      "codeSentTitle": "Controlla la tua casella di posta",
      "invitedAddress": "Invito inviato a",
      "sendCodeCta": "Inviami un codice",
      "sending": "Invio in corso…",
      "signedInAs": "Hai effettuato l'accesso come",
      "switchAccountCta": "Accedi con un altro account",
      "switchAccountHint": "Tornerai a questo invito dopo aver effettuato l'accesso.",
      "tryAgainCta": "Riprova",
      "unverifiedBody": "{{email}} è già sul tuo account ma non è stato verificato. {{company}} ha inviato questo invito lì, quindi verificarlo dimostra che è tuo.",
      "unverifiedTitle": "Verifica questo indirizzo per continuare",
      "verifyCta": "Verifica e continua",
      "verifyError": "Non abbiamo potuto verificare quell'indirizzo. Riprova tra un momento.",
      "verifying": "Verifica in corso…"
    },
    "card": {
      "eyebrow": "Invito",
      "titleCheckup": "{{company}} ti ha invitato a un CheckUp",
      "titleTestit": "{{company}} ti ha chiesto alcuni test",
      "detail": "Inviato a {{email}} · trasferimento in {{country}}",
      "detailNoCountry": "Inviato a {{email}}",
      "expires": "Scade il {{date}}",
      "review": "Vedi invito",
      "notNow": "Non ora",
      "decline": "Rifiuta",
      "actionFailed": "Operazione non riuscita. Controlla la connessione e riprova.",
      "declineTitle": "Rifiutare l'invito di {{company}}?",
      "declineBody": "{{company}} vedrà che hai rifiutato e questo invito non potrà più essere usato.",
      "declineConfirm": "Rifiuta invito",
      "declineCancel": "Tienilo"
    },
    "review": {
      "title": "Unisciti a {{company}}",
      "bodyCheckup": "{{company}} ti chiede di fare un CheckUp per il tuo trasferimento in {{country}}.",
      "bodyCheckupNoCountry": "{{company}} ti chiede di fare un CheckUp.",
      "accept": "Accetta invito",
      "accepting": "Accettazione…",
      "residenceBody": "Il tuo percorso con {{company}} parte da qui e si apre appena accetti.",
      "deferredUntil": "Hai rimandato questo invito per ora. Ti aspetta qui finché non decidi e torna nella Home il {{date}}."
    },
    "claim": {
      "title": "Questo indirizzo ha un proprio account Tonnie",
      "subtitle": "{{email}} appartiene a un altro account Tonnie.",
      "body": "Se anche quell'account è tuo, puoi accettare qui l'invito di {{company}}. Invieremo un codice a quell'indirizzo per confermare che è tuo.",
      "sendCta": "Inviami un codice",
      "sending": "Invio in corso…",
      "switchInstead": "Accedi invece con quell'account",
      "codeSentBody": "Abbiamo inviato un codice di 6 cifre a {{email}}. Scade tra {{minutes}} minuti.",
      "resendCta": "Invia un nuovo codice",
      "resendIn": "Invia un nuovo codice tra {{seconds}} s",
      "codeWrong_one": "Il codice non è corretto. Ti resta {{count}} tentativo.",
      "codeWrong_other": "Il codice non è corretto. Ti restano {{count}} tentativi.",
      "codeExpired": "Il codice è scaduto o è già stato esaurito. Inviane uno nuovo.",
      "tooManyCodes": "Abbiamo già inviato diversi codici. Riprova più tardi.",
      "noOtherAccount": "Nessun altro account Tonnie usa ora questo indirizzo. Aggiungilo invece a questo account.",
      "failed": "Qualcosa è andato storto. Riprova.",
      "retireNote": "{{email}} è confermato come tuo. L'altro tuo account Tonnie con questo indirizzo non contiene nulla, quindi verrà chiuso quando accetti. Avrai un solo account.",
      "keptNote": "{{email}} è confermato come tuo. L'altro tuo account Tonnie con questo indirizzo mantiene il suo percorso, e puoi ancora accedervi."
    },
    "choice": {
      "checking": "Controllo dei tuoi percorsi…",
      "loadFailed": "Non siamo riusciti a caricare i tuoi percorsi. Riprova prima di accettare.",
      "legend": "Quale percorso condividi con {{company}}?",
      "route": "{{origin}} → {{destination}}",
      "companyJourney": "{{company}} ti segue già su questo percorso",
      "sharedWith": "Condiviso anche con {{companies}}",
      "checkupShared": "{{company}} vedrà il tuo CheckUp del {{date}}",
      "newTitle": "Un nuovo percorso per {{company}}",
      "newBody": "Si parte da zero: {{company}} vede solo ciò che farai d'ora in poi.",
      "newCapped_one": "Hai già {{count}} percorso su questa rotta, il massimo possibile. Archivialo per iniziarne un altro.",
      "newCapped_other": "Hai già {{count}} percorsi su questa rotta, il massimo possibile. Archiviane uno per iniziarne un altro.",
      "newOnly": "Inizieremo un nuovo percorso verso {{country}} per {{company}}.",
      "newOnlyNoCountry": "Inizieremo un nuovo percorso per {{company}}.",
      "blocked_one": "Il tuo percorso su questa rotta appartiene a un'altra azienda e ne hai già {{count}}, il massimo per rotta. Archiviane uno per accettare l'invito di {{company}}.",
      "blocked_other": "I tuoi percorsi su questa rotta appartengono ad altre aziende e ne hai già {{count}}, il massimo per rotta. Archiviane uno per accettare l'invito di {{company}}."
    },
    "list": {
      "title": "{{company}} ti ha invitato",
      "deferredUntil": "Rimandato fino al {{date}}",
      "expires": "Valido fino al {{date}}",
      "openHint": "Apre l'invito per accettarlo o rifiutarlo"
    },
    "request": {
      "eyebrow": "Richiesta",
      "titleCheckup": "{{company}} chiede di vedere il punteggio del tuo CheckUp",
      "titleTests": "{{company}} chiede di vedere i tuoi risultati di {{tests}}",
      "cardBody": "Non viene condiviso nulla finché non decidi. Guarda cosa vedrebbero e poi decidi.",
      "bodyCheckupScored": "Il tuo punteggio è pronto. Non viene condiviso nulla finché non decidi.",
      "bodyCheckupPending": "Se condividi, vedranno il tuo punteggio quando il CheckUp sarà calcolato. Non viene condiviso nulla finché non decidi.",
      "bodyTests": "I risultati che hai già vengono riutilizzati. Non viene condiviso nulla finché non decidi.",
      "willSeeTitle": "Se condividi, {{company}} vede",
      "wontSeeTitle": "{{company}} continua a non vedere",
      "new": "Nuovo",
      "share": "Condividi",
      "sharing": "Condivisione…",
      "declineTitle": "Rifiutare la richiesta di {{company}}?",
      "declineBody": "{{company}} verrà informata. Nient’altro cambia: continua a vedere solo ciò che hai condiviso prima.",
      "declineConfirm": "Rifiuta richiesta",
      "sharedToast": "Condiviso con {{company}}",
      "sharedToastBody": "Ora possono vederlo. Puoi cambiare ciò che vedono in qualsiasi momento in I miei percorsi.",
      "declinedToast": "Hai rifiutato la richiesta di {{company}}",
      "listTitle": "{{company}} chiede di vedere di più",
      "kindCheckup": "Il punteggio del tuo CheckUp",
      "kindTests": "I tuoi risultati dei test",
      "signInBody": "Accedi all’account con cui lavora {{company}} per vedere esattamente cosa chiede, e decidere.",
      "signIn": "Accedi",
      "notWaitingTitle": "Questa richiesta non è in attesa della tua risposta",
      "notWaitingBody": "È già stata risposta o ritirata, oppure è per un altro account."
    },
    "testit": {
      "title": "{{company}} chiede i risultati dei tuoi test",
      "body": "{{company}} ti chiede i test qui sotto. Quelli che non hai ancora fatto li fai dopo aver accettato.",
      "bodyAllDone": "Hai già fatto tutti i test che {{company}} chiede. Non c’è nulla di nuovo da fare.",
      "listLabel": "Cosa chiede {{company}}",
      "testDone": "Già fatto — verrà condiviso il tuo risultato del {{date}}",
      "testPending": "Da fare dopo aver accettato",
      "scopeTestsOnly": "Accettando condividi i risultati di questi test con {{company}}. Il tuo CheckUp non viene condiviso.",
      "scopeUnchanged": "Accettando aggiungi i risultati di questi test. {{company}} continua a vedere ciò che già condividi con lei.",
      "accept": "Accetta e fai i test",
      "acceptShare": "Condividi i miei risultati",
      "confirmTitle": "I tuoi risultati sono condivisi con {{company}}",
      "confirmBody": "{{company}} può ora vedere i tuoi risultati in questi test. Non ti resta nulla da fare.",
      "confirmDone": "Fatto"
    }
  },
  "journey": {
    "arrives": "Arriva {{date}}",
    "buildFirstJourney": "Costruisci il tuo primo viaggio internazionale per iniziare",
    "buildYourFirstJourney": "Costruisci il tuo primo viaggio",
    "builder": {
      "title": "Costruttore di percorsi",
      "createErrorFallback": "Impossibile creare il viaggio",
      "notAuthenticated": "Devi essere connesso per continuare",
      "missingCountries": "Non siamo riusciti a capire dove inizia e finisce il tuo percorso. Scegli il tuo Paese attuale e la tua destinazione e riprova.",
      "alsoToDestination": "Hai anche un percorso verso {{destination}} da {{origins}}.",
      "advice": {
        "title": "Hai già questa rotta",
        "body": "Hai già un percorso da {{origin}} a {{destination}}. Aprilo, o creane un altro.",
        "capTitle": "Questa rotta è al completo",
        "capBody_one": "Hai già {{count}} percorso da {{origin}} a {{destination}}, il massimo per rotta. Aprilo.",
        "capBody_other": "Hai già {{count}} percorsi da {{origin}} a {{destination}}, il massimo per rotta. Aprine uno.",
        "listLabel": "I tuoi percorsi su questa rotta",
        "open": "Apri",
        "buildAnother": "Creane un altro",
        "notNow": "Non ora"
      }
    },
    "daysOnJourney": "Giorni in viaggio",
    "details": {
      "amount": "Importo",
      "featuresIncluded": "Funzionalità incluse",
      "paymentInfo": "Informazioni di pagamento",
      "scenario": "Scenario",
      "scenario_already_abroad": "Già all'estero",
      "scenario_integration_only": "Solo integrazione",
      "scenario_pre_immigration": "Pre-Immigrazione",
      "scenario_relocation_only": "Solo trasferimento",
      "status": "Stato",
      "title": "Dettagli del viaggio",
      "type": "Tipo"
    },
    "expires": "Scade",
    "family": "Famiglia",
    "govSponsored": "Sponsorizzato dal governo",
    "guard": {
      "buildDescription": "Prima di poter accedere a questa funzionalità, devi creare il tuo viaggio di carriera internazionale. Ci vogliono solo pochi minuti.",
      "buildFirst": "Costruisci il tuo primo viaggio",
      "buildNew": "Costruisci nuovo viaggio",
      "buildTitle": "Costruisci prima il tuo viaggio",
      "builderHint": "Il costruttore di viaggi ti aiuterà a impostare la tua origine, destinazione e obiettivi di carriera.",
      "expiredDescription": "Questo viaggio ha raggiunto la fine del suo piano. Rinnova o aggiorna per continuare a utilizzare i tuoi eroi.",
      "expiredTitle": "Il tuo viaggio è scaduto",
      "goToDashboard": "Vai alla dashboard",
      "loadErrorDescription": "Qualcosa è andato storto durante il caricamento dei tuoi viaggi. I tuoi dati sono al sicuro — riprova.",
      "loadErrorTitle": "Non siamo riusciti a caricare i tuoi viaggi",
      "noActiveDescription": "Tutti i tuoi viaggi potrebbero essere in pausa, scaduti o completati. Seleziona uno dall'intestazione o costruiscine uno nuovo.",
      "noActiveTitle": "Nessun viaggio attivo",
      "pausedDescription": "L'accesso è temporaneamente in pausa — di solito perché il pagamento di uno sponsor non è andato a buon fine, o il viaggio è stato messo in pausa da un amministratore. Contatta il tuo sponsor o controlla la fatturazione per riprendere.",
      "pausedTitle": "Il tuo viaggio è in pausa",
      "pendingSetupDescription": "Abbiamo riservato questo percorso per te. Dicci da dove ti trasferisci e si apre subito.",
      "pendingSetupTitle": "Completa la configurazione del tuo viaggio",
      "renewJourney": "Rinnova",
      "selectDescription": "Devi selezionare un'istanza di viaggio attiva per accedere a questa funzionalità. Usa il selettore di viaggio nell'intestazione sopra per sceglierne uno.",
      "selectTitle": "Seleziona un viaggio",
      "selectorHint": "Suggerimento: Usa il selettore di viaggio nella barra di navigazione in alto per passare tra i tuoi viaggi.",
      "unavailableDescription": "Questo viaggio non è più accessibile. Scegli un altro o costruisci un nuovo viaggio per continuare.",
      "unavailableTitle": "Viaggio non disponibile",
      "viewBilling": "Visualizza fatturazione",
      "errorTitle": "Impossibile caricare i tuoi viaggi",
      "errorDescription": "Non siamo riusciti a raggiungere il server. Controlla la tua connessione e riprova.",
      "openSelector": "Apri selettore di percorso",
      "openJourney": "Apri il mio percorso"
    },
    "loadingJourneys": "Caricamento viaggi…",
    "milesToGo": "Miles da percorrere",
    "nextMilestone": "Prossimo traguardo",
    "pro": "Pro",
    "progress": "Progresso",
    "selectJourney": "Seleziona viaggio",
    "selector": {
      "andMore_one": "e 1 altra",
      "andMore_other": "e altre {{count}}",
      "basicAccess": "Accesso base",
      "buildFirst": "Crea il tuo primo viaggio",
      "buildNew": "Costruisci nuovo viaggio",
      "buildOne": "Crea un viaggio",
      "buildOneShort": "Crea viaggio",
      "companiesHint": "Mostra tutte le aziende di questo viaggio",
      "companiesTitle": "Aziende in questo viaggio",
      "company": "Azienda",
      "expired": "Scaduto",
      "expiresOn": "Scade",
      "family": "Famiglia",
      "from": "da {{country}}",
      "fromUnknown": "Da sconosciuto",
      "fullAccess": "Accesso completo",
      "government": "Governo",
      "invitedBy": "Invitato da {{company}}",
      "invitedOnly": "Solo invitato",
      "loadingJourneys": "Caricamento viaggi…",
      "locked": "Bloccato",
      "noJourneys": "Nessun viaggio ancora",
      "noJourneysDescription": "Non hai ancora viaggi. Inizia uno per cominciare il tuo trasferimento.",
      "noJourneysTitle": "Nessun viaggio ancora",
      "paused": "In pausa",
      "setupPending": "Configurazione in sospeso",
      "sponsored": "Sponsorizzato",
      "unlocked": "Sbloccato",
      "sharedWith": "Condiviso con {{company}}"
    },
    "sponsored": "Sponsorizzato",
    "status": {
      "active": "Attivo",
      "completed": "Completato",
      "draft": "Bozza",
      "expired": "Scaduto",
      "limited": "Limitato",
      "paused": "In pausa"
    },
    "statusActive": "Attivo",
    "statusExpired": "Scaduto",
    "statusLimited": "Limitato",
    "switchBetweenJourneys": "Passa tra i tuoi viaggi attivi",
    "yourJourneyTo": "Il tuo viaggio verso {{country}}",
    "originPending": "Origine in attesa",
    "invited": "Invitato",
    "yourJourneyToUnknown": "Il tuo percorso",
    "relationship": {
      "live": "Attivo",
      "archivedByCompany": "Archiviato dall’azienda",
      "ended": "Terminato",
      "left": "Sei uscito"
    },
    "manage": {
      "accessUntil": "Accesso fino al {{date}}",
      "activeDescription": "Ogni percorso conserva i propri progressi in CheckUp, TelePortal e Care. Il percorso attuale è quello mostrato nella tua dashboard.",
      "activeSection": "Percorsi attivi",
      "archive": "Archivia",
      "archiveCanRestore": "Puoi recuperarlo da questa pagina quando vuoi.",
      "archiveConfirm": "Archivia percorso",
      "archiveDialogDescription": "Esce dal tuo elenco di percorsi. Non si perde nulla di ciò che contiene.",
      "archiveDialogTitle": "Archiviare il tuo percorso verso {{destination}}?",
      "archiveFailed": "Non è stato possibile archiviare questo percorso. Riprova.",
      "archiveKeepsProgress": "Non viene eliminato nulla: i progressi in CheckUp, TelePortal e Care restano con il percorso.",
      "archiveSwitchesCurrent": "È il tuo percorso attuale, quindi Tonnie ti sposta su un altro, se ne hai uno.",
      "archivedDescription": "I percorsi archiviati conservano tutto. Recuperane uno per riprendere da dove avevi lasciato.",
      "archivedOn": "Archiviato il {{date}}",
      "archivedSection": "Archiviati",
      "archivedToastBody": "Il tuo percorso verso {{destination}} è archiviato. Non è stato eliminato nulla.",
      "archivedToastTitle": "Percorso archiviato",
      "blockedLiveProgramBody": "Esci prima dal programma — così termina la tua relazione con l’azienda — e poi potrai archiviare questo percorso.",
      "blockedLiveProgramTitle": "Un’azienda sta ancora gestendo questo programma",
      "blockedSponsorshipBody": "La sponsorizzazione deve terminare prima che questo percorso possa essere archiviato.",
      "blockedSponsorshipTitle": "Questo percorso è sponsorizzato",
      "continueJourney": "Continua il percorso",
      "current": "Attuale",
      "emptyWithArchived": "Non hai nessun percorso attivo. Iniziane uno nuovo o recuperane uno che hai archiviato.",
      "leaveConfirm": "Esci dal programma",
      "leaveDialogTitle": "Uscire dal programma di {{company}}?",
      "leaveFailed": "Non è stato possibile farti uscire dal programma. Riprova.",
      "leaveFinerHint": "Vuoi nascondere solo alcune cose? Scegli esattamente che cosa possono vedere.",
      "leaveKeepsJourney": "Il tuo percorso, i suoi progressi e i tuoi documenti restano tuoi.",
      "leaveProgramme": "Esci dal programma",
      "leaveCompanyProgramme": "Esci dal programma di {{company}}",
      "leaveWithdrawsAccess": "Revochi l’accesso di {{company}} ai dati che hai condiviso in questo percorso.",
      "leftToastCanArchive": "Non vedono più i tuoi dati e la relazione è terminata. Ora puoi archiviare questo percorso.",
      "leftToastTitle": "Hai lasciato il programma di {{company}}",
      "manageConsents": "Che cosa vedono",
      "manageJourneys": "Gestisci percorsi",
      "newJourney": "Nuovo percorso",
      "openExisting": "Aprilo",
      "recoverArchived": "Recupera un percorso archiviato ({{count}})",
      "restore": "Recupera",
      "restoreFailed": "Non è stato possibile recuperare questo percorso. Riprova.",
      "restoredToastTitle": "Percorso recuperato",
      "startedOn": "Iniziato il {{date}}",
      "subtitle": "Passa da un percorso all’altro, archivia quelli che non usi e decidi che cosa possono vedere le aziende.",
      "switchToJourney": "Passa a questo percorso",
      "title": "I miei percorsi",
      "undo": "Annulla",
      "actionsLabel": "Gestisci percorso",
      "actionsHint": "Tieni premuto, o usa il menu delle azioni, per archiviare o uscire",
      "restoreCapTitle": "Questa rotta è al completo",
      "restoreCapBody_one": "Hai già {{count}} percorso attivo verso {{destination}} da questa origine. Aprilo, o archivialo prima di ripristinare questo.",
      "restoreCapBody_other": "Hai già {{count}} percorsi attivi verso {{destination}} da questa origine. Aprine uno, o archiviane uno prima di ripristinare questo.",
      "labelField": "Nome del percorso",
      "labelPlaceholder": "es. Lavoro — Lisbona",
      "nameIt": "Dagli un nome",
      "rename": "Rinomina",
      "renamedToast": "Percorso rinominato",
      "nameClearedToast": "Nome del percorso rimosso",
      "renameFailed": "Non siamo riusciti a salvare il nome. Riprova.",
      "leaveDialogDescriptionInvited": "{{company}} ti ha invitato al tuo percorso verso {{destination}}.",
      "leaveDialogDescriptionShared": "Hai condiviso il tuo percorso verso {{destination}} con {{company}}.",
      "leaveEndsRelationship": "La tua relazione con {{company}} in questo percorso termina. Possono invitarti di nuovo, e decidi tu se accettare.",
      "leftToastOtherProgramme": "Non vedono più i tuoi dati e la relazione è terminata. Il programma di un’altra azienda è ancora attivo su questo percorso, quindi rimane.",
      "leftToastSponsorshipHolds": "Non vedono più i tuoi dati e la relazione è terminata. Una sponsorizzazione è ancora attiva su questo percorso, quindi rimane finché non termina.",
      "archiveAfterSponsorship": "Questo percorso è sponsorizzato fino al {{date}}. Potrai archiviarlo al termine della sponsorizzazione.",
      "archiveAfterSponsorshipNoDate": "C'è una sponsorizzazione attiva su questo percorso. Potrai archiviarlo al termine della sponsorizzazione."
    },
    "consent": {
      "action": {
        "granted": "Condiviso",
        "narrowed": "Condiviso di meno",
        "revoked": "Non più condiviso",
        "widened": "Condiviso di più"
      },
      "allRevoked": "Non vedono più i tuoi risultati in questo percorso.",
      "archivedByCompany": "Archiviato dall’azienda",
      "changeFailed": "La modifica non è andata a buon fine. Non è cambiato nulla.",
      "changedToastBody": "{{company}} · {{scope}}",
      "empty": "Nessuna azienda ha accesso ai tuoi dati in questo percorso.",
      "grantedOn": "Condiviso dal {{date}}",
      "grantedToast": "Di nuovo condiviso",
      "grantedUnknown": "Condiviso prima che iniziassimo a registrare le date di consenso",
      "groupJourney": "In questo percorso",
      "groupProfile": "Dal tuo profilo",
      "revokedToast": "Non più condiviso",
      "scope": {
        "care": "Il mio percorso Care",
        "care_checkins": "I miei check-in quotidiani",
        "checkup": "I miei risultati CheckUp",
        "cv": "Il mio CV",
        "household": "I dati della mia famiglia",
        "irr": "La mia cronologia di attività",
        "passport_stamps": "I miei timbri e le miglia Passport",
        "pitch_video": "La mia registrazione di presentazione",
        "qultureup": "I miei progressi QultureUp",
        "teleportal": "Il mio piano di trasferimento",
        "testit": "I miei risultati TestIt"
      },
      "sharingCount": "{{shared}} di {{total}} condivisi",
      "subtitle": "Ogni azienda qui sotto ha accesso a una parte del tuo percorso. Disattiva quello che vuoi e smetteranno di vederlo; riattivalo quando vuoi. Nulla di ciò che hai fatto viene cancellato.",
      "title": "Chi vede i miei dati",
      "trailTitle": "Che cosa è cambiato",
      "leftOn": "Sei uscito il {{date}}",
      "endedOn": "Terminato il {{date}}",
      "stoppedOn": "Condivisione interrotta il {{date}}",
      "leftReadOnly": "Questa relazione è terminata. Non viene più condiviso nulla con {{company}}, a meno che tu non accetti un loro nuovo invito."
    }
  },
  "journeyBuilder": {
    "aboutDescription": "Crea la tua configurazione di viaggio internazionale personalizzata",
    "creatingMessage": "Configurazione del tuo viaggio — ci vuole solo un momento.",
    "creatingTitle": "Creazione del tuo viaggio…",
    "creationErrorTitle": "Impossibile creare il tuo viaggio",
    "description": "Configuriamo il tuo viaggio internazionale",
    "estimatedTime": "Tempo stimato",
    "infoCountries": "Scegli i tuoi paesi di origine e destinazione",
    "infoDescription": "Raccontaci alcune cose sul tuo trasferimento in modo da poter personalizzare il tuo viaggio.",
    "infoDestination": "Destinazione",
    "infoDestinationDesc": "Dove ti stai trasferendo.",
    "infoFeatures": "Seleziona quali funzionalità includere nel tuo viaggio",
    "infoHousehold": "Configura la composizione della tua famiglia e la tua situazione familiare",
    "infoIntro": "Costruire un viaggio richiede alcuni minuti. Una volta completato, vedrai la tua tabella di marcia personalizzata.",
    "infoJourney": "Viaggio",
    "infoJourneyDesc": "Il piano completo dall'origine alla destinazione.",
    "infoOrigin": "Origine",
    "infoOriginDesc": "Da dove ti stai trasferendo.",
    "infoProfile": "Profilo",
    "infoProfileDesc": "I tuoi dettagli personali — utilizzati per personalizzare le raccomandazioni.",
    "infoScenario": "Seleziona il tuo scopo di viaggio e cosa stai cercando",
    "progress": "Progresso",
    "progressTitle": "Progresso",
    "purposeCare": "Supporto e assistenza per arrivarci",
    "purposeCheckup": "Controlla le tue Competenze Internazionali",
    "purposeCulture": "Conosci la Cultura e diventa un Citizen",
    "purposeJob": "Hai un'opportunità di lavoro e supporto",
    "purposeRelocation": "Supporto nel processo di trasferimento",
    "redirectingMessage": "Reindirizzandoti al tuo dashboard...",
    "scenario": "Qual è la tua situazione?",
    "scenarioAlreadyAbroad": "Vivo già all'estero",
    "scenarioAlreadyAbroadDesc": "Ti sei già trasferito e vuoi migliorare la tua integrazione",
    "scenarioIntegration": "Supporto per l'integrazione solo",
    "scenarioIntegrationDesc": "Vuoi concentrarti su cultura, lingua e sviluppo della carriera",
    "scenarioPreImmigration": "Sto pianificando di trasferirmi all'estero",
    "scenarioPreImmigrationDesc": "Sei ancora nel tuo paese d'origine e stai pianificando il tuo trasferimento internazionale",
    "scenarioRelocation": "Supporto per il trasferimento solo",
    "scenarioRelocationDesc": "Hai bisogno di aiuto con gli aspetti logistici del trasferimento: visto, alloggio, legale",
    "successTitle": "Viaggio configurato! 🎉",
    "successToast": "Viaggio configurato con successo!",
    "title": "Costruttore di percorsi",
    "mobile": {
      "stepOf": "Crea il tuo viaggio · {{current}} di {{total}}",
      "create": "Crea il mio viaggio",
      "sameCountry": "Scegli il paese che lasci: non può essere la tua destinazione.",
      "createFailed": "Non siamo riusciti a creare il tuo viaggio. Controlla la connessione e riprova.",
      "gateBody": "Tre domande e il tuo viaggio è pronto, direttamente sul tuo telefono.",
      "adviceFailed": "Non siamo riusciti a controllare i tuoi percorsi su questa rotta. Riprova."
    }
  },
  "language": {
    "languages": {
      "de": "Deutsch",
      "en": "Inglese",
      "es": "Español",
      "fr": "Français",
      "it": "Italiano",
      "pt": "Português"
    }
  },
  "legal": {
    "privacy": {
      "changes": {
        "content": "Potremmo aggiornare questa Informativa sulla Privacy di tanto in tanto. Ti informeremo di eventuali modifiche pubblicando la nuova politica su questa pagina.",
        "title": "10. Modifiche a questa politica"
      },
      "children": {
        "content": "Il nostro Servizio non è destinato ai bambini di età inferiore ai 16 anni. Non raccogliamo consapevolmente dati personali da bambini di età inferiore ai 16 anni.",
        "title": "9. Privacy dei bambini"
      },
      "collect": {
        "account": "Informazioni sull'account (nome, email, numero di telefono)",
        "assessment": "Risposte alle valutazioni e dati di progresso",
        "documents": "Documenti caricati nel nostro servizio Vault",
        "intro": "Raccogliamo informazioni che ci fornisci direttamente, inclusi:",
        "location": "Dati di posizione (paese attuale, paese di destinazione)",
        "profile": "Informazioni sul profilo (professione, istruzione, competenze)",
        "title": "1. Informazioni che raccogliamo"
      },
      "contact": {
        "content": "Per domande su questa Politica sulla Privacy o per esercitare i tuoi diritti sui dati, contatta il nostro Responsabile della Protezione dei Dati a",
        "title": "11. Contattaci"
      },
      "cookies": {
        "content": "Utilizziamo cookie e tecnologie simili per migliorare la tua esperienza, analizzare i modelli di utilizzo e fornire contenuti personalizzati. Puoi gestire le preferenze sui cookie tramite le impostazioni del tuo browser.",
        "title": "7. Cookie e tracciamento"
      },
      "international": {
        "content": "Le tue informazioni possono essere trasferite e trattate in paesi diversi da quello di residenza. Garantiamo che siano in atto misure di protezione appropriate per proteggere i tuoi dati in conformità con questa Politica sulla Privacy.",
        "title": "8. Trasferimenti internazionali di dati"
      },
      "lastUpdated": "Ultimo aggiornamento: {{date}}",
      "retention": {
        "content": "Conserviamo i tuoi dati personali finché il tuo account è attivo o finché necessario per fornirti servizi. Puoi richiedere la cancellazione dei tuoi dati in qualsiasi momento contattandoci.",
        "title": "5. Conservazione dei dati"
      },
      "rights": {
        "access": "Accedi ai tuoi dati personali",
        "correct": "Correggi dati imprecisi",
        "delete": "Richiedi la cancellazione dei tuoi dati",
        "intro": "Ai sensi delle leggi sulla protezione dei dati applicabili, hai il diritto di:",
        "object": "Opporsi al trattamento dei tuoi dati",
        "portability": "Richiedere la portabilità dei dati",
        "title": "6. I tuoi diritti"
      },
      "security": {
        "content": "Implementiamo misure tecniche e organizzative appropriate per proteggere i tuoi dati personali da accessi non autorizzati, alterazioni, divulgazioni o distruzioni. Tutti i dati sono crittografati in transito e a riposo.",
        "title": "4. Sicurezza dei dati"
      },
      "sharing": {
        "employers": "Con i datori di lavoro che sponsorizzano il tuo viaggio (con il tuo esplicito consenso)",
        "intro": "Potremmo condividere le tue informazioni:",
        "legal": "Quando richiesto dalla legge o per proteggere i nostri diritti",
        "providers": "Con fornitori di servizi che assistono nel funzionamento della nostra piattaforma",
        "title": "3. Condivisione delle informazioni"
      },
      "title": "Informativa sulla privacy",
      "use": {
        "communicate": "Comunicarti informazioni sul progresso del tuo viaggio",
        "intro": "Utilizziamo le informazioni che raccogliamo per:",
        "personalize": "Personalizzare la tua esperienza e le raccomandazioni di viaggio",
        "process": "Elabora le tue valutazioni di iQulture e genera approfondimenti",
        "protect": "Proteggere contro frodi e accessi non autorizzati",
        "provide": "Fornire, mantenere e migliorare il nostro Servizio",
        "title": "2. Come utilizziamo le tue informazioni"
      }
    },
    "terms": {
      "acceptance": {
        "content": "Accedendo e utilizzando la Piattaforma Tonnie (\"Servizio\"), accetti di essere vincolato da questi Termini di Servizio (\"Termini\"). Se non accetti questi Termini, ti preghiamo di non utilizzare il Servizio.",
        "title": "1. Accettazione dei termini"
      },
      "accounts": {
        "content": "Per utilizzare alcune funzionalità del Servizio, devi creare un account. Sei responsabile della riservatezza delle credenziali del tuo account e di tutte le attività che si verificano sotto il tuo account.",
        "title": "3. Account utente"
      },
      "changes": {
        "content": "Ci riserviamo il diritto di modificare questi Termini in qualsiasi momento. Ti informeremo di eventuali modifiche pubblicando i nuovi Termini su questa pagina e aggiornando la data di \"Ultimo aggiornamento\".",
        "title": "8. Modifiche ai termini"
      },
      "contact": {
        "content": "Se hai domande su questi Termini, ti preghiamo di contattarci a",
        "title": "9. Contatto"
      },
      "ip": {
        "content": "Il Servizio e il suo contenuto originale, funzionalità e caratteristiche sono di proprietà di Tonnie e sono protetti da leggi internazionali sul copyright, marchi e altre leggi sulla proprietà intellettuale.",
        "title": "5. Proprietà intellettuale"
      },
      "lastUpdated": "Ultimo aggiornamento: {{date}}",
      "liability": {
        "content": "In nessun caso Tonnie sarà responsabile per eventuali danni indiretti, incidentali, speciali, consequenziali o punitivi derivanti o relativi all'uso del Servizio.",
        "title": "7. Limitazione di responsabilità"
      },
      "responsibilities": {
        "accurate": "Fornire informazioni accurate e complete",
        "compliance": "Utilizzare il Servizio in conformità con le leggi applicabili",
        "intro": "Accetti di:",
        "noMisuse": "Non abusare o tentare di eludere le funzionalità di sicurezza del Servizio",
        "title": "4. Responsabilità degli utenti",
        "upToDate": "Tenere aggiornate le informazioni del tuo account"
      },
      "serviceDesc": {
        "care": "Care — Supporto al benessere",
        "checkup": "CheckUp — Valutazioni di prontezza",
        "content": "Tonnie fornisce una piattaforma globale di mobilità dei talenti che assiste gli individui (\"Talenti\") con il trasferimento internazionale e aiuta le aziende (\"Datori di lavoro\") a gestire programmi globali per i talenti. Il Servizio include:",
        "passport": "Passport — Monitoraggio dei progressi e verifica",
        "qultureup": "QultureUp — Moduli di apprendimento culturale",
        "teleportal": "TelePortal — Gestione delle attività di trasferimento",
        "title": "2. Descrizione del servizio"
      },
      "termination": {
        "content": "Possiamo terminare o sospendere il tuo account e l'accesso al Servizio immediatamente, senza preavviso, per comportamenti che riteniamo violino questi Termini o siano dannosi per altri utenti, noi o terzi.",
        "title": "6. Risoluzione"
      },
      "title": "Termini di servizio"
    }
  },
  "mission": {
    "almostThere": "Quasi ci siamo!",
    "answerPlaceholder": "Scrivi la tua risposta qui...",
    "complete": "Completa missione",
    "completeToEarn": "Completa per guadagnare",
    "completedBadge": "Completato!",
    "completedSuccess": "Missione completata!",
    "correct": "Corretto",
    "correctOf": "{{correct}} di {{total}} corretti",
    "exitForNow": "Esci per ora",
    "milesEarnedLabel": "Miles guadagnate",
    "milesHint": "Miles tiene traccia dei tuoi progressi nell'apprendimento culturale in QultureUp",
    "needToPass": "Hai bisogno del 75% per superare. Rivedi il contenuto e riprova.",
    "next": "Avanti",
    "notFound": "Missione non trovata",
    "notPassed": "Non superato",
    "passed": "Superato",
    "perfectScoreBonus": "Bonus punteggio perfetto",
    "previous": "Precedente",
    "progressWarning": "Perderai i tuoi progressi. Sei sicuro?",
    "progressWarningTitle": "Lasciare la missione?",
    "questionBreakdown": "Analisi delle domande",
    "quizResults": "Risultati del quiz",
    "review": "Revisione",
    "reviewAndTryAgain": "Rivedi & riprova",
    "startMission": "Inizia missione",
    "watchVideo": "Guarda il video",
    "scrollToContinue": "Scorri fino alla fine per continuare",
    "startQuiz": "Inizia quiz",
    "submit": "Invia",
    "submitAnyway": "Invia comunque",
    "submitError": "Impossibile inviare il quiz. Per favore riprova.",
    "tipReread": "Suggerimento: Rileggi il contenuto",
    "tipRereadDetail": "Fai attenzione alle sezioni che hai perso. Le domande del quiz provengono direttamente dal materiale della lezione.",
    "title": "Missione",
    "unansweredTitle": "Domande senza risposta",
    "whatYoullLearn": "Cosa imparerai",
    "wrong": "Sbagliato",
    "lockedError": "Questa missione è ancora bloccata. Completa prima le missioni precedenti.",
    "milesEarned_one": "+{{count}} Mile",
    "milesEarned_other": "+{{count}} Miles",
    "questionsCount_one": "{{count}} domanda",
    "questionsCount_other": "{{count}} domande",
    "unansweredMessage_one": "Hai {{count}} domanda senza risposta. Inviare comunque?",
    "unansweredMessage_other": "Hai {{count}} domande senza risposta. Inviare comunque?"
  },
  "nav": {
    "billing": "Fatturazione",
    "care": "Care",
    "career": "Career",
    "checkup": "CheckUp",
    "family": "Famiglia",
    "home": "Home",
    "passport": "Passport",
    "profile": "Profilo",
    "qultureup": "QultureUp",
    "settings": "Impostazioni",
    "teleportal": "TelePortal",
    "testit": "TestIt",
    "userMenu": {
      "billing": "Fatturazione",
      "loggingOut": "Disconnessione in corso…",
      "logout": "Esci",
      "openMenu": "Apri menu utente",
      "preferences": "Preferenze",
      "profile": "Profilo",
      "howItWorks": "Come funziona Tonnie"
    },
    "vault": "Vault"
  },
  "notFound": {
    "description": "La pagina che stai cercando non esiste o è stata spostata.",
    "goBack": "Torna indietro",
    "goHome": "Vai a home",
    "message": "La pagina che stai cercando non esiste.",
    "title": "Pagina non trovata"
  },
  "inbox": {
    "title": "Posta in arrivo",
    "subtitle": "Tutti i messaggi che ti sono stati inviati — via email e nell'app — in un unico posto.",
    "tabInbox": "Posta in arrivo",
    "tabUnread": "Da leggere",
    "tabArchived": "Archiviati",
    "unreadCount_one": "{{count}} messaggio da leggere",
    "unreadCount_other": "{{count}} messaggi da leggere",
    "unreadLabel": "Da leggere",
    "emptyInbox": "Ancora nessun messaggio.",
    "emptyUnread": "Hai letto tutto.",
    "emptyArchived": "Nessun messaggio archiviato.",
    "loadError": "Non siamo riusciti a caricare i tuoi messaggi.",
    "retry": "Riprova",
    "loadMore": "Carica altri",
    "archive": "Archivia",
    "restore": "Sposta in posta in arrivo",
    "back": "Torna ai messaggi",
    "fromPlatform": "Tonnie",
    "channelEmail": "Email",
    "channelInApp": "Nell'app",
    "channelPush": "Notifica push",
    "notRetainedTitle": "Contenuto non conservato",
    "notRetainedBody": "Questa email è stata inviata prima che Tonnie conservasse una copia dei messaggi che invia, quindi il suo testo non può essere mostrato qui.",
    "openAction": "Apri",
    "selectPrompt": "Seleziona un messaggio per leggerlo.",
    "actionError": "Non ha funzionato. Riprova.",
    "sentAt": "Inviato il {{date}}",
    "openFromBell": "Apri la posta in arrivo",
    "markAllRead": "Segna tutto come letto",
    "markAllReadDone": "Tutti i messaggi sono stati segnati come letti",
    "allCaughtUp": "Nessun messaggio da leggere",
    "archived": "Messaggio archiviato",
    "restored": "Spostato in posta in arrivo",
    "undo": "Annulla",
    "markUnread": "Segna come da leggere",
    "markRead": "Segna come letto",
    "markedUnread": "Segnato come da leggere",
    "markedRead": "Segnato come letto",
    "groupToday": "Oggi",
    "groupYesterday": "Ieri",
    "groupThisWeek": "Questa settimana",
    "groupEarlier": "Meno recenti",
    "selectTitle": "Nessun messaggio selezionato",
    "emptyInboxHint": "Qui compariranno le email e i messaggi nell’app di Tonnie e delle aziende con cui collabori.",
    "emptyUnreadHint": "I nuovi messaggi compariranno qui appena arrivano.",
    "emptyArchivedHint": "I messaggi che archivi restano qui e puoi riportarli in posta in arrivo in qualsiasi momento.",
    "loadErrorHint": "Controlla la connessione e riprova.",
    "loading": "Caricamento dei messaggi",
    "readerLabel": "Messaggio",
    "messageNotFound": "Questo messaggio non è qui",
    "messageNotFoundHint": "Potrebbe essere stato eliminato o inviato a un altro account.",
    "notRetainedPreview": "Il testo di questa email non è stato conservato.",
    "opensInNewTab": "(si apre in una nuova scheda)",
    "viewArchived": "Vedi archiviati",
    "invitationsSection": "Inviti · {{count}}",
    "invitationsWaiting_one": "{{count}} invito in attesa della tua risposta",
    "invitationsWaiting_other": "{{count}} inviti in attesa della tua risposta"
  },
  "notifications": {
    "care": {
      "checkpointOverdueTitle": "Il tuo check-in è in attesa",
      "coachingAssignedTitle": {
        "encourage": "Assegnato a te: inviare un incoraggiamento",
        "challenge": "Assegnato a te: lanciare una nuova sfida",
        "checkin": "Assegnato a te: chiedere come sta",
        "celebrate": "Assegnato a te: festeggiare i progressi",
        "remind": "Assegnato a te: inviare un promemoria amichevole"
      },
      "coachingTouchTitle": {
        "encourage": "Il tuo team ti ha inviato un incoraggiamento",
        "challenge": "Il tuo team ti ha lanciato una nuova sfida",
        "checkin": "Il tuo team vuole sapere come stai",
        "celebrate": "Il tuo team sta festeggiando i tuoi progressi",
        "remind": "Un promemoria amichevole dal tuo team"
      },
      "checkpointOverdueBody": "Un check-in di Care è scaduto — ci vogliono solo circa 3 minuti. Apri Care per completarlo.",
      "interactionAssignedBody": "Ti è stata assegnata un’interazione Care.",
      "interventionTouchBody": "Il tuo team sponsor ha programmato un supporto per te. Apri Care per vedere di più.",
      "objectiveFeedbackCycleOpenTitle": "Nuovo ciclo di feedback",
      "objectiveFeedbackCycleOpenBody": "Il tuo team condividerà presto il suo feedback — poi potrai aggiungere la tua autovalutazione. Apri Care per vedere i tuoi obiettivi.",
      "objectiveFeedbackDueTitle": "Feedback richiesto",
      "objectiveFeedbackDueBody": "È il momento di condividere il tuo feedback sugli obiettivi di questo ciclo. Apri Care per darlo.",
      "objectiveFeedbackReceivedTitle": "Nuovo feedback ricevuto",
      "objectiveFeedbackReceivedBody": "Il tuo team ha condiviso feedback sui tuoi obiettivi. Apri Care per esaminarlo e aggiungere la tua autovalutazione."
    },
    "checkup": {
      "scoreReadyBody": "{{score}}: scopri cosa significa, pilastro per pilastro.",
      "scoreReadyTitle": "Punteggio iQulture pronto"
    },
    "billing": {
      "actionRequiredBody": "La tua banca richiede l’autorizzazione di questo pagamento. Apri Fatturazione per completarlo.",
      "actionRequiredTitle": "Conferma il pagamento",
      "paymentFailedBody": "Non è stato possibile elaborare il pagamento. Aggiorna il metodo di pagamento per mantenere l'accesso.",
      "paymentFailedTitle": "Pagamento non riuscito"
    },
    "testit": {
      "reminderBody": "Completa il tuo TestIt così l'azienda che ti valuta può vedere i tuoi risultati.",
      "reminderTitle": "Il tuo TestIt è in attesa"
    },
    "justNow": "Appena adesso",
    "bellLabel_one": "Notifiche, {{count}} non letta",
    "bellLabel_other": "Notifiche, {{count}} non lette",
    "title": "Notifiche",
    "moreActions": "Altre azioni",
    "tabAll": "Tutte",
    "markReadAction": "Segna come letta",
    "unsubscribe": {
      "confirmBody": "Smetteremo di inviare email di «{{category}}» a {{email}}.",
      "confirmCta": "Annulla iscrizione",
      "confirmTitle": "Annullare l’iscrizione a queste email?",
      "confirming": "Annullamento…",
      "doneBody": "Non riceverai più email di «{{category}}».",
      "doneTitle": "Iscrizione annullata",
      "failed": "Operazione non riuscita. Riprova.",
      "invalidBody": "Potrebbe essere già stato usato, o l’account a cui apparteneva è stato chiuso. Non è stato modificato nulla.",
      "invalidTitle": "Questo link non è più valido",
      "loading": "Verifica del link…",
      "malformedBody": "Il link per annullare l'iscrizione sembra troncato. Alcune app di posta tagliano i link lunghi: prova ad aprire il messaggio in un browser oppure usa il pulsante Annulla iscrizione che la tua app di posta mostra in cima al messaggio.",
      "malformedTitle": "Questo link è incompleto",
      "stillReceive": "Le email essenziali dell’account — reimpostazioni della password e avvisi di sicurezza — continueranno ad arrivarti."
    },
    "showMore": "Mostra altro",
    "showLess": "Mostra meno",
    "journey": {
      "relationshipMovedTitle": "Percorsi aggiornati",
      "relationshipMovedBody": "{{company}} ora ti segue su un percorso dedicato, sulla stessa rotta. Lo trovi in I miei percorsi."
    },
    "bellLabelNeedsYou_one": "Notifiche, {{count}} in attesa, incluso un invito",
    "bellLabelNeedsYou_other": "Notifiche, {{count}} in attesa, inclusi inviti",
    "tabInvitations": "Inviti",
    "company": {
      "programmeLeftTitle": "Talento uscito dal programma",
      "programmeLeftBody": "La scheda di {{name}} è ora nella sezione Archiviato del tuo Pipeline e non vedi più ciò che ha condiviso.",
      "programmeLeftSponsoredBody": "{{name}} non condivide più nulla con te. La tua sponsorizzazione continua fino al {{date}}, fine del periodo pagato.",
      "programmeLeftSponsoredOpenEndedBody": "{{name}} non condivide più nulla con te. La tua sponsorizzazione continua fino alla fine del periodo pagato.",
      "shareRequestDeclinedTitle": "Richiesta rifiutata",
      "shareRequestDeclinedBody": "{{name}} ha rifiutato. Non è cambiato nulla: vedi ciò che aveva già condiviso con te. Puoi chiederlo di nuovo dalla sua scheda.",
      "testitCompletedTitle": "Test richiesti completati",
      "testitCompletedBody": "{{name}} ha completato i test richiesti. Apri la sua scheda nel tuo Pipeline per esaminarli e registrare la tua decisione.",
      "sponsorshipAcceptedTitle": "Sponsorizzazione accettata",
      "sponsorshipAcceptedBody": "{{name}} ha accettato. La sua scheda è ora nella colonna Sponsorizzato del tuo Pipeline, dove puoi seguirne i progressi.",
      "sponsorshipDeclinedTitle": "Sponsorizzazione rifiutata",
      "sponsorshipDeclinedBody": "{{name}} ha rifiutato. Ciò che hai pagato viene rimborsato automaticamente. Puoi fare una nuova offerta dalla sua scheda.",
      "nudgeDigestTitle": "In attesa del tuo team",
      "nudgeDigestBody": "In attesa di te: {{count}}. Inviti mai inviati o respinti e offerte di sponsorizzazione senza risposta: solo il tuo team li sblocca."
    }
  },
  "onboarding": {
    "completed": "Completa l'onboarding",
    "education": {
      "addEducation": "Aggiungi istruzione",
      "bachelor": "Laurea triennale",
      "degree": "Laurea",
      "description": "Aggiungi il tuo background educativo",
      "emptyDescription": "Aggiungi la tua storia educativa per aiutarci a comprendere meglio il tuo background e le tue qualifiche.",
      "emptyTitle": "Nessuna voce di istruzione ancora",
      "entry": "Voce di istruzione",
      "field": "Campo di studio",
      "fieldPlaceholder": "es. Informatica",
      "graduationYear": "Anno di laurea",
      "institution": "Istituzione",
      "institutionPlaceholder": "Nome dell'università",
      "master": "Laurea magistrale",
      "phd": "Dottorato",
      "selectDegree": "Seleziona il tipo di laurea",
      "title": "Storia educativa"
    },
    "experience": {
      "addExperience": "Aggiungi esperienza",
      "company": "Azienda",
      "companyPlaceholder": "Nome dell'azienda",
      "current": "Attuale",
      "currentJob": "Lascia vuoto se attuale",
      "description": "Descrizione",
      "descriptionPlaceholder": "Descrivi il tuo ruolo e i tuoi successi...",
      "emptyDescription": "Aggiungi la tua esperienza lavorativa per mostrare il tuo background professionale e le tue competenze.",
      "emptyTitle": "Nessuna esperienza lavorativa ancora",
      "endDate": "Data di fine",
      "endDateHint": "Lascia vuoto se questa è la tua posizione attuale",
      "entry": "Voce di esperienza",
      "locationCity": "Città",
      "locationCityPlaceholder": "es. San Francisco",
      "locationCountry": "Paese",
      "locationCountryPlaceholder": "Seleziona paese",
      "role": "Ruolo / Titolo",
      "rolePlaceholder": "Titolo di lavoro",
      "startDate": "Data di inizio",
      "title": "Esperienza lavorativa"
    },
    "family": {
      "childrenCount": "Numero di figli",
      "description": "Parlaci del tuo nucleo familiare",
      "familyProgramHint": "Puoi impostare il Programma Familiare in seguito per invitare i membri della famiglia nel tuo percorso",
      "hasChildren": "Ho figli",
      "hasPartner": "Ho un partner/coniuge",
      "hasPets": "Ho animali domestici",
      "householdInfo": "Informazioni sul nucleo familiare",
      "householdInfoDesc": "Questo ci aiuta a personalizzare i tuoi checkpoint di TelePortal e Care",
      "title": "Configurazione familiare"
    },
    "fieldFilledFromImport": "Compilato dal profilo importato",
    "fieldImportHint": "Importa profilo per precompilare questo campo",
    "languages": {
      "addLanguage": "Aggiungi lingua",
      "advanced": "Avanzato",
      "beginner": "Principiante",
      "description": "Parlaci delle tue competenze linguistiche",
      "elementary": "Elementare",
      "emptyDescription": "Aggiungi le lingue che parli per aiutarci a valutare la tua prontezza comunicativa.",
      "emptyTitle": "Nessuna lingua aggiunta ancora",
      "entry": "Lingua",
      "intermediate": "Intermedio",
      "language": "Lingua",
      "level": "Livello di competenza",
      "native": "Madrelingua",
      "proficient": "Competente",
      "selectLanguage": "Seleziona una lingua",
      "selectLevel": "Seleziona il livello di competenza",
      "title": "Lingue",
      "upperIntermediate": "Superiore Intermedio"
    },
    "linkedin": {
      "dropPdfSubtitle": "o clicca per sfogliare",
      "dropPdfTitle": "Trascina qui il tuo PDF del Profilo LinkedIn",
      "fileTooLarge": "Il file è troppo grande. La dimensione massima è di 10 MB.",
      "invalidFileType": "Tipo di file non supportato. Si prega di caricare un PDF, un documento Word o un file di testo.",
      "parseFailed": "Impossibile estrarre dati dal documento. Si prega di provare un file diverso.",
      "pdfInstructions": {
        "step1": "Vai su LinkedIn e accedi",
        "step2": "Naviga su Impostazioni e Privacy → Privacy dei Dati → Ottieni una copia dei tuoi dati",
        "step3": "Seleziona 'Profilo' e scarica come PDF",
        "step4": "Carica il file PDF qui sotto",
        "title": "Come ottenere il tuo PDF del Profilo LinkedIn"
      },
      "pdfUploadError": "Impossibile caricare il PDF. Si prega di riprovare.",
      "selectPdfFile": "Seleziona file PDF",
      "uploadDifferentFile": "Carica file diverso",
      "uploading": "Caricamento...",
      "wizard": {
        "compliance": {
          "description": "I tuoi dati rimangono privati. Leggiamo solo il documento che carichi — nulla viene memorizzato o condiviso senza il tuo consenso.",
          "title": "Conforme al GDPR e a LinkedIn"
        },
        "confirmAndContinue": "Conferma e continua",
        "getStarted": "Inizia",
        "guide": {
          "cv": {
            "subtitle": "Alcuni consigli per ottenere i migliori risultati dal tuo CV",
            "tip1": {
              "description": "Carica il tuo CV più aggiornato per il miglior import del profilo.",
              "title": "Usa una versione recente"
            },
            "tip2": {
              "description": "I CV con sezioni chiare (Esperienza, Istruzione, Competenze) danno i migliori risultati di estrazione.",
              "title": "I formati strutturati funzionano meglio"
            },
            "tip3": {
              "description": "Accettiamo file PDF, DOCX, DOC e TXT fino a 10 MB.",
              "title": "Formati supportati"
            },
            "title": "Consigli per il caricamento del tuo CV"
          },
          "linkedin": {
            "openLinkedIn": "Apri LinkedIn",
            "step1": {
              "description": "Vai su linkedin.com, accedi e naviga alla tua pagina profilo.",
              "title": "Apri il tuo profilo"
            },
            "step2": {
              "description": "Nella tua pagina profilo, clicca sul pulsante \"Altro\" sotto il tuo titolo, poi seleziona \"Salva come PDF\".",
              "title": "Clicca su \"Altro\" poi \"Salva come PDF\""
            },
            "step3": {
              "description": "LinkedIn genererà un PDF. Salvalo sul tuo computer — lo caricherai nel passaggio successivo.",
              "title": "Scarica il file"
            },
            "subtitle": "Segui questi 3 semplici passaggi per scaricare il tuo profilo",
            "tip": "Il PDF viene generato istantaneamente dalla tua pagina profilo. Non è necessario richiedere un'esportazione dei dati.",
            "title": "Come ottenere il tuo PDF di LinkedIn"
          }
        },
        "processing": {
          "analyzing": "Analizzando con AI",
          "extracting": "Estraendo contenuto testuale",
          "structuring": "Strutturando i tuoi dati",
          "subtitle": "Attendere mentre analizziamo il tuo documento...",
          "title": "Estraendo il tuo profilo",
          "uploading": "Caricamento documento"
        },
        "progress": "Progresso",
        "readyToUpload": "Sono pronto per caricare",
        "review": {
          "at": "a",
          "editHint": "Puoi modificare tutti i dettagli nei prossimi passaggi di onboarding.",
          "fieldCertifications": "Certificazioni",
          "fieldEducation": "Istruzione",
          "fieldExperience": "Esperienza lavorativa",
          "fieldHeadline": "Titolo professionale",
          "fieldLanguages": "Lingue",
          "fieldNames": "Nome",
          "fieldSkills": "Competenze",
          "fieldWebsites": "Siti web e link",
          "noDataFound": "Nessun dato è stato estratto. Assicurati che il file sia un documento di profilo valido (PDF, DOCX o TXT).",
          "present": "Attuale",
          "previewDescription": "I seguenti campi saranno precompilati nel tuo profilo Tonnie:",
          "subtitle": "Abbiamo trovato le seguenti informazioni nel tuo documento. Rivedile e conferma per continuare.",
          "title": "Il tuo profilo estratto",
          "entries_one": "{{count}} voce",
          "entries_other": "{{count}} voci",
          "languagesCount_one": "{{count}} lingua",
          "languagesCount_other": "{{count}} lingue",
          "positions_one": "{{count}} posizione",
          "positions_other": "{{count}} posizioni",
          "skillsCount_one": "{{count}} competenza",
          "skillsCount_other": "{{count}} competenze",
          "summaryStats_one": "{{count}} campo estratto dal tuo documento",
          "summaryStats_other": "{{count}} campi estratti dal tuo documento"
        },
        "reviewData": "Rivedi dati",
        "source": {
          "cvCard": {
            "description": "Carica il tuo CV o curriculum esistente in formato PDF, DOCX o TXT. Funziona con qualsiasi layout.",
            "title": "CV / Curriculum personale"
          },
          "linkedinCard": {
            "description": "Scarica il tuo profilo da LinkedIn e carica il PDF. Ideale per dati accurati e strutturati.",
            "tag": "Consigliato",
            "title": "PDF profilo LinkedIn"
          },
          "subtitle": "Scegli come desideri importare il tuo profilo professionale. Estrarremo automaticamente la tua esperienza, istruzione e competenze.",
          "title": "Importa il tuo profilo"
        },
        "steps": {
          "guide": "Guida",
          "processing": "Elaborazione",
          "review": "Revisione",
          "source": "Fonte",
          "upload": "Carica"
        },
        "success": {
          "description": "I tuoi dati sono stati importati. Ora puoi generare CV professionali e gestire più versioni.",
          "title": "Profilo importato con successo!"
        },
        "upload": {
          "subtitle": "Trascina e rilascia il tuo file o clicca per sfogliare. Accettiamo file PDF, DOCX e TXT.",
          "title": "Carica il tuo documento"
        },
        "aria": {
          "progress": "Progresso mago"
        }
      }
    },
    "linkedinBound": "Profilo importato",
    "linkedinConnectionError": "Impossibile importare il profilo. Riprova.",
    "location": {
      "currentCountry": "Paese attuale",
      "description": "Dove sei ora e dove vuoi andare?",
      "goal": "Il tuo obiettivo",
      "goalHint": "Questo ci aiuta a personalizzare il tuo percorso",
      "goalPlaceholder": "Parlaci dei tuoi obiettivi e aspettative di trasferimento...",
      "selectCountry": "Seleziona un paese",
      "targetCountry": "Paese target",
      "title": "Posizione & obiettivi"
    },
    "mobility": {
      "citizenship": "Paesi di cittadinanza",
      "citizenshipHint": "Seleziona tutti i paesi in cui possiedi la cittadinanza",
      "description": "Parlaci dei tuoi interessi riguardo la cittadinanza e il trasferimento",
      "selectCitizenship": "Seleziona un paese...",
      "removeCitizenship": "Rimuovi {{country}}",
      "title": "Mobilità",
      "validPassport": "Hai un passaporto valido?",
      "validPassportHint": "I dettagli di Passport saranno gestiti in TelePortal"
    },
    "personalInfo": {
      "addAddress": "Aggiungi indirizzo",
      "addWebsiteUrl": "Aggiungi URL sito web",
      "address": "Indirizzo",
      "addressDetails": "Dettagli indirizzo",
      "addressDetailsError": "Impossibile ottenere i dettagli dell'indirizzo. Riprova.",
      "addressHint": "Seleziona il tuo indirizzo dalle suggerimenti",
      "addressInitError": "Impossibile inizializzare la ricerca dell'indirizzo. Riprova.",
      "addressInvalid": "Dati dell'indirizzo non validi. Prova a selezionare un altro indirizzo.",
      "addressLoadError": "Impossibile caricare la ricerca dell'indirizzo. Ricarica la pagina.",
      "addressPlaceholder": "Inizia a digitare il tuo indirizzo...",
      "addressSearchError": "Impossibile cercare indirizzi. Riprova.",
      "addressSelected": "Indirizzo selezionato",
      "addressSuggestions": "Suggerimenti per l'indirizzo",
      "avatarFileSizeError": "La dimensione del file deve essere inferiore a 5MB",
      "avatarFileTypeError": "Carica un file immagine valido (JPG, PNG, GIF o WEBP)",
      "avatarRemoved": "Foto rimossa con successo!",
      "avatarUploadFailed": "Caricamento avatar fallito",
      "avatarUploaded": "Foto caricata con successo!",
      "changePhoto": "Cambia foto",
      "city": "Città",
      "clickEditToAdd": "Clicca su Modifica per aggiungere il tuo indirizzo",
      "clickToUpload": "Clicca per caricare",
      "complement": "Complemento",
      "complementPlaceholder": "Appartamento, suite, unità, ecc.",
      "country": "Paese",
      "dateOfBirth": "Data di nascita",
      "description": "Parlaci di te",
      "firstName": "Nome",
      "firstNamePlaceholder": "Inserisci il tuo nome",
      "lastName": "Cognome",
      "lastNamePlaceholder": "Inserisci il tuo cognome",
      "linkedinConnected": "Dati del profilo importati da LinkedIn",
      "loadingAddressDetails": "Caricamento dettagli dell'indirizzo...",
      "noAddress": "Nessun indirizzo aggiunto ancora",
      "phone": "Numero di telefono",
      "phoneHint": "Lo useremo per contattarti riguardo al tuo viaggio",
      "phonePlaceholder": "Inserisci il tuo numero di telefono",
      "photoFileTypes": "JPG, PNG, GIF o WEBP. Max 5MB.",
      "photoInstructions": "Aggiungi una foto professionale per personalizzare il tuo profilo. Questo aiuta reclutatori e aziende a riconoscerti.",
      "profilePhoto": "Foto del profilo",
      "removePhoto": "Rimuovi foto",
      "searchAddress": "Cerca indirizzo",
      "searchAddressDescription": "Digita il tuo indirizzo e seleziona dai suggerimenti di Google Places",
      "state": "Stato/Provincia",
      "street": "Via",
      "title": "Informazioni personali",
      "uploadPhoto": "Carica foto",
      "websiteLabelPlaceholder": "Etichetta personalizzata (es. Il mio Blog)",
      "websiteType": {
        "blog": "Blog",
        "facebook": "Facebook",
        "github": "GitHub",
        "gitlab": "GitLab",
        "instagram": "Instagram",
        "linkedin": "LinkedIn",
        "other": "Altro",
        "personal": "Personale",
        "portfolio": "Portfolio",
        "twitter": "Twitter / X",
        "website": "Sito web",
        "youtube": "YouTube"
      },
      "websiteUrlPlaceholder": "https://...",
      "websiteUrls": "URL dei siti web e link social",
      "websiteUrlsHint": "Aggiungi il tuo portfolio, sito web personale, GitHub, LinkedIn o altri link professionali",
      "workModel": {
        "flexible": "Flessibile",
        "hybrid": "Ibrido",
        "on-site": "In sede",
        "remote": "Remoto"
      },
      "workModelPreference": "Preferenza del modello di lavoro",
      "workModelPreferenceHint": "Seleziona i modelli di lavoro a cui sei aperto",
      "zipCode": "Codice postale",
      "websiteTypeLabel": "Tipo di link",
      "websiteUrlLabel": "URL del link",
      "websiteCustomLabel": "Etichetta personalizzata",
      "removeWebsiteUrl": "Rimuovi link"
    },
    "professional": {
      "advanced": "Avanzato",
      "beginner": "Principiante",
      "description": "Raccontaci della tua carriera",
      "elementary": "Elementare",
      "englishLevel": "Competenza in inglese",
      "englishLevelHint": "Questo ci aiuta a valutare la tua prontezza",
      "intermediate": "Intermedio",
      "junior": "Junior",
      "mid": "Livello intermedio",
      "proficient": "Competente",
      "role": "Ruolo attuale / Titolo di lavoro",
      "rolePlaceholder": "es. Ingegnere del software",
      "selectEnglishLevel": "Seleziona il tuo livello di inglese",
      "selectSeniority": "Seleziona il tuo livello di seniority",
      "senior": "Senior",
      "seniority": "Livello di seniority",
      "title": "Esperienza professionale",
      "upperIntermediate": "Superiore intermedio"
    },
    "review": {
      "address": "Indirizzo",
      "careerTime": "Tempo Career",
      "certifications": "Certificazioni",
      "countriesOfInterest": "Paesi di interesse",
      "currentRole": "Ruolo corrente",
      "education": "Istruzione",
      "experience": "Esperienza",
      "familyConfig": "Configurazione familiare",
      "hardSkills": "Competenze tecniche",
      "hasChildren": "Ha figli",
      "hasPartner": "Ha partner",
      "hasPets": "Ha animali domestici",
      "mobility": "Mobilità",
      "passport": "Valido Passport",
      "personalInfo": "Informazioni personali",
      "profilePhoto": "Foto del profilo",
      "profilePhotoSet": "La foto profilo è stata impostata",
      "skills": "Competenze e expertise",
      "softSkills": "Competenze trasversali",
      "spokenLanguages": "Lingue parlate",
      "websiteUrls": "URL dei siti web e link social",
      "workModel": "Preferenza del modello di lavoro",
      "years": "anni"
    },
    "saveError": "Impossibile salvare i progressi. Riprova.",
    "saved": "Progressi salvati con successo",
    "skills": {
      "addCertification": "Aggiungi certificazione",
      "addHardSkill": "Aggiungi competenza tecnica",
      "addLanguage": "Aggiungi lingua",
      "addSoftSkill": "Aggiungi competenza trasversale",
      "careerTime": "Tempo Career",
      "certification": "Certificazione",
      "certificationAuthority": "Autorità di emissione",
      "certificationAuthorityPlaceholder": "ad es., Amazon Web Services",
      "certificationExpiryDate": "Data di scadenza",
      "certificationExpiryDatePlaceholder": "Lascia vuoto se non c'è scadenza",
      "certificationIssueDate": "Data di emissione",
      "certificationLicenseNumber": "Numero di licenza",
      "certificationLicenseNumberPlaceholder": "Numero di licenza o certificato (opzionale)",
      "certificationName": "Nome della certificazione",
      "certificationNamePlaceholder": "ad es., AWS Certified Solutions Architect",
      "certificationUrl": "URL del certificato",
      "certificationUrlPlaceholder": "https://...",
      "certifications": "Certificazioni",
      "certificationsHint": "Aggiungi certificazioni e licenze professionali",
      "currentRole": "Ruolo corrente",
      "description": "Parlaci delle tue competenze e esperienze professionali",
      "experienceYears": {
        "0_1": "0-1 anni",
        "11_15": "11-15 anni",
        "16_plus": "16+ anni",
        "2_3": "2-3 anni",
        "4_5": "4-5 anni",
        "6_10": "6-10 anni"
      },
      "hardSkills": "Competenze tecniche",
      "hardSkillsHint": "Aggiungi competenze tecniche e i tuoi anni di esperienza",
      "hardSkillsInfo": "Fornisci almeno 5 delle tue competenze tecniche più forti e il tempo di esperienza.",
      "languageLevels": {
        "A1": "A1 — Principiante",
        "A2": "A2 — Elementare",
        "B1": "B1 — Intermedio",
        "B2": "B2 — Intermedio superiore",
        "C1": "C1 — Avanzato",
        "C2": "C2 — Competente",
        "native": "Madrelingua"
      },
      "languages": "Lingue parlate",
      "languagesHint": "Aggiungi le lingue che conosci e il tuo livello di competenza",
      "languagesInfo": "Importante aggiungere le tue competenze in inglese e nella lingua madre, almeno. Più informi, più opportunità saranno disponibili.",
      "noHardSkillFound": "Nessuna competenza tecnica trovata.",
      "noLanguageFound": "Nessuna lingua trovata.",
      "noRoleFound": "Nessun ruolo trovato.",
      "noSoftSkillFound": "Nessuna competenza trasversale trovata.",
      "searchHardSkill": "Cerca competenze tecniche...",
      "searchLanguage": "Cerca lingue...",
      "searchRole": "Cerca ruoli...",
      "searchSoftSkill": "Cerca competenze trasversali...",
      "selectExperience": "Seleziona esperienza",
      "selectLevel": "Seleziona livello",
      "selectRole": "Seleziona il tuo ruolo...",
      "skillExperience": {
        "0_1": "0-1 anni",
        "11_plus": "11+ anni",
        "2_3": "2-3 anni",
        "4_5": "4-5 anni",
        "6_10": "6-10 anni"
      },
      "softSkillLevels": {
        "advanced": "Avanzato",
        "beginner": "Principiante",
        "expert": "Esperto",
        "intermediate": "Intermedio"
      },
      "softSkills": "Competenze trasversali",
      "softSkillsHint": "Aggiungi competenze trasversali e il tuo livello di competenza",
      "softSkillsInfo": "Fornisci almeno 3 delle tue competenze trasversali più forti.",
      "title": "Autovalutazione delle competenze",
      "levelFor": "Livello di {{name}}",
      "experienceFor": "Esperienza in {{name}}"
    },
    "validation": {
      "address_city_country_required": "Si prega di fornire almeno la propria città e paese",
      "address_city_required": "La città è obbligatoria",
      "address_country_required": "Il paese è obbligatorio",
      "career_experience_required": "Si prega di selezionare la propria esperienza lavorativa",
      "certification_authority_required": "L'autorità di emissione è obbligatoria",
      "certification_name_required": "Il nome della certificazione è obbligatorio",
      "citizenship_required": "Si prega di selezionare almeno una cittadinanza",
      "company_required": "L'azienda è obbligatoria",
      "dateOfBirth_invalid": "Si prega di inserire una data di nascita valida",
      "dateOfBirth_invalid_format": "Formato data non valido",
      "dateOfBirth_min_age": "Devi avere almeno {{minAge}} anni",
      "dateOfBirth_required": "La data di nascita è obbligatoria",
      "degree_required": "Il titolo di studio è obbligatorio",
      "end_date_after_start": "La data di fine deve essere dopo la data di inizio",
      "exp_role_required": "Il ruolo è obbligatorio",
      "field_of_study_required": "Il campo di studio è obbligatorio",
      "firstName_max_length": "Il nome deve avere al massimo 100 caratteri",
      "firstName_min_length": "Il nome deve avere almeno 2 caratteri",
      "firstName_required": "Il nome è obbligatorio",
      "fixErrors": "Si prega di correggere i campi evidenziati prima di continuare.",
      "graduation_year_invalid": "Si prega di inserire un anno di laurea valido",
      "institution_required": "L'istituzione è obbligatoria",
      "lastName_max_length": "Il cognome deve avere al massimo 100 caratteri",
      "lastName_min_length": "Il cognome deve avere almeno 2 caratteri",
      "lastName_required": "Il cognome è obbligatorio",
      "passport_required": "Si prega di indicare se si dispone di un passaporto valido",
      "phone_invalid_characters": "Il numero di telefono contiene caratteri non validi",
      "phone_max_digits": "Il numero di telefono deve avere al massimo {{maxDigits}} cifre",
      "phone_min_digits": "Il numero di telefono deve avere almeno {{minDigits}} cifre",
      "phone_required": "Il numero di telefono è obbligatorio",
      "role_select_required": "Si prega di selezionare il proprio ruolo attuale",
      "start_date_required": "La data di inizio è obbligatoria",
      "url_invalid": "Si prega di inserire un URL valido (es. https://...)",
      "work_model_required": "Si prega di selezionare almeno una preferenza di modello di lavoro"
    }
  },
  "passport": {
    "achievementUnlocked": "🎉 Obiettivo sbloccato: {{name}}!",
    "activeJourneys": "Viaggi attivi",
    "adjustFilters": "Regola i tuoi filtri o completa le attività per vedere eventi",
    "allTime": "Tutto il tempo",
    "badgeMilesReward": "+{{miles}} miglia",
    "badges": "Badge",
    "badgesCount": "{{earned}} di {{total}} badge guadagnati",
    "badgesEarned": "{{earned}} di {{total}} guadagnati",
    "badgesProgress": "Progresso badge",
    "bio": {
      "address": "Indirizzo",
      "citizenLevel": "Livello Citizen",
      "dateOfBirth": "Data di nascita",
      "email": "Email",
      "fullName": "Nome completo",
      "nationality": "Cittadinanza",
      "phone": "Telefono"
    },
    "rarityHeading": "Rarità",
    "citizenBadges": "Citizen badge",
    "citizenBadgesDesc": "Badge speciali guadagnati dimostrando adattamento culturale e completamento del percorso",
    "citizenBadgesSection": "Citizen badge",
    "citizenLevel": {
      "starter": "Inizio"
    },
    "citizenNumber": "Citizen #{{number}}",
    "companyCohort": "Coorte aziendale",
    "completeForBadges": "Completa attività per guadagnare badge cittadini!",
    "coverSubtitle": "Passport",
    "coverTitle": "Citizen",
    "daysOnJourney": "Giorni nel percorso",
    "description": "Il tuo record di percorso",
    "earnBadgesMessage": "Completa valutazioni e lezioni per guadagnare badge!",
    "earned": "Guadagnato",
    "earnedOn": "Guadagnato il",
    "errors": {
      "tryAgain": "Per favore riprova più tardi.",
      "unableToLoad": "Impossibile caricare i dati di Passport"
    },
    "event": {
      "ACHIEVEMENT_EARNED.desc": "Hai guadagnato un traguardo"
    },
    "eventCategory": "Categoria",
    "eventData": "Dati evento",
    "eventDetails": "Dettagli evento",
    "eventType": "Tipo di evento",
    "heroBanner": {
      "levelLabel": "Livello {{level}}",
      "milesToNextLevel": "{{miles}} miglia a {{nextLevel}}",
      "subtitle": "Tieni traccia delle tue timbrature, distintivi e traguardi in ogni eroe del tuo viaggio di rilocazione.",
      "title": "Il tuo viaggio Passport"
    },
    "heroes": "Eroi",
    "identification": "Identificazione",
    "insightCultural": "🌍 L'integrazione culturale è fondamentale",
    "insightCulturalDesc": "Concentrati su QultureUp lezioni per migliorare la tua prontezza all'integrazione.",
    "insightProgress": "🎯 Stai progredendo più velocemente del previsto!",
    "insightProgressDesc": "Il tuo punteggio di prontezza è migliorato di 15 punti nelle ultime 2 settimane.",
    "insightStreak": "📚 Mantieni viva la tua serie di apprendimento",
    "insightStreakDesc": "Sei in una serie di 7 giorni. Un giorno in più per sbloccare un nuovo distintivo!",
    "insights": "Approfondimenti",
    "issued": "Emesso: {{date}}",
    "journeyMiles": "Miles",
    "journeyStamps": "Timbrature di viaggio",
    "journeySummary": "Riepilogo del viaggio",
    "journeyTimeline": "Cronologia del viaggio",
    "journeyTimelineDesc": "Un record dei tuoi traguardi e successi nel viaggio",
    "keepGoingMilestones": "Continua a guadagnare traguardi!",
    "kpiSectionDesc": "Evoluzione complessiva della prontezza e tendenze dei pilastri M/E/S/H",
    "last3Months": "Ultimi 3 mesi",
    "level": "Livello",
    "levelCurrent": "Attuale",
    "levelMilesThreshold": "{{miles}} Miles",
    "levelMilesToReach": "{{miles}} Miles in più per raggiungere questo livello",
    "levelProgress": "Progresso di livello",
    "levels": {
      "ambassador": "Ambasciatore",
      "explorer": "Esploratore",
      "newcomer": "Nuovo arrivato",
      "pioneer": "Pioniere",
      "voyager": "Viaggiatore"
    },
    "levelsCollection": "Livelli di viaggio",
    "levelsCount": "{{achieved}} di {{total}} livelli raggiunti",
    "limitedJourneys": "Viaggi limitati",
    "loading": "Caricamento del tuo passaporto...",
    "locked": "Bloccato",
    "maxLevel": "(Max)",
    "meshPillarTrends": "Tendenze m/E/S/H pillar",
    "miles": "Miles",
    "milesAbbr": "mi",
    "milesThisWeek": "Miles questa settimana",
    "milesToNextLevel": "Miles per il prossimo livello",
    "milesValue": "Valore delle Miles",
    "milestonesAchievements": "Traguardi e risultati",
    "milestonesSection": "Traguardi",
    "mobileApp": {
      "description": "Visualizza il tuo passaporto completo, condividi i tuoi risultati e monitora il progresso del tuo viaggio con l'app mobile.",
      "openApp": "Apri nell'app",
      "title": "Passport su mobile"
    },
    "nextMilestone": "Prossimo: {{name}}",
    "noAchievements": "Nessun risultato ancora",
    "noBadgesYet": "Nessun badge cittadino ancora. Completa le attività di viaggio per guadagnare badge.",
    "noRecentActivity": "Nessuna attività recente. Inizia il tuo viaggio per guadagnare miglia!",
    "noStampsYet": "Nessun timbro ancora",
    "noTimelineYet": "Nessun evento nella cronologia ancora. Completa le attività di viaggio per vedere la tua storia.",
    "notReady": {
      "badges": "Citizen badge",
      "badgesDesc": "Sblocca badge speciali che riconoscono la tua adattamento culturale",
      "miles": "Miles di viaggio",
      "milesDesc": "Accumula miglia mentre progredisci nella tua relocation",
      "progress": "Monitora progresso",
      "progressDesc": "Visualizza la tua cronologia di viaggio completa e i traguardi",
      "stamps": "Colleziona timbri",
      "stampsDesc": "Guadagna timbri completando attività tra tutti gli eroi",
      "startCheckup": "Inizia la valutazione CheckUp",
      "subtitle": "Completa le tue prime attività da eroe per iniziare a collezionare timbri, guadagnare badge e costruire il tuo record di relocation.",
      "title": "Il tuo Passport ti aspetta!"
    },
    "openInApp": "Apri nell'app",
    "overallReadinessEvolution": "Evoluzione della prontezza complessiva",
    "pagePrefix": "P.",
    "percentComplete": "{{percent}}% completato",
    "photo": "Foto",
    "progress": "Progresso",
    "progressLabel": "Progresso",
    "rarity": {
      "common": "Comune",
      "epic": "Epico",
      "legendary": "Leggendario",
      "rare": "Raro",
      "uncommon": "Non comune"
    },
    "readinessScore": "Punteggio di prontezza",
    "recentActivity": "Attività recenti",
    "recentActivityDesc": "Le tue ultime miglia di viaggio guadagnate",
    "returnToDashboard": "Torna alla dashboard",
    "reward": "Ricompensa",
    "searchEvents": "Cerca eventi...",
    "shareAchievement": "Condividi risultato",
    "shareMessage": "Ho guadagnato il timbro {{name}} su Tonnie! +{{miles}} Miles 🏆",
    "since": "Dal",
    "stampArrived": "Arrivato nella destinazione",
    "stampArrivedDesc": "Sei arrivato nel tuo paese di destinazione",
    "stampCultureStarter": "Inizio Cultura",
    "stampCultureStarterDesc": "Hai completato il tuo primo mondo QultureUp",
    "stampCategory": {
      "onboarding": "Primi passi",
      "checkup": "CheckUp",
      "teleportal": "TelePortal",
      "qultureup": "QultureUp",
      "care": "Care",
      "cross_hero": "Tra gli eroi"
    },
    "stampDetail": {
      "earned": "Francobollo guadagnato!",
      "locked": "Non ancora guadagnato",
      "milesReward": "Ricompensa Miles",
      "milesValueUnit": "{{value}} Miles",
      "title": "Dettagli francobollo",
      "source": "Origine: {{category}}"
    },
    "stampFirstCare": "Primo ciclo Care",
    "stampFirstCareDesc": "Hai completato il tuo primo ciclo di feedback Care",
    "stampFirstCheckup": "Primo CheckUp",
    "stampFirstCheckupDesc": "Hai completato la tua prima valutazione di prontezza",
    "stampNotFound": "Francobollo non trovato",
    "stampVisaApproved": "Visto approvato",
    "stampVisaApprovedDesc": "La tua domanda di visto è stata approvata",
    "stamps": "Timbrature",
    "stampsCollection": "Collezione di francobolli",
    "stampsCollectionDesc": "Guadagna francobolli completando risultati durante il tuo viaggio",
    "stampsCount": "{{earned}} di {{total}} francobolli guadagnati",
    "stampsEarned": "Francobolli guadagnati",
    "stampsSection": "Timbrature",
    "status": "Stato",
    "swipeToOpen": "Scorri per aprire",
    "tabs": {
      "levels": "Livelli",
      "overview": "Panoramica",
      "stamps": "Timbrature",
      "timeline": "Tempistica"
    },
    "thisWeek": "Questa settimana",
    "timelineCheckupCompleted": "CheckUp completato",
    "timelineCheckupCompletedDesc": "Il tuo punteggio di prontezza: 85/100",
    "timelineCultureBadge": "Badge inizio cultura guadagnato",
    "timelineCultureBadgeDesc": "Hai completato CheckUp + 5 lezioni culturali",
    "timelineFeedbackChampion": "Campione di feedback",
    "timelineFeedbackChampionDesc": "Hai completato il tuo 3° ciclo di feedback",
    "timelineJourneyStarted": "Viaggio iniziato",
    "timelineJourneyStartedDesc": "Benvenuto nel tuo viaggio internazionale!",
    "timelineLessonsCompleted": "10 lezioni completate",
    "timelineLessonsCompletedDesc": "Hai completato 10 lezioni QultureUp",
    "timelineStreak": "Serie di 7 giorni",
    "timelineStreakDesc": "Hai imparato in modo costante per 7 giorni",
    "timelineVisaDocs": "Documenti per visto caricati",
    "timelineVisaDocsDesc": "Tutti i documenti richiesti verificati e pronti",
    "toNextLevel": "Prossimo livello",
    "tonnieAverage": "Tonnie medio",
    "title": "Passport",
    "totalJourneys": "Viaggi totali",
    "totalMiles": "Miles totali",
    "totalStamps": "Francobolli totali",
    "tryDifferentSearch": "Prova un termine di ricerca diverso",
    "unlocked": "Sbloccato",
    "viewInMobile": "Visualizza in mobile",
    "visibility": "Visibilità",
    "visibleToCompany": "Azienda",
    "visibleToTalent": "Talento",
    "visibleToTonnie": "Tonnie",
    "vsCompanyCohort": "vs coorte aziendale",
    "vsSelfHistory": "vs storia personale",
    "vsTonnieDatabase": "vs database Tonnie",
    "welcome": {
      "badgesStep": "Citizen badge",
      "badgesStepDesc": "Sblocca badge che riconoscono la tua adattamento culturale",
      "description": "Il tuo Passport è il tuo record di trasferimento. Completa attività da eroe per iniziare a collezionare timbri, guadagnare badge e tracciare le tappe del tuo viaggio.",
      "hint": "Completa il tuo primo CheckUp per iniziare a collezionare timbri",
      "progressStep": "Traccia il tuo viaggio",
      "progressStepDesc": "Visualizza la tua cronologia completa, traguardi e miglia",
      "stampsStep": "Colleziona timbri",
      "stampsStepDesc": "Guadagna timbri completando attività tra tutti gli eroi",
      "startJourney": "Inizia il tuo viaggio",
      "title": "Il tuo Passport ti aspetta"
    },
    "yourScore": "Il tuo punteggio"
  },
  "payment": {
    "addPaymentMethod": "Aggiungi metodo di pagamento",
    "amount": "Importo",
    "basePrice": "Prezzo base",
    "cancelFamilyAddon": "Annulla add-on familiare",
    "cancelFamilyAddonDesc": "Sei sicuro di voler annullare il tuo Add-on Familiare? Mantieni l'accesso fino alla fine del tuo periodo di fatturazione.",
    "cancelFamilyAddonWarning": "Dopo l'annullamento, perderai l'accesso alle funzionalità del Programma Familiare alla fine del tuo periodo di fatturazione.",
    "cardEnding": "Carta che termina in {{last4}}",
    "cardExpires": "Scade {{month}}/{{year}}",
    "checkoutCancelled": "Checkout annullato",
    "checkoutError": "Impossibile avviare il checkout. Riprova.",
    "checkoutSuccess": "Pagamento riuscito! Elaborazione del tuo ordine...",
    "citizenOnly": "Solo Citizen",
    "confirmAndPay": "Conferma & paga",
    "coupon": {
      "apply": "Applica",
      "applied": "{{code}} · {{percent}}% di sconto applicato",
      "applyOrClear": "Applica il coupon per utilizzarlo, oppure cancellalo per continuare senza.",
      "invalid": "Questo codice coupon non è valido.",
      "label": "Hai un coupon?",
      "placeholder": "Inserisci il codice",
      "remove": "Rimuovi",
      "errors": {
        "notFound": "Questo codice coupon non esiste. Controllalo e riprova.",
        "expired": "Questo coupon è scaduto o non è ancora attivo.",
        "disabled": "Questo coupon non è più disponibile.",
        "exhausted": "Questo coupon ha raggiunto il limite di utilizzi e non può essere usato di nuovo.",
        "wrongProduct": "Questo coupon non può essere usato per questo acquisto."
      }
    },
    "confirmCancelFamily": "Conferma annullamento",
    "confirmCancelPro": "Conferma annullamento",
    "confirmDowngrade": "Sei sicuro di voler annullare il tuo abbonamento Pro? Mantieni l'accesso fino alla fine del tuo periodo di fatturazione.",
    "confirmRenewal": "Conferma rinnovo",
    "createFirstJourney": "Crea il tuo primo viaggio",
    "createJourneyFirst": "Per favore crea prima un'istanza di viaggio",
    "createNewJourney": "Crea nuovo viaggio",
    "creditSourcePromotion": "Bonus di benvenuto",
    "creditSourceReferral": "Hai invitato 2 amici",
    "currentExpiration": "Scadenza corrente",
    "currentPlan": "Piano corrente",
    "discount": "Sconto",
    "downgradeToJourney": "Annulla abbonamento Pro",
    "downgradeWarning": "Dopo l'annullamento, manterrai l'accesso alle funzionalità Pro fino alla fine del tuo periodo di fatturazione, poi sarai retrocesso a Modalità Viaggio.",
    "downgradedToJourney": "Abbonamento Pro annullato. Mantieni l'accesso fino alla fine del tuo periodo di fatturazione.",
    "editPaymentMethod": "Modifica",
    "expiresOn": "Scade il",
    "expiringSoon": "In scadenza presto",
    "familyAddon": "Add-on familiare",
    "familyAddonActive": "Il Programma Familiare è attivo",
    "familyAddonCancelled": "Add-on Familiare annullato con successo!",
    "familyAddonDesc": "Unisci la tua famiglia nel tuo viaggio. Invita i membri della famiglia a condividere l'accesso, gestire insieme i compiti del nucleo familiare e supportare il successo dell'integrazione di tutti.",
    "familyAddonFeature1": "Invita i membri della famiglia — tutti ottengono accesso a Citizen e funzionalità web Citizen",
    "familyAddonFeature2": "TelePortal e Care consapevoli delle famiglie — gestisci il trasferimento insieme",
    "familyAddonFeature3": "Progresso del viaggio condiviso — tutti rimangono connessi e supportati",
    "familyAddonFeatures": "Gestisci i membri della famiglia e le autorizzazioni",
    "familyAddonPurchased": "Add-on Familiare acquistato con successo!",
    "familyAddonRequiresPro": "L'Add-on Familiare richiede Modalità Pro o Modalità Viaggio",
    "familyAddonTitle": "Accesso al programma familiare",
    "featureAdvancedCare": "Funzionalità complete di Care: checkpoint, cicli di feedback e supporto",
    "featureAllHeroes": "Tutti e 5 gli eroi sbloccati",
    "featureBasicCareer": "Opportunità Career e costruttore di CV",
    "featureBasicCheckup": "Valutazione completa di CheckUp e risultati",
    "featureBasicPassport": "Visualizzazione del registro eventi Passport (senza analisi)",
    "featureCareer": "Opportunità Career, corrispondenza e candidature proattive",
    "featureFullAccess": "Accesso completo a tutte le funzionalità del viaggio",
    "featureFullCheckup": "Completa CheckUp con analisi completa di MESH e punteggi iQulture",
    "featureFullPassport": "Passport avanzato: analisi, storia e risultati",
    "featureFullQultureup": "Completa QultureUp: tutti i mondi, lezioni e contenuti creatori",
    "featureFullTeleportal": "TelePortal completo: tutte le fasi, validazione documenti e revisione AI",
    "featureLimitedCopilot": "Richieste CoPilot limitate",
    "featureLimitedQultureup": "Missioni QultureUp limitate",
    "featureLimitedTeleportal": "Checklist TelePortal solo (nessun caricamento di documenti)",
    "featureNoExtra": "Nessun pagamento aggiuntivo richiesto",
    "featurePriority": "Supporto prioritario e risposte più rapide",
    "featureProPeriod": "Accesso per la durata del tuo abbonamento Pro",
    "featureUnlimitedCopilot": "CoPilot illimitato (guida, cervello e agente) — tutte le modalità",
    "featureUnlimitedJourneys": "Viaggi illimitati — crea quanti più ne hai bisogno",
    "freePlan": "Piano gratuito",
    "freePlanDesc": "Un viaggio base con funzionalità essenziali. Aggiorna per sbloccare accesso completo o crea viaggi illimitati.",
    "fullAccessEnabled": "Accesso completo abilitato",
    "includedInPro": "Incluso nel tuo piano Pro",
    "includedInSubscription": "Incluso nell'abbonamento Pro",
    "installmentPeriod": "Periodo di rateizzazione",
    "installmentPlan": "Piano rateale",
    "installments": "Rate",
    "instantUnlock": "Sblocco istantaneo",
    "invoiceHistory": "Cronologia fatture",
    "invoiceHistoryDesc": "Visualizza e scarica le tue fatture",
    "journeyRenewed": "Viaggio rinnovato con successo!",
    "journeyUnlocked": "Viaggio sbloccato con successo!",
    "managePaymentMethods": "Gestisci i tuoi metodi di pagamento",
    "month": "mese",
    "monthly": "Mensile",
    "monthlyCommitment": "Impegno minimo di 12 mesi",
    "monthlyPayment": "Pagamento mensile",
    "newExpiration": "Nuova scadenza",
    "noInvoices": "Nessuna fattura ancora",
    "noInvoicesHint": "Le fatture appariranno qui dopo il tuo primo pagamento",
    "noJourneyInstances": "Nessun viaggio configurato ancora",
    "oneTimePayment": "Pagamento una tantum",
    "paymentMethods": "Metodi di pagamento",
    "paymentOption": "Opzione di pagamento",
    "paymentSecurity": "Il tuo pagamento è sicuro e crittografato. Supportiamo le principali carte di credito e metodi di pagamento locali (SIBS per il Portogallo, Stripe per gli altri).",
    "paymentType": "Tipo di pagamento",
    "price": "Prezzo",
    "proJourney": "Piano Pro",
    "proJourneyDesc": "Sblocca viaggi illimitati con accesso completo a tutte le funzionalità. Crea quanti più viaggi hai bisogno — ogni viaggio ottiene accesso completo a tutti gli eroi, funzionalità avanzate e supporto premium.",
    "proUnlockDesc": "Sblocca questo viaggio istantaneamente con il tuo abbonamento Pro",
    "proUnlockError": "Impossibile sbloccare il viaggio. Riprova.",
    "proUnlockSuccess": "Viaggio sbloccato istantaneamente con il tuo abbonamento Pro!",
    "proceedToPayment": "Procedi al pagamento",
    "processing": "Elaborazione...",
    "purchaseFamilyAddon": "Acquista add-on famiglia",
    "purchaseJourneyInstance": "Acquista istanza di viaggio",
    "purchaseJourneyInstanceDesc": "Sblocca tutte le funzionalità di questo viaggio",
    "purchasedOn": "Acquistato il",
    "recommended": "Raccomandato",
    "removePaymentMethod": "Rimuovi",
    "renewJourneyInstance": "Rinnova istanza di viaggio",
    "renewJourneyInstanceDesc": "Estendi il tuo accesso a questo viaggio",
    "renewNow": "Rinnova ora",
    "renewalPrice": "Prezzo di rinnovo",
    "save10": "Risparmia €10.00 con pagamento anticipato",
    "saveYearly": "Risparmia €19.89 all'anno!",
    "scenarioAlreadyAbroad": "Già all'estero",
    "scenarioIntegrationOnly": "Solo integrazione",
    "scenarioPreImmigration": "Pre-immigrazione",
    "scenarioRelocationOnly": "Solo rilocazione",
    "secureCheckout": "Pagamento sicuro alimentato da Stripe",
    "selectInstallmentPeriod": "Seleziona il periodo di rateizzazione",
    "selectJourneyToPurchase": "Seleziona un'istanza di viaggio da acquistare",
    "selfPaidJourneys": "Viaggi auto-finanziati",
    "sponsoredJourneys": "Viaggi sponsorizzati",
    "total": "Totale",
    "totalAmount": "Importo totale",
    "unlockInstant": "Sblocca immediatamente",
    "unlockJourney": "Sblocca viaggio",
    "unlockNow": "Sblocca ora",
    "unlockedJourneys": "Viaggi configurati",
    "unlockedJourneysDesc": "Tutte le tue istanze di viaggio acquistate e sponsorizzate",
    "unlocking": "Sblocco in corso...",
    "upfront": "Anticipo",
    "upfrontDiscount": "Sconto del 10% — Risparmia €10,00",
    "upfrontPayment": "Pagamento anticipato: €323,89 (sconto del 10%)",
    "upfrontPrice": "Pagamento anticipato",
    "upgradeDescription": "Sblocca tutte le funzionalità e accelera il tuo viaggio",
    "upgradeToPro": "Aggiorna a Pro",
    "upgradedToPro": "Aggiornato al piano Pro!",
    "viewReceipt": "Visualizza ricevuta",
    "whatYouGet": "Cosa ottieni",
    "year": "anno",
    "yearly": "Annuale",
    "featureMonthsAccess_one": "{{count}} mese di accesso illimitato",
    "featureMonthsAccess_other": "{{count}} mesi di accesso illimitato",
    "coveredByPro": "Il tuo abbonamento Pro copre già questo viaggio: sbloccalo con Pro, senza costi aggiuntivi.",
    "renewNotRenewable": "Questo percorso non può essere rinnovato mentre un'azienda lo sponsorizza.",
    "paymentReference": "Rif. pagamento {{reference}}",
    "refunded": "Rimborsato {{amount}}",
    "viewInvoice": "Vedi fattura",
    "documentUnavailable": "Non è stato possibile aprire questo documento ora. Riprova.",
    "invoicesLoadFailed": "Non è stato possibile caricare le tue fatture."
  },
  "persona": {
    "familyMaster": {
      "badge": "Controllore",
      "controlsHousehold": "Controlli TelePortal e Care per la tua famiglia",
      "description": "Talento principale che controlla il viaggio della famiglia. Accesso completo a tutte le funzionalità più responsabilità di gestione del nucleo familiare.",
      "title": "Family master"
    },
    "info": {
      "description": "La tua persona determina il tuo livello di accesso e le funzionalità disponibili. Puoi cambiare questo in seguito nelle impostazioni del tuo profilo se necessario.",
      "title": "Informazioni sulle persone"
    },
    "loading": "Caricamento...",
    "matrix": {
      "allowed": "Accesso completo",
      "billingCompanySponsored": "Fatturazione gestita dall'azienda sponsorizzante",
      "billingDescription": "Gestione del piano e della fatturazione",
      "billingGovernmentSponsored": "Fatturazione gestita dal governo/programma sponsorizzante",
      "careDescription": "Checkpoint e supporto post-arrivo",
      "careerDescription": "Opportunità di lavoro e strumenti per la carriera",
      "checkupDescription": "Valutazione di prontezza pre-immigrazione",
      "citizenMobile": "Citizen mobile",
      "controls": "Controlli",
      "cvBuilder": "Costruttore CV",
      "cvBuilderDescription": "Generatore di CV in stile UE e modelli",
      "description": "Confronta l'accesso alle funzionalità tra tutte le persone. Seleziona una persona per continuare.",
      "familyProgramDescription": "Gestione del programma familiare e inviti",
      "familyProgramViaBilling": "Disponibile tramite fatturazione. Acquista un piano per diventare Family master e gestirlo",
      "features": "Funzionalità",
      "homeDescription": "Panoramica del dashboard e del percorso",
      "journeyBuilder": "Costruttore di percorsi",
      "journeyBuilderDescription": "Configura e costruisci il tuo percorso personalizzato",
      "journeyBuilderViaBilling": "Disponibile dopo l'acquisto di un piano tramite Fatturazione",
      "journeyBuilderViaBillingBecomesTalent": "Disponibile tramite fatturazione. Dopo l'acquisto di crediti/pro, diventa talent flow",
      "legend": {
        "allowed": "Accesso completo",
        "citizenMobile": "Disponibile tramite l'app mobile Citizen",
        "controls": "Funzionalità controlli",
        "limited": "Accesso limitato (solo proprietario)",
        "notAllowed": "Non disponibile",
        "viaBilling": "Disponibile tramite fatturazione/Aggiornamento"
      },
      "limited": "Accesso limitato",
      "notAllowed": "Non disponibile",
      "passportDescription": "Cronologia del percorso e traguardi",
      "profileDescription": "Impostazioni e preferenze del profilo",
      "qultureupDescription": "Integrazione culturale e apprendimento",
      "selected": "Selezionato",
      "teleportalDescription": "Compiti di rilocazione e mobilità",
      "title": "Matrice di accesso alle funzionalità",
      "viaBilling": "Via fatturazione"
    },
    "select": "Seleziona questo ruolo",
    "subtitle": "Scegli la persona che meglio corrisponde al tuo ruolo nel percorso. Questo determinerà quali funzionalità puoi accedere.",
    "talent": {
      "description": "Principale talento che pianifica un trasferimento internazionale di carriera. Accesso completo a tutte le funzionalità Citizen.",
      "title": "Talento (individuale)"
    },
    "talentB2B2C": {
      "badge": "Sponsorizzato dall'azienda",
      "description": "Talento con percorso sponsorizzato da un'azienda. Funzionalità di livello Pro, nessun pagamento richiesto.",
      "title": "Talento (sponsorizzato dall'azienda)"
    },
    "talentB2G": {
      "badge": "Sponsorizzato dal governo",
      "description": "Talento con percorso sponsorizzato da un programma governativo/pubblico. Funzionalità di livello Pro, nessun pagamento richiesto.",
      "title": "Talento (sponsorizzato dal governo)"
    },
    "title": "Seleziona il tuo ruolo nel percorso"
  },
  "preferences": {
    "title": "Preferenze"
  },
  "profile": {
    "aboutAndLegal": "Informazioni & legale",
    "aboutTonnieJourney": "Informazioni su Tonnie Citizen",
    "address": "Indirizzo",
    "allowCohortComparisons": "Consenti benchmarking aziendale",
    "allowCohortComparisonsDesc": "Consenti alle aziende partner di confrontare il tuo profilo anonimizzato per approfondimenti sul talento",
    "backupCodesDesc": "Conserva questi codici in un luogo sicuro. Ogni codice può essere utilizzato solo una volta per accedere al tuo account se perdi il tuo dispositivo di autenticazione.",
    "backupCodesDone": "Ho salvato i miei codici",
    "backupCodesTitle": "Salva i tuoi codici di backup",
    "cantScanQr": "Non riesci a scansionare? Inserisci questa chiave manualmente:",
    "changePhoto": "Cambia foto",
    "photo": {
      "actionSheetTitle": "Foto profilo",
      "takePhoto": "Scatta foto",
      "chooseFromLibrary": "Scegli dalla libreria",
      "remove": "Rimuovi foto",
      "removeConfirmTitle": "Rimuovere la foto del profilo?",
      "removeConfirmBody": "La tua foto verrà rimossa e verranno mostrate le tue iniziali al suo posto.",
      "uploadSuccess": "Foto profilo aggiornata",
      "uploadError": "Impossibile aggiornare la tua foto. Per favore riprova.",
      "removeSuccess": "Foto profilo rimossa",
      "managedByTitle": "Gestito da {{provider}}",
      "genericProvider": "il tuo fornitore di accesso",
      "cameraPermissionTitle": "Accesso alla fotocamera necessario",
      "cameraPermissionMessage": "Per scattare una nuova foto profilo, consenti l'accesso alla fotocamera per Tonnie nelle impostazioni del tuo dispositivo.",
      "libraryUnavailableTitle": "Libreria foto non disponibile",
      "libraryUnavailableMessage": "Non siamo riusciti ad aprire la tua libreria foto. Per favore riprova."
    },
    "completeOnWeb": "Completa il profilo sul web",
    "completeOnWebDesc": "Imposta i tuoi obiettivi di mobilità e modifica i dettagli della tua carriera sul Portale Web di Citizen.",
    "completeProfile": "Completa il tuo profilo",
    "confirmDeleteAccount": "Sì, elimina il mio account",
    "confirmDisable2FA": "Sì, Disabilita 2FA",
    "connectLinkedInIdentity": "Collega LinkedIn (per identità)",
    "contactSupport": "Contatta il nostro team di supporto",
    "contactSupportButton": "Contatta supporto",
    "copyBackupCodes": "Copia tutti i codici",
    "copyright": "© 2024 Tonnie. Tutti i diritti riservati.",
    "currentRole": "Ruolo corrente",
    "currentSession": "Sessione corrente",
    "dangerZone": "Zona pericolosa",
    "dataProtection": "Protezione dei dati",
    "dataProtectionDesc": "Hai il diritto di accedere, modificare o eliminare i tuoi dati personali in qualsiasi momento. Per ulteriori informazioni su come gestiamo i tuoi dati, ti preghiamo di consultare la nostra Informativa sulla Privacy.",
    "dateOfBirth": "Data di nascita",
    "deleteAccount": "Elimina account",
    "deleteAccountError": "Impossibile eliminare l'account. Per favore riprova.",
    "deleteAccountTitle": "Elimina il tuo account",
    "deleteAccountWarning": "Questa azione è permanente. Tutti i tuoi dati, il progresso del viaggio e i documenti caricati verranno eliminati permanentemente. Questa operazione non può essere annullata.",
    "description": "Gestisci il tuo account e le preferenze",
    "disable2FA": "Disabilita 2FA",
    "disable2FATitle": "Disabilita l'autenticazione a due fattori",
    "disable2FAWarning": "Sei sicuro di voler disabilitare l'autenticazione a due fattori? Il tuo account sarà meno sicuro senza di essa.",
    "disconnectIdentity": "Disconnetti identità",
    "documentation": "Documentazione",
    "educationCount": "Istruzione ({{count}})",
    "educationalBackground": "Formazione educativa",
    "email": "Email",
    "emailNotifications": "Notifiche email",
    "emailNotificationsDesc": "Ricevi aggiornamenti via email",
    "enable2FA": "Abilita 2FA",
    "enabled": "Abilitato",
    "experienceCount": "Esperienza ({{count}})",
    "feature": {
      "billingManagement": "Gestione della fatturazione e dell'abbonamento",
      "careCheckpoints": "Gestione checkpoint Care e monitoraggio del benessere",
      "careerOpportunities": "Opportunità Career e costruttore di CV",
      "checkupAssessments": "Valutazioni complete di CheckUp e monitoraggio della prontezza",
      "familyProgram": "Gestione del programma familiare",
      "passportTimeline": "Timeline Passport, timbri e badge",
      "qultureupLearning": "Riepiloghi di apprendimento QultureUp e dashboard di progresso",
      "teleportalManagement": "Gestione del piano TelePortal e coordinamento delle attività"
    },
    "firstName": "Nome",
    "firstNamePlaceholder": "Inserisci il nome",
    "fullName": "Nome completo",
    "gdprCompliance": "Conformità al GDPR",
    "gdprComplianceDesc": "Tonnie è conforme al Regolamento Generale sulla Protezione dei Dati (GDPR) e ad altre leggi sulla protezione dei dati applicabili. Puoi esercitare i tuoi diritti contattandoci tramite l'app o il sito web.",
    "keyFeatures": "Caratteristiche principali",
    "languages": "Lingue",
    "lastName": "Cognome",
    "lastNamePlaceholder": "Inserisci il cognome",
    "lastPdfUpload": "Ultimo PDF caricato: {{date}}",
    "learnMoreAboutTonnie": "Scopri di più su Tonnie Citizen e sulla nostra piattaforma",
    "legalInformation": "Informazioni legali e politiche",
    "linkedInDisconnected": "LinkedIn disconnesso",
    "logOut": "Disconnetti",
    "mobility": "Mobilità",
    "mobilityDescription": "Cittadinanza, passaporto e interessi di trasferimento",
    "needHelp": "Hai bisogno di aiuto?",
    "notProvided": "—",
    "notificationSettings": "Impostazioni di notifica",
    "ongoing": "In corso",
    "personalInfo": "Informazioni sul profilo",
    "personalInfoDescription": "Aggiorna le tue informazioni personali e i dettagli del profilo",
    "phone": "Telefono",
    "phoneInvalidFormat": "Il numero di telefono può contenere solo cifre, spazi, trattini e +",
    "phoneNumber": "Numero di telefono",
    "phonePlaceholder": "912 345 678",
    "phoneTooShort": "Il numero di telefono è troppo corto (minimo 6 cifre)",
    "photoSet": "Foto impostata",
    "platformOverview": "Panoramica della piattaforma",
    "platformOverviewDescription": "Tonnie Citizen Web funziona senza problemi con Tonnie Citizen Mobile per fornire un'esperienza di rilocazione completa. L'app mobile è il tuo compagno quotidiano per azioni rapide e funzionalità mobile-first, mentre il portale web fornisce strumenti di pianificazione completi, valutazioni dettagliate e monitoraggio dei progressi.",
    "preferenceSettings": "Impostazioni preferenze",
    "preferences": "Preferenze",
    "preferencesSaveError": "Salvataggio preferenza non riuscito",
    "privacyImportance": "La tua privacy è importante per noi. La nostra Informativa sulla Privacy spiega come raccogliamo, utilizziamo e proteggiamo le tue informazioni personali.",
    "privacyPolicy": "Informativa sulla privacy",
    "privacyPolicyDesc": "Come gestiamo e proteggiamo i tuoi dati personali",
    "privacySettingUpdated": "Impostazione della privacy aggiornata",
    "privacySettings": "Impostazioni sulla privacy",
    "professionalWorkExperience": "Esperienza lavorativa professionale",
    "profile": "Profilo",
    "profilePhoto": "Foto del profilo",
    "profileUpdateFailed": "Impossibile aggiornare il profilo. Riprova.",
    "profileUpdated": "Profilo aggiornato con successo!",
    "pushNotifications": "Notifiche push",
    "pushNotificationsDesc": "Ricevi notifiche sul tuo dispositivo",
    "readOnly": "Questo campo è di sola lettura",
    "readyToComplete": "Pronto per completare il tuo onboarding!",
    "reviewAndComplete": "Rivedi tutte le informazioni sopra e clicca su \"Completa\" per finire.",
    "scanQrCode": "Scansiona questo codice QR",
    "scanQrCodeDesc": "Usa la tua app di autenticazione (ad es. Google Authenticator, Authy) per scansionare il codice QR qui sotto.",
    "security": "Sicurezza",
    "sessionBrowserOnDevice": "{{browser}} su {{device}}",
    "settingDisabled": "{{setting}} disabilitato",
    "settingEnabled": "{{setting}} abilitato",
    "shareAnalytics": "Condividi analisi",
    "shareAnalyticsDesc": "Aiuta a migliorare la nostra piattaforma con dati di utilizzo anonimizzati",
    "showInTalentPool": "Mostrami nel Talent Pool",
    "showInTalentPoolDesc": "Fai scoprire il tuo profilo alle aziende di assunzione su Tonnie. Puoi disattivarlo in qualsiasi momento.",
    "skills": "Competenze",
    "skillsDescription": "Competenze professionali ed esperienza",
    "quietHours": "Ore di silenzio",
    "quietHoursDesc": "Sospendi le notifiche push durante queste ore.",
    "quietHoursEnd": "Alle",
    "quietHoursTimezone": "Gli orari sono in {{timeZone}}.",
    "quietHoursStart": "Dalle",
    "termsAgreement": "Utilizzando Tonnie Citizen, accetti i nostri Termini di Servizio. Si prega di rivedere i termini completi per comprendere i propri diritti e obblighi.",
    "termsAndPrivacy": "Termini e privacy",
    "termsOfService": "Termini di servizio",
    "termsOfServiceDesc": "I nostri termini e condizioni per l'utilizzo di Tonnie Citizen",
    "title": "Profilo",
    "tonnieJourney": "Tonnie Citizen",
    "tonnieJourneyDescription": "Tonnie Citizen è la tua piattaforma completa per pianificare e gestire il tuo viaggio di relocation internazionale. Monitora i tuoi progressi, accedi a dashboard dettagliate e coordina il tuo trasferimento con precisione.",
    "twoFactor": {
      "backupCodesLabel": "Codici di backup",
      "disableError": "Impossibile disabilitare 2FA",
      "disabledToast": "Autenticazione a due fattori disabilitata",
      "enableError": "Impossibile avviare la configurazione 2FA",
      "enabledToast": "Autenticazione a due fattori abilitata",
      "copySecretKey": "Copia chiave segreta",
      "secretKeyLabel": "Chiave segreta",
      "verifyError": "Codice di verifica non valido. Riprova."
    },
    "twoFactorAuth": "Autenticazione a due fattori",
    "twoFactorAuthDesc": "Aggiungi un ulteriore livello di sicurezza",
    "verificationCode": "Codice di verifica",
    "verify": "Verifica",
    "version": "Versione {{version}}",
    "viewPolicy": "Visualizza politica",
    "viewTerms": "Visualizza termini",
    "yourRights": "I tuoi diritti",
    "notifCatHero": "Percorso e progressi",
    "notifCatHeroDesc": "Aggiornamenti da CheckUp, Care, QultureUp, TelePortal e Passport.",
    "notifCatSystem": "Account e sistema",
    "notifCatSystemDesc": "Sicurezza, account e manutenzione della piattaforma.",
    "notifCatSocial": "Persone e aziende",
    "notifCatSocialDesc": "Inviti, valutazioni, team e messaggi.",
    "notifCatAlert": "Avvisi e promemoria",
    "notifCatAlertDesc": "Sensibili a tempo o denaro: fatturazione, pagamenti e scadenze.",
    "notifMatrixTitle": "Come ricevi ogni aggiornamento",
    "notifMatrixDesc": "Scegli email e push per ogni tipo di aggiornamento. La tua posta in arrivo ne conserva sempre una copia.",
    "notifMatrixCategory": "Categoria",
    "notifMatrixInApp": "Nell'app",
    "notifMatrixEmail": "Email",
    "notifMatrixPush": "Push",
    "notifMatrixInAppAlways": "Sempre attivo: la tua posta in arrivo conserva ogni messaggio",
    "notifMatrixEmailOff": "Le Notifiche Email sono disattivate, quindi nessuna categoria invia email. Attivale per scegliere qui.",
    "notifMatrixPushOff": "Le Notifiche Push sono disattivate, quindi nessuna categoria invia notifiche push. Attivale per scegliere qui.",
    "notifMatrixCell": "{{channel}} per {{category}}",
    "identitySection": "Identità",
    "currentCountry": "Paese attuale",
    "currentCountryPlaceholder": "Seleziona dove vivi adesso",
    "currentCity": "Città attuale",
    "currentCityPlaceholder": "La città in cui vivi adesso",
    "sections": {
      "add": "Aggiungi {{section}}",
      "saved": "Salvato.",
      "saveFailed": "Non è stato possibile salvare. Riprova.",
      "importSaved": "Importato nel tuo profilo.",
      "fixErrors_one": "{{count}} campo richiede attenzione",
      "fixErrors_other": "{{count}} campi richiedono attenzione",
      "status": {
        "complete": "Completa",
        "empty": "Da aggiungere"
      },
      "identity": {
        "title": "Identità",
        "description": "Il tuo nome, data di nascita, telefono e dove vivi."
      },
      "mobility": {
        "title": "Mobilità e passaporto",
        "description": "La tua cittadinanza, il passaporto, il nucleo familiare e come preferisci lavorare."
      },
      "skills": {
        "title": "Competenze",
        "description": "Il tuo ruolo, gli anni di esperienza, le lingue e le competenze."
      },
      "education": {
        "title": "Istruzione",
        "description": "I tuoi titoli di studio e corsi."
      },
      "experience": {
        "title": "Esperienza",
        "description": "Dove hai lavorato e cosa hai fatto."
      },
      "import": {
        "title": "Importa dal tuo CV o da LinkedIn",
        "description": "Carica un CV o un PDF di LinkedIn e compiliamo competenze, istruzione ed esperienza. Controlli tutto prima che venga salvato.",
        "cta": "Importa CV o LinkedIn"
      }
    },
    "strengthen": {
      "title": "Rafforza il tuo profilo",
      "description": "Il tuo punteggio è pronto. Racconta di più di te alle aziende: aggiungi uno di questi quando vuoi. Niente di tutto questo è obbligatorio."
    },
    "degreeInField": "{{degree}} in {{field}}",
    "strength": {
      "gaugeCaption": "solidità",
      "gaugeLabel": "Solidità del profilo: {{percent}} per cento",
      "headline": "Il tuo profilo è completo al {{percent}}%",
      "headlineComplete": "Il tuo profilo è completo",
      "subline_one": "Manca {{count}} cosa. Quelle indicate sotto influiscono sul tuo punteggio iQulture.",
      "subline_other": "Mancano {{count}} cose. Quelle indicate sotto influiscono sul tuo punteggio iQulture.",
      "sublineComplete": "Il tuo CheckUp ha tutto ciò che il profilo può dargli e le aziende lo vedono per intero.",
      "level": {
        "getting_started": "Agli inizi",
        "good": "Buono",
        "strong": "Solido",
        "complete": "Completo"
      },
      "next": {
        "label": "Prossimo passo",
        "labelFastest": "Prossimo passo · il più rapido",
        "addButton": "Aggiungi",
        "documentTitle": "Carica il tuo passaporto",
        "documentFills": "Un solo caricamento compila: {{items}}",
        "documentButton": "Carica passaporto"
      },
      "why": {
        "start": "Necessario per iniziare il tuo CheckUp",
        "persona": "Necessario per iniziare · definisce come ti legge iQulture",
        "languages": "Il tuo livello di inglese influisce sul punteggio di Comunicazione",
        "experience": "Influisce sul tuo punteggio di Esperienza Globale",
        "years": "Influisce sui tuoi punteggi di competenze ed esperienza",
        "skills": "Influisce sul tuo punteggio di competenze",
        "education": "Influisce sul tuo punteggio di Preparazione Accademica",
        "workModel": "Influisce sul tuo punteggio di Flessibilità del Modello di Lavoro",
        "passport": "Il tuo trasferimento ne ha bisogno — TelePortal lo usa"
      },
      "readiness": {
        "startTitle": "Necessario per iniziare il tuo CheckUp",
        "startDone": "Tutto pronto. Il tuo CheckUp può iniziare quando vuoi.",
        "scoreTitle": "Influisce sul tuo punteggio iQulture",
        "scoreHint": "Il punteggio si calcola anche senza, ma con meno informazioni:",
        "scoreDone": "Il tuo punteggio ha tutto ciò che il profilo può dargli.",
        "more_one": "+{{count}} altro",
        "more_other": "+{{count}} altri"
      },
      "tag": {
        "start": "Necessario per iniziare",
        "score": "Influisce su iQulture",
        "journey": "Per il tuo percorso"
      },
      "item": {
        "name": "Nome completo",
        "date_of_birth": "Data di nascita",
        "phone": "Telefono",
        "residence": "Dove vivi",
        "nationality": "Cittadinanza",
        "passport": "Passaporto valido",
        "work_model": "Come preferisci lavorare",
        "current_role": "Ruolo attuale",
        "years_experience": "Anni di esperienza",
        "skills": "Competenze",
        "languages": "Livello di inglese",
        "education": "Un titolo o un corso",
        "experience": "Un ruolo che hai ricoperto"
      },
      "addItem": "Aggiungi {{item}}",
      "sectionBar": "Sezioni del profilo",
      "sectionCount": "{{complete}} di {{total}}",
      "segmentLabel": "{{section}}: {{complete}} di {{total}}",
      "fillFaster": {
        "recommended": "Consigliato"
      },
      "missing": "Manca ancora",
      "fromCareerCv": "Il tuo CV in Career dà già questo al tuo punteggio iQulture. Aggiungilo anche qui per mostrarlo nel tuo profilo.",
      "loadFailed": "Non siamo riusciti a caricare quanto è completo il tuo profilo."
    },
    "identityDocument": {
      "title": "Compila con il passaporto o la carta d'identità",
      "subtitle": "Caricalo una volta. Lo leggiamo noi, tu confermi.",
      "close": "Chiudi",
      "typeGroup": "Tipo di documento",
      "passport": "Il mio passaporto",
      "passportHint": "Una sola pagina. Compila di più e ogni trasferimento ne ha bisogno.",
      "idCard": "La mia carta d'identità",
      "idCardHint": "Fronte e retro. Compila nome, data di nascita e nazionalità.",
      "uploadPassport": "La pagina con la foto del passaporto",
      "uploadFront": "Fronte della carta d'identità",
      "uploadBack": "Retro della carta d'identità",
      "uploadHint": "Una foto o una scansione · JPG, PNG, HEIC o PDF, fino a {{size}} MB",
      "chooseFile": "Scegli file",
      "source": {
        "camera": "Scatta una foto",
        "library": "Scegli una foto",
        "files": "Scegli un file"
      },
      "cameraPermission": "Serve l'accesso alla fotocamera per fotografare il documento. Puoi consentirlo in Impostazioni.",
      "pickUnavailable": "Al momento non è possibile scegliere un file.",
      "replaceFile": "Cambia",
      "aiNotice": "Il tuo documento viene letto dal nostro servizio di IA per compilare il profilo. Nulla viene salvato nel profilo finché non confermi. Il file resta nel tuo Archivio e puoi eliminarlo quando vuoi.",
      "continue": "Continua",
      "back": "Indietro",
      "cancel": "Annulla",
      "read": "Leggi documento",
      "reading": {
        "saving": "Salvataggio nel tuo Archivio",
        "reading": "Lettura del documento"
      },
      "review": {
        "intro": "Seleziona cosa usare. Dove il profilo dice già qualcosa di diverso, resta deselezionato così nulla cambia a sorpresa.",
        "verified": "Verificato",
        "unverified": "Letto dall'IA — controlla",
        "onFile": "Nel tuo profilo: {{value}}",
        "passportValid": "Valido fino al {{date}}",
        "passportExpired": "Scaduto il {{date}}",
        "profileYes": "Sì",
        "profileNo": "No",
        "documentNumber": "Documento che termina con {{last4}}",
        "expiredWarning": "Questo passaporto è scaduto. Usarlo registra che non hai un passaporto valido.",
        "save": "Salva nel mio profilo",
        "discard": "Scarta",
        "matches": "Corrisponde al tuo profilo"
      },
      "done": {
        "title": "Il tuo documento è stato aggiunto",
        "bodyPassport": "Salvato nel tuo Archivio e inserito nel profilo. TelePortal lo userà per le attività sul passaporto, senza un secondo caricamento.",
        "bodyIdCard": "Salvato nel tuo Archivio e inserito nel profilo.",
        "close": "Fatto"
      },
      "error": {
        "notIdentity": "Non sembra un passaporto né una carta d'identità. Prova con una foto nitida della pagina con la foto.",
        "unreadable": "Non siamo riusciti a leggere il file. Prova con una foto più nitida o una scansione PDF.",
        "unsupported": "Questo tipo di file non è supportato. Usa JPG, PNG, HEIC o PDF.",
        "tooLarge": "Questo file supera i {{size}} MB. Usa una foto o una scansione più piccola.",
        "unavailable": "La lettura dei documenti non è disponibile al momento. Riprova tra poco.",
        "generic": "Qualcosa è andato storto nella lettura del documento. Riprova.",
        "upload": "Il caricamento non è terminato. Riprova.",
        "save": "Non siamo riusciti a salvare. Riprova.",
        "tryAgain": "Prova un altro file"
      },
      "steps": {
        "document": "Documento",
        "upload": "Caricamento",
        "reading": "Lettura",
        "review": "Revisione"
      },
      "stepsAria": "Avanzamento del caricamento",
      "start": "Inizia",
      "privacyTitle": "Riservato per scelta.",
      "upload": {
        "title": "Aggiungi una foto o una scansione nitida",
        "tipFrame": "La pagina intera, piatta e a fuoco",
        "tipGlare": "Nessun riflesso né dita sul testo",
        "tipMrzPassport": "Le due righe di codice in fondo alla pagina ben visibili",
        "tipMrzIdCard": "Le righe di codice sul retro ben visibili",
        "dropHint": "Trascina qui una foto o un PDF"
      },
      "readingView": {
        "title": "Stiamo leggendo il documento",
        "subtitle": "Ci vuole qualche secondo. Nulla arriva al profilo finché non confermi.",
        "savingCount": "Salvataggio nel tuo Vault · {{saved}} di {{total}}"
      },
      "reviewView": {
        "title": "Controlla cosa abbiamo letto",
        "mrzVerified": "La zona a lettura ottica è corretta",
        "mrzUnverified": "Non abbiamo potuto verificare una zona a lettura ottica — controlla ogni riga",
        "selected_one": "{{count}} riga da salvare",
        "selected_other": "{{count}} righe da salvare"
      },
      "doneView": {
        "applied": "Ora nel tuo profilo",
        "nothingApplied": "Il documento è nel tuo Vault. Nel profilo non è cambiato nulla."
      },
      "line": {
        "name": "Nome legale, come sul documento",
        "account_name": "Usalo come nome del tuo account",
        "date_of_birth": "Data di nascita",
        "nationality": "Nazionalità",
        "passport": "Passaporto valido"
      },
      "legalName": {
        "label": "Nome sul passaporto o documento d'identità",
        "hint": "Letto dal tuo documento. Compila i moduli in cui il documento deve corrispondere; il nome dell'account qui sopra è quello che vedono le persone."
      },
      "sourceShort": {
        "camera": "Fotocamera",
        "library": "Foto",
        "files": "File"
      },
      "slot": {
        "empty": "Non ancora aggiunto",
        "added": "Aggiunto"
      }
    },
    "emailChange": {
      "sameAsCurrent": "Questa è già la tua email di accesso.",
      "taken": "Questo indirizzo appartiene a un altro account Tonnie. Usane un altro.",
      "done": "La tua email di accesso ora è {{email}}. Abbiamo inviato un avviso al tuo indirizzo precedente.",
      "oldKept": "Ora accedi con {{email}}, ma {{old}} è ancora nel tuo account.",
      "oldLinked": "{{old}} resta nel tuo account: continui ad accedere con {{provider}} tramite questo indirizzo.",
      "oldLinkedOther": "{{old}} resta nel tuo account: un metodo di accesso che usi è collegato a questo indirizzo.",
      "removeOld": "Rimuovi il vecchio indirizzo",
      "sendError": "Non siamo riusciti a inviare il codice in questo momento. Riprova tra qualche minuto.",
      "verifyError": "Non siamo riusciti a verificare il codice in questo momento. Riprova tra qualche minuto.",
      "switchError": "Il nuovo indirizzo è confermato, ma non siamo riusciti a renderlo la tua email di accesso. Riprova."
    },
    "review": {
      "company": {
        "children_one": "1 figlio",
        "children_other": "{{count}} figli",
        "partner": "Partner",
        "personalInfoDescription": "Ciò che il talento ha condiviso su di sé",
        "pets": "Animali domestici",
        "validPassport": "Passaporto valido"
      },
      "present": "Oggi",
      "showMore": "Mostra di più",
      "showLess": "Mostra meno"
    },
    "ways": {
      "document": {
        "title": "Passaporto o carta d'identità",
        "body": "Compila data di nascita, nazionalità e passaporto da una foto.",
        "cta": "Scansiona il passaporto"
      },
      "import": {
        "title": "PDF di LinkedIn o CV",
        "body": "Compila esperienza, formazione, competenze e lingue da un solo PDF.",
        "cta": "Importa un PDF"
      },
      "fastest": "Il più veloce"
    },
    "citizenshipsAdd": "Aggiungi cittadinanza"
  },
  "qultureup": {
    "aboutDescription": "Questa valutazione valuta la tua conoscenza di:",
    "aboveLevel": "Sopra il livello",
    "achievementAdvanced": "Esperto culturale",
    "achievementAdvancedDesc": "Raggiungi il livello avanzato",
    "achievementCultureExplorer": "Esploratore culturale",
    "achievementCultureExplorerDesc": "Iniziato 2+ mondi",
    "achievementFirstMission": "Prima missione",
    "achievementFirstMissionDesc": "Hai completato la tua prima missione",
    "achievementStreak3": "Serie di 3 giorni",
    "achievementStreak3Desc": "Apprendimento per 3 giorni consecutivi",
    "achievementWorldMaster": "Maestro del mondo",
    "achievementWorldMasterDesc": "Completa un intero mondo",
    "achievements": "Risultati",
    "ariaWeeklyActivityChart": "Grafico di attività settimanale",
    "assessedOn": "Valutato il {{date}}",
    "assessment": {
      "aboutDesc": "Una breve valutazione di allineamento culturale che richiede circa 10 minuti.",
      "completeMessage": "La tua valutazione QultureUp è completa. Esplora i mondi per continuare a imparare.",
      "completeTitle": "Valutazione completata",
      "description": "Rispondi a qualche domanda sulla tua orientazione culturale in modo da poter personalizzare il tuo percorso.",
      "saving": "Salvataggio…",
      "subtitle": "Circa 10 minuti",
      "title": "Valutazione QultureUp"
    },
    "assessmentDescription": "Determina il tuo livello di apprendimento",
    "assessmentTitle": "Valutazione QultureUp",
    "coPilot": "CoPilot",
    "complete": "completo",
    "completeDescription": "Il tuo percorso di apprendimento è stato personalizzato.",
    "completePreviousTrack": "Completa il percorso precedente per sbloccare questo",
    "completePreviousWorld": "Completa il mondo precedente",
    "completeTitle": "Valutazione completata!",
    "continue": "Continua",
    "continueDescription": "Hai iniziato la tua valutazione di QultureUp. Riprendi esattamente da dove hai lasciato su Citizen Web — le tue risposte finora sono salvate.",
    "continueInApp": "Continua nell'app",
    "continueInAppButton": "Continua nell'app",
    "continueLearning": "Continua a imparare",
    "continueOnWeb": "Continua su Citizen Web",
    "continueOnWebDesc": "Riprendi la tua valutazione di QultureUp da dove l'hai lasciata sul Portale Web di Citizen.",
    "continueTitle": "Continua la tua valutazione QultureUp",
    "copilotGuideDescription": "Rispondi a domande sulla tua conoscenza culturale",
    "copilotGuideTitle": "Guida CoPilot",
    "dayStreak": "Serie di giorni",
    "description": "Impara la tua nuova cultura",
    "difficultyAdvanced": "Avanzato",
    "difficultyBeginner": "Principiante",
    "difficultyIntermediate": "Intermedio",
    "dimensionCulture": "Cultura locale e norme",
    "dimensionHistory": "Storia e vita quotidiana",
    "dimensionLanguage": "Realtà linguistica (madrelingua + inglese e frasi di base nella lingua target)",
    "dimensionWorkplace": "Cultura del lavoro e basi dei diritti/doveri",
    "error": {
      "description": "Non siamo riusciti a caricare i tuoi dati QultureUp. Per favore riprova.",
      "retry": "Riprova",
      "title": "Qualcosa è andato storto"
    },
    "estimatedTime": "Tempo stimato",
    "filterAdvanced": "Avanzato",
    "filterAll": "Tutti i livelli",
    "filterBeginner": "Principiante",
    "filterIntermediate": "Intermedio",
    "heroBanner": {
      "subtitle": "Padroneggia il lato culturale del tuo trasferimento",
      "title": "QultureUp"
    },
    "heroMiles": "QultureUp Miles",
    "hours": "h",
    "learnOnTheGo": "Impara in movimento",
    "learnOnTheGoDesc": "Completa missioni, guadagna Miles e monitora i tuoi progressi di apprendimento culturale con l'app mobile.",
    "loadingAssessment": "Caricamento valutazione…",
    "miles": "Miles",
    "minutes": "min",
    "missionDetailsInApp": "Dettagli della missione disponibili nell'app mobile",
    "missions": "Missioni",
    "missionsCompleted": "{{completed}} di {{total}} missioni completate",
    "missionsCount": "{{completed}}/{{total}} missioni",
    "missionsLabel": "Missioni",
    "nextMission": "Avanti",
    "noMissionsForLevel": "Nessuna missione a questo livello per questo percorso.",
    "noTracksAvailable": "Nessun percorso disponibile per questo mondo ancora.",
    "noUnlockedWorlds": "Nessun mondo sbloccato ancora.",
    "noWorldsAvailable": "Nessun mondo disponibile ancora. Torna presto!",
    "ofTotal": "{{completed}} di {{total}}",
    "ofTotalCompleted": "{{completed}} di {{total}} completati",
    "openInApp": "Apri nell'app",
    "openTonnieCitizen": "Apri nell'app",
    "percentComplete": "{{percent}}% completato",
    "progressTitle": "Progresso della valutazione",
    "qultureupMiles": "QultureUp miglia",
    "recentlyCompleted": "Recentemente completato",
    "retakeAssessment": "Ripeti la valutazione",
    "retakeOnWeb": "Rifai su Citizen Web",
    "retakeOnWebDesc": "Rifai la tua valutazione di QultureUp sul Portale Web di Citizen per aggiornare il tuo percorso di apprendimento personalizzato.",
    "returnToDashboard": "Torna alla dashboard",
    "score": "Punteggio: {{score}}%",
    "start": "Inizia",
    "startInApp": "Inizia nell'app",
    "startMission": "Inizia missione",
    "startOnWeb": "Inizia su Citizen Web",
    "startOnWebDesc": "Completa la tua valutazione di QultureUp sul Portale Web di Citizen per sbloccare il tuo percorso di apprendimento personalizzato.",
    "tabOverview": "Panoramica",
    "tabTracksAndMissions": "Percorsi & missioni",
    "tabWorlds": "Mondi",
    "thisWeek": "Questa settimana",
    "timeLearning": "Tempo di apprendimento",
    "title": "QultureUp",
    "todaysMission": "Missione di oggi",
    "tracks": "Tracce",
    "tracksCompleted": "{{completed}} di {{total}} percorsi completati",
    "tryAgainLater": "Per favore riprova più tardi.",
    "unableToLoad": "Impossibile caricare i dati QultureUp",
    "upNext": "Prossimo",
    "welcome": {
      "cultureStep": "Cultura & storia",
      "cultureStepDesc": "Esplora tradizioni locali, patrimonio e vita civica",
      "description": "Scopri la tua prontezza culturale e sblocca un percorso di apprendimento personalizzato. La nostra valutazione valuta le tue conoscenze su dimensioni chiave della cittadinanza per guidare il tuo percorso di integrazione.",
      "languageStep": "Lingua e comunicazione",
      "languageStepDesc": "Costruisci fiducia nelle interazioni quotidiane e ufficiali",
      "letsStart": "Iniziamo",
      "socialStep": "Norme sociali e professionali",
      "socialStepDesc": "Comprendi le usanze quotidiane e le aspettative professionali",
      "timeEstimate": "Ci vogliono circa 5-10 minuti per completare",
      "title": "Benvenuto in QultureUp"
    },
    "world": {
      "completed": "Completato"
    },
    "worlds": "Mondi",
    "questionTier": {
      "easy": "Facile",
      "medium": "Media",
      "hard": "Difficile"
    },
    "difficultyA11y": "Difficoltà: {{level}}",
    "min_one": "{{count}} min",
    "min_other": "{{count}} min",
    "sectionsLabel_one": "{{count}} sezione",
    "sectionsLabel_other": "{{count}} sezioni"
  },
  "security": {
    "changePassword": "Cambia password",
    "changing": "Cambio in corso...",
    "confirmNewPassword": "Conferma nuova password",
    "confirmPasswordPlaceholder": "Conferma la nuova password",
    "currentPassword": "Password corrente",
    "currentPasswordPlaceholder": "Inserisci la password corrente",
    "fillAllFields": "Per favore, compila tutti i campi",
    "newPassword": "Nuova password",
    "newPasswordPlaceholder": "Inserisci la nuova password",
    "passwordChangeFailed": "Impossibile cambiare la password. Per favore riprova.",
    "passwordChanged": "La tua password è stata cambiata con successo.",
    "passwordMustDiffer": "La nuova password deve essere diversa dalla password corrente",
    "passwordsNotMatch": "Le nuove password non corrispondono",
    "sessionNotFound": "Sessione utente non trovata. Si prega di accedere di nuovo.",
    "title": "Sicurezza",
    "ssoManagedTitle": "Accesso gestito da {{provider}}",
    "ssoManagedDesc": "Ti sei registrato con {{provider}}, quindi il tuo account non ha una password Tonnie. Gestisci le tue credenziali nel tuo account {{provider}}.",
    "ssoGenericProvider": "il tuo provider di accesso collegato"
  },
  "settings": {
    "about": {
      "title": "Informazioni"
    },
    "billing": "Fatturazione",
    "dark": "Scuro",
    "deleteAccount": "Elimina account",
    "deleteAccountConfirm": "Questo eliminerà permanentemente il tuo account e tutti i dati. Questa operazione non può essere annullata.",
    "deleteAccountFailed": "Impossibile eliminare l'account. Per favore riprova.",
    "freePlan": "Piano gratuito",
    "language": {
      "title": "Lingua"
    },
    "light": "Chiaro",
    "myCheckups": "I miei CheckUp",
    "myFamily": "La mia famiglia",
    "myJourneys": "I miei viaggi",
    "preferences": "Preferenze",
    "profile": "Profilo",
    "security": "Sicurezza",
    "sendFeedback": "Invia feedback",
    "signOut": "Disconnetti",
    "signOutConfirm": "Sei sicuro di voler disconnetterti?",
    "termsPrivacy": "Termini e privacy",
    "theme": {
      "title": "Tema"
    },
    "themeSystem": "Sistema ({{mode}})",
    "title": "Impostazioni",
    "sessions": {
      "notFound": "Sessione non trovata",
      "signedOut": "Sessione disconnessa",
      "signOutFailed": "Impossibile disconnettere la sessione",
      "loadFailed": "Impossibile caricare le sessioni"
    },
    "preferencesLanguageFallback": "Inglese",
    "membersCount_one": "{{count}} membro",
    "membersCount_other": "{{count}} membri",
    "groups": {
      "journey": "Il tuo viaggio",
      "app": "App",
      "help": "Aiuto e note legali"
    },
    "profileStrength": "Profilo: {{level}} · {{percent}}",
    "pro": "Pro"
  },
  "splash": {
    "authenticateToContinue": "Autenticati per continuare",
    "biometricFailed": "Autenticazione biometrica fallita",
    "tryAgain": "Riprova",
    "unlockPrompt": "Sblocca Tonnie Citizen",
    "usePasswordInstead": "Usa invece la password"
  },
  "sponsorship": {
    "companySponsored": "Sponsorizzato dall'azienda",
    "familySponsored": "Sponsorizzato dalla famiglia",
    "governmentSponsored": "Sponsorizzato dal governo",
    "selfPaid": "Pagato da sé"
  },
  "stepper": {
    "care": "Care",
    "checkup": "CheckUp",
    "passport": "Passport",
    "qultureup": "QultureUp",
    "start": "Inizia",
    "teleportal": "TelePortal"
  },
  "supportRequest": {
    "categories": {
      "account": "Account",
      "billing": "Fatturazione",
      "general": "Generale",
      "technical": "Tecnico"
    },
    "category": "Categoria",
    "description": "Descrizione",
    "descriptionPlaceholder": "Descrivi il tuo problema in dettaglio...",
    "fillAllFields": "Si prega di compilare tutti i campi.",
    "requestSubmitted": "Richiesta inviata",
    "subject": "Oggetto",
    "subjectPlaceholder": "Breve riassunto del tuo problema",
    "submitRequest": "Invia richiesta",
    "successMessage": "Il nostro team di supporto esaminerà la tua richiesta e ti contatterà presto.",
    "teamFollowUp": "Il nostro team ti risponderà presto.",
    "trustHow": "Risoluzione più rapida e follow-up personalizzato.",
    "trustWho": "Solo il nostro team di supporto — mai condiviso con terze parti.",
    "trustWhy": "Per indirizzare la tua richiesta al giusto specialista di supporto."
  },
  "tabs": {
    "care": "Care",
    "home": "Home",
    "passport": "Passport",
    "qultureup": "QultureUp",
    "teleportal": "TelePortal"
  },
  "teleportal": {
    "aboutDescription": "Questa valutazione ci aiuta a comprendere le tue esigenze di trasferimento:",
    "aboutTitle": "Informazioni su questa valutazione",
    "addNote": "Aggiungi nota",
    "agentDate": "Data",
    "agentHistory": "Storico interazioni con l'agente",
    "agentHistoryDescription": "Visualizza le interazioni passate con il Consultant Agent TelePortal",
    "agentInteraction": "Interazione",
    "agentSummary": "Riepilogo",
    "all": "Tutti",
    "allScope": "Tutti i membri",
    "allStatus": "Tutti gli stati",
    "allTracks": "Tutti i percorsi",
    "applicationPackages": "Pacchetti di domanda",
    "applicationPackagesDescription": "Visualizza i tuoi pacchetti di documenti organizzati",
    "askCoPilot": "Chiedi a CoPilot riguardo a questo compito",
    "assessment": {
      "destination": "Destinazione",
      "education": "Istruzione",
      "educationBachelor": "Laurea triennale",
      "educationHighSchool": "Scuola superiore",
      "educationMaster": "Laurea magistrale",
      "educationPhd": "Dottorato",
      "educationVocational": "Professionale / Tecnica",
      "experience": "Esperienza",
      "experience0to2": "0-2 anni",
      "experience10Plus": "Più di 10 anni",
      "experience3to5": "3-5 anni",
      "experience6to10": "6-10 anni",
      "infoDestination": "Preferenze di paese di destinazione",
      "infoPurpose": "Scopo del trasferimento",
      "infoQualifications": "Valutazione delle qualifiche",
      "infoTimeline": "Tempistiche e urgenza",
      "purpose": "Scopo",
      "purposeEntrepreneur": "Avviare un'attività",
      "purposeFamily": "Ricongiungimento familiare",
      "purposeRetire": "Pensione",
      "purposeStudy": "Studio / Istruzione",
      "purposeWork": "Occupazione / Lavoro",
      "questionDestination": "Quale paese stai mirando per il trasferimento?",
      "questionEducation": "Qual è il tuo livello di istruzione più alto?",
      "questionExperience": "Quanti anni di esperienza professionale hai?",
      "questionPurpose": "Qual è il tuo scopo principale per il trasferimento?",
      "questionTimeline": "Quando prevedi di trasferirti?",
      "timeline": "Tempistica",
      "timeline1Year": "Entro 1 anno",
      "timeline3Months": "Entro 3 mesi",
      "timeline6Months": "Entro 6 mesi",
      "timelineAsap": "Il prima possibile",
      "timelineExploring": "Solo esplorazione"
    },
    "assessmentCompleteMessage": "Abbiamo analizzato il tuo profilo e identificato potenziali percorsi per il visto per la tua destinazione.",
    "assessmentDescription": "Configura il tuo viaggio di trasferimento",
    "assessmentTitle": "Valutazione TelePortal",
    "associatedWithTasks": "Associato a compiti",
    "attachExistingDocument": "Allega documento esistente",
    "backToDashboard": "Torna alla dashboard",
    "blocked": "Bloccato",
    "blockedBy": "Bloccato Da",
    "blocking": "Bloccante",
    "blockingOnly": "Blocco solo compiti",
    "brain": {
      "error": "Qualcosa è andato storto durante la creazione del tuo kit. Per favore riprova tra un momento.",
      "destinationNotSupported": "Non possiamo ancora creare un kit di trasferimento per questa destinazione. Il tuo percorso è salvato: TelePortal si aprirà qui non appena questa destinazione sarà supportata.",
      "phase1": "Analizzando il tuo profilo",
      "phase2": "Mappatura dei documenti richiesti",
      "phase3": "Creazione della lista delle attività",
      "phase4": "Personalizzazione delle tappe",
      "phase5": "Finalizzazione del tuo kit",
      "ready": "Il tuo kit è pronto",
      "reviewKit": "Rivedi il tuo kit",
      "stat": {
        "docsNeeded": "Documenti necessari",
        "fromVault": "Dal tuo vault",
        "members": "Membri",
        "tasks": "Compiti"
      },
      "subtitle": "Creazione del tuo kit di trasferimento personalizzato",
      "title": "Cervello TelePortal",
      "complexity": {
        "simple": "Semplice",
        "standard": "Standard",
        "complex": "Complesso"
      }
    },
    "captureMobile": "Cattura su mobile",
    "certificationLabel": "Certificazione",
    "certificationRequired": "{{type}}",
    "clearFilters": "Cancella filtri",
    "clickToUpload": "Clicca per caricare o trascina e rilascia",
    "collapseDetails": "Riduci dettagli",
    "comingSoon": "In arrivo",
    "companionCareerProgress": "Companion Career progresso",
    "companionEmploymentReadiness": "Companion employment readiness assessment",
    "companionIntegrationSupport": "Companion Adaptation support milestones",
    "companionProgram": "Companion program",
    "companionProgramDesc": "Riduzione del rischio per famiglie con doppia carriera — monitora la prontezza al lavoro e il supporto all'integrazione del companion",
    "complete": "Completo",
    "completeInMobile": "Completa in mobile",
    "completeTasksOnMobile": "Completa le attività su mobile",
    "completeTitle": "Valutazione completata!",
    "completed": "Completato",
    "completedDate": "Completato {{date}}",
    "completedSection": "Completato",
    "completionNotesPlaceholder": "Aggiungi note di completamento (opzionale)...",
    "complexity": {
      "complex": "Complesso",
      "simple": "Semplice",
      "standard": "Standard"
    },
    "consultantAgent": "Consultant agent TelePortal",
    "consultantAgentDesc": "Ricevi indicazioni esperte dai nostri consulenti per l'immigrazione",
    "consultantAgentDescription": "Ricevi aiuto con i tuoi documenti e compiti TelePortal",
    "consultantAgentHelp": "Il Consultant Agent può aiutarti a convalidare, organizzare e allegare documenti automaticamente",
    "continue": {
      "description": "Hai iniziato la tua configurazione di TelePortal. Riprendi esattamente da dove hai lasciato su Citizen Web — le tue risposte finora sono salvate.",
      "title": "Continua la tua configurazione TelePortal"
    },
    "continueOnWeb": "Continua su Citizen Web",
    "continueOnWebDesc": "Riprendi la tua configurazione di TelePortal da dove l'hai lasciata sul Portale Web di Citizen.",
    "copilotGuideDescription": "Rispondi a domande sulle tue esigenze di trasferimento",
    "copilotGuideTitle": "Guida CoPilot",
    "couldNotLoad": "Non siamo riusciti a caricare i tuoi dati TelePortal. Per favore riprova.",
    "createApplicationPackage": "Crea pacchetto di domanda",
    "createApplicationPackageDesc": "Prepara e organizza tutti i tuoi documenti di domanda",
    "createApplicationPackageDescription": "Imballa più documenti per le domande di visto e altre sottomissioni",
    "createInMobile": "Crea in mobile",
    "criticalTasks": "Attività critiche",
    "currentProofDocuments": "Documenti di prova correnti",
    "currentlyInProgress": "Attualmente in corso",
    "daysLeft": "{{count}}d rimasti",
    "deleteDocumentDescription": "Questa azione non può essere annullata. Il documento verrà rimosso permanentemente.",
    "deleteDocumentTitle": "Eliminare il documento?",
    "dependencies": {
      "allTracks": "Tutti i percorsi",
      "blockedBy": "Bloccato da",
      "blocking": "Bloccante",
      "blocks": "Blocchi",
      "connectedTasks": "attività collegate",
      "criticalPath": "Percorso critico",
      "dependsOn": "Dipende da",
      "description": "Visualizza come le attività dipendono l'una dall'altra attraverso i percorsi",
      "empty": "Nessuna dipendenza di attività da visualizzare",
      "emptyHint": "Le dipendenze appariranno quando il tuo kit di trasferimento avrà attività collegate",
      "enterFullscreen": "Entra in modalità schermo intero",
      "exitFullscreen": "Esci dalla modalità schermo intero",
      "filterByTrack": "Filtra per percorso",
      "graphLabel": "Grafico delle dipendenze delle attività",
      "graphView": "Visualizzazione grafica",
      "independentTasks": "attività indipendenti",
      "insightBanner": "Panoramica delle dipendenze",
      "listView": "Visualizzazione elenco",
      "members": "Membri",
      "resetView": "Ripristina visualizzazione",
      "shared": "Condiviso",
      "tabTitle": "Dipendenze",
      "title": "Grafico delle dipendenze delle attività",
      "zoomIn": "Zoom avanti",
      "zoomOut": "Zoom indietro"
    },
    "dependenciesResolved": "Dipendenze (risolte)",
    "description": "Descrizione",
    "dimensionFamily": "Configurazione familiare",
    "dimensionStatus": "Stato attuale",
    "dimensionTimeline": "Timeline e scadenze",
    "dimensionVisa": "Tipo di visto e requisiti",
    "docDetail": {
      "actions": "Azioni",
      "certification": "Certificazione",
      "certificationNone": "Non richiesto",
      "certificationRequired": "Richiesto ({{type}})",
      "expired": "Scaduto",
      "expiryDate": "Data di scadenza",
      "issuingAuthority": "Autorità di emissione",
      "location": "Posizione",
      "locationHomeCountry": "Paese di origine",
      "locationOnline": "Online",
      "locationTargetCountry": "Paese target",
      "noExpiry": "Nessuna data di scadenza",
      "status": "Stato",
      "title": "Dettagli del documento",
      "type": "Tipo di documento",
      "upload": "Carica documento",
      "uploadedAt": "Caricato",
      "validityPeriod": "Periodo di validità",
      "view": "Visualizza documento",
      "viewFailed": "Impossibile aprire il documento",
      "openWith": "Apri documento con…",
      "expiresIn_one": "Scade tra {{count}} giorno",
      "expiresIn_other": "Scade tra {{count}} giorni",
      "validFor_one": "Valido per {{count}} giorno",
      "validFor_other": "Valido per {{count}} giorni"
    },
    "docEmployment": "Contratto di lavoro",
    "docIncome": "Prova di reddito",
    "docInsurance": "Assicurazione sanitaria",
    "docNeedsReview": "Il documento necessita di revisione — il formato potrebbe non essere ottimale",
    "docNotUploaded": "Documento non ancora caricato",
    "docPassport": "Passport",
    "docStatusMissing": "Mancante",
    "docStatusPending": "In Attesa",
    "docStatusRejected": "Rifiutato",
    "docStatusUploaded": "Caricato",
    "docStatusVerified": "Verificato",
    "docSuggestion1": "Assicurati che il documento sia chiaro e leggibile",
    "docSuggestion2": "Controlla la data di scadenza",
    "docTypeEducation": "Istruzione",
    "docTypeFinancial": "Finanziario",
    "docTypeHousing": "Alloggio",
    "docTypeIdentity": "Identità",
    "docTypeLegal": "Legale",
    "docTypeOther": "Altro",
    "docTypeTravel": "Viaggio",
    "docUploadedPendingValidation": "Documento caricato, in attesa di validazione",
    "docValid": "Documento verificato e valido",
    "document": {
      "apostille": "Apostille richiesta",
      "certification": "Certificazione",
      "certificationRequired": "Certificazione richiesta",
      "docExpired": "Questo documento è scaduto",
      "docExpiring": "Questo documento scade tra {{days}} giorni",
      "expired": "Scaduto",
      "expiresIn": "Scade tra {{days}} giorni",
      "expiresSoon": "Scade presto",
      "haia": "Apostille dell'aia",
      "validFor": "Valido per {{duration}}"
    },
    "documentDeleted": "Documento eliminato",
    "documentDownloaded": "Documento scaricato",
    "documentName": "Nome del documento",
    "documentNamePlaceholder": "ad es., Passport, Certificato di Nascita...",
    "documentType": "Tipo di documento",
    "documentUploadError": "Impossibile caricare il documento. Riprova.",
    "documentUploadRequired": "Caricamento documento richiesto",
    "documentUploadedSuccess": "Documento caricato con successo",
    "documentValidatedSuccess": "Documento validato con successo",
    "documentValidationError": "Impossibile convalidare il documento. Riprova.",
    "documents": "documenti",
    "documentsDescription": "Carica e verifica i documenti richiesti per la tua domanda di visto e il trasferimento.",
    "documentsGathered": "Documenti raccolti",
    "documentsReady": "Documenti pronti",
    "documentsStatus": "Stato dei documenti",
    "documentsUploaded": "Documenti caricati con successo",
    "done": "Fatto",
    "dueDate": "Data di scadenza",
    "dueToday": "Scadenza oggi",
    "dueTomorrow": "Scadenza domani",
    "editNote": "Modifica nota",
    "editTask": "Modifica attività",
    "employerFull": "Sì, sponsorizzazione completa",
    "employerNA": "Non applicabile",
    "employerNone": "No, auto-sponsorizzato",
    "employerPartial": "Sì, supporto parziale",
    "entireFamily": "Intera famiglia",
    "estimatedDuration": "Durata stimata",
    "estimatedTime": "Tempo stimato",
    "eventTargetArrival": "Arrivo previsto",
    "eventVisaDecision": "Decisione sul visto",
    "eventVisaInterview": "Colloquio per il visto",
    "expandDetails": "Espandi dettagli",
    "expired": "Scaduto",
    "expiredCount": "Scaduto",
    "expiresInDays": "Scade tra {{count}}d",
    "downloadAllDocuments": "Scarica tutto ({{count}})",
    "downloadSelectedDocuments": "Scarica {{count}}",
    "selectDocument": "Seleziona documento",
    "expiresOn": "Scade: {{date}}",
    "expiringSoon": "In scadenza presto",
    "explainTask": "Spiega attività",
    "family": "Famiglia",
    "familyBoth": "Con partner e bambini",
    "familyChildren": "Con bambini",
    "familyConfig": {
      "applicableTracks": "Percorsi applicabili",
      "childNumber": "Bambino {{number}}",
      "companion": "Compagno",
      "configureTracksDescription": "Seleziona quali percorsi (Legale, Viaggio, Configurazione) si applicano a ciascun membro della famiglia",
      "configureTracksTitle": "Configura percorsi per ogni membro",
      "dependent": "Dipendente",
      "description": "Configura l'accesso ai percorsi per ogni membro della famiglia, animale domestico, compagno o dipendente",
      "familyMember": "Membro della famiglia",
      "justMe": "Solo io",
      "legal": "Legale",
      "mainQuestion": "Ti trasferirai con membri della famiglia?",
      "partnerSpouse": "Partner/Coniuge",
      "pet": "Animale domestico",
      "pets": "Animali domestici",
      "setup": "Impostazione",
      "travel": "Viaggio",
      "yesBringingFamily": "Sì, porto la famiglia",
      "membersConfigured_one": "{{count}} membro configurato",
      "membersConfigured_other": "{{count}} membri configurati"
    },
    "familyJustMe": "Solo io",
    "familyMasterOnly": "Solo il Capofamiglia può modificare i compiti TelePortal",
    "familyMasterOnlyDesc": "Solo il Capofamiglia può avviare o controllare la valutazione e i compiti TelePortal. Contatta il tuo Capofamiglia per assistenza.",
    "familyPartner": "Con partner/coniuge",
    "filter": {
      "allExpiry": "Tutte le scadenze",
      "clearAll": "Cancella",
      "expired": "Scaduto",
      "expiringSoon": "In scadenza presto",
      "location": "Posizione",
      "locationAll": "Tutte le posizioni",
      "locationHome": "Paese di origine",
      "locationOnline": "Online",
      "locationTarget": "Paese target",
      "member": "Membro",
      "memberAll": "Tutti i membri",
      "selectMember": "Seleziona membro",
      "sort": "Ordina",
      "sortDefault": "Predefinito",
      "sortDueDate": "Data di scadenza",
      "sortPriority": "Priorità",
      "valid": "Valido"
    },
    "ganttView": "Visualizzazione Gantt",
    "generatingChecklist": "Generazione della tua checklist personalizzata...",
    "goToJourneyBuilder": "Vai al costruttore di viaggi",
    "groupBy": {
      "byTrack": "Per percorso",
      "label": "Raggruppa per",
      "location": "Raggruppa per posizione"
    },
    "guideSetupSubtitle": "Ti guideremo attraverso la configurazione — rispondi a qualche domanda e costruiremo il tuo kit.",
    "heroBanner": {
      "complete": "Completo",
      "documents": "Documenti",
      "household": "Nucleo familiare",
      "milestones": "Traguardi",
      "subtitle": "Il tuo centro di comando per la relocation",
      "tasks": "Compiti",
      "title": "TelePortal"
    },
    "heroMiles": "TelePortal Miles",
    "highPriority": "Alta priorità",
    "household": {
      "everyone": "Tutti",
      "bar": {
        "allMembers": "Tutti i membri",
        "filterBy": "Filtra per membro",
        "filterByMember": "Filtra per membro"
      },
      "petSpecies": {
        "cat": "Gatto",
        "dog": "Cane",
        "other": "Altro"
      },
      "schoolStages": {
        "higher": "Istruzione superiore",
        "pre_school": "Scuola materna",
        "primary": "Scuola primaria",
        "secondary": "Scuola secondaria"
      },
      "talent": "Tu"
    },
    "householdAware": "Consapevole della famiglia",
    "householdMembers": "Membri del nucleo familiare",
    "inProgressSection": "In corso",
    "keyDates": "Date chiave",
    "kit": {
      "activate": "Attiva kit",
      "activateModified": "Attiva kit modificato",
      "buildFailed": "Impossibile costruire il tuo kit",
      "buildFailedHint": "Riprova o contatta il supporto se il problema persiste.",
      "byMember": "Per membro",
      "byTrack": "Per percorso",
      "complexity": {
        "complex": "Complesso",
        "simple": "Semplice",
        "standard": "Standard"
      },
      "defaultMember": "Tu",
      "dependencyWarning": "Alcune attività dipendono da altre. Rimuovere una potrebbe bloccare il lavoro successivo.",
      "docs": "Documenti",
      "docsLinked": "Dal vault",
      "docsNeeded": "Documenti necessari",
      "editHint": "Clicca su qualsiasi attività per modificare, rimuovere o riordinare.",
      "loading": "Caricamento kit…",
      "members": "Membri",
      "miles": "Miles",
      "modified": "Modificato",
      "rebuild": "Ricostruisci",
      "rebuildConfirm": "Ricostruisci kit",
      "rebuildConfirmDesc": "La ricostruzione creerà un nuovo kit basato sul tuo ultimo profilo. Le modifiche apportate andranno perse.",
      "rebuildConfirmTitle": "Ricostruire il tuo kit?",
      "removeTask": "Rimuovi attività",
      "removedTasks": "Attività rimosse",
      "required": "Richiesto",
      "requiredTask": "Attività richiesta",
      "restore": "Ripristina",
      "retry": "Riprova",
      "tasks": "Compiti",
      "title": "Il tuo kit TelePortal",
      "vaultLinked": "Collegato dal vault",
      "taskCount_one": "{{count}} compito",
      "taskCount_other": "{{count}} compiti",
      "milestoneCount_one": "{{count}} traguardo",
      "milestoneCount_other": "{{count}} traguardi"
    },
    "location": {
      "all": "Tutti",
      "either": "Qualsiasi paese",
      "filter": "Posizione",
      "filterLabel": "Posizione",
      "homeCountry": "Paese di origine",
      "online": "Online",
      "other": "Altro",
      "targetCountry": "Paese target"
    },
    "locationEither": "Qualsiasi",
    "locationHome": "Casa",
    "locationOnline": "Online",
    "locationTarget": "Target",
    "manageJourney": "Pianifica la tua relocation",
    "markAsDone": "Segna come fatto",
    "markComplete": "Segna completo",
    "milesEarned": "+{{miles}} Miles di Viaggio guadagnate",
    "milestoneArrivalPlanning": "Pianificazione arrivo",
    "milestoneDocumentCollection": "Raccolta documenti",
    "milestoneEssentialServices": "Servizi essenziali",
    "milestoneFinancialSetup": "Impostazione finanziaria",
    "milestoneHousing": "Alloggio",
    "milestoneTravelBooking": "Prenotazione viaggio",
    "milestoneVisaApplication": "Domanda di visto",
    "milestones": {
      "admin_complete": "Amministrazione completa",
      "arrived_in_destination": "Arrivato a destinazione",
      "arrived_in_portugal": "Arrivato in portogallo",
      "documents_gathered": "Documenti raccolti",
      "documents_legalized": "Documenti legalizzati",
      "fully_settled": "Completamente sistemato",
      "housing_secured": "Alloggio sicuro",
      "legal_registration_complete": "Registrazione legale completata",
      "travel_booked": "Viaggio prenotato",
      "visa_approved": "Visto approvato"
    },
    "milestonesCount": "{{completed}}/{{total}} traguardi",
    "milestonesLabel": "Traguardi",
    "missing": "Mancante",
    "mobileAppDescription": "Usa l'app mobile per caricare documenti, completare compiti e ricevere assistenza in tempo reale dal Consultant Agent TelePortal.",
    "needHelp": "Hai bisogno di aiuto?",
    "needsAttention": "Richiede attenzione",
    "noAgentHistory": "Nessuna interazione con l'agente finora",
    "noAgentHistoryDescription": "Usa il Consultant Agent TelePortal nell'app mobile per ricevere aiuto con i documenti",
    "noDocumentsAttached": "Nessun documento allegato ancora",
    "noDocumentsInTrack": "Nessun documento in questo percorso finora",
    "noDocumentsUploaded": "Nessun documento caricato finora",
    "noJourneySelected": "Nessun viaggio selezionato",
    "noJourneySelectedDesc": "Seleziona un viaggio per visualizzare i tuoi compiti e progressi TelePortal",
    "noMilestonesYet": "Nessun traguardo finora",
    "noPackages": "Nessun pacchetto di applicazione creato finora",
    "noPackagesDescription": "Crea pacchetti nell'app mobile per organizzare i documenti per le presentazioni",
    "noProofAttached": "Nessun documento di prova allegato finora",
    "noTasksAnyTrack": "Nessun compito disponibile in alcun percorso finora",
    "noTasksFoundForFilter": "Nessun compito trovato per il filtro selezionato",
    "noTasksInProgress": "Nessun compito attualmente in corso",
    "noTasksInTrack": "Nessun compito disponibile in questo percorso finora",
    "noTasksMatchingFilters": "Nessun compito corrisponde ai tuoi filtri attuali",
    "notePlaceholder": "Aggiungi le tue note qui...",
    "noteSaved": "Nota salvata",
    "notes": "Note",
    "openInApp": "Apri nell'app",
    "openInMobile": "Apri nel mobile",
    "openTonnieCitizen": "Apri nell'app",
    "openingDocument": "Apertura documento...",
    "orDragAndDrop": "PDF, JPG, PNG fino a 10MB",
    "orUploadNewProof": "O carica nuovo documento di prova",
    "otherDocuments": "Altri documenti",
    "overallProgress": "Progresso complessivo",
    "overdue": "Scaduto",
    "packageCreated": "Creato",
    "packageDocuments": "Documenti",
    "packageDownload": "Scarica pacchetto",
    "packageName": "Nome pacchetto",
    "packagePurpose": "Scopo",
    "pending": "In Attesa",
    "pendingReview": "In attesa di revisione",
    "preparingSetup": "Preparazione configurazione…",
    "priorityBlockedTasks": "Compiti prioritari e bloccati",
    "priorityTasksRequiringAttention": "Compiti prioritari che richiedono attenzione",
    "proOnly": "Solo Pro",
    "processing": "Elaborazione...",
    "progress": "Progresso",
    "progressComplete": "{{percent}}% completato",
    "progressSummary": "Sei al {{progress}}% del tuo viaggio di trasferimento. {{attention}} compiti necessitano della tua attenzione.",
    "progressTitle": "Progresso della valutazione",
    "proof": "Prova",
    "proofOfDone": "Prova di completamento",
    "proofOfDoneDescription": "Allega un documento come prova che questo compito è stato completato",
    "proofRequired": "Questo compito richiede prova di completamento. Si prega di allegare un documento.",
    "questionCurrentStatus": "Qual è il tuo stato attuale?",
    "questionEmployerSupport": "Hai supporto o sponsorizzazione da parte del datore di lavoro?",
    "questionFamily": "Ti trasferirai con membri della famiglia?",
    "questionTargetDate": "Qual è la tua data di trasferimento target?",
    "questionTargetDateFormatted": "Qual è la tua data di trasferimento target? (MM/YYYY)",
    "questionVisaType": "Che tipo di visto o percorso di trasferimento stai pianificando?",
    "readOnly": "Visualizzazione solo lettura",
    "readOnlyDescription": "I compiti possono essere completati nell'app mobile",
    "redirectingIn": "Reindirizzamento...",
    "rejected": "Rifiutato",
    "required": "Richiesto",
    "requiredDocuments": "Documenti richiesti",
    "requiredForTask": "Richiesto per",
    "requiresProof": "Richiede prova",
    "resolveNow": "Risolvi ora",
    "retakeOnWeb": "Rifai la configurazione su Citizen Web",
    "retakeOnWebDesc": "Ripeti la procedura guidata di configurazione di TelePortal sul Portale Web di Citizen per aggiornare il tuo piano di relocation personalizzato.",
    "retakeSetup": {
      "label": "Ripeti configurazione",
      "acknowledge": "Capisco",
      "cleanDocs": "Cancella documenti collegati",
      "cleanTasks": "Cancella attività modificate",
      "confirmReset": "Ripristina e ricostruisci",
      "preFilled": "Le tue risposte precedenti sono precompilate. Aggiorna ciò che è cambiato.",
      "rebuildTasks": "Ricostruisci elenco attività"
    },
    "returnToDashboard": "Torna alla dashboard",
    "saveNote": "Salva nota",
    "searchTasks": "Cerca attività...",
    "selectDocumentType": "Seleziona tipo...",
    "selected": "Selezionato",
    "setup": {
      "dimensions": {
        "household": {
          "addMember": "Aggiungi membro della famiglia",
          "memberTypes": {
            "child": "Bambino",
            "extended_family": "Famiglia allargata",
            "partner": "Partner / Coniuge",
            "pet": "Animale domestico",
            "talent": "Richiedente principale (tu)"
          },
          "subtitle": "Chi si sta trasferendo con te?",
          "title": "La tua famiglia"
        },
        "housing": {
          "plans": {
            "buy": "Acquista una proprietà",
            "company_provided": "Alloggio fornito dall'azienda",
            "rent": "Affitta un appartamento",
            "temporary": "Alloggio temporaneo prima"
          },
          "subtitle": "Dove vivrai?",
          "title": "Piano abitativo"
        },
        "legalStatus": {
          "currentStatus": "Stato attuale dell'immigrazione",
          "subtitle": "La tua attuale situazione legale",
          "title": "Stato legale e di immigrazione",
          "visaType": "Tipo di visto"
        },
        "professional": {
          "sponsorshipTypes": {
            "company_sponsored": "Sponsorizzato dall'azienda",
            "freelancer": "Libero professionista / Nomade digitale",
            "intra_company": "Trasferimento intra-aziendale",
            "job_seeker": "Cercatore di lavoro",
            "other": "Altro",
            "retired": "Pensionato",
            "self_employed": "Lavoratore autonomo",
            "startup": "Avviare un'attività",
            "student": "Studente"
          },
          "subtitle": "La tua situazione lavorativa",
          "title": "Contesto professionale"
        },
        "specialCircumstances": {
          "freeTextPlaceholder": "Dicci qualsiasi altra cosa...",
          "options": {
            "custody_arrangement": "Accordo di custodia",
            "dietary_needs": "Esigenze dietetiche speciali",
            "disability_accommodation": "Adattamento per disabilità",
            "medical_needs": "Esigenze mediche o trattamenti in corso",
            "military_service": "Obblighi di servizio militare",
            "pending_legal": "Questioni legali in sospeso",
            "religious_requirements": "Requisiti religiosi"
          },
          "subtitle": "C'è qualcos'altro che dovremmo sapere?",
          "title": "Circostanze speciali"
        },
        "timeline": {
          "subtitle": "Quando hai bisogno di trasferirti?",
          "title": "Tempistica",
          "urgencies": {
            "flexible": "Flessibile / Nessuna fretta",
            "immediate": "Immediatamente (entro 1 mese)",
            "within_3_months": "Entro 3 mesi",
            "within_6_months": "Entro 6 mesi"
          }
        },
        "travel": {
          "modes": {
            "already_there": "Già a destinazione",
            "one_way": "Viaggio di sola andata",
            "round_trip": "Viaggio di andata e ritorno (tornando prima)"
          },
          "subtitle": "Come e quando viaggerai?",
          "title": "Logistica di viaggio"
        },
        "vaultScan": {
          "linked": "Collegato da vault",
          "outdated": "Necessita aggiornamento",
          "skip": "Salta per ora",
          "subtitle": "Controlliamo quali documenti hai già",
          "title": "Scansione documenti"
        }
      },
      "processing": {
        "subtitle": "Tonnie sta analizzando la tua situazione e creando un piano personalizzato...",
        "title": "Costruendo il tuo kit di trasferimento"
      },
      "refresh": {
        "button": "Aggiorna il mio kit di trasferimento",
        "cancel": "Annulla",
        "confirm": "Aggiorna",
        "confirmMessage": "Le tue attività completate saranno preservate. Potrebbero essere aggiunte nuove attività e alcune potrebbero essere archiviate.",
        "confirmTitle": "Aggiornare il kit di trasferimento?"
      },
      "subtitle": "Personalizziamo il tuo piano di rilocazione",
      "summary": {
        "beginJourney": "Inizia il mio viaggio",
        "complexityLabel": "Complessità",
        "documentsLabel": "Documenti necessari",
        "householdLabel": "Membri del nucleo familiare",
        "tasksLabel": "Totale attività",
        "title": "Il tuo kit di trasferimento",
        "tracksLabel": "Tracce"
      },
      "title": "Crea il tuo kit di trasferimento",
      "welcome": {
        "prePopulated": "Abbiamo precompilato alcune informazioni dal tuo profilo",
        "subtitle": "Costruiremo un Kit di Trasferimento personalizzato in base alla tua situazione",
        "title": "Benvenuto nella configurazione TelePortal"
      },
      "aria": {
        "collapsePanel": "Riduci il pannello",
        "pinPanel": "Fissa il pannello",
        "unpinPanel": "Sblocca il pannello"
      }
    },
    "setupActivateError": "Attivazione del kit non riuscita",
    "setupActivatingMessage": "Attivazione del tuo kit — ci vuole solo un momento.",
    "setupActivatingTitle": "Attivazione…",
    "setupComplete": "Configurazione completata",
    "setupCompletedOn": "Configurazione completata il {{date}}",
    "setupConfigError": "Non siamo riusciti a caricare la tua configurazione di setup",
    "setupError": "Errore di configurazione",
    "setupEstimatedTime": "Circa 5 minuti",
    "setupInfoDescription": "Ti faremo alcune domande per personalizzare il tuo kit — cosa portare, chi viene e la tua tempistica.",
    "setupInfoIntro": "TelePortal è il tuo centro di comando per il trasferimento. La configurazione ci aiuta a personalizzare il kit per il tuo trasferimento.",
    "setupMissingJourney": "Non siamo riusciti a trovare un viaggio da configurare.",
    "setupNoJourney": "Nessun viaggio selezionato",
    "setupNoJourneyMessage": "Scegli prima un viaggio, poi costruiremo il tuo kit TelePortal.",
    "setupOnWeb": "Configura su Citizen Web",
    "setupOnWebDesc": "Completa la procedura guidata di configurazione di TelePortal sul Portale Web di Citizen per costruire il tuo piano di relocation personalizzato.",
    "setupProgress": "Progresso della configurazione",
    "setupSubtitle": "Personalizza il tuo kit di trasferimento",
    "setupSuccessMessage": "Il tuo kit è pronto. Iniziamo il tuo trasferimento.",
    "setupSuccessTitle": "Sei a posto",
    "setupTitle": "Configurazione TelePortal",
    "somethingWentWrong": "Qualcosa è andato storto",
    "startAssessment": "Inizia valutazione",
    "startTask": "Inizia attività",
    "status": "Stato",
    "statusBlocked": "Bloccato",
    "statusCompleted": "Completato",
    "statusHome": "Ancora nel paese d'origine",
    "statusInProgress": "In corso",
    "statusMoved": "Già trasferito a destinazione",
    "statusOverdue": "Scaduto",
    "statusTodo": "Da fare",
    "statusTransit": "In transito",
    "stepOf": "Passo {{current}} di {{total}}",
    "summary": {
      "assessmentDetails": "Dettagli della valutazione",
      "checklistPreviewTitle": "La tua lista di controllo personalizzata includerà:",
      "currentStatus": "Stato attuale",
      "description": "Rivedi i dettagli del tuo trasferimento prima di generare la tua lista di controllo personalizzata",
      "destination": "Destinazione",
      "employerSupport": "Supporto del datore di lavoro",
      "familyConfiguration": "Configurazione familiare",
      "generateChecklist": "Genera lista di controllo",
      "journeyRoute": "Percorso del viaggio",
      "legalTrackDesc": "Traccia legale — Prontezza legale e documenti",
      "makeChanges": "Apporta modifiche",
      "notSelected": "Non selezionato",
      "origin": "Origine",
      "setupTrackDesc": "Traccia di configurazione — Sistemazione, riconoscimento delle credenziali e prime settimane",
      "targetMoveDate": "Data di trasferimento target",
      "title": "Riepilogo della valutazione TelePortal",
      "travelTrackDesc": "Traccia di viaggio — Logistica e pianificazione dei viaggi",
      "viewModeDescription": "Completa informazioni sulla tua valutazione di trasferimento",
      "visaType": "Tipo di visto"
    },
    "tabDocuments": "Documenti",
    "tabOverview": "Panoramica",
    "tabTasks": "Compiti",
    "tabTimeline": "Tempistica",
    "tabTracks": "Tracce & attività",
    "targetDate": "Data target",
    "task": {
      "allMembers": "Tutti i membri",
      "ask": "Chiedi",
      "askCopilotTask": "Chiedi a CoPilot riguardo a questo compito",
      "blockedBy": "Bloccato Da",
      "blockedComplete": "Bloccato — Completa prima le dipendenze",
      "completeError": "Impossibile completare il compito. Riprova.",
      "completionNotesPlaceholder": "Aggiungi note di completamento (opzionale)...",
      "confirmComplete": {
        "message": "Sei sicuro di voler contrassegnare questa attività come completata? Questa azione non può essere annullata.",
        "title": "Contrassegna attività come completata?"
      },
      "dependenciesResolved": "Dipendenze (risolte)",
      "docStatusMissing": "Mancante",
      "docStatusPending": "In Attesa",
      "docStatusRejected": "Rifiutato",
      "docStatusUploaded": "Caricato",
      "docStatusVerified": "Verificato",
      "documents": "Documenti",
      "documentsRequired": "Documenti richiesti",
      "dueToday": "Scadenza oggi",
      "dueTomorrow": "Scadenza domani",
      "entireFamily": "Intera famiglia",
      "markComplete": "Segna come completo",
      "needHelp": "Hai bisogno di aiuto?",
      "noAdditionalDocs": "Nessun documento aggiuntivo",
      "noDocsAttached": "Nessun documento allegato ancora",
      "notFound": "Compito non trovato",
      "notes": "Note",
      "otherDocuments": "Altri documenti",
      "reopenError": "Impossibile riaprire il compito. Riprova.",
      "reopenTask": "Riattiva compito",
      "requiredDocuments": "Documenti richiesti",
      "statusBlocked": "Bloccato",
      "statusCompleted": "Completato",
      "statusInProgress": "In corso",
      "statusOverdue": "Scaduto",
      "statusTodo": "Da fare",
      "taskBlocked": "Compito bloccato",
      "taskBlockedMsg": "Completa prima i compiti bloccanti prima di segnare questo come fatto.",
      "title": "Compito",
      "trackLegal": "Legale",
      "trackSetup": "Impostazione",
      "trackTravel": "Viaggio",
      "uploadDocument": "Carica documento",
      "uploadDocumentHint": "Usa la fotocamera, la libreria foto o file",
      "uploadRequired": "Carica richiesto",
      "uploaded": "Caricato",
      "validated": "Convalidato",
      "companyOwnedNote": "Questo compito è gestito dalla tua azienda — lo completeranno da parte loro.",
      "companyProvidesDoc": "La tua azienda fornisce questo",
      "daysOverdue_one": "{{count}} giorno di ritardo",
      "daysOverdue_other": "{{count}} giorni di ritardo",
      "documentsRequiredMsg_one": "Carica i documenti richiesti prima di completare questa attività. Manca ancora {{count}} documento.",
      "documentsRequiredMsg_other": "Carica i documenti richiesti prima di completare questa attività. Mancano ancora {{count}} documenti.",
      "dueInDays_one": "Scade tra {{count}} giorno",
      "dueInDays_other": "Scade tra {{count}} giorni",
      "milesReward_one": "+{{count}} Mile",
      "milesReward_other": "+{{count}} Miles",
      "missingCount_one": "{{count}} mancante",
      "missingCount_other": "{{count}} mancanti",
      "uploadDocsFirst_one": "Carica prima {{count}} documento richiesto",
      "uploadDocsFirst_other": "Carica prima {{count}} documenti richiesti"
    },
    "taskArrangePickup": "Organizza il ritiro dall'aeroporto",
    "taskArrangePickupDesc": "Organizza il trasporto dall'aeroporto",
    "taskBookFlights": "Prenota voli",
    "taskBookFlightsDesc": "Prenota i tuoi voli per il paese di destinazione",
    "taskCompleted": "Compito completato",
    "taskCompletedError": "Impossibile completare il compito. Riprova.",
    "taskCompletedSuccess": "Compito completato con successo!",
    "taskCredentialRecognition": "Completa il processo di riconoscimento delle credenziali",
    "taskCredentialRecognitionDesc": "Completa il processo di riconoscimento delle credenziali per professioni regolamentate",
    "taskDefinitiveHousing": "Trova alloggio definitivo",
    "taskDefinitiveHousingDesc": "Trova e assicurati un alloggio permanente",
    "taskFillApplication": "Compila il modulo di richiesta del visto",
    "taskFillApplicationDesc": "Completa il modulo di richiesta del visto con informazioni accurate",
    "taskGatherDocuments": "Raccogli documenti richiesti",
    "taskGatherDocumentsDesc": "Raccogli tutti i documenti necessari per la tua richiesta di visto",
    "taskNotFound": "Compito non trovato",
    "taskNoteDescription": "Aggiungi una nota personale per questo compito",
    "taskNoteTitle": "Nota compito: {{title}}",
    "taskPlanItinerary": "Pianifica l'itinerario di arrivo",
    "taskPlanItineraryDesc": "Pianifica il tuo itinerario di arrivo e i primi giorni",
    "taskPrepareMaterials": "Prepara materiali per il colloquio",
    "taskPrepareMaterialsDesc": "Prepara tutti i materiali necessari per il colloquio",
    "taskReopened": "Compito riaperto",
    "taskScheduleInterview": "Pianifica colloquio per il visto",
    "taskScheduleInterviewDesc": "Pianifica il tuo appuntamento per il colloquio per il visto",
    "taskSchoolingChildcare": "Organizza istruzione e assistenza all'infanzia",
    "taskSchoolingChildcareDesc": "Organizza istruzione e assistenza all'infanzia per i bambini",
    "taskStatus": {
      "blocked": "Bloccato",
      "completed": "Completato",
      "in_progress": "In corso",
      "not_started": "Non iniziato",
      "overdue": "Scaduto",
      "pending": "In Attesa",
      "todo": "Da fare"
    },
    "taskTemporaryHousing": "Assicurati un alloggio temporaneo",
    "taskTemporaryHousingDesc": "Assicurati un alloggio temporaneo per il tuo arrivo",
    "tasks": {
      "apostille_documents": {
        "description": "Ottieni timbri apostille ufficiali su tutti i documenti richiesti",
        "title": "Documenti apostille"
      },
      "baggage_shipping": {
        "company_title": "Organizza spedizione bagagli",
        "description": "Organizza la spedizione degli effetti personali alla destinazione",
        "title": "Spedizione bagagli"
      },
      "child_dependent_visa": {
        "description": "Invia la domanda per il visto dipendente per i bambini",
        "title": "Visto per minori dipendenti"
      },
      "collect_birth_certificate": {
        "description": "Ottieni certificati di nascita certificati per tutti i membri della famiglia che si trasferiscono",
        "title": "Raccogli certificato di nascita"
      },
      "collect_marriage_certificate": {
        "description": "Ottieni certificato di matrimonio certificato per le domande di visto",
        "title": "Raccogli certificato di matrimonio"
      },
      "collect_passport": {
        "description": "Raccogli passaporti validi per tutti i membri della famiglia che si trasferiscono",
        "title": "Raccogli Passport"
      },
      "credential_recognition": {
        "description": "Richiedi il riconoscimento delle credenziali professionali nel paese di destinazione",
        "title": "Riconoscimento delle credenziali"
      },
      "criminal_record": {
        "description": "Richiedi il certificato del casellario giudiziale dal tuo paese d'origine",
        "title": "Ottieni certificato del casellario giudiziale"
      },
      "drivers_license_exchange": {
        "description": "Scambia la tua patente di guida straniera con una locale",
        "title": "Scambio di patente di guida"
      },
      "employment_contract": {
        "company_title": "Emettere il contratto di lavoro",
        "description": "Assicurati di avere il contratto di lavoro firmato dal tuo datore di lavoro",
        "title": "Contratto di lavoro"
      },
      "find_housing": {
        "company_title": "Organizza supporto abitativo",
        "description": "Cerca e trova un alloggio permanente",
        "title": "Trova alloggio"
      },
      "flight_booking": {
        "company_title": "Organizza prenotazione volo",
        "description": "Prenota voli per tutti i membri della famiglia che si trasferiscono",
        "title": "Prenota voli"
      },
      "get_codice_fiscale": {
        "description": "Ottieni il tuo codice fiscale italiano",
        "title": "Ottieni codice fiscale"
      },
      "get_nie": {
        "description": "Ottieni il tuo numero di identificazione per stranieri spagnolo",
        "title": "Ottieni NIE"
      },
      "get_nif": {
        "description": "Richiedi il tuo numero di identificazione fiscale portoghese (NIF)",
        "title": "Ottieni NIF (numero fiscale)"
      },
      "get_niss": {
        "description": "Registrati per il numero di previdenza sociale portoghese (NISS)",
        "title": "Ottieni NISS (previdenza sociale)"
      },
      "groupBy": {
        "member": "Gruppo per membro",
        "shared": "Condiviso (familiare)",
        "status": "Gruppo per stato"
      },
      "health_insurance_enrollment": {
        "company_title": "Organizza assicurazione sanitaria",
        "description": "Iscriviti alla copertura assicurativa sanitaria",
        "title": "Assicurazione sanitaria"
      },
      "health_registration": {
        "description": "Registrati con il sistema sanitario locale",
        "title": "Registrazione sanitaria"
      },
      "local_sim": {
        "description": "Acquista una SIM locale o eSIM per il tuo paese di destinazione",
        "title": "Ottieni SIM locale"
      },
      "marriage_certificate": {
        "description": "Raccogli il tuo certificato di matrimonio",
        "title": "Certificato di matrimonio"
      },
      "municipality_registration": {
        "description": "Registrati presso il tuo comune locale (Junta de Freguesia)",
        "title": "Registrazione comunale"
      },
      "nif_partner": {
        "description": "Richiedi il numero di identificazione fiscale portoghese del tuo partner",
        "title": "NIF partner (numero fiscale)"
      },
      "open_bank_account": {
        "description": "Apri un conto bancario nel tuo paese di destinazione",
        "title": "Apri conto bancario"
      },
      "ownership": {
        "company": "Compito aziendale",
        "dual": "Responsabilità condivisa",
        "government": "Processo governativo",
        "talent": "Il tuo compito"
      },
      "partner_visa_application": {
        "description": "Invia la domanda di visto per il tuo partner/coniuge",
        "title": "Domanda di visto per partner"
      },
      "pet_microchip_verification": {
        "description": "Verifica che il microchip del tuo animale domestico sia conforme ISO e leggibile",
        "title": "Verifica microchip animale domestico"
      },
      "pet_passport": {
        "description": "Ottieni il passaporto UE per animali domestici con registri di vaccinazione",
        "title": "Passaporto dell'animale domestico"
      },
      "pet_transport": {
        "description": "Organizza un trasporto sicuro per il tuo animale domestico verso la destinazione",
        "title": "Trasporto animale domestico"
      },
      "pet_vaccination": {
        "description": "Assicurati che tutte le vaccinazioni richieste siano aggiornate per il tuo animale domestico",
        "title": "Vaccinazione animale domestico"
      },
      "portuguese_bank_transfer": {
        "description": "Imposta trasferimenti internazionali al tuo conto bancario portoghese",
        "title": "Trasferimento bancario internazionale"
      },
      "proof_of_address": {
        "description": "Ottieni prova ufficiale del tuo indirizzo di residenza",
        "title": "Prova di indirizzo"
      },
      "proof_of_income": {
        "description": "Raccogli estratti conto bancari e prova di mezzi finanziari",
        "title": "Prova di reddito"
      },
      "provide_employment_contract": {
        "company_title": "Fornisci contratto di lavoro al talento",
        "description": "L'azienda fornisce il contratto di lavoro firmato",
        "title": "Fornisci contratto di lavoro"
      },
      "promise_contract": {
        "company_title": "Fornisci contratto di promessa di lavoro",
        "description": "L'azienda emette il contratto di promessa di lavoro firmato per la domanda di visto",
        "title": "Contratto di promessa di lavoro"
      },
      "consulate_invitation_letter": {
        "company_title": "Fornisci lettera di invito per il consolato",
        "description": "L'azienda emette la lettera di invito / dichiarazione che il talento presenta al consolato",
        "title": "Lettera di invito al consolato"
      },
      "term_of_responsibility": {
        "company_title": "Fornisci termini di responsabilità",
        "description": "L'azienda firma il termine di responsabilità notarizzato che copre il soggiorno del talento",
        "title": "Termini di responsabilità"
      },
      "techvisa_endorsement": {
        "company_title": "Fornire l'endorsement per il visto tecnologico dell'azienda",
        "description": "L'azienda certificata emette l'endorsement per il visto tecnologico / termine di responsabilità per l'assunzione riconosciuta da IAPMEI",
        "title": "Endorsement per il visto tecnologico"
      },
      "reopen": {
        "button": "Riattiva compito",
        "confirmMessage": "Questo riporterà il compito allo stato di attesa.",
        "confirmTitle": "Riattivare questo compito?",
        "reason": "Motivo per la riattivazione (opzionale)"
      },
      "residence_permit_renewal": {
        "description": "Monitora e pianifica la tua tempistica di rinnovo del permesso di soggiorno",
        "title": "Rinnovo del permesso di soggiorno"
      },
      "salary_proof": {
        "description": "Raccogli le buste paga o la prova di compenso",
        "title": "Prova di salario"
      },
      "school_enrollment": {
        "description": "Iscrivi i bambini nelle scuole locali",
        "title": "Iscrizione scolastica"
      },
      "school_records": {
        "description": "Raccogli i documenti scolastici e le trascrizioni per i bambini",
        "title": "Documenti scolastici"
      },
      "sef_aima_appointment": {
        "description": "Pianifica e partecipa al tuo appuntamento con l'autorità per l'immigrazione",
        "title": "Appuntamento sEF/AIMA"
      },
      "sign_lease": {
        "description": "Rivedi e firma il tuo contratto di locazione",
        "title": "Firma contratto di locazione"
      },
      "sns_registration": {
        "description": "Registrati presso il Servizio Sanitario Nazionale Portoghese (SNS)",
        "title": "Registrazione SNS"
      },
      "sponsor_letter": {
        "company_title": "Fornire lettera di sponsorizzazione",
        "description": "Ottieni la lettera di sponsorizzazione dal tuo datore di lavoro",
        "title": "Lettera di sponsorizzazione"
      },
      "temp_accommodation": {
        "company_title": "Organizza sistemazione temporanea",
        "description": "Organizza un alloggio temporaneo per le tue prime settimane",
        "title": "Sistemazione temporanea"
      },
      "translate_documents": {
        "description": "Ottieni traduzioni certificate di tutti i documenti richiesti",
        "title": "Traduci documenti"
      },
      "travel_insurance": {
        "description": "Organizza la copertura assicurativa per il viaggio durante il periodo di trasferimento",
        "title": "Assicurazione di viaggio"
      },
      "utilities_setup": {
        "description": "Imposta elettricità, acqua, gas e internet nella tua nuova casa",
        "title": "Impostazione utilità"
      },
      "visa_application": {
        "description": "Invia la tua domanda di visto al consolato o al portale online",
        "title": "Domanda di visto"
      },
      "visa_pickup": {
        "description": "Ritira il visto approvato dal consolato o dall'ambasciata",
        "title": "Ritiro visto"
      }
    },
    "tasksCompleted": "Compiti completati",
    "tasksCount": "{{completed}}/{{total}} compiti",
    "tasksDone": "Compiti fatti",
    "tasksLabel": "Compiti",
    "tasksOfTotal": "{{completed}}/{{total}} compiti",
    "timelineDescription": "Cronologia visiva delle fasi del tuo trasferimento",
    "timelineTitle": "Cronologia & vista Gantt",
    "timelineView": "Vista cronologia",
    "title": "TelePortal",
    "toDo": "Da fare",
    "tonnieChecked": "Tonnie-Controllato",
    "track": {
      "legal": "Legale",
      "setup": "Impostazione",
      "travel": "Viaggio"
    },
    "trackJourneyProgress": "Monitora i progressi del tuo viaggio di trasferimento",
    "trackLegal": "Monitoraggio legale",
    "trackLegalDesc": "Prontezza legale basata su percorsi, liste di controllo documenti (consapevole delle famiglie)",
    "trackLegalDescShort": "Visti, permessi e documentazione legale",
    "trackProgress": "Monitora progresso",
    "trackSetup": "Impostazione monitoraggio",
    "trackSetupDesc": "Strato di stabilizzazione (prime settimane) inclusi alloggio, riconoscimento delle credenziali, istruzione/assistenza all'infanzia e traguardi del Programma Compagno",
    "trackSetupDescShort": "Alloggio, banche e sistemazione",
    "trackSuffix": "Monitora",
    "trackTasksProgress": "{{completed}}/{{total}} compiti",
    "trackTravel": "Monitoraggio viaggio",
    "trackTravelDesc": "Prontezza logistica, pianificazione dei viaggi consapevole delle famiglie",
    "trackTravelDescShort": "Voli, alloggio e logistica",
    "tracks": {
      "legal": "Legale & documenti",
      "setup": "Impostazione locale",
      "travel": "Viaggio & logistica"
    },
    "tracksCompleted": "Tracce completate",
    "tryAgain": "Riprova",
    "tryAgainLater": "Per favore riprova più tardi.",
    "unableToLoadData": "Impossibile caricare i dati di TelePortal",
    "unlockPro": "Sblocca con Pro",
    "upcomingDeadlines": "Scadenze imminenti",
    "upcomingTasks": "Compiti imminenti",
    "upgradeMessage": "Aggiorna per accedere a tutte le fasi e funzionalità avanzate di TelePortal.",
    "upload": "Carica",
    "uploadDocument": "Carica documento",
    "uploadDocumentDescription": "Aggiungi un documento al tuo viaggio TelePortal",
    "uploadFromMobile": "Carica da mobile",
    "uploadFromMobileDescription": "Usa Tonnie Citizen per scansionare e caricare documenti istantaneamente",
    "uploadFromMobileTitle": "Carica documenti dal mobile",
    "uploadInMobile": "Carica nel mobile",
    "uploaded": "caricato",
    "uploading": "Caricamento...",
    "validate": "Convalida",
    "validated": "Convalidato",
    "vault": {
      "continue": "Continua",
      "continueWithPending": "Continua (in attesa di revisione)",
      "documentsFound": "documenti trovati nel tuo Vault",
      "empty": "Vault vuoto",
      "emptyMessage": "Il tuo vault è vuoto. Aggiungeremo documenti qui man mano che completi i compiti.",
      "expired": "Scaduto",
      "expiringSoon": "In scadenza presto",
      "hint": "Collega documenti dal tuo vault per saltare i caricamenti.",
      "link": "Collega",
      "linked": "Collegato",
      "remaining": "rimasti",
      "scanning": "Scansione del vault…",
      "skip": "Salta",
      "undo": "Annulla",
      "validUntil": "Valido fino a {{date}}",
      "skipped": "Saltato"
    },
    "verifiedByTonnieGuard": "Verificato da Tonnie guard",
    "viewDetails": "Visualizza dettagli",
    "viewDocumentInMobile": "Carica e gestisci questo documento nell'app mobile",
    "viewMyOptions": "Visualizza le mie opzioni",
    "viewTaskInMobile": "Visualizza e completa questo compito nell'app mobile",
    "visaBlueCard": "Carta blu UE",
    "visaFamily": "Riunione familiare",
    "visaNomad": "Nomade digitale / Lavoratore remoto",
    "visaStudent": "Visto per studenti",
    "visaWork": "Visto di lavoro / Occupazione",
    "welcome": {
      "description": "Crea il tuo piano di rilocazione personalizzato. Ti guideremo attraverso una rapida configurazione per creare il tuo cruscotto con compiti, documenti e scadenze su misura per il tuo viaggio.",
      "docsStep": "Documenti e compiti",
      "docsStepDesc": "Ottieni una lista di controllo personalizzata di tutto ciò di cui hai bisogno",
      "householdStep": "La tua famiglia e il visto",
      "householdStepDesc": "Dicci chi si sta trasferendo e la tua situazione immigratoria",
      "letsStart": "Iniziamo",
      "planStep": "Alloggio e logistica",
      "planStepDesc": "Imposta il tuo piano abitativo, viaggio e cronologia",
      "timeEstimate": "Ci vogliono circa 5-10 minuti per completare",
      "title": "Benvenuto in TelePortal"
    },
    "welcomeMessage": "Benvenuto in TelePortal Assessment! Ti aiuterò a creare una lista di controllo personalizzata per il trasferimento. Iniziamo comprendendo la tua situazione.",
    "you": "Tu",
    "yourNextStep": "Il tuo prossimo passo",
    "setupDimension": {
      "profile": "Profilo",
      "profileDesc": "Origine, destinazione e contesto di trasferimento",
      "household": "Nucleo familiare",
      "householdDesc": "Membri della famiglia che si uniscono al trasferimento",
      "documents": "Documenti",
      "documentsDesc": "Scansione e collegamento di documenti Vault",
      "preferences": "Preferenze",
      "preferencesDesc": "Preferenze di viaggio, alloggio e stile di vita"
    },
    "docType": {
      "bank_statements": "Estratti conto bancari",
      "birth_certificate": "Certificato di nascita",
      "certified_translation": "Traduzione certificata",
      "consulate_invitation_letter": "Lettera di invito del consolato",
      "criminal_record": "Certificato penale",
      "drivers_license": "Patente di guida",
      "employment_contract": "Contratto di lavoro",
      "health_insurance_policy": "Polizza di assicurazione sanitaria",
      "lease_agreement": "Contratto di locazione",
      "marriage_certificate": "Certificato di matrimonio",
      "passport": "Passport",
      "pet_passport": "Passaporto dell'animale domestico",
      "promise_contract": "Contratto di promessa",
      "proof_of_address": "Prova di indirizzo",
      "proof_of_income": "Prova di reddito",
      "salary_proof": "Prova di stipendio",
      "school_records": "Documenti scolastici",
      "sponsor_letter": "Lettera di sponsorizzazione",
      "techvisa_endorsement": "Approvazione TechVisa",
      "term_of_responsibility": "Termini di responsabilità",
      "travel_insurance": "Assicurazione di viaggio"
    },
    "duration": {
      "1_2_days": "1-2 giorni",
      "1_2_weeks": "1-2 settimane",
      "1_3_days": "1-3 giorni",
      "1_day": "1 giorno",
      "1_week": "1 settimana",
      "2_3_weeks": "2-3 settimane",
      "2_4_weeks": "2-4 settimane",
      "2_6_weeks": "2-6 settimane",
      "2_8_weeks": "2-8 settimane",
      "3_5_days": "3-5 giorni",
      "4_12_weeks": "4-12 settimane",
      "4_8_weeks": "4-8 settimane",
      "ongoing": "In corso"
    },
    "daysOverdue_one": "{{count}} giorno di ritardo",
    "daysOverdue_other": "{{count}} giorni di ritardo",
    "documentsAttached_one": "{{count}} documento allegato",
    "documentsAttached_other": "{{count}} documenti allegati",
    "documentsCount_one": "{{count}} documento",
    "documentsCount_other": "{{count}} documenti",
    "dueInDays_one": "Scade tra {{count}} giorno",
    "dueInDays_other": "Scade tra {{count}} giorni",
    "inProgressCount_one": "{{count}} in corso",
    "inProgressCount_other": "{{count}} in corso",
    "missingDocs_one": "{{count}} mancante",
    "missingDocs_other": "{{count}} mancanti",
    "moreCompleted_one": "+{{count}} altra completata",
    "moreCompleted_other": "+{{count}} altre completate",
    "needsAttentionCount_one": "{{count}} richiede attenzione",
    "needsAttentionCount_other": "{{count}} richiedono attenzione",
    "pendingCount_one": "{{count}} in attesa",
    "pendingCount_other": "{{count}} in attesa",
    "timeMinutes_one": "~{{count}} minuto",
    "timeMinutes_other": "~{{count}} minuti"
  },
  "termsPrivacy": {
    "gdprRights": "Ai sensi del GDPR e delle leggi sulla protezione dei dati applicabili, hai il diritto di accedere, rettificare, cancellare e trasferire i tuoi dati personali. Puoi esercitare questi diritti in qualsiasi momento tramite Impostazioni o contattando il nostro Responsabile della Protezione dei Dati.",
    "privacyPolicy": "Informativa sulla privacy",
    "termsOfService": "Termini di servizio",
    "title": "Termini e privacy",
    "yourRights": "I tuoi diritti"
  },
  "theme": {
    "autoMatchSystem": "L'app abbinerà automaticamente le impostazioni del tema del tuo dispositivo.",
    "configure": "Configura",
    "custom": "Personalizzato",
    "dark": "Scuro",
    "darkTheme": "Tema scuro",
    "followSystem": "Segui il sistema ({{mode}})",
    "light": "Chiaro",
    "lightTheme": "Tema chiaro",
    "system": "Sistema",
    "theme": "Tema",
    "themeSelection": "Selezione del tema",
    "useFixedTheme": "L'app utilizzerà il tema {{mode}} indipendentemente dalle impostazioni del tuo dispositivo."
  },
  "validation": {
    "passwordUpdateFailed": "Impossibile aggiornare la password. Si prega di riprovare.",
    "passwordUpdated": "Password aggiornata con successo",
    "required": "Questo campo è obbligatorio",
    "email": {
      "invalid": "Indirizzo email non valido",
      "required": "Inserisci il tuo indirizzo email."
    },
    "password": {
      "min": "La password deve avere almeno {{passwordMinLength}} caratteri.",
      "mismatch": "Le password non corrispondono",
      "max": "La password può avere al massimo {{passwordMaxLength}} caratteri.",
      "required": "Inserisci la tua password.",
      "confirmRequired": "Conferma la tua password."
    },
    "firstName": {
      "required": "Il nome è obbligatorio",
      "tooLong": "Il nome può avere al massimo 50 caratteri."
    },
    "lastName": {
      "required": "Il cognome è obbligatorio",
      "tooLong": "Il cognome può avere al massimo 50 caratteri."
    },
    "uuid": {
      "invalid": "UUID non valido"
    },
    "phone": {
      "invalid": "Numero di telefono non valido"
    },
    "url": {
      "invalid": "URL non valido"
    },
    "countryCode": {
      "length": "Il codice paese deve essere di 2 caratteri (ISO 3166-1 alpha-2)"
    },
    "dateRange": {
      "endAfterStart": "La data di fine deve essere dopo la data di inizio"
    },
    "field": {
      "required": "Questo campo è obbligatorio"
    },
    "iqulture": {},
    "city": {
      "required": "Indica la città in cui vivi",
      "tooLong": "Il nome della città è troppo lungo (massimo 100 caratteri)"
    },
    "originCountry": {
      "required": "Scegli il paese da cui parti"
    },
    "nationality": {},
    "timeZone": {
      "invalid": "Questo fuso orario non è riconosciuto."
    },
    "timeOfDay": {
      "invalid": "Usa un orario come 22:00."
    },
    "code": {
      "sixDigits": "Inserisci il codice a 6 cifre."
    },
    "destination": {
      "notOpen": "Non offriamo ancora questa destinazione. Oggi la destinazione disponibile è il Portogallo."
    },
    "journey": {
      "requestIdRequired": "Un nuovo percorso richiede un identificativo di richiesta",
      "newIntentOnly": "Solo un nuovo percorso accetta un identificativo di richiesta o un nome",
      "labelRequired": "Inserisci un nome o cancellalo",
      "labelTooLong": "Usa al massimo 40 caratteri"
    }
  },
  "vault": {
    "downloadError": "Download fallito",
    "downloadSuccess": "Scaricato",
    "downloadZipError": "Download documenti fallito",
    "loadingPreview": "Caricamento anteprima…",
    "removeError": "Rimozione fallita",
    "removeSuccess": "Rimosso",
    "uploadError": "Caricamento fallito",
    "uploadSuccess": "Caricato",
    "uploadRejected": {
      "mimeNotAllowed": "Questo tipo di file non è accettato in questa sezione. Scegli un altro file.",
      "unidentifiable": "Non riusciamo a riconoscere questo file. Potrebbe essere danneggiato: prova a esportarlo di nuovo.",
      "declaredMimeMismatch": "Il contenuto di questo file non corrisponde al suo tipo. Carica il file originale.",
      "pitchTooLong": "Questo video dura più di {{minutes}} minuti. Scegli un video più breve.",
      "fileTooLarge": "Questo file è troppo grande per essere caricato. Scegli un file più piccolo.",
      "uploadStalled": "Il caricamento si è interrotto perché la connessione ha smesso di inviare dati. Controlla la connessione e riprova."
    },
    "downloadZipSuccess_one": "Download di {{count}} documento",
    "downloadZipSuccess_other": "Download di {{count}} documenti",
    "documentsCount_one": "{{count}} documento",
    "documentsCount_other": "{{count}} documenti"
  },
  "viewport": {
    "description": "Il Web di Tonnie Citizen è progettato per schermi più grandi. Per la migliore esperienza mobile, si prega di scaricare l'app mobile.",
    "downloadAppStore": "Scarica su app store",
    "downloadPlayStore": "Ottienilo su Google play",
    "orAccessDesktop": "Oppure accedi da un tablet o desktop",
    "switchToMobile": "Passa a Tonnie Citizen"
  },
  "wallet": {
    "additions": "Aggiunte",
    "allTransactions": "Tutti",
    "amount": "Importo",
    "available": "disponibile",
    "confirmTopUp": "Conferma ricarica",
    "deductions": "Detrazioni",
    "description": "Il saldo del tuo portafoglio e la cronologia delle transazioni",
    "maxTopUp": "L'importo massimo di ricarica è {{amount}}",
    "minMaxTopUp": "Minimo: {{min}}, massimo: {{max}}",
    "minTopUp": "L'importo minimo di ricarica è {{amount}}",
    "noTransactions": "Nessuna transazione ancora",
    "sourceAdmin": "Allocazione admin",
    "sourceCoupon": "Coupon",
    "sourceEcosystem": "Ecosistema",
    "sourcePurchase": "Acquisto",
    "sourceReferral": "Riferimento",
    "sourceRenewal": "Rinnovo",
    "sourceSponsor": "Sponsor",
    "sourceSubscription": "Abbonamento",
    "sourceTopUp": "Ricarica",
    "title": "Tonnie wallet",
    "topUp": "Ricarica",
    "topUpDescription": "Aggiungi denaro al tuo portafoglio utilizzando il tuo metodo di pagamento",
    "topUpError": "Impossibile ricaricare il portafoglio. Si prega di riprovare.",
    "topUpSuccess": "{{amount}} aggiunti con successo al tuo portafoglio",
    "topUpTitle": "Ricarica portafoglio",
    "transactionHistory": "Cronologia transazioni",
    "transactionHistoryDesc": "Visualizza tutte le tue transazioni nel portafoglio"
  },
  "webPortal": {
    "availableOnWeb": "Disponibile sul portale web di Citizen",
    "copied": "Copiato!",
    "copyLink": "Copia link per desktop",
    "hint": "Il Portale Web di Citizen richiede un browser desktop.",
    "shareLink": "Condividi link"
  },
  "widgets": {
    "continue": "Continua",
    "motivationalForm": {
      "sharePlaceholder": "Condividi i tuoi pensieri..."
    },
    "rating": {
      "notAtAll": "Per niente",
      "veryMuch": "Molto"
    },
    "timeline": {
      "12plusMonths": "12+ mesi",
      "12plusMonthsDesc": "Pianificazione futura",
      "1to3months": "1-3 mesi",
      "1to3monthsDesc": "Pianificazione a breve termine",
      "3to6months": "3-6 mesi",
      "3to6monthsDesc": "Pianificazione a medio termine",
      "6to12months": "6-12 mesi",
      "6to12monthsDesc": "Pianificazione a lungo termine",
      "asap": "Il prima possibile",
      "asapDesc": "Entro il prossimo mese",
      "flexible": "Flessibile",
      "flexibleDesc": "Nessuna tempistica specifica"
    }
  },
  "world": {
    "completeToUnlock": "Completa le missioni precedenti per sbloccare",
    "upgradeToUnlock": "Passa a Pro per sbloccare",
    "completed": "Completato",
    "notFound": "Mondo non trovato",
    "backToQultureUp": "Torna a QultureUp",
    "ofMissions": "{{completed}} di {{total}} missioni",
    "overallProgress": "Progresso complessivo",
    "remaining": "Rimanente",
    "title": "Mondo",
    "tracks": "Tracce",
    "milesReward_one": "+{{count}} Mile",
    "milesReward_other": "+{{count}} Miles"
  },
  "pricing": {
    "betaPriceLabel": "Prezzo di accesso anticipato",
    "percentOffLabel": "−{{percent}}%",
    "betaDisclaimer": "Prezzo di accesso anticipato — prezzo regolare {{listPrice}} dopo il lancio."
  },
  "ui": {
    "sidebar": {
      "toggle": "Attiva/Disattiva sidebar"
    },
    "carousel": {
      "prev": "Diapositiva precedente",
      "next": "Diapositiva successiva"
    },
    "command": {
      "title": "Palette dei comandi",
      "description": "Cerca un comando da eseguire..."
    }
  },
  "plan": {
    "upgrade": {
      "teleportal": "Aggiorna a Modalità Viaggio o Pro per sbloccare tutte le fasi di TelePortal",
      "qultureup": "Aggiorna a Modalità Viaggio o Pro per accedere a tutti i mondi di QultureUp",
      "care": "Aggiorna a Modalità Viaggio o Pro per accedere a Care & Supporto",
      "passport": "Aggiorna a Journey Mode o Pro per analisi avanzate Passport",
      "career": "Aggiorna a Pro per funzionalità di carriera avanzate",
      "copilot": "Aggiorna a Pro per query CoPilot illimitate",
      "journeyBuilder": "Aggiorna a Journey Mode o Pro per creare nuovi percorsi",
      "familyProgram": "Aggiorna a Journey Mode o Pro per attivare il Programma Famiglia",
      "default": "Aggiorna per sbloccare questa funzionalità"
    }
  },
  "appUpdate": {
    "required": {
      "title": "Aggiornamento necessario",
      "body": "Questa versione di Tonnie non è più supportata. Aggiorna per continuare.",
      "cta": "Aggiorna ora"
    },
    "available": {
      "title": "Aggiornamento disponibile",
      "body": "È disponibile una nuova versione di Tonnie.",
      "cta": "Aggiorna"
    },
    "dismiss": "Più tardi"
  },
  "setup": {
    "title": "Da quale paese parti?",
    "countryLabel": "Paese da cui parti",
    "countryPlaceholder": "Seleziona un paese",
    "cityLabel": "Città in cui vivi",
    "cityPlaceholder": "Inizia a scrivere la tua città…",
    "destinationLabel": "Destinazione",
    "destinationOpenToday": "{{country}} è la destinazione disponibile oggi. Presto ce ne saranno altre.",
    "submit": "Continua",
    "saving": "Configurazione del tuo percorso…",
    "saveFailed": "Non siamo riusciti a salvare. Controlla la connessione e riprova."
  },
  "profileComplete": {
    "known": "Già nel tuo profilo",
    "countryPlaceholder": "Seleziona un paese",
    "cityPlaceholder": "Inizia a scrivere la tua città…",
    "phonePlaceholder": "Il tuo numero di telefono",
    "optionalNote": "I dati del passaporto, il CV e il nucleo familiare sono facoltativi. Non bloccano mai il tuo punteggio.",
    "saving": "Salvataggio…",
    "saveFailed": "Non siamo riusciti a salvare. Controlla la connessione e riprova.",
    "label": {
      "firstName": "Nome",
      "lastName": "Cognome",
      "dateOfBirth": "Data di nascita",
      "currentCountry": "Paese in cui vivi",
      "currentCity": "Città in cui vivi",
      "phone": "Telefono"
    },
    "loadFailed": "Non siamo riusciti a caricare il tuo profilo. Controlla la connessione e riprova."
  },
  "profileBasics": {
    "title": "I tuoi dati di base",
    "subtitle": "Ciò che serve al tuo CheckUp per iniziare. Lascia che sia un documento a scrivere: controlli tutto prima che venga salvato.",
    "progressLabel": "Essenziali per il tuo CheckUp",
    "close": "Chiudi",
    "back": "Torna ai tuoi dati",
    "faster": {
      "title": "Compila più in fretta",
      "fastest": "Il più veloce",
      "document": {
        "title": "Scansiona passaporto o documento",
        "fills": "Data di nascita · cittadinanza"
      },
      "import": {
        "title": "PDF di LinkedIn o CV",
        "fills": "Esperienza · formazione · competenze · lingue"
      }
    },
    "orType": "oppure scrivili",
    "filled": {
      "document_one": "Il tuo documento ha compilato {{count}} dato. Controlla cosa manca qui sotto.",
      "document_other": "Il tuo documento ha compilato {{count}} dati. Controlla cosa manca qui sotto.",
      "documentNone": "Non è stato aggiunto nulla dal documento.",
      "import": "Il tuo PDF di LinkedIn o CV è nel profilo: rende il punteggio più preciso."
    },
    "done": {
      "title": "I tuoi dati di base sono completi",
      "body": "Tutto ciò che serve al tuo CheckUp per iniziare è già registrato. Un PDF di LinkedIn o un CV rende il punteggio ancora più preciso."
    },
    "doneCta": "Fatto",
    "privacy": "Non si salva nulla finché non premi Salva.",
    "later": "Più tardi",
    "save": "Salva i miei dati",
    "saved": "I tuoi dati sono stati salvati."
  },
  "citizenHome": {
    "needsYou": {
      "checkin": {
        "action": "Fai il check-in",
        "body": "Il check-in quotidiano richiede un minuto.",
        "last": "Ultimo check-in: {{date}}",
        "title": "Come stai oggi?"
      },
      "checkpoint": {
        "action": "Inizia",
        "body": "Raccontaci come procede il tuo inserimento.",
        "overdueTitle": "Un checkpoint di Care è in ritardo",
        "title": "È il momento di un checkpoint di Care"
      },
      "invitation": {
        "action": "Esamina",
        "body": "Esamina l'invito per decidere se aderire.",
        "title": "Invito da {{company}}"
      },
      "later": "Più tardi",
      "laterA11y": "Più tardi: {{title}}",
      "seeAll": "Vedi tutto",
      "showLess": "Mostra meno",
      "seeAllA11y_one": "Vedi la {{count}} cosa che richiede la tua attenzione",
      "seeAllA11y_other": "Vedi tutte le {{count}} cose che richiedono la tua attenzione",
      "profile": {
        "action": "Completa il profilo",
        "body": "Il tuo punteggio CheckUp ha bisogno di qualche altro dato su di te.",
        "title": "Completa il tuo profilo",
        "secondary": "Carica passaporto"
      },
      "taskOverdue": {
        "action": "Apri l'attività",
        "body": "Alcune scadenze del trasferimento sono passate.",
        "title_one": "{{count}} attività in ritardo",
        "title_other": "{{count}} attività in ritardo"
      },
      "title": "Richiede la tua attenzione",
      "unread": {
        "action": "Leggi",
        "body": "Scopri le novità.",
        "title_one": "{{count}} messaggio da leggere",
        "title_other": "{{count}} messaggi da leggere"
      },
      "dismiss": "Ignora",
      "dismissA11y": "Ignora: {{title}}",
      "sponsorship": {
        "title": "{{company}} vuole sponsorizzare il tuo percorso",
        "body": "Si aprono tutti i capitoli — TelePortal, QultureUp, Care e Passport — senza alcun costo per te.",
        "action": "Vedi offerta"
      },
      "testit": {
        "title_one": "{{company}} ti chiede {{count}} test",
        "title_other": "{{company}} ti chiede {{count}} test",
        "body_one": "Ne manca {{count}}. I risultati restano tuoi da riutilizzare.",
        "body_other": "Ne mancano {{count}}. I risultati restano tuoi da riutilizzare.",
        "action": "Inizia i test"
      },
      "checkupRequested": {
        "title": "{{company}} aspetta il tuo CheckUp",
        "bodyStart": "Hanno chiesto il tuo punteggio iQulture. Richiede circa 10–15 minuti.",
        "actionStart": "Inizia il CheckUp",
        "bodyContinue": "Completa il tuo CheckUp: hanno chiesto il tuo punteggio iQulture.",
        "actionContinue": "Continua il CheckUp",
        "bodyProfile": "Il tuo CheckUp è completo. Aggiungi qualche dato al profilo e il tuo punteggio sarà pronto.",
        "actionProfile": "Completa il profilo",
        "bodyCalculate": "Tutti i passaggi sono completi. Calcola il tuo punteggio per rispondere alla richiesta.",
        "actionCalculate": "Calcola il punteggio",
        "bodyCalculating": "Il tuo punteggio è in calcolo. Non ci vorrà molto.",
        "actionCalculating": "Vedi il CheckUp",
        "bodyConsent": "Il tuo punteggio è pronto. Lo vedono solo se scegli di condividerlo.",
        "actionConsent": "Scegli cosa vedono",
        "titleConsent": "{{company}} chiede di vedere il punteggio del tuo CheckUp"
      },
      "checkupShared": {
        "title": "{{company}} può vedere il tuo CheckUp",
        "body": "Vedono il tuo punteggio e la tua preparazione, mai le tue risposte. Puoi cambiarlo quando vuoi.",
        "action": "Gestisci la condivisione"
      },
      "countAria_one": "{{count}} cosa richiede la tua attenzione",
      "countAria_other": "{{count}} cose richiedono la tua attenzione",
      "request": {
        "titleTests": "{{company}} chiede di vedere altri risultati dei tuoi test",
        "body": "Guarda cosa vedrebbero e decidi. Non viene condiviso nulla fino ad allora.",
        "action": "Esamina"
      }
    },
    "handoff": {
      "testit": {
        "title": "Fai i tuoi test",
        "description": "TestIt funziona su Citizen Web, con la fotocamera e il microfono che servono ad alcuni test."
      },
      "sharing": {
        "title": "Scegli cosa vedono le aziende",
        "description": "Chi vede i tuoi dati, e cosa vede, si gestisce su Citizen Web, in I miei percorsi."
      }
    },
    "welcome": {
      "badge": "Benvenuto in Tonnie",
      "badgeInvited": "Invitato da {{company}}",
      "title": "{{name}}, il tuo trasferimento all'estero inizia qui.",
      "titleNoName": "Il tuo trasferimento all'estero inizia qui.",
      "titleInvited": "Benvenuto, {{name}}. {{company}} ti sta aspettando.",
      "titleInvitedNoName": "Benvenuto. {{company}} ti sta aspettando.",
      "body": "Crea il tuo percorso, scopri quanto sei pronto con un CheckUp completo come un check-up medico e pianifica ogni documento e ogni scadenza, fino a diventare un Citizen.",
      "bodyInvited": "Accetta l'invito e il tuo percorso inizia: prima ciò che ha chiesto {{company}}, poi un piano per ogni documento e scadenza del trasferimento.",
      "ctaBuild": "Crea il tuo percorso",
      "ctaReview": "Vedi invito",
      "ctaBasics": "Aggiungi i miei dati · 1 min",
      "ctaHow": "Come funziona",
      "routeAria": "Quattro capitoli: il tuo percorso, il CheckUp, pianificare e trasferirsi, diventare Citizen",
      "route": {
        "build": {
          "title": "Crea il percorso",
          "sub": "Dove vai"
        },
        "accept": {
          "title": "Accetta l'invito",
          "sub": "Il percorso viene creato"
        },
        "checkup": {
          "title": "CheckUp",
          "sub": "Quanto sei pronto"
        },
        "plan": {
          "title": "Pianifica e trasferisciti",
          "sub": "Documenti, scadenze"
        },
        "citizen": {
          "title": "Diventa Citizen",
          "sub": "Cultura, cura, passaporto"
        }
      }
    },
    "quickStart": {
      "eyebrow": "Avvio rapido",
      "title": "I tuoi dati di base in circa un minuto",
      "body": "Lascia che sia un documento a scrivere: controlli tutto prima che venga salvato.",
      "progress": "Essenziali per il tuo CheckUp: {{done}} di {{total}}",
      "type": {
        "title": "Scrivili tu",
        "body": "Solo quello che manca ancora: circa due minuti.",
        "cta": "Aggiungi a mano"
      }
    },
    "path": {
      "eyebrow": "Per iniziare",
      "title": "I tuoi primi cinque passi",
      "progress": "{{done}} di {{total}} completati",
      "progressAria": "{{done}} di {{total}} passi completati",
      "parts": "{{done}} di {{total}}",
      "note": "Il CheckUp è gratuito per tutti. I passi 3 e 4 sono più rapidi con il passaporto o il CV.",
      "status": {
        "done": "Fatto",
        "in_progress": "In corso",
        "available": "Disponibile ora",
        "locked": "Bloccato"
      },
      "optional": "Facoltativo · punteggio migliore",
      "missing": "Manca ancora: {{items}}",
      "steps": {
        "journey": {
          "title": "Crea il tuo percorso",
          "titleInvited": "Accetta l'invito di {{company}}",
          "text": "Dicci dove vai e costruiamo il piano su misura.",
          "textInvited": "Accettando, il tuo percorso viene creato, con {{company}}.",
          "textDone": "Il tuo percorso è pronto.",
          "meta": "Circa 3 minuti",
          "metaInvited": "1 minuto",
          "cta": "Crea percorso",
          "ctaInvited": "Vedi invito"
        },
        "essential": {
          "title": "Aggiungi i dati essenziali",
          "text": "Ciò che serve al CheckUp per iniziare: nome, data di nascita, cittadinanza, dove vivi e telefono.",
          "textDone": "Tutto ciò che serve al CheckUp per iniziare.",
          "meta": "2 minuti · o una foto del passaporto",
          "cta": "Aggiungi in un minuto"
        },
        "assessment": {
          "title": "Fai la valutazione CheckUp",
          "text": "Cinque brevi parti: video, il tuo pitch, lingue, motivazione e una chat.",
          "textLocked": "Si apre quando il tuo percorso esiste.",
          "textDone": "Tutte e cinque le parti sono completate.",
          "next": "Prossimo: {{part}}.",
          "meta": "Circa 20 minuti · puoi fermarti quando vuoi",
          "cta": "Inizia",
          "ctaContinue": "Continua",
          "parts": {
            "videos_watched": "i video introduttivi",
            "pitch_video": "il tuo video di pitch",
            "language_tests": "i tuoi test di lingua",
            "motivational_answers": "le tue risposte sulla motivazione",
            "assistant_chat": "la chat con Tonnie"
          }
        },
        "moreData": {
          "title": "Aggiungi altri dati",
          "text": "Competenze, lingue, formazione ed esperienza rendono il punteggio più preciso.",
          "textDone": "Tutto ciò che legge il punteggio è compilato.",
          "meta": "1 minuto con un PDF di LinkedIn o un CV",
          "cta": "Importa LinkedIn o CV"
        },
        "score": {
          "title": "Ottieni il tuo punteggio iQulture",
          "titleShared": "Invia il tuo punteggio a {{company}}",
          "text": "La tua preparazione, pilastro per pilastro, e su cosa lavorare dopo.",
          "textShared": "Si calcola con un clic e {{company}} lo vede.",
          "meta": "Un clic, dopo i passi 2 e 3",
          "cta": "Calcola il mio punteggio",
          "ctaCalculating": "Vedi avanzamento",
          "ctaDone": "Vedi risultati"
        }
      }
    },
    "chapters": {
      "eyebrow": "Come funziona",
      "title": "Quattro capitoli per diventare Citizen",
      "free": "Gratuito per tutti",
      "planOrSponsor": "Piano o sponsor",
      "basics": {
        "title": "Tutto inizia dai tuoi dati di base",
        "body": "Il tuo CheckUp ha bisogno di alcuni dati su di te, e un documento può scriverne la maggior parte al posto tuo.",
        "document": "Una foto del passaporto o della carta d'identità compila data di nascita e cittadinanza.",
        "import": "Un PDF di LinkedIn o un CV compila esperienza, formazione, competenze e lingue.",
        "check": "Non si salva nulla prima che tu lo controlli. Scrivi solo dove vivi e il telefono.",
        "cta": "Aggiungi i miei dati"
      },
      "checkup": {
        "title": "Una diagnosi, non un quiz",
        "body": "Come un check-up medico per il tuo trasferimento: il punteggio iQulture, pilastro per pilastro, cosa è forte e su cosa lavorare."
      },
      "teleportal": {
        "title": "Il trasferimento, pianificato giorno per giorno",
        "body": "Ogni passo del visto, documento e scadenza del tuo percorso, con i documenti custoditi nel tuo Vault."
      },
      "qultureup": {
        "title": "Conosci il paese prima di arrivare",
        "body": "Missioni e mondi sulla cultura, il lavoro e la vita quotidiana della tua destinazione. Guadagna miglia strada facendo."
      },
      "care": {
        "label": "Care e Passport",
        "title": "Ambientati, e dimostralo",
        "body": "Check-in che ti fanno stare bene dopo l'arrivo e un Passport che raccoglie ogni timbro del tuo percorso."
      }
    },
    "unlock": {
      "badge": "Sblocca tutti i capitoli",
      "title": "Il CheckUp è gratuito. Il resto del percorso si apre in due modi.",
      "body": "TelePortal, QultureUp, Care e Passport si aprono con un tuo piano, o quando un'azienda sponsorizza il tuo percorso.",
      "plan": {
        "title": "Scegli un piano",
        "body": "Tutti i capitoli del tuo percorso si aprono appena scegli.",
        "cta": "Vedi i piani"
      },
      "sponsor": {
        "title": "Fatti sponsorizzare da un'azienda",
        "body": "Le aziende che assumono all'estero possono pagare tutto il tuo percorso. Quando una lo fa, la sua offerta compare qui."
      }
    },
    "error": {
      "title": "Impossibile caricare la home",
      "body": "Controlla la connessione e riprova."
    },
    "ready": {
      "chipInvited": "Invitato da {{company}}",
      "chipSponsored": "Sponsorizzato da {{company}}",
      "chipRoute": "Il tuo viaggio · {{origin}} → {{destination}}",
      "title": "Ciao {{name}}, il tuo trasferimento in {{country}} inizia qui.",
      "titleNoName": "Il tuo trasferimento in {{country}} inizia qui.",
      "titleNoCountry": "Ciao {{name}}, il tuo trasferimento inizia qui.",
      "titleBare": "Il tuo trasferimento inizia qui.",
      "body": "Cinque passi verso il tuo punteggio iQulture: la tua preparazione, pilastro per pilastro, e su cosa lavorare dopo. Ogni capitolo del trasferimento si adatta a esso.",
      "bodyWaiting": "Cinque passi verso il tuo punteggio iQulture. {{company}} lo aspetta, e ogni capitolo del tuo viaggio si adatta a esso.",
      "bodyYours": "Cinque passi verso il tuo punteggio iQulture: è tuo. Decidi tu se {{company}} lo vede.",
      "stepsAria": "Cinque passi verso il tuo punteggio iQulture",
      "ofTotal": "di {{total}} completati",
      "now": "Ora",
      "privacyShared": "{{company}} vede il tuo punteggio e la tua preparazione, mai le tue risposte.",
      "privacyOwn": "Le tue risposte restano tue. Nessuno vede il tuo punteggio se non lo condividi.",
      "next": {
        "eyebrow": "Il tuo prossimo passo",
        "whatIs": "Che cos’è il CheckUp?",
        "parts": {
          "videos_watched": "Video",
          "pitch_video": "Il tuo pitch",
          "language_tests": "Lingue",
          "motivational_answers": "Motivazione",
          "assistant_chat": "Una breve chat"
        },
        "assessment": {
          "title": "Fai la valutazione CheckUp",
          "body": "Cinque parti brevi, circa 15 minuti. Puoi fermarti e riprendere da dove avevi lasciato.",
          "cta": "Inizia il CheckUp"
        },
        "assessmentContinue": {
          "title": "Completa la valutazione CheckUp",
          "body": "{{done}} di {{total}} parti completate. Prossima: {{part}}.",
          "cta": "Continua il CheckUp"
        },
        "essential": {
          "title_one": "Aggiungi {{count}} dato per avere il tuo punteggio",
          "title_other": "Aggiungi {{count}} dati per avere il tuo punteggio",
          "body": "{{items}}: meno di un minuto. Le tue risposte sono salvate; non si perde nulla.",
          "cta": "Aggiungi i dati"
        },
        "moreData": {
          "title": "Affina il tuo punteggio",
          "body": "Competenze, lingue ed esperienza: facoltativo, e ognuna conta.",
          "cta": "Importa LinkedIn o CV"
        },
        "score": {
          "title": "Ottieni il tuo punteggio iQulture",
          "titleShared": "Calcola il tuo punteggio e invialo a {{company}}",
          "body": "Un clic. La tua preparazione, pilastro per pilastro, e su cosa lavorare dopo. Resta tuo se non lo condividi.",
          "bodyShared": "Un clic. {{company}} vede il tuo punteggio e la tua preparazione, mai le tue risposte.",
          "cta": "Ottieni il mio punteggio",
          "ctaShared": "Calcola il mio punteggio"
        },
        "retry": {
          "title": "Riprova il calcolo",
          "body": "Qualcosa è andato storto da parte nostra. Le tue risposte sono salvate: non c’è nulla da rifare.",
          "cta": "Calcola di nuovo"
        },
        "calculating": {
          "title": "Stiamo calcolando il tuo punteggio",
          "body": "Stiamo valutando le tue risposte, il tuo pitch e le tue lingue. Puoi uscire: lo troverai qui al tuo ritorno.",
          "status": "Calcolo in corso…",
          "cta": "Vedi il CheckUp"
        },
        "failed": {
          "title": "Non è stato possibile calcolare il tuo punteggio",
          "body": "Qualcosa è andato storto da parte nostra. Apri il tuo CheckUp per riprendere da dove si è fermato.",
          "cta": "Apri il CheckUp"
        }
      },
      "chapters": {
        "title": "Cosa si apre dopo il tuo punteggio",
        "body": "Il tuo punteggio iQulture adatta a te ogni capitolo del trasferimento.",
        "bodyPlan": "Tutto si apre con un piano, o quando un’azienda sponsorizza il tuo viaggio.",
        "seePlans": "Vedi i piani",
        "bodySponsored": "Sponsorizzato da {{company}}: tutti i capitoli sono aperti.",
        "teleportal": "Ogni attività del trasferimento (legale, viaggio, sistemazione) in ordine.",
        "qultureup": "Conosci la cultura prima di arrivare, un mondo alla volta.",
        "care": "Supporto dopo l’arrivo: check-in di benessere e traguardi.",
        "passport": "Ogni traguardo del tuo viaggio, timbrato.",
        "open": "Aperto",
        "basic": "Base · aperto ora",
        "locked": "Si apre con un piano o una sponsorizzazione",
        "passportStatus_one": "{{count}} timbro · {{miles}} miglia",
        "passportStatus_other": "{{count}} timbri · {{miles}} miglia",
        "passportStamps_one": "{{count}} timbro",
        "passportStamps_other": "{{count}} timbri",
        "explore": "Esplora",
        "view": "Vedi"
      },
      "latest": {
        "eyebrow": "Ultimo",
        "empty": "I tuoi primi timbri e miglia appariranno qui."
      },
      "ask": {
        "title": "Domande sul CheckUp?",
        "cta": "Chiedi a Tonnie"
      }
    },
    "phone": {
      "surface": {
        "phone": "Sul telefono",
        "computer": "Su un computer",
        "either": "Telefono o computer"
      },
      "emailLink": "Inviami il link via email",
      "shareLink": "Condividi il link",
      "emailSent": "Ti abbiamo inviato il link via email: aprilo sul computer.",
      "emailHeld": "Al momento non possiamo inviarti email. Usa «Condividi il link» per inviartelo.",
      "emailFailed": "L'email non è partita. Riprova o condividi il link.",
      "next": {
        "assessment": {
          "title": "Fai la valutazione del CheckUp su un computer",
          "body": "Cinque brevi parti, circa 15 minuti, con video e il tuo pitch: per questo è pensata per uno schermo più grande. Puoi fermarti e riprendere da dove avevi lasciato."
        },
        "assessmentContinue": {
          "title": "Completa la valutazione del CheckUp su un computer"
        },
        "calculating": {
          "body": "Stiamo valutando le tue risposte, il tuo pitch e le tue lingue. Ti invieremo una notifica quando sarà pronto."
        },
        "score": {
          "body": "Un tocco. La tua preparazione, pilastro per pilastro, e su cosa lavorare dopo. Resta tua, a meno che tu non la condivida.",
          "bodyShared": "Un tocco. {{company}} vede il tuo punteggio e la tua preparazione, mai le tue risposte."
        }
      },
      "header": {
        "route": "{{origin}} → {{destination}}",
        "switchJourney": "Cambia viaggio. Attuale: {{route}}"
      },
      "welcome": {
        "meta": "3 domande · sul telefono"
      },
      "quickStart": {
        "eyebrow": "Già che ci sei",
        "title": "Aggiungi i tuoi dati di base · 1 min",
        "body": "Una foto del passaporto compila data di nascita e cittadinanza."
      },
      "meanwhile": {
        "title": "Nel frattempo, sul telefono",
        "essential": {
          "title_one": "Aggiungi {{count}} dato che serve al tuo punteggio",
          "title_other": "Aggiungi {{count}} dati che servono al tuo punteggio",
          "body": "{{items}} · una foto del passaporto ne compila la maggior parte"
        }
      },
      "stepsTitle": "I tuoi cinque passi",
      "steps": {
        "assessment": {
          "text": "Cinque brevi parti, circa 20 minuti, su un computer. Ti inviamo il link via email."
        },
        "score": {
          "text": "Un tocco, una volta completati i passi 2 e 3.",
          "textShared": "Un tocco, una volta completati i passi 2 e 3, e {{company}} lo vede."
        }
      },
      "stepper": {
        "notStarted": "Non iniziato"
      }
    },
    "how": {
      "intro": {
        "eyebrow": "Il tuo compagno",
        "title": "Tonnie, ogni giorno del tuo trasferimento",
        "body": "Dai primi progetti all’ambientarti, Tonnie è con te: sul telefono e sul web."
      },
      "chapters": {
        "checkup": {
          "title": "Scopri a che punto sei",
          "body": "Il tuo punteggio di preparazione al trasferimento e su cosa lavorare dopo. La valutazione si fa su un computer; il punteggio ti segue ovunque."
        },
        "teleportal": {
          "title": "Il tuo trasferimento, passo dopo passo",
          "body": "Segui le attività e le tappe del trasferimento e spuntale man mano che procedi."
        },
        "qultureup": {
          "title": "Sentiti a casa prima",
          "body": "Missioni brevi per imparare la cultura, la lingua e la vita quotidiana della tua destinazione."
        },
        "care": {
          "title": "Supporto quando ti serve",
          "body": "Contatta il tuo team per il trasferimento — messaggi, check-in e riunioni, tutto in un unico posto."
        },
        "passport": {
          "title": "I tuoi progressi, timbrati",
          "body": "Guadagna timbri e scopri quanta strada hai fatto nel tuo percorso di trasferimento."
        }
      },
      "title": "Come funziona Tonnie",
      "start": {
        "title": "Tutto inizia dal tuo viaggio",
        "body": "Tre domande (dove vai, la tua situazione, la tua famiglia) e il tuo viaggio è pronto, sul telefono o sul web. Da lì parte tutto il resto."
      }
    }
  },
  "profileImport": {
    "phone": {
      "source": {
        "subtitle": "Leggiamo esperienza, formazione, competenze e lingue: li controlli prima che venga salvato qualcosa.",
        "linkedin": "Il tuo profilo LinkedIn, salvato come PDF.",
        "cv": "Il tuo CV: PDF, Word o testo, fino a 10 MB."
      },
      "guide": {
        "title": "Ottieni il PDF di LinkedIn",
        "choose": "Scegli il PDF",
        "steps": {
          "computer": "Da un computer, apri il tuo profilo su linkedin.com",
          "save": "Scegli Altro, poi Salva come PDF",
          "send": "Invia il PDF a questo telefono — via email, File o iCloud",
          "choose": "Torna qui e sceglilo"
        }
      },
      "review": {
        "privacy": "Non viene salvato nulla finché non premi Salva. Il tuo nome resta com'è.",
        "save": "Salva nel mio profilo",
        "showAll": "Mostra tutti ({{count}})",
        "showLess": "Mostra meno",
        "present": "Oggi",
        "languageNoLevel_one": "{{names}}: il documento non indica il livello, quindi non viene salvata — aggiungila nel tuo profilo.",
        "languageNoLevel_other": "{{names}}: il documento non indica il livello, quindi non vengono salvate — aggiungile nel tuo profilo."
      },
      "saved": {
        "title": "Il tuo profilo è aggiornato",
        "body": "Esperienza, competenze e lingue ora rendono più precisa la tua valutazione."
      },
      "saveFailed": "Non siamo riusciti a salvarlo. Controlla la connessione e riprova."
    }
  },
  "profileQuality": {
    "calculate": {
      "anyway": "Calcola con quello che ho",
      "footnote": "Puoi aggiungere dettagli e ricalcolare quando vuoi."
    },
    "backTo": "Torna a {{hero}}",
    "returnHint": "Ogni dettaglio che aggiungi qui rende {{hero}} più preciso."
  },
  "checkupCard": {
    "status": {
      "answersDone": "Risposte complete"
    },
    "title": {
      "welcome": "Il tuo punteggio iQulture, in due parti",
      "ready": "Le tue risposte sono complete"
    },
    "subtitle": {
      "welcome": "Il tuo punteggio legge insieme le tue risposte e il tuo profilo: più sono completi, più è preciso.",
      "ready": "Il tuo punteggio le legge insieme al tuo profilo. Aggiungi ciò che manca per un punteggio più preciso, o calcola ora.",
      "readyComplete": "Anche il tuo profilo è completo: il punteggio legge ogni dettaglio."
    },
    "ring": {
      "caption": "il tuo punteggio",
      "label": "Il tuo punteggio iQulture compare qui una volta calcolato"
    },
    "next": {},
    "part": {
      "answers": "Le tue risposte",
      "done": "Fatto",
      "profileRead": "Il punteggio legge {{complete}} dettagli su {{total}}",
      "profileOptional": "Facoltativo: rende più preciso il punteggio, e puoi iniziare subito.",
      "profileComplete": "Completo: il punteggio legge ogni dettaglio."
    },
    "calculate": {
      "improveFirst": "Prima migliora il mio profilo"
    },
    "basics": {
      "title": "A un passo dal tuo punteggio",
      "subtitle": "Le tue risposte sono salvate. Aggiungi i dati di base per sbloccare il calcolo e completa il profilo per il punteggio più preciso.",
      "lockedHint": "Si sblocca quando ci sono i dati di base.",
      "lockedLabel": "Calcola il mio punteggio: bloccato finché mancano i dati di base"
    },
    "path": {
      "label": "Il tuo percorso verso il punteggio",
      "answers": "Le tue risposte",
      "answersState": "Fatto",
      "basics": "Dati di base",
      "basicsState": "Obbligatorio · {{complete}} su {{total}}",
      "profile": "Profilo completo",
      "profileState": "Consigliato · {{percent}}",
      "calculate": "Il tuo punteggio",
      "calculateState": "Bloccato"
    },
    "required": {
      "eyebrow": "Necessario per calcolare",
      "title_one": "Aggiungi {{count}} dettaglio per sbloccare il punteggio",
      "title_other": "Aggiungi {{count}} dettagli per sbloccare il punteggio",
      "addField": "Aggiungi {{field}}",
      "fastest": "Il modo più rapido: scansiona il passaporto, compila {{items}} in un colpo."
    },
    "recommended": {
      "eyebrow": "Consigliato",
      "title": "Per il punteggio più preciso",
      "body": "Il punteggio legge {{complete}} dettagli su {{total}} dal tuo profilo. Ognuno che aggiungi rende più precisi pilastri e consigli."
    }
  },
  "heroStart": {
    "status": {
      "notStarted": "Da iniziare",
      "inProgress": "In corso"
    },
    "next": {
      "eyebrow": "Il tuo prossimo passo"
    },
    "part": {
      "profile": "Il tuo profilo",
      "addBasics": "Aggiungi i dati di base",
      "improve": "Migliora il mio profilo"
    },
    "profileRead": "{{complete}} dettagli del profilo su {{total}} aggiunti",
    "profileComplete": "Completo: ci sono tutti i dettagli.",
    "teleportal": {
      "title": "Il tuo piano di trasferimento, in due parti",
      "subtitle": "TelePortal costruisce il tuo piano dalla configurazione e dal tuo profilo: più sono completi, più precisi sono compiti e scadenze.",
      "ringCaption": "il tuo piano",
      "steps": "La tua configurazione",
      "why": "Nazionalità, residenza e nucleo familiare definiscono il tuo percorso di visto.",
      "optional": "Facoltativo: rende il piano più preciso, e puoi iniziare subito."
    },
    "qultureup": {
      "title": "Il tuo percorso di apprendimento, in due parti",
      "subtitle": "QultureUp adatta il percorso alla tua valutazione e al tuo profilo: più sono completi, più ti calza.",
      "ringCaption": "il tuo percorso",
      "steps": "La tua valutazione",
      "why": "Da dove vieni e dove vivi definiscono il tuo punto di partenza.",
      "optional": "Facoltativo: avvicina il percorso a te, e puoi iniziare subito."
    },
    "care": {
      "title": "Care, accanto al tuo percorso",
      "subtitle": "Care inizia con una breve valutazione di come ti stai ambientando. Il tuo profilo è la base che legge tutto il percorso.",
      "ringCaption": "la tua cura",
      "steps": "La tua valutazione",
      "why": "Il punteggio, il piano di trasferimento e il percorso di apprendimento lo leggono.",
      "optional": "Facoltativo: mantiene preciso tutto il percorso, e puoi iniziare subito."
    }
  }
}
